/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/~__root';
import { Route as IndexRouteImport } from './routes/~index';
import { Route as AdminConsentRouteImport } from './routes/~admin-consent';
import { Route as AdminConsoleRouteRouteImport } from './routes/~admin-console/~route';
import { Route as AttestationRouteRouteImport } from './routes/~attestation/~route';
import { Route as InviteRouteRouteImport } from './routes/~invite/~route';
import { Route as MaintenanceRouteImport } from './routes/~maintenance';
import { Route as NotFoundRouteImport } from './routes/~not-found';
import { Route as NotSupportedRouteImport } from './routes/~not-supported';
import { Route as OauthRouteRouteImport } from './routes/~oauth/~route';
import { Route as OrgSwitchedRouteImport } from './routes/~org-switched';
import { Route as PublicRouteRouteImport } from './routes/~public/~route';
import { Route as StatusRouteImport } from './routes/~status';
import { Route as TermsAcceptanceRouteRouteImport } from './routes/~terms-acceptance/~route';
import { Route as authenticationAdminLoginRouteImport } from './routes/~(authentication)/~admin-login';
import { Route as authenticationCallbackRouteImport } from './routes/~(authentication)/~callback';
import { Route as authenticationLoginRouteImport } from './routes/~(authentication)/~login';
import { Route as authenticationLogoutRouteImport } from './routes/~(authentication)/~logout';
import { Route as authenticationLogoutinRouteImport } from './routes/~(authentication)/~logoutin';
import { Route as authenticationOrgMismatchRouteImport } from './routes/~(authentication)/~org-mismatch';
import { Route as authenticationPaymentPendingRouteImport } from './routes/~(authentication)/~payment-pending';
import { Route as AdminConsoleIndexRouteImport } from './routes/~admin-console/~index';
import { Route as AdminConsoleAdvancedRouteRouteImport } from './routes/~admin-console/~advanced/~route';
import { Route as AdminConsoleAiRouteRouteImport } from './routes/~admin-console/~ai/~route';
import { Route as AdminConsoleAuthorisedAppsRouteRouteImport } from './routes/~admin-console/~authorised-apps/~route';
import { Route as AdminConsoleMonitoringRouteRouteImport } from './routes/~admin-console/~monitoring/~route';
import { Route as AdminConsoleOrganisationManagementRouteRouteImport } from './routes/~admin-console/~organisation-management/~route';
import { Route as AdminConsolePlatformContentRouteRouteImport } from './routes/~admin-console/~platform-content/~route';
import { Route as AdminConsoleToolsRouteRouteImport } from './routes/~admin-console/~tools/~route';
import { Route as AdminConsoleUserAccessRouteRouteImport } from './routes/~admin-console/~user-access/~route';
import { Route as AttestationTokenRouteImport } from './routes/~attestation/~$token';
import { Route as ConsoleOrgIdRouteRouteImport } from './routes/~console.$orgId/~route';
import { Route as OauthAuthorizeRouteImport } from './routes/~oauth/~authorize';
import { Route as PasswordResetRequestRouteImport } from './routes/~password-reset/~request';
import { Route as PasswordResetResetRouteImport } from './routes/~password-reset/~reset';
import { Route as PublicOrgIdRouteRouteImport } from './routes/~public/~$orgId/~route';
import { Route as WhatsNewReleaseIdRouteImport } from './routes/~whats-new.$releaseId';
import { Route as authenticationChangeOrgOrgIdRouteImport } from './routes/~(authentication)/~change-org.$orgId';
import { Route as AdminConsoleAdvancedIndexRouteImport } from './routes/~admin-console/~advanced/~index';
import { Route as AdminConsoleAdvancedAppSettingsRouteRouteImport } from './routes/~admin-console/~advanced/~app-settings/~route';
import { Route as AdminConsoleAdvancedClaimsRouteImport } from './routes/~admin-console/~advanced/~claims';
import { Route as AdminConsoleAdvancedDbStatsRouteImport } from './routes/~admin-console/~advanced/~db-stats';
import { Route as AdminConsoleAdvancedDbUpgradesRouteImport } from './routes/~admin-console/~advanced/~db-upgrades';
import { Route as AdminConsoleAdvancedInboundEmailArchiveRouteRouteImport } from './routes/~admin-console/~advanced/~inbound-email-archive/~route';
import { Route as AdminConsoleAdvancedInboundParseRouteRouteImport } from './routes/~admin-console/~advanced/~inbound-parse/~route';
import { Route as AdminConsoleAdvancedIndicatorsRouteRouteImport } from './routes/~admin-console/~advanced/~indicators/~route';
import { Route as AdminConsoleAdvancedIntegrationTestsRouteImport } from './routes/~admin-console/~advanced/~integration-tests';
import { Route as AdminConsoleAdvancedJobsRouteRouteImport } from './routes/~admin-console/~advanced/~jobs/~route';
import { Route as AdminConsoleAdvancedPlaygroundRouteRouteImport } from './routes/~admin-console/~advanced/~playground/~route';
import { Route as AdminConsoleAdvancedWeaviateRouteImport } from './routes/~admin-console/~advanced/~weaviate';
import { Route as AdminConsoleAiAiFeedbackRouteRouteImport } from './routes/~admin-console/~ai/~ai-feedback/~route';
import { Route as AdminConsoleAiAiPromptsRouteRouteImport } from './routes/~admin-console/~ai/~ai-prompts/~route';
import { Route as AdminConsoleAiEvalRunsRouteRouteImport } from './routes/~admin-console/~ai/~eval-runs/~route';
import { Route as AdminConsoleAiModelPricingRouteRouteImport } from './routes/~admin-console/~ai/~model-pricing/~route';
import { Route as AdminConsoleAiModelTiersRouteRouteImport } from './routes/~admin-console/~ai/~model-tiers/~route';
import { Route as AdminConsoleAiRequestAnalyticsRouteRouteImport } from './routes/~admin-console/~ai/~request-analytics/~route';
import { Route as AdminConsoleAiStatisticsRouteRouteImport } from './routes/~admin-console/~ai/~statistics/~route';
import { Route as AdminConsoleAiUsageBillingRouteRouteImport } from './routes/~admin-console/~ai/~usage-billing/~route';
import { Route as AdminConsoleMonitoringIndexRouteImport } from './routes/~admin-console/~monitoring/~index';
import { Route as AdminConsoleMonitoringAuditTrailRouteRouteImport } from './routes/~admin-console/~monitoring/~audit-trail/~route';
import { Route as AdminConsoleMonitoringAxiomLogsRouteRouteImport } from './routes/~admin-console/~monitoring/~axiom-logs/~route';
import { Route as AdminConsoleMonitoringComplianceRouteRouteImport } from './routes/~admin-console/~monitoring/~compliance/~route';
import { Route as AdminConsoleMonitoringComplianceAuditRouteRouteImport } from './routes/~admin-console/~monitoring/~compliance-audit/~route';
import { Route as AdminConsoleMonitoringEmailActivityRouteRouteImport } from './routes/~admin-console/~monitoring/~email-activity/~route';
import { Route as AdminConsoleMonitoringEngagementRouteRouteImport } from './routes/~admin-console/~monitoring/~engagement/~route';
import { Route as AdminConsoleMonitoringLlmLogsRouteRouteImport } from './routes/~admin-console/~monitoring/~llm-logs/~route';
import { Route as AdminConsoleMonitoringLlmStatsRouteRouteImport } from './routes/~admin-console/~monitoring/~llm-stats/~route';
import { Route as AdminConsoleMonitoringMemoryRouteRouteImport } from './routes/~admin-console/~monitoring/~memory/~route';
import { Route as AdminConsoleMonitoringReportsRouteRouteImport } from './routes/~admin-console/~monitoring/~reports/~route';
import { Route as AdminConsoleMonitoringStatisticsRouteRouteImport } from './routes/~admin-console/~monitoring/~statistics/~route';
import { Route as AdminConsoleOrganisationManagementNewRouteRouteImport } from './routes/~admin-console/~organisation-management/~new/~route';
import { Route as AdminConsoleOrganisationManagementNewFromTemplateRouteRouteImport } from './routes/~admin-console/~organisation-management/~new-from-template/~route';
import { Route as AdminConsoleOrganisationManagementOrganisationsRouteRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~route';
import { Route as AdminConsolePlatformContentIndexRouteImport } from './routes/~admin-console/~platform-content/~index';
import { Route as AdminConsolePlatformContentAiTrainingRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~route';
import { Route as AdminConsolePlatformContentCommsAndContentRouteRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~route';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~route';
import { Route as AdminConsolePlatformContentMarketPdsRouteRouteImport } from './routes/~admin-console/~platform-content/~market-pds/~route';
import { Route as AdminConsolePlatformContentObligationsRouteRouteImport } from './routes/~admin-console/~platform-content/~obligations/~route';
import { Route as AdminConsolePlatformContentProductsRouteRouteImport } from './routes/~admin-console/~platform-content/~products/~route';
import { Route as AdminConsolePlatformContentWhatsNewRouteRouteImport } from './routes/~admin-console/~platform-content/~whats-new/~route';
import { Route as AdminConsoleToolsIndexRouteImport } from './routes/~admin-console/~tools/~index';
import { Route as AdminConsoleToolsDocumentToMarkdownRouteImport } from './routes/~admin-console/~tools/~document-to-markdown';
import { Route as AdminConsoleToolsFeatureFlagsRouteImport } from './routes/~admin-console/~tools/~feature-flags';
import { Route as AdminConsoleToolsSanitiseTextPiiRouteRouteImport } from './routes/~admin-console/~tools/~sanitise-text-pii/~route';
import { Route as AdminConsoleUserAccessIndexRouteImport } from './routes/~admin-console/~user-access/~index';
import { Route as AdminConsoleUserAccessAdminUsersRouteRouteImport } from './routes/~admin-console/~user-access/~admin-users/~route';
import { Route as AdminConsoleUserAccessSupportSessionsRouteRouteImport } from './routes/~admin-console/~user-access/~support-sessions/~route';
import { Route as AdminConsoleUserAccessUsersRouteRouteImport } from './routes/~admin-console/~user-access/~users/~route';
import { Route as ConsoleOrgIdIndexRouteImport } from './routes/~console.$orgId/~index';
import { Route as ConsoleOrgIdAttestationsRouteRouteImport } from './routes/~console.$orgId/~attestations/~route';
import { Route as ConsoleOrgIdClaimsRouteRouteImport } from './routes/~console.$orgId/~claims/~route';
import { Route as ConsoleOrgIdComplianceRouteRouteImport } from './routes/~console.$orgId/~compliance/~route';
import { Route as ConsoleOrgIdComponentShowcaseRouteRouteImport } from './routes/~console.$orgId/~component-showcase/~route';
import { Route as ConsoleOrgIdConfigurationRouteRouteImport } from './routes/~console.$orgId/~configuration/~route';
import { Route as ConsoleOrgIdControlsRouteRouteImport } from './routes/~console.$orgId/~controls/~route';
import { Route as ConsoleOrgIdDashboardRouteRouteImport } from './routes/~console.$orgId/~dashboard/~route';
import { Route as ConsoleOrgIdDocumentsRouteRouteImport } from './routes/~console.$orgId/~documents/~route';
import { Route as ConsoleOrgIdFaqRouteRouteImport } from './routes/~console.$orgId/~faq/~route';
import { Route as ConsoleOrgIdFleetPortalRouteRouteImport } from './routes/~console.$orgId/~fleet-portal/~route';
import { Route as ConsoleOrgIdGetFileRouteRouteImport } from './routes/~console.$orgId/~get-file/~route';
import { Route as ConsoleOrgIdMsprRouteRouteImport } from './routes/~console.$orgId/~mspr/~route';
import { Route as ConsoleOrgIdReportingRouteRouteImport } from './routes/~console.$orgId/~reporting/~route';
import { Route as ConsoleOrgIdRiskRouteRouteImport } from './routes/~console.$orgId/~risk/~route';
import { Route as ConsoleOrgIdToolsRouteRouteImport } from './routes/~console.$orgId/~tools/~route';
import { Route as ConsoleOrgIdToolsOnlyHomePageRouteImport } from './routes/~console.$orgId/~tools-only-home-page';
import { Route as ConsoleOrgIdUserSettingsRouteRouteImport } from './routes/~console.$orgId/~user-settings/~route';
import { Route as ConsoleOrgIdWorkloadManagerRouteRouteImport } from './routes/~console.$orgId/~workload-manager/~route';
import { Route as PublicLodgementSummaryAccessKeyRouteRouteImport } from './routes/~public/~lodgement-summary.$accessKey/~route';
import { Route as PublicNewComplaintByKeyKeyRouteRouteImport } from './routes/~public/~new-complaint-by-key.$key/~route';
import { Route as PublicNewComplaintOrgIdRouteRouteImport } from './routes/~public/~new-complaint.$orgId/~route';
import { Route as AdminConsoleAdvancedAppSettingsAllRouteRouteImport } from './routes/~admin-console/~advanced/~app-settings/~all/~route';
import { Route as AdminConsoleAdvancedAppSettingsWellKnownRouteImport } from './routes/~admin-console/~advanced/~app-settings/~well-known';
import { Route as AdminConsoleAdvancedInboundParseIndexRouteImport } from './routes/~admin-console/~advanced/~inbound-parse/~index';
import { Route as AdminConsoleAdvancedIndicatorsComplaintsRouteImport } from './routes/~admin-console/~advanced/~indicators/~complaints';
import { Route as AdminConsoleAdvancedIndicatorsIncidentsRouteImport } from './routes/~admin-console/~advanced/~indicators/~incidents';
import { Route as AdminConsoleAdvancedJobsIndexRouteImport } from './routes/~admin-console/~advanced/~jobs/~index';
import { Route as AdminConsoleAdvancedJobsDynamicRecurringRouteImport } from './routes/~admin-console/~advanced/~jobs/~dynamic-recurring';
import { Route as AdminConsoleAdvancedJobsOnDemandRouteImport } from './routes/~admin-console/~advanced/~jobs/~on-demand';
import { Route as AdminConsoleAdvancedJobsRecurringRouteImport } from './routes/~admin-console/~advanced/~jobs/~recurring';
import { Route as AdminConsoleAiEvalRunsEvalRunIdRouteRouteImport } from './routes/~admin-console/~ai/~eval-runs/~$evalRunId/~route';
import { Route as AdminConsoleAiEvalRunsCompareRouteRouteImport } from './routes/~admin-console/~ai/~eval-runs/~compare/~route';
import { Route as AdminConsoleMonitoringEmailActivityIndexRouteImport } from './routes/~admin-console/~monitoring/~email-activity/~index';
import { Route as AdminConsoleMonitoringEngagementIndexRouteImport } from './routes/~admin-console/~monitoring/~engagement/~index';
import { Route as AdminConsoleOrganisationManagementOrganisationsIndexRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~index';
import { Route as AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~$orgId/~route';
import { Route as AdminConsolePlatformContentAiTrainingIndexRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~index';
import { Route as AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~classification-example/~route';
import { Route as AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~vulnerability-example/~route';
import { Route as AdminConsolePlatformContentCommsAndContentAppTextRouteRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~app-text/~route';
import { Route as AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~comm-templates/~route';
import { Route as AdminConsolePlatformContentCommsAndContentFaqRouteRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~faq/~route';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesIndexRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~index';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~search/~route';
import { Route as AdminConsolePlatformContentMarketPdsAddRouteImport } from './routes/~admin-console/~platform-content/~market-pds/~add';
import { Route as AdminConsolePlatformContentObligationsIndexRouteImport } from './routes/~admin-console/~platform-content/~obligations/~index';
import { Route as AdminConsolePlatformContentObligationsConfigurationRouteRouteImport } from './routes/~admin-console/~platform-content/~obligations/~configuration/~route';
import { Route as AdminConsolePlatformContentObligationsControlsLibraryRouteRouteImport } from './routes/~admin-console/~platform-content/~obligations/~controls-library/~route';
import { Route as AdminConsolePlatformContentObligationsLibraryRouteRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~route';
import { Route as AdminConsolePlatformContentProductsServiceIdRouteImport } from './routes/~admin-console/~platform-content/~products/~$serviceId';
import { Route as AdminConsolePlatformContentWhatsNewIndexRouteImport } from './routes/~admin-console/~platform-content/~whats-new/~index';
import { Route as AdminConsolePlatformContentWhatsNewIdRouteImport } from './routes/~admin-console/~platform-content/~whats-new/~$id';
import { Route as AdminConsolePlatformContentWhatsNewNewRouteImport } from './routes/~admin-console/~platform-content/~whats-new/~new';
import { Route as AdminConsoleToolsSanitiseTextPiiCompareRouteImport } from './routes/~admin-console/~tools/~sanitise-text-pii/~compare';
import { Route as AdminConsoleToolsSanitiseTextPiiToolRouteImport } from './routes/~admin-console/~tools/~sanitise-text-pii/~tool';
import { Route as AdminConsoleUserAccessAdminUsersGrantRouteImport } from './routes/~admin-console/~user-access/~admin-users/~grant';
import { Route as ConsoleOrgIdAttestationsIndexRouteImport } from './routes/~console.$orgId/~attestations/~index';
import { Route as ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteImport } from './routes/~console.$orgId/~attestations/~scheduled-attestations/~route';
import { Route as ConsoleOrgIdAttestationsUserAttestationsRouteRouteImport } from './routes/~console.$orgId/~attestations/~user-attestations/~route';
import { Route as ConsoleOrgIdClaimsIndexRouteImport } from './routes/~console.$orgId/~claims/~index';
import { Route as ConsoleOrgIdComplianceIndexRouteImport } from './routes/~console.$orgId/~compliance/~index';
import { Route as ConsoleOrgIdComplianceCoiRouteRouteImport } from './routes/~console.$orgId/~compliance/~coi/~route';
import { Route as ConsoleOrgIdComplianceComplaintsRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~route';
import { Route as ConsoleOrgIdComplianceIncidentsRouteRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~route';
import { Route as ConsoleOrgIdComplianceIntakeRouteRouteImport } from './routes/~console.$orgId/~compliance/~intake/~route';
import { Route as ConsoleOrgIdComplianceObligationsRouteRouteImport } from './routes/~console.$orgId/~compliance/~obligations/~route';
import { Route as ConsoleOrgIdComplianceRegistersRouteRouteImport } from './routes/~console.$orgId/~compliance/~registers/~route';
import { Route as ConsoleOrgIdComplianceTrainingRouteRouteImport } from './routes/~console.$orgId/~compliance/~training/~route';
import { Route as ConsoleOrgIdComponentShowcaseIndexRouteImport } from './routes/~console.$orgId/~component-showcase/~index';
import { Route as ConsoleOrgIdComponentShowcaseAiChatTestRouteImport } from './routes/~console.$orgId/~component-showcase/~ai-chat-test';
import { Route as ConsoleOrgIdComponentShowcaseButtonIconTestRouteImport } from './routes/~console.$orgId/~component-showcase/~button-icon-test';
import { Route as ConsoleOrgIdComponentShowcaseButtonVariantsRouteImport } from './routes/~console.$orgId/~component-showcase/~button-variants';
import { Route as ConsoleOrgIdComponentShowcaseComponentShowcaseRouteImport } from './routes/~console.$orgId/~component-showcase/~component-showcase';
import { Route as ConsoleOrgIdComponentShowcaseDatePickerTestRouteImport } from './routes/~console.$orgId/~component-showcase/~date-picker-test';
import { Route as ConsoleOrgIdComponentShowcaseFitOnPageRouteImport } from './routes/~console.$orgId/~component-showcase/~fit-on-page';
import { Route as ConsoleOrgIdComponentShowcaseMarkdownShowcaseRouteImport } from './routes/~console.$orgId/~component-showcase/~markdown-showcase';
import { Route as ConsoleOrgIdComponentShowcaseTableShowcaseRouteImport } from './routes/~console.$orgId/~component-showcase/~table-showcase';
import { Route as ConsoleOrgIdComponentShowcaseTagVariantsRouteImport } from './routes/~console.$orgId/~component-showcase/~tag-variants';
import { Route as ConsoleOrgIdComponentShowcaseTiptapTestRouteImport } from './routes/~console.$orgId/~component-showcase/~tiptap-test';
import { Route as ConsoleOrgIdConfigurationIndexRouteImport } from './routes/~console.$orgId/~configuration/~index';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsRouteRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~route';
import { Route as ConsoleOrgIdConfigurationClientDatabaseRouteImport } from './routes/~console.$orgId/~configuration/~client-database';
import { Route as ConsoleOrgIdConfigurationComplianceRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsRouteRouteImport } from './routes/~console.$orgId/~configuration/~financials/~route';
import { Route as ConsoleOrgIdConfigurationFleetRouteRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringRouteRouteImport } from './routes/~console.$orgId/~configuration/~monitoring/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~route';
import { Route as ConsoleOrgIdConfigurationRiskRouteRouteImport } from './routes/~console.$orgId/~configuration/~risk/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementRouteRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~route';
import { Route as ConsoleOrgIdControlsIndexRouteImport } from './routes/~console.$orgId/~controls/~index';
import { Route as ConsoleOrgIdControlsActivitiesRouteRouteImport } from './routes/~console.$orgId/~controls/~activities/~route';
import { Route as ConsoleOrgIdControlsRegisterRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~route';
import { Route as ConsoleOrgIdControlsTestsRouteRouteImport } from './routes/~console.$orgId/~controls/~tests/~route';
import { Route as ConsoleOrgIdDashboardIndexRouteImport } from './routes/~console.$orgId/~dashboard/~index';
import { Route as ConsoleOrgIdDashboardClaimsRouteImport } from './routes/~console.$orgId/~dashboard/~claims';
import { Route as ConsoleOrgIdDashboardComplaintsRouteImport } from './routes/~console.$orgId/~dashboard/~complaints';
import { Route as ConsoleOrgIdDashboardIncidentsRouteImport } from './routes/~console.$orgId/~dashboard/~incidents';
import { Route as ConsoleOrgIdDashboardManagementRouteImport } from './routes/~console.$orgId/~dashboard/~management';
import { Route as ConsoleOrgIdDashboardPeopleAndCultureRouteImport } from './routes/~console.$orgId/~dashboard/~people-and-culture';
import { Route as ConsoleOrgIdDashboardRisksRouteImport } from './routes/~console.$orgId/~dashboard/~risks';
import { Route as ConsoleOrgIdDebugIndexRouteImport } from './routes/~console.$orgId/~debug/~index';
import { Route as ConsoleOrgIdFleetPortalIndexRouteImport } from './routes/~console.$orgId/~fleet-portal/~index';
import { Route as ConsoleOrgIdFleetPortalAuthorisationsRouteImport } from './routes/~console.$orgId/~fleet-portal/~authorisations';
import { Route as ConsoleOrgIdFleetPortalClaimsRouteRouteImport } from './routes/~console.$orgId/~fleet-portal/~claims/~route';
import { Route as ConsoleOrgIdFleetPortalDashboardRouteImport } from './routes/~console.$orgId/~fleet-portal/~dashboard';
import { Route as ConsoleOrgIdFleetPortalFleetRouteImport } from './routes/~console.$orgId/~fleet-portal/~fleet';
import { Route as ConsoleOrgIdFleetPortalSlaRouteImport } from './routes/~console.$orgId/~fleet-portal/~sla';
import { Route as ConsoleOrgIdMsprMspExceptionsRouteRouteImport } from './routes/~console.$orgId/~mspr/~msp-exceptions/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~route';
import { Route as ConsoleOrgIdReportingAddRouteImport } from './routes/~console.$orgId/~reporting/~add';
import { Route as ConsoleOrgIdRiskIndexRouteImport } from './routes/~console.$orgId/~risk/~index';
import { Route as ConsoleOrgIdRiskRasRouteRouteImport } from './routes/~console.$orgId/~risk/~ras/~route';
import { Route as ConsoleOrgIdRiskRegisterRouteRouteImport } from './routes/~console.$orgId/~risk/~register/~route';
import { Route as ConsoleOrgIdToolsIndexRouteImport } from './routes/~console.$orgId/~tools/~index';
import { Route as ConsoleOrgIdToolsAutoDetectRouteRouteImport } from './routes/~console.$orgId/~tools/~auto-detect/~route';
import { Route as ConsoleOrgIdToolsComplianceAuditRouteRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~route';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerRouteRouteImport } from './routes/~console.$orgId/~tools/~document-analyzer/~route';
import { Route as ConsoleOrgIdToolsPdsCompareRouteRouteImport } from './routes/~console.$orgId/~tools/~pds-compare/~route';
import { Route as ConsoleOrgIdToolsWebsiteCheckerRouteRouteImport } from './routes/~console.$orgId/~tools/~website-checker/~route';
import { Route as ConsoleOrgIdUserSettingsIndexRouteImport } from './routes/~console.$orgId/~user-settings/~index';
import { Route as ConsoleOrgIdUserSettingsNotificationsRouteImport } from './routes/~console.$orgId/~user-settings/~notifications';
import { Route as ConsoleOrgIdUserSettingsProfileRouteImport } from './routes/~console.$orgId/~user-settings/~profile';
import { Route as ConsoleOrgIdWorkloadManagerIndexRouteImport } from './routes/~console.$orgId/~workload-manager/~index';
import { Route as ConsoleOrgIdWorkloadManagerComplaintsRouteImport } from './routes/~console.$orgId/~workload-manager/~complaints';
import { Route as ConsoleOrgIdWorkloadManagerEmailsRouteRouteImport } from './routes/~console.$orgId/~workload-manager/~emails/~route';
import { Route as ConsoleOrgIdWorkloadManagerTasksRouteRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~route';
import { Route as PublicOrgIdComplaintNewRouteRouteImport } from './routes/~public/~$orgId/~complaint.new/~route';
import { Route as AdminConsoleAdvancedAppSettingsAllAddRouteImport } from './routes/~admin-console/~advanced/~app-settings/~all/~add';
import { Route as AdminConsoleAdvancedJobsDynamicRecurringJobIdRouteImport } from './routes/~admin-console/~advanced/~jobs/~dynamic-recurring.$jobId';
import { Route as AdminConsoleAdvancedJobsOnDemandJobIdRouteImport } from './routes/~admin-console/~advanced/~jobs/~on-demand.$jobId';
import { Route as AdminConsoleAdvancedJobsRecurringJobIdRouteImport } from './routes/~admin-console/~advanced/~jobs/~recurring.$jobId';
import { Route as AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~$orgId/~subscriptions';
import { Route as AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~$orgId/~users/~route';
import { Route as AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~$orgId/~wallet';
import { Route as AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~classification-example/~create/~route';
import { Route as AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~vulnerability-example/~create/~route';
import { Route as AdminConsolePlatformContentCommsAndContentAppTextAddRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~app-text/~add';
import { Route as AdminConsolePlatformContentCommsAndContentCommTemplatesAddRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~comm-templates/~add';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~route';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~search/~add';
import { Route as AdminConsolePlatformContentMarketPdsEditIdRouteImport } from './routes/~admin-console/~platform-content/~market-pds/~edit.$id';
import { Route as AdminConsolePlatformContentObligationsControlsLibraryIndexRouteImport } from './routes/~admin-console/~platform-content/~obligations/~controls-library/~index';
import { Route as AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteImport } from './routes/~admin-console/~platform-content/~obligations/~controls-library/~$id/~route';
import { Route as AdminConsolePlatformContentObligationsLibraryIndexRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~index';
import { Route as AdminConsoleUserAccessAdminUsersEditUserIdRouteImport } from './routes/~admin-console/~user-access/~admin-users/~edit.$userId';
import { Route as AdminConsoleUserAccessUsersEditUserIdRouteImport } from './routes/~admin-console/~user-access/~users/~edit.$userId';
import { Route as AdminConsoleUserAccessUsersViewUserIdRouteImport } from './routes/~admin-console/~user-access/~users/~view.$userId';
import { Route as ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRouteImport } from './routes/~console.$orgId/~attestations/~scheduled-attestations/~$scheduleId/~route';
import { Route as ConsoleOrgIdAttestationsScheduledAttestationsNewRouteImport } from './routes/~console.$orgId/~attestations/~scheduled-attestations/~new';
import { Route as ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRouteImport } from './routes/~console.$orgId/~attestations/~user-attestations/~$attestationId/~route';
import { Route as ConsoleOrgIdAttestationsUserAttestationsSendRouteImport } from './routes/~console.$orgId/~attestations/~user-attestations/~send';
import { Route as ConsoleOrgIdClaimsDetailsIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceCoiIndexRouteImport } from './routes/~console.$orgId/~compliance/~coi/~index';
import { Route as ConsoleOrgIdComplianceCoiAddRouteRouteImport } from './routes/~console.$orgId/~compliance/~coi/~add/~route';
import { Route as ConsoleOrgIdComplianceComplaintsIndexRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~index';
import { Route as ConsoleOrgIdComplianceComplaintsAddRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~add/~route';
import { Route as ConsoleOrgIdComplianceIncidentsIndexRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~index';
import { Route as ConsoleOrgIdComplianceIncidentsAddRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~add';
import { Route as ConsoleOrgIdComplianceObligationsIndexRouteImport } from './routes/~console.$orgId/~compliance/~obligations/~index';
import { Route as ConsoleOrgIdComplianceObligationsAddRouteRouteImport } from './routes/~console.$orgId/~compliance/~obligations/~add/~route';
import { Route as ConsoleOrgIdComplianceRegistersIndexRouteImport } from './routes/~console.$orgId/~compliance/~registers/~index';
import { Route as ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteImport } from './routes/~console.$orgId/~compliance/~registers/~$registerId/~route';
import { Route as ConsoleOrgIdComplianceTrainingIndexRouteImport } from './routes/~console.$orgId/~compliance/~training/~index';
import { Route as ConsoleOrgIdComplianceTrainingSearchRouteRouteImport } from './routes/~console.$orgId/~compliance/~training/~search/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~api-tokens/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~form-designer/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~mcp-access/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~insurers/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~questionnaire/~route';
import { Route as ConsoleOrgIdConfigurationClientDatabaseSplatRouteImport } from './routes/~console.$orgId/~configuration/~client-database.$';
import { Route as ConsoleOrgIdConfigurationComplianceIndexRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~index';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~attestations/~route';
import { Route as ConsoleOrgIdConfigurationComplianceAutoDetectRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~auto-detect/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~compliance-audit/~route';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~general/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~route';
import { Route as ConsoleOrgIdConfigurationComplianceObligationsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~obligations';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~training/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingRouteRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRouteImport } from './routes/~console.$orgId/~configuration/~financials/~expenses-billing/~route';
import { Route as ConsoleOrgIdConfigurationFinancialsPaymentsRouteRouteImport } from './routes/~console.$orgId/~configuration/~financials/~payments/~route';
import { Route as ConsoleOrgIdConfigurationFleetIndexRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~index';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~route';
import { Route as ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~delegated-authority/~route';
import { Route as ConsoleOrgIdConfigurationFleetEscalationsRouteRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~escalations/~route';
import { Route as ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~portal-claim-page/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRouteImport } from './routes/~console.$orgId/~configuration/~monitoring/~audit-trail/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRouteImport } from './routes/~console.$orgId/~configuration/~monitoring/~email-activity/~route';
import { Route as ConsoleOrgIdConfigurationMonitoringStatisticsRouteRouteImport } from './routes/~console.$orgId/~configuration/~monitoring/~statistics/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~fleet-escalations';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~support-sessions/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsSystemRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~system/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsTasksRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~tasks/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~trash/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~users/~route';
import { Route as ConsoleOrgIdConfigurationRiskIndexRouteImport } from './routes/~console.$orgId/~configuration/~risk/~index';
import { Route as ConsoleOrgIdConfigurationRiskAppetiteRouteImport } from './routes/~console.$orgId/~configuration/~risk/~appetite';
import { Route as ConsoleOrgIdConfigurationRiskCategoriesRouteImport } from './routes/~console.$orgId/~configuration/~risk/~categories';
import { Route as ConsoleOrgIdConfigurationRiskMatrixRouteImport } from './routes/~console.$orgId/~configuration/~risk/~matrix';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~route';
import { Route as ConsoleOrgIdControlsRegisterIndexRouteImport } from './routes/~console.$orgId/~controls/~register/~index';
import { Route as ConsoleOrgIdControlsRegisterAddRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~add/~route';
import { Route as ConsoleOrgIdDocumentsDetailsFileIdRouteRouteImport } from './routes/~console.$orgId/~documents/~details.$fileId/~route';
import { Route as ConsoleOrgIdFleetPortalClaimsIndexRouteImport } from './routes/~console.$orgId/~fleet-portal/~claims/~index';
import { Route as ConsoleOrgIdMsprServiceProvidersIndexRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~index';
import { Route as ConsoleOrgIdMsprServiceProvidersSearchRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~search/~route';
import { Route as ConsoleOrgIdRiskRasIndexRouteImport } from './routes/~console.$orgId/~risk/~ras/~index';
import { Route as ConsoleOrgIdRiskRegisterIndexRouteImport } from './routes/~console.$orgId/~risk/~register/~index';
import { Route as ConsoleOrgIdToolsAutoDetectDashboardRouteImport } from './routes/~console.$orgId/~tools/~auto-detect/~dashboard';
import { Route as ConsoleOrgIdToolsAutoDetectInboxRouteRouteImport } from './routes/~console.$orgId/~tools/~auto-detect/~inbox/~route';
import { Route as ConsoleOrgIdToolsComplianceAuditIndexRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~index';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~overview/~route';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerIndexRouteImport } from './routes/~console.$orgId/~tools/~document-analyzer/~index';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteImport } from './routes/~console.$orgId/~tools/~document-analyzer/~history/~route';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerUploadRouteImport } from './routes/~console.$orgId/~tools/~document-analyzer/~upload';
import { Route as ConsoleOrgIdToolsPdsCompareIndexRouteImport } from './routes/~console.$orgId/~tools/~pds-compare/~index';
import { Route as ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteImport } from './routes/~console.$orgId/~tools/~pds-compare/~pds-documents/~route';
import { Route as ConsoleOrgIdToolsWebsiteCheckerIndexRouteImport } from './routes/~console.$orgId/~tools/~website-checker/~index';
import { Route as ConsoleOrgIdUserSettingsAuthorisedAppsIndexRouteImport } from './routes/~console.$orgId/~user-settings/~authorised-apps/~index';
import { Route as ConsoleOrgIdWorkloadManagerTasksIndexRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~index';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~route';
import { Route as ConsoleOrgIdWorkloadManagerTasksListRouteRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~list/~route';
import { Route as PublicOrgIdInvoiceViewAccessKeyRouteRouteImport } from './routes/~public/~$orgId/~invoice.view.$accessKey/~route';
import { Route as AdminConsoleAdvancedAppSettingsAllEditNameRouteImport } from './routes/~admin-console/~advanced/~app-settings/~all/~edit.$name';
import { Route as AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRouteImport } from './routes/~admin-console/~monitoring/~compliance-audit/~$orgId.$complianceAuditId.statistics';
import { Route as AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~classification-example/~edit.$id/~route';
import { Route as AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~classification-example/~view.$id/~route';
import { Route as AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~vulnerability-example/~edit.$id/~route';
import { Route as AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRouteImport } from './routes/~admin-console/~platform-content/~ai-training/~vulnerability-example/~view.$id/~route';
import { Route as AdminConsolePlatformContentCommsAndContentAppTextEditIdRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~app-text/~edit.$id';
import { Route as AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRouteImport } from './routes/~admin-console/~platform-content/~comms-and-content/~comm-templates/~edit.$commTemplateId';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~changes';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~evidence-types/~route';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~principles/~route';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~structure';
import { Route as AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRouteImport } from './routes/~admin-console/~platform-content/~obligations/~controls-library/~$id/~details';
import { Route as AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRouteImport } from './routes/~admin-console/~platform-content/~obligations/~controls-library/~$id/~history';
import { Route as AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~details.$id/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdActivityRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~activity/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~ai-assessment/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~comms/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~contacts/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~expenses/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdHistoryRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~history/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~library/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdManageRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~policy-info/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~product-type-data/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~vehicle/~route';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdRouteRouteImport } from './routes/~console.$orgId/~compliance/~coi/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteImport } from './routes/~console.$orgId/~compliance/~obligations/~details.$id/~route';
import { Route as ConsoleOrgIdComplianceRegistersRegisterIdIndexRouteImport } from './routes/~console.$orgId/~compliance/~registers/~$registerId/~index';
import { Route as ConsoleOrgIdComplianceTrainingSearchAddRouteImport } from './routes/~console.$orgId/~compliance/~training/~search/~add';
import { Route as ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteImport } from './routes/~console.$orgId/~compliance/~training/~user.$userId/~route';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~form-designer/~index';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~form-designer/~$formDefinitionId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~catastrophe-events/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~claim-flags/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~documents';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~general/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~handling-standards';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~id';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~questionnaire/~add';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~attestations/~user-attestations/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsIndexRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~index';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsBrandsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~brands';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~custom-fields';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~flags/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~general';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsRulesRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~rules';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralIndexRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~general/~index';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~general/~asic-products';
import { Route as ConsoleOrgIdConfigurationComplianceGeneralDocumentsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~general/~documents';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsIndexRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~index';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~custom-fields';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~flags/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~route';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsRulesRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~rules';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~definitions/~route';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDocumentsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~documents';
import { Route as ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~governance-config/~route';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingIndexRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~training/~index';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~training/~custom-fields';
import { Route as ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~training/~training-periods';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingBalanceRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~balance';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~billing-info';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingInvoicesRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~invoices';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingTransactionsRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~transactions';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingUsageRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~usage';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseAddRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-signatures/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-templates/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsUsersIndexRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~users/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersAddRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~add';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~definitions';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~details.$id/~route';
import { Route as ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRouteImport } from './routes/~console.$orgId/~fleet-portal/~claims/~details.$claimId';
import { Route as ConsoleOrgIdMsprMspExceptionsEditIdRouteImport } from './routes/~console.$orgId/~mspr/~msp-exceptions/~edit.$id';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersSearchAddRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~search/~add';
import { Route as ConsoleOrgIdRiskRasDetailsIdRouteRouteImport } from './routes/~console.$orgId/~risk/~ras/~details.$id/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdRouteRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~route';
import { Route as ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~details.$complianceAuditId';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewIndexRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~overview/~index';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewInsightsRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~overview/~insights';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~overview/~search/~route';
import { Route as ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRouteImport } from './routes/~console.$orgId/~tools/~website-checker/~report.$id/~route';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarAddRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~add';
import { Route as ConsoleOrgIdWorkloadManagerTasksListAddRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~list/~add';
import { Route as PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport } from './routes/~public/~claim-lodgement.$orgId.$pdsVersionId.$questionnaireId.$productTypeId/~route';
import { Route as AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRouteImport } from './routes/~admin-console/~organisation-management/~organisations/~$orgId/~users/~edit.$userId';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~evidence-types/~add';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~principles/~add';
import { Route as AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~details.$id/~ai-related';
import { Route as AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~details.$id/~document-analyser';
import { Route as AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~details.$id/~history';
import { Route as AdminConsolePlatformContentObligationsLibraryDetailsIdManageRouteImport } from './routes/~admin-console/~platform-content/~obligations/~library/~details.$id/~manage';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~comms/~add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~contacts/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdExpensesAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~expenses/~add';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdIndexRouteImport } from './routes/~console.$orgId/~compliance/~coi/~details.$id/~index';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdLibraryRouteImport } from './routes/~console.$orgId/~compliance/~coi/~details.$id/~library';
import { Route as ConsoleOrgIdComplianceCoiDetailsIdManageRouteImport } from './routes/~console.$orgId/~compliance/~coi/~details.$id/~manage';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdIndexRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~index';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~comms/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~history/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~library/~route';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdIndexRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~index';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~history/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~library/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdComplianceObligationsDetailsIdDebugRouteImport } from './routes/~console.$orgId/~compliance/~obligations/~details.$id/~debug';
import { Route as ConsoleOrgIdComplianceObligationsDetailsIdManageRouteImport } from './routes/~console.$orgId/~compliance/~obligations/~details.$id/~manage';
import { Route as ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRouteImport } from './routes/~console.$orgId/~compliance/~registers/~$registerId/~records.$recordId';
import { Route as ConsoleOrgIdComplianceTrainingUserUserIdAddRouteImport } from './routes/~console.$orgId/~compliance/~training/~user.$userId/~add';
import { Route as ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRouteImport } from './routes/~console.$orgId/~configuration/~api-integrations/~form-designer/~$formDefinitionId/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~catastrophe-events/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~claim-flags/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~index';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~states.$id/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~edit.$productId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~questionnaire/~edit.$questionnaireId';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~attestations/~user-attestations/~add';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~flags/~add';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~flags/~add';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~index';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~incident-details';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~lodgement';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~rectification';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~general/~timeline';
import { Route as ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~governance-config/~add';
import { Route as ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRouteImport } from './routes/~console.$orgId/~configuration/~financials/~billing/~payment.success';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-signatures/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-templates/~add';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~details.$id/~route';
import { Route as ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~users/~details.$userId/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~search/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~search/~definitions';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~search/~list';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~history/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~library/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~action-plan/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~assessment/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdHistoryRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~history';
import { Route as ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRouteImport } from './routes/~console.$orgId/~tools/~auto-detect/~inbox/~$id/~review-email-classification';
import { Route as ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~details.$complianceAuditId.statistics';
import { Route as ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRouteImport } from './routes/~console.$orgId/~tools/~compliance-audit/~overview/~search/~add';
import { Route as ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRouteImport } from './routes/~console.$orgId/~tools/~document-analyzer/~history/~$id/~results';
import { Route as ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRouteImport } from './routes/~console.$orgId/~tools/~pds-compare/~pds-documents/~edit.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksListDetailsIdRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~list/~details.$id';
import { Route as PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport } from './routes/~public/~$orgId/~claim.lodgement-lookup.$pdsVersionId.$questionnaireId.$productTypeId/~route';
import { Route as PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport } from './routes/~public/~$orgId/~claim.lodgement.$pdsVersionId.$questionnaireId.$productTypeId/~route';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~evidence-types/~edit.$complianceAuditTemplateEvidenceTypeId';
import { Route as AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRouteImport } from './routes/~admin-console/~platform-content/~compliance-audit-templates/~details.$complianceAuditTemplateId/~principles/~edit.$complianceAuditTemplatePrincipleId';
import { Route as ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~activity/~add.phone';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsAddEmailRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~comms/~add/~email';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsAddSmsRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~comms/~add/~sms';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~comms/~message.$messageId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~comms/~reply.$messageId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~contacts/~edit.$contactId';
import { Route as ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~expenses/~edit.$expenseItemId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~manage/~strategies.add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~manage/~supplier-jobs/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~manage/~supplier-jobs/~add-supplier';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~manage/~incidents';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~manage/~complaints';
import { Route as ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRouteImport } from './routes/~console.$orgId/~compliance/~training/~user.$userId/~edit.$recordId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~catastrophe-events/~edit.$catastropheEventId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~claim-flags/~edit.$claimFlagId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~general/~claim-statuses/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~conditions';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~exclusions';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~guide';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~limits-excesses';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~loss-causes';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~overview';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~policy-trigger-mapping';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~product-info';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~decision-engine/~red-flags';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~edit.$pdsId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~pds-text.$pdsId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~$productTypeId/~pds.$pdsId/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~data-fields';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~policy-fields';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~third-party-contact-type/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~cost-codes';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~sections';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~tax';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~transaction-types/~route';
import { Route as ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~attestations/~user-attestations/~edit.$id/~route';
import { Route as ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~complaints/~flags/~edit.$complaintFlagId';
import { Route as ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~incidents/~flags/~edit.$incidentFlagId';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~identified/~add';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~definitions/~categories/~add';
import { Route as ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~governance-config/~edit.$id';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~clients';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~drivers';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~overview';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~portal-access';
import { Route as ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRouteImport } from './routes/~console.$orgId/~configuration/~fleet/~client-database/~details.$id/~vehicles';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-signatures/~edit.$commSignatureId';
import { Route as ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~communication/~comm-templates/~edit.$communicationTemplateId';
import { Route as ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRouteImport } from './routes/~console.$orgId/~configuration/~org-settings/~handling-parties/~details.$id/~users';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~details.$id/~index';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~details.$id/~$';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~details.$id/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~details.$id/~activity.$activityId/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~details.$id/~activity.add/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~details.$id/~test.$testId/~route';
import { Route as ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRouteImport } from './routes/~console.$orgId/~controls/~register/~details.$id/~test.add/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~add';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~assessment/~incidents';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.control_activity.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.control_test.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.msp_governance_check.$id';
import { Route as ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRouteImport } from './routes/~console.$orgId/~workload-manager/~tasks/~calendar/~details.risk_action.$id';
import { Route as ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~activity/~edit.phone.$callLogId';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~contacts/~suppliers/~details.$supplierId';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~contacts/~suppliers/~reassign.$supplierId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~manage/~supplier-jobs/~edit.$jobId';
import { Route as ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRouteImport } from './routes/~console.$orgId/~compliance/~complaints/~details.$id/~manage/~note.add/~route';
import { Route as ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRouteImport } from './routes/~console.$orgId/~compliance/~incidents/~details.$id/~manage/~note.add/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~general/~claim-statuses/~edit.$claimStatusId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~$taskListId/~tasks/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~edit.$id';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~third-party-contact-type/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~transaction-types/~add';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~excluded/~edit.$id';
import { Route as ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~critical-operations/~identified/~edit.$id';
import { Route as ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRouteImport } from './routes/~console.$orgId/~configuration/~compliance/~mspr/~definitions/~categories/~edit.$id';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~check.$checkId/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~check.add/~route';
import { Route as ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRouteImport } from './routes/~console.$orgId/~mspr/~service-providers/~details.$id/~manage/~edit.$arrangementId';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~action-plan/~action-plan.$actionPlanId/~route';
import { Route as ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRouteImport } from './routes/~console.$orgId/~risk/~register/~details.$id/~action-plan/~action-plan.add/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~contacts/~suppliers/~reassign.$supplierId/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~compensation-payments.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~excess-payments.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~add/~suppliers.add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~financials/~route';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~library';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~payee';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~payment';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~library';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~manage';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~excesses/~details.$excessId/~payments';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~compensation-payments';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~library';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~reserve-adjustments/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~$taskListId/~tasks/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~edit.$productTypeId/~third-party-contact-type/~edit.$thirdPartyContactTypeId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~product-types/~financials.$id/~transaction-types/~edit.$transactionTypeId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~route';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~details.$id/~contacts/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~reserves/~details.$reserveId/~reserve-adjustments/~add';
import { Route as ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~claims/~task-lists/~search/~$taskListId/~tasks/~edit.$id';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~contact-types/~route';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~details';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~documents';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~fields';
import { Route as ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRouteImport } from './routes/~console.$orgId/~configuration/~vendor-management/~suppliers/~list/~details.$id/~contacts/~edit.$contactId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~contact-types/~add';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~financials/~compensation-payments.details.$compensationPaymentId';
import { Route as ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRouteImport } from './routes/~console.$orgId/~claims/~details.$id/~financials/~compensations/~details.$compensationId/~financials/~excess-payments.details.$excessPaymentId';
import { Route as ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRouteImport } from './routes/~console.$orgId/~configuration/~claims-products/~products-v2/~details.$productId/~product-versions/~details.$productVersionId/~contact-types/~edit.$contactTypeId';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminConsentRoute = AdminConsentRouteImport.update({
  id: '/admin-consent',
  path: '/admin-consent',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminConsoleRouteRoute = AdminConsoleRouteRouteImport.update({
  id: '/admin-console',
  path: '/admin-console',
  getParentRoute: () => rootRouteImport,
} as any);
const AttestationRouteRoute = AttestationRouteRouteImport.update({
  id: '/attestation',
  path: '/attestation',
  getParentRoute: () => rootRouteImport,
} as any);
const InviteRouteRoute = InviteRouteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any);
const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any);
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any);
const NotSupportedRoute = NotSupportedRouteImport.update({
  id: '/not-supported',
  path: '/not-supported',
  getParentRoute: () => rootRouteImport,
} as any);
const OauthRouteRoute = OauthRouteRouteImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => rootRouteImport,
} as any);
const OrgSwitchedRoute = OrgSwitchedRouteImport.update({
  id: '/org-switched',
  path: '/org-switched',
  getParentRoute: () => rootRouteImport,
} as any);
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRouteImport,
} as any);
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any);
const TermsAcceptanceRouteRoute = TermsAcceptanceRouteRouteImport.update({
  id: '/terms-acceptance',
  path: '/terms-acceptance',
  getParentRoute: () => rootRouteImport,
} as any);
const authenticationAdminLoginRoute =
  authenticationAdminLoginRouteImport.update({
    id: '/(authentication)/admin-login',
    path: '/admin-login',
    getParentRoute: () => rootRouteImport,
  } as any);
const authenticationCallbackRoute = authenticationCallbackRouteImport.update({
  id: '/(authentication)/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any);
const authenticationLoginRoute = authenticationLoginRouteImport.update({
  id: '/(authentication)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const authenticationLogoutRoute = authenticationLogoutRouteImport.update({
  id: '/(authentication)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any);
const authenticationLogoutinRoute = authenticationLogoutinRouteImport.update({
  id: '/(authentication)/logoutin',
  path: '/logoutin',
  getParentRoute: () => rootRouteImport,
} as any);
const authenticationOrgMismatchRoute =
  authenticationOrgMismatchRouteImport.update({
    id: '/(authentication)/org-mismatch',
    path: '/org-mismatch',
    getParentRoute: () => rootRouteImport,
  } as any);
const authenticationPaymentPendingRoute =
  authenticationPaymentPendingRouteImport.update({
    id: '/(authentication)/payment-pending',
    path: '/payment-pending',
    getParentRoute: () => rootRouteImport,
  } as any);
const AdminConsoleIndexRoute = AdminConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminConsoleRouteRoute,
} as any);
const AdminConsoleAdvancedRouteRoute =
  AdminConsoleAdvancedRouteRouteImport.update({
    id: '/advanced',
    path: '/advanced',
    getParentRoute: () => AdminConsoleRouteRoute,
  } as any);
const AdminConsoleAiRouteRoute = AdminConsoleAiRouteRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AdminConsoleRouteRoute,
} as any);
const AdminConsoleAuthorisedAppsRouteRoute =
  AdminConsoleAuthorisedAppsRouteRouteImport.update({
    id: '/authorised-apps',
    path: '/authorised-apps',
    getParentRoute: () => AdminConsoleRouteRoute,
  } as any);
const AdminConsoleMonitoringRouteRoute =
  AdminConsoleMonitoringRouteRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => AdminConsoleRouteRoute,
  } as any);
const AdminConsoleOrganisationManagementRouteRoute =
  AdminConsoleOrganisationManagementRouteRouteImport.update({
    id: '/organisation-management',
    path: '/organisation-management',
    getParentRoute: () => AdminConsoleRouteRoute,
  } as any);
const AdminConsolePlatformContentRouteRoute =
  AdminConsolePlatformContentRouteRouteImport.update({
    id: '/platform-content',
    path: '/platform-content',
    getParentRoute: () => AdminConsoleRouteRoute,
  } as any);
const AdminConsoleToolsRouteRoute = AdminConsoleToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => AdminConsoleRouteRoute,
} as any);
const AdminConsoleUserAccessRouteRoute =
  AdminConsoleUserAccessRouteRouteImport.update({
    id: '/user-access',
    path: '/user-access',
    getParentRoute: () => AdminConsoleRouteRoute,
  } as any);
const AttestationTokenRoute = AttestationTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => AttestationRouteRoute,
} as any);
const ConsoleOrgIdRouteRoute = ConsoleOrgIdRouteRouteImport.update({
  id: '/console/$orgId',
  path: '/console/$orgId',
  getParentRoute: () => rootRouteImport,
} as any);
const OauthAuthorizeRoute = OauthAuthorizeRouteImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => OauthRouteRoute,
} as any);
const PasswordResetRequestRoute = PasswordResetRequestRouteImport.update({
  id: '/password-reset/request',
  path: '/password-reset/request',
  getParentRoute: () => rootRouteImport,
} as any);
const PasswordResetResetRoute = PasswordResetResetRouteImport.update({
  id: '/password-reset/reset',
  path: '/password-reset/reset',
  getParentRoute: () => rootRouteImport,
} as any);
const PublicOrgIdRouteRoute = PublicOrgIdRouteRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => PublicRouteRoute,
} as any);
const WhatsNewReleaseIdRoute = WhatsNewReleaseIdRouteImport.update({
  id: '/whats-new/$releaseId',
  path: '/whats-new/$releaseId',
  getParentRoute: () => rootRouteImport,
} as any);
const authenticationChangeOrgOrgIdRoute =
  authenticationChangeOrgOrgIdRouteImport.update({
    id: '/(authentication)/change-org/$orgId',
    path: '/change-org/$orgId',
    getParentRoute: () => rootRouteImport,
  } as any);
const AdminConsoleAdvancedIndexRoute =
  AdminConsoleAdvancedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedAppSettingsRouteRoute =
  AdminConsoleAdvancedAppSettingsRouteRouteImport.update({
    id: '/app-settings',
    path: '/app-settings',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedClaimsRoute =
  AdminConsoleAdvancedClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedDbStatsRoute =
  AdminConsoleAdvancedDbStatsRouteImport.update({
    id: '/db-stats',
    path: '/db-stats',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedDbUpgradesRoute =
  AdminConsoleAdvancedDbUpgradesRouteImport.update({
    id: '/db-upgrades',
    path: '/db-upgrades',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedInboundEmailArchiveRouteRoute =
  AdminConsoleAdvancedInboundEmailArchiveRouteRouteImport.update({
    id: '/inbound-email-archive',
    path: '/inbound-email-archive',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedInboundParseRouteRoute =
  AdminConsoleAdvancedInboundParseRouteRouteImport.update({
    id: '/inbound-parse',
    path: '/inbound-parse',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedIndicatorsRouteRoute =
  AdminConsoleAdvancedIndicatorsRouteRouteImport.update({
    id: '/indicators',
    path: '/indicators',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedIntegrationTestsRoute =
  AdminConsoleAdvancedIntegrationTestsRouteImport.update({
    id: '/integration-tests',
    path: '/integration-tests',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedJobsRouteRoute =
  AdminConsoleAdvancedJobsRouteRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedPlaygroundRouteRoute =
  AdminConsoleAdvancedPlaygroundRouteRouteImport.update({
    id: '/playground',
    path: '/playground',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAdvancedWeaviateRoute =
  AdminConsoleAdvancedWeaviateRouteImport.update({
    id: '/weaviate',
    path: '/weaviate',
    getParentRoute: () => AdminConsoleAdvancedRouteRoute,
  } as any);
const AdminConsoleAiAiFeedbackRouteRoute =
  AdminConsoleAiAiFeedbackRouteRouteImport.update({
    id: '/ai-feedback',
    path: '/ai-feedback',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiAiPromptsRouteRoute =
  AdminConsoleAiAiPromptsRouteRouteImport.update({
    id: '/ai-prompts',
    path: '/ai-prompts',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiEvalRunsRouteRoute =
  AdminConsoleAiEvalRunsRouteRouteImport.update({
    id: '/eval-runs',
    path: '/eval-runs',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiModelPricingRouteRoute =
  AdminConsoleAiModelPricingRouteRouteImport.update({
    id: '/model-pricing',
    path: '/model-pricing',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiModelTiersRouteRoute =
  AdminConsoleAiModelTiersRouteRouteImport.update({
    id: '/model-tiers',
    path: '/model-tiers',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiRequestAnalyticsRouteRoute =
  AdminConsoleAiRequestAnalyticsRouteRouteImport.update({
    id: '/request-analytics',
    path: '/request-analytics',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiStatisticsRouteRoute =
  AdminConsoleAiStatisticsRouteRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleAiUsageBillingRouteRoute =
  AdminConsoleAiUsageBillingRouteRouteImport.update({
    id: '/usage-billing',
    path: '/usage-billing',
    getParentRoute: () => AdminConsoleAiRouteRoute,
  } as any);
const AdminConsoleMonitoringIndexRoute =
  AdminConsoleMonitoringIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringAuditTrailRouteRoute =
  AdminConsoleMonitoringAuditTrailRouteRouteImport.update({
    id: '/audit-trail',
    path: '/audit-trail',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringAxiomLogsRouteRoute =
  AdminConsoleMonitoringAxiomLogsRouteRouteImport.update({
    id: '/axiom-logs',
    path: '/axiom-logs',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringComplianceRouteRoute =
  AdminConsoleMonitoringComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringComplianceAuditRouteRoute =
  AdminConsoleMonitoringComplianceAuditRouteRouteImport.update({
    id: '/compliance-audit',
    path: '/compliance-audit',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringEmailActivityRouteRoute =
  AdminConsoleMonitoringEmailActivityRouteRouteImport.update({
    id: '/email-activity',
    path: '/email-activity',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringEngagementRouteRoute =
  AdminConsoleMonitoringEngagementRouteRouteImport.update({
    id: '/engagement',
    path: '/engagement',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringLlmLogsRouteRoute =
  AdminConsoleMonitoringLlmLogsRouteRouteImport.update({
    id: '/llm-logs',
    path: '/llm-logs',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringLlmStatsRouteRoute =
  AdminConsoleMonitoringLlmStatsRouteRouteImport.update({
    id: '/llm-stats',
    path: '/llm-stats',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringMemoryRouteRoute =
  AdminConsoleMonitoringMemoryRouteRouteImport.update({
    id: '/memory',
    path: '/memory',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringReportsRouteRoute =
  AdminConsoleMonitoringReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleMonitoringStatisticsRouteRoute =
  AdminConsoleMonitoringStatisticsRouteRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => AdminConsoleMonitoringRouteRoute,
  } as any);
const AdminConsoleOrganisationManagementNewRouteRoute =
  AdminConsoleOrganisationManagementNewRouteRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminConsoleOrganisationManagementRouteRoute,
  } as any);
const AdminConsoleOrganisationManagementNewFromTemplateRouteRoute =
  AdminConsoleOrganisationManagementNewFromTemplateRouteRouteImport.update({
    id: '/new-from-template',
    path: '/new-from-template',
    getParentRoute: () => AdminConsoleOrganisationManagementRouteRoute,
  } as any);
const AdminConsoleOrganisationManagementOrganisationsRouteRoute =
  AdminConsoleOrganisationManagementOrganisationsRouteRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => AdminConsoleOrganisationManagementRouteRoute,
  } as any);
const AdminConsolePlatformContentIndexRoute =
  AdminConsolePlatformContentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentAiTrainingRouteRoute =
  AdminConsolePlatformContentAiTrainingRouteRouteImport.update({
    id: '/ai-training',
    path: '/ai-training',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentCommsAndContentRouteRoute =
  AdminConsolePlatformContentCommsAndContentRouteRouteImport.update({
    id: '/comms-and-content',
    path: '/comms-and-content',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteImport.update({
    id: '/compliance-audit-templates',
    path: '/compliance-audit-templates',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentMarketPdsRouteRoute =
  AdminConsolePlatformContentMarketPdsRouteRouteImport.update({
    id: '/market-pds',
    path: '/market-pds',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsRouteRoute =
  AdminConsolePlatformContentObligationsRouteRouteImport.update({
    id: '/obligations',
    path: '/obligations',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentProductsRouteRoute =
  AdminConsolePlatformContentProductsRouteRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsolePlatformContentWhatsNewRouteRoute =
  AdminConsolePlatformContentWhatsNewRouteRouteImport.update({
    id: '/whats-new',
    path: '/whats-new',
    getParentRoute: () => AdminConsolePlatformContentRouteRoute,
  } as any);
const AdminConsoleToolsIndexRoute = AdminConsoleToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminConsoleToolsRouteRoute,
} as any);
const AdminConsoleToolsDocumentToMarkdownRoute =
  AdminConsoleToolsDocumentToMarkdownRouteImport.update({
    id: '/document-to-markdown',
    path: '/document-to-markdown',
    getParentRoute: () => AdminConsoleToolsRouteRoute,
  } as any);
const AdminConsoleToolsFeatureFlagsRoute =
  AdminConsoleToolsFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => AdminConsoleToolsRouteRoute,
  } as any);
const AdminConsoleToolsSanitiseTextPiiRouteRoute =
  AdminConsoleToolsSanitiseTextPiiRouteRouteImport.update({
    id: '/sanitise-text-pii',
    path: '/sanitise-text-pii',
    getParentRoute: () => AdminConsoleToolsRouteRoute,
  } as any);
const AdminConsoleUserAccessIndexRoute =
  AdminConsoleUserAccessIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleUserAccessRouteRoute,
  } as any);
const AdminConsoleUserAccessAdminUsersRouteRoute =
  AdminConsoleUserAccessAdminUsersRouteRouteImport.update({
    id: '/admin-users',
    path: '/admin-users',
    getParentRoute: () => AdminConsoleUserAccessRouteRoute,
  } as any);
const AdminConsoleUserAccessSupportSessionsRouteRoute =
  AdminConsoleUserAccessSupportSessionsRouteRouteImport.update({
    id: '/support-sessions',
    path: '/support-sessions',
    getParentRoute: () => AdminConsoleUserAccessRouteRoute,
  } as any);
const AdminConsoleUserAccessUsersRouteRoute =
  AdminConsoleUserAccessUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AdminConsoleUserAccessRouteRoute,
  } as any);
const ConsoleOrgIdIndexRoute = ConsoleOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdAttestationsRouteRoute =
  ConsoleOrgIdAttestationsRouteRouteImport.update({
    id: '/attestations',
    path: '/attestations',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsRouteRoute = ConsoleOrgIdClaimsRouteRouteImport.update({
  id: '/claims',
  path: '/claims',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdComplianceRouteRoute =
  ConsoleOrgIdComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseRouteRoute =
  ConsoleOrgIdComponentShowcaseRouteRouteImport.update({
    id: '/component-showcase',
    path: '/component-showcase',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationRouteRoute =
  ConsoleOrgIdConfigurationRouteRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdControlsRouteRoute =
  ConsoleOrgIdControlsRouteRouteImport.update({
    id: '/controls',
    path: '/controls',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdDashboardRouteRoute =
  ConsoleOrgIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdDocumentsRouteRoute =
  ConsoleOrgIdDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdFaqRouteRoute = ConsoleOrgIdFaqRouteRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdFleetPortalRouteRoute =
  ConsoleOrgIdFleetPortalRouteRouteImport.update({
    id: '/fleet-portal',
    path: '/fleet-portal',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdGetFileRouteRoute =
  ConsoleOrgIdGetFileRouteRouteImport.update({
    id: '/get-file',
    path: '/get-file',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdMsprRouteRoute = ConsoleOrgIdMsprRouteRouteImport.update({
  id: '/mspr',
  path: '/mspr',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdReportingRouteRoute =
  ConsoleOrgIdReportingRouteRouteImport.update({
    id: '/reporting',
    path: '/reporting',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdRiskRouteRoute = ConsoleOrgIdRiskRouteRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdToolsRouteRoute = ConsoleOrgIdToolsRouteRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdToolsOnlyHomePageRoute =
  ConsoleOrgIdToolsOnlyHomePageRouteImport.update({
    id: '/tools-only-home-page',
    path: '/tools-only-home-page',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdUserSettingsRouteRoute =
  ConsoleOrgIdUserSettingsRouteRouteImport.update({
    id: '/user-settings',
    path: '/user-settings',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerRouteRoute =
  ConsoleOrgIdWorkloadManagerRouteRouteImport.update({
    id: '/workload-manager',
    path: '/workload-manager',
    getParentRoute: () => ConsoleOrgIdRouteRoute,
  } as any);
const PublicLodgementSummaryAccessKeyRouteRoute =
  PublicLodgementSummaryAccessKeyRouteRouteImport.update({
    id: '/lodgement-summary/$accessKey',
    path: '/lodgement-summary/$accessKey',
    getParentRoute: () => PublicRouteRoute,
  } as any);
const PublicNewComplaintByKeyKeyRouteRoute =
  PublicNewComplaintByKeyKeyRouteRouteImport.update({
    id: '/new-complaint-by-key/$key',
    path: '/new-complaint-by-key/$key',
    getParentRoute: () => PublicRouteRoute,
  } as any);
const PublicNewComplaintOrgIdRouteRoute =
  PublicNewComplaintOrgIdRouteRouteImport.update({
    id: '/new-complaint/$orgId',
    path: '/new-complaint/$orgId',
    getParentRoute: () => PublicRouteRoute,
  } as any);
const AdminConsoleAdvancedAppSettingsAllRouteRoute =
  AdminConsoleAdvancedAppSettingsAllRouteRouteImport.update({
    id: '/all',
    path: '/all',
    getParentRoute: () => AdminConsoleAdvancedAppSettingsRouteRoute,
  } as any);
const AdminConsoleAdvancedAppSettingsWellKnownRoute =
  AdminConsoleAdvancedAppSettingsWellKnownRouteImport.update({
    id: '/well-known',
    path: '/well-known',
    getParentRoute: () => AdminConsoleAdvancedAppSettingsRouteRoute,
  } as any);
const AdminConsoleAdvancedInboundParseIndexRoute =
  AdminConsoleAdvancedInboundParseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleAdvancedInboundParseRouteRoute,
  } as any);
const AdminConsoleAdvancedIndicatorsComplaintsRoute =
  AdminConsoleAdvancedIndicatorsComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => AdminConsoleAdvancedIndicatorsRouteRoute,
  } as any);
const AdminConsoleAdvancedIndicatorsIncidentsRoute =
  AdminConsoleAdvancedIndicatorsIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => AdminConsoleAdvancedIndicatorsRouteRoute,
  } as any);
const AdminConsoleAdvancedJobsIndexRoute =
  AdminConsoleAdvancedJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleAdvancedJobsRouteRoute,
  } as any);
const AdminConsoleAdvancedJobsDynamicRecurringRoute =
  AdminConsoleAdvancedJobsDynamicRecurringRouteImport.update({
    id: '/dynamic-recurring',
    path: '/dynamic-recurring',
    getParentRoute: () => AdminConsoleAdvancedJobsRouteRoute,
  } as any);
const AdminConsoleAdvancedJobsOnDemandRoute =
  AdminConsoleAdvancedJobsOnDemandRouteImport.update({
    id: '/on-demand',
    path: '/on-demand',
    getParentRoute: () => AdminConsoleAdvancedJobsRouteRoute,
  } as any);
const AdminConsoleAdvancedJobsRecurringRoute =
  AdminConsoleAdvancedJobsRecurringRouteImport.update({
    id: '/recurring',
    path: '/recurring',
    getParentRoute: () => AdminConsoleAdvancedJobsRouteRoute,
  } as any);
const AdminConsoleAiEvalRunsEvalRunIdRouteRoute =
  AdminConsoleAiEvalRunsEvalRunIdRouteRouteImport.update({
    id: '/$evalRunId',
    path: '/$evalRunId',
    getParentRoute: () => AdminConsoleAiEvalRunsRouteRoute,
  } as any);
const AdminConsoleAiEvalRunsCompareRouteRoute =
  AdminConsoleAiEvalRunsCompareRouteRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AdminConsoleAiEvalRunsRouteRoute,
  } as any);
const AdminConsoleMonitoringEmailActivityIndexRoute =
  AdminConsoleMonitoringEmailActivityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleMonitoringEmailActivityRouteRoute,
  } as any);
const AdminConsoleMonitoringEngagementIndexRoute =
  AdminConsoleMonitoringEngagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsoleMonitoringEngagementRouteRoute,
  } as any);
const AdminConsoleOrganisationManagementOrganisationsIndexRoute =
  AdminConsoleOrganisationManagementOrganisationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AdminConsoleOrganisationManagementOrganisationsRouteRoute,
  } as any);
const AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute =
  AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteImport.update({
    id: '/$orgId',
    path: '/$orgId',
    getParentRoute: () =>
      AdminConsoleOrganisationManagementOrganisationsRouteRoute,
  } as any);
const AdminConsolePlatformContentAiTrainingIndexRoute =
  AdminConsolePlatformContentAiTrainingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsolePlatformContentAiTrainingRouteRoute,
  } as any);
const AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute =
  AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteImport.update(
    {
      id: '/classification-example',
      path: '/classification-example',
      getParentRoute: () => AdminConsolePlatformContentAiTrainingRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute =
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteImport.update(
    {
      id: '/vulnerability-example',
      path: '/vulnerability-example',
      getParentRoute: () => AdminConsolePlatformContentAiTrainingRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentCommsAndContentAppTextRouteRoute =
  AdminConsolePlatformContentCommsAndContentAppTextRouteRouteImport.update({
    id: '/app-text',
    path: '/app-text',
    getParentRoute: () => AdminConsolePlatformContentCommsAndContentRouteRoute,
  } as any);
const AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute =
  AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteImport.update(
    {
      id: '/comm-templates',
      path: '/comm-templates',
      getParentRoute: () =>
        AdminConsolePlatformContentCommsAndContentRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentCommsAndContentFaqRouteRoute =
  AdminConsolePlatformContentCommsAndContentFaqRouteRouteImport.update({
    id: '/faq',
    path: '/faq',
    getParentRoute: () => AdminConsolePlatformContentCommsAndContentRouteRoute,
  } as any);
const AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute,
  } as any);
const AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteImport.update(
    {
      id: '/search',
      path: '/search',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentMarketPdsAddRoute =
  AdminConsolePlatformContentMarketPdsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AdminConsolePlatformContentMarketPdsRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsIndexRoute =
  AdminConsolePlatformContentObligationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsolePlatformContentObligationsRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsConfigurationRouteRoute =
  AdminConsolePlatformContentObligationsConfigurationRouteRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => AdminConsolePlatformContentObligationsRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsControlsLibraryRouteRoute =
  AdminConsolePlatformContentObligationsControlsLibraryRouteRouteImport.update({
    id: '/controls-library',
    path: '/controls-library',
    getParentRoute: () => AdminConsolePlatformContentObligationsRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsLibraryRouteRoute =
  AdminConsolePlatformContentObligationsLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AdminConsolePlatformContentObligationsRouteRoute,
  } as any);
const AdminConsolePlatformContentProductsServiceIdRoute =
  AdminConsolePlatformContentProductsServiceIdRouteImport.update({
    id: '/$serviceId',
    path: '/$serviceId',
    getParentRoute: () => AdminConsolePlatformContentProductsRouteRoute,
  } as any);
const AdminConsolePlatformContentWhatsNewIndexRoute =
  AdminConsolePlatformContentWhatsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminConsolePlatformContentWhatsNewRouteRoute,
  } as any);
const AdminConsolePlatformContentWhatsNewIdRoute =
  AdminConsolePlatformContentWhatsNewIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AdminConsolePlatformContentWhatsNewRouteRoute,
  } as any);
const AdminConsolePlatformContentWhatsNewNewRoute =
  AdminConsolePlatformContentWhatsNewNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AdminConsolePlatformContentWhatsNewRouteRoute,
  } as any);
const AdminConsoleToolsSanitiseTextPiiCompareRoute =
  AdminConsoleToolsSanitiseTextPiiCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AdminConsoleToolsSanitiseTextPiiRouteRoute,
  } as any);
const AdminConsoleToolsSanitiseTextPiiToolRoute =
  AdminConsoleToolsSanitiseTextPiiToolRouteImport.update({
    id: '/tool',
    path: '/tool',
    getParentRoute: () => AdminConsoleToolsSanitiseTextPiiRouteRoute,
  } as any);
const AdminConsoleUserAccessAdminUsersGrantRoute =
  AdminConsoleUserAccessAdminUsersGrantRouteImport.update({
    id: '/grant',
    path: '/grant',
    getParentRoute: () => AdminConsoleUserAccessAdminUsersRouteRoute,
  } as any);
const ConsoleOrgIdAttestationsIndexRoute =
  ConsoleOrgIdAttestationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  } as any);
const ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute =
  ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteImport.update({
    id: '/scheduled-attestations',
    path: '/scheduled-attestations',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  } as any);
const ConsoleOrgIdAttestationsUserAttestationsRouteRoute =
  ConsoleOrgIdAttestationsUserAttestationsRouteRouteImport.update({
    id: '/user-attestations',
    path: '/user-attestations',
    getParentRoute: () => ConsoleOrgIdAttestationsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsIndexRoute = ConsoleOrgIdClaimsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
} as any);
const ConsoleOrgIdComplianceIndexRoute =
  ConsoleOrgIdComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiRouteRoute =
  ConsoleOrgIdComplianceCoiRouteRouteImport.update({
    id: '/coi',
    path: '/coi',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsRouteRoute =
  ConsoleOrgIdComplianceComplaintsRouteRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsRouteRoute =
  ConsoleOrgIdComplianceIncidentsRouteRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIntakeRouteRoute =
  ConsoleOrgIdComplianceIntakeRouteRouteImport.update({
    id: '/intake',
    path: '/intake',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceObligationsRouteRoute =
  ConsoleOrgIdComplianceObligationsRouteRouteImport.update({
    id: '/obligations',
    path: '/obligations',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceRegistersRouteRoute =
  ConsoleOrgIdComplianceRegistersRouteRouteImport.update({
    id: '/registers',
    path: '/registers',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingRouteRoute =
  ConsoleOrgIdComplianceTrainingRouteRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => ConsoleOrgIdComplianceRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseIndexRoute =
  ConsoleOrgIdComponentShowcaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseAiChatTestRoute =
  ConsoleOrgIdComponentShowcaseAiChatTestRouteImport.update({
    id: '/ai-chat-test',
    path: '/ai-chat-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseButtonIconTestRoute =
  ConsoleOrgIdComponentShowcaseButtonIconTestRouteImport.update({
    id: '/button-icon-test',
    path: '/button-icon-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseButtonVariantsRoute =
  ConsoleOrgIdComponentShowcaseButtonVariantsRouteImport.update({
    id: '/button-variants',
    path: '/button-variants',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseComponentShowcaseRoute =
  ConsoleOrgIdComponentShowcaseComponentShowcaseRouteImport.update({
    id: '/component-showcase',
    path: '/component-showcase',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseDatePickerTestRoute =
  ConsoleOrgIdComponentShowcaseDatePickerTestRouteImport.update({
    id: '/date-picker-test',
    path: '/date-picker-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseFitOnPageRoute =
  ConsoleOrgIdComponentShowcaseFitOnPageRouteImport.update({
    id: '/fit-on-page',
    path: '/fit-on-page',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute =
  ConsoleOrgIdComponentShowcaseMarkdownShowcaseRouteImport.update({
    id: '/markdown-showcase',
    path: '/markdown-showcase',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseTableShowcaseRoute =
  ConsoleOrgIdComponentShowcaseTableShowcaseRouteImport.update({
    id: '/table-showcase',
    path: '/table-showcase',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseTagVariantsRoute =
  ConsoleOrgIdComponentShowcaseTagVariantsRouteImport.update({
    id: '/tag-variants',
    path: '/tag-variants',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdComponentShowcaseTiptapTestRoute =
  ConsoleOrgIdComponentShowcaseTiptapTestRouteImport.update({
    id: '/tiptap-test',
    path: '/tiptap-test',
    getParentRoute: () => ConsoleOrgIdComponentShowcaseRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationIndexRoute =
  ConsoleOrgIdConfigurationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsRouteRouteImport.update({
    id: '/api-integrations',
    path: '/api-integrations',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsRouteRouteImport.update({
    id: '/claims-products',
    path: '/claims-products',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClientDatabaseRoute =
  ConsoleOrgIdConfigurationClientDatabaseRouteImport.update({
    id: '/client-database',
    path: '/client-database',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceRouteRoute =
  ConsoleOrgIdConfigurationComplianceRouteRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsRouteRoute =
  ConsoleOrgIdConfigurationFinancialsRouteRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetRouteRoute =
  ConsoleOrgIdConfigurationFleetRouteRouteImport.update({
    id: '/fleet',
    path: '/fleet',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationMonitoringRouteRoute =
  ConsoleOrgIdConfigurationMonitoringRouteRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsRouteRouteImport.update({
    id: '/org-settings',
    path: '/org-settings',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationRiskRouteRoute =
  ConsoleOrgIdConfigurationRiskRouteRouteImport.update({
    id: '/risk',
    path: '/risk',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationVendorManagementRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementRouteRouteImport.update({
    id: '/vendor-management',
    path: '/vendor-management',
    getParentRoute: () => ConsoleOrgIdConfigurationRouteRoute,
  } as any);
const ConsoleOrgIdControlsIndexRoute =
  ConsoleOrgIdControlsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  } as any);
const ConsoleOrgIdControlsActivitiesRouteRoute =
  ConsoleOrgIdControlsActivitiesRouteRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  } as any);
const ConsoleOrgIdControlsRegisterRouteRoute =
  ConsoleOrgIdControlsRegisterRouteRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  } as any);
const ConsoleOrgIdControlsTestsRouteRoute =
  ConsoleOrgIdControlsTestsRouteRouteImport.update({
    id: '/tests',
    path: '/tests',
    getParentRoute: () => ConsoleOrgIdControlsRouteRoute,
  } as any);
const ConsoleOrgIdDashboardIndexRoute =
  ConsoleOrgIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDashboardClaimsRoute =
  ConsoleOrgIdDashboardClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDashboardComplaintsRoute =
  ConsoleOrgIdDashboardComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDashboardIncidentsRoute =
  ConsoleOrgIdDashboardIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDashboardManagementRoute =
  ConsoleOrgIdDashboardManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDashboardPeopleAndCultureRoute =
  ConsoleOrgIdDashboardPeopleAndCultureRouteImport.update({
    id: '/people-and-culture',
    path: '/people-and-culture',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDashboardRisksRoute =
  ConsoleOrgIdDashboardRisksRouteImport.update({
    id: '/risks',
    path: '/risks',
    getParentRoute: () => ConsoleOrgIdDashboardRouteRoute,
  } as any);
const ConsoleOrgIdDebugIndexRoute = ConsoleOrgIdDebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => ConsoleOrgIdRouteRoute,
} as any);
const ConsoleOrgIdFleetPortalIndexRoute =
  ConsoleOrgIdFleetPortalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalAuthorisationsRoute =
  ConsoleOrgIdFleetPortalAuthorisationsRouteImport.update({
    id: '/authorisations',
    path: '/authorisations',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalClaimsRouteRoute =
  ConsoleOrgIdFleetPortalClaimsRouteRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalDashboardRoute =
  ConsoleOrgIdFleetPortalDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalFleetRoute =
  ConsoleOrgIdFleetPortalFleetRouteImport.update({
    id: '/fleet',
    path: '/fleet',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalSlaRoute =
  ConsoleOrgIdFleetPortalSlaRouteImport.update({
    id: '/sla',
    path: '/sla',
    getParentRoute: () => ConsoleOrgIdFleetPortalRouteRoute,
  } as any);
const ConsoleOrgIdMsprMspExceptionsRouteRoute =
  ConsoleOrgIdMsprMspExceptionsRouteRouteImport.update({
    id: '/msp-exceptions',
    path: '/msp-exceptions',
    getParentRoute: () => ConsoleOrgIdMsprRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersRouteRoute =
  ConsoleOrgIdMsprServiceProvidersRouteRouteImport.update({
    id: '/service-providers',
    path: '/service-providers',
    getParentRoute: () => ConsoleOrgIdMsprRouteRoute,
  } as any);
const ConsoleOrgIdReportingAddRoute =
  ConsoleOrgIdReportingAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdReportingRouteRoute,
  } as any);
const ConsoleOrgIdRiskIndexRoute = ConsoleOrgIdRiskIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdRiskRouteRoute,
} as any);
const ConsoleOrgIdRiskRasRouteRoute =
  ConsoleOrgIdRiskRasRouteRouteImport.update({
    id: '/ras',
    path: '/ras',
    getParentRoute: () => ConsoleOrgIdRiskRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterRouteRoute =
  ConsoleOrgIdRiskRegisterRouteRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => ConsoleOrgIdRiskRouteRoute,
  } as any);
const ConsoleOrgIdToolsIndexRoute = ConsoleOrgIdToolsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
} as any);
const ConsoleOrgIdToolsAutoDetectRouteRoute =
  ConsoleOrgIdToolsAutoDetectRouteRouteImport.update({
    id: '/auto-detect',
    path: '/auto-detect',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditRouteRoute =
  ConsoleOrgIdToolsComplianceAuditRouteRouteImport.update({
    id: '/compliance-audit',
    path: '/compliance-audit',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  } as any);
const ConsoleOrgIdToolsDocumentAnalyzerRouteRoute =
  ConsoleOrgIdToolsDocumentAnalyzerRouteRouteImport.update({
    id: '/document-analyzer',
    path: '/document-analyzer',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  } as any);
const ConsoleOrgIdToolsPdsCompareRouteRoute =
  ConsoleOrgIdToolsPdsCompareRouteRouteImport.update({
    id: '/pds-compare',
    path: '/pds-compare',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  } as any);
const ConsoleOrgIdToolsWebsiteCheckerRouteRoute =
  ConsoleOrgIdToolsWebsiteCheckerRouteRouteImport.update({
    id: '/website-checker',
    path: '/website-checker',
    getParentRoute: () => ConsoleOrgIdToolsRouteRoute,
  } as any);
const ConsoleOrgIdUserSettingsIndexRoute =
  ConsoleOrgIdUserSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  } as any);
const ConsoleOrgIdUserSettingsNotificationsRoute =
  ConsoleOrgIdUserSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  } as any);
const ConsoleOrgIdUserSettingsProfileRoute =
  ConsoleOrgIdUserSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerIndexRoute =
  ConsoleOrgIdWorkloadManagerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerComplaintsRoute =
  ConsoleOrgIdWorkloadManagerComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerEmailsRouteRoute =
  ConsoleOrgIdWorkloadManagerEmailsRouteRouteImport.update({
    id: '/emails',
    path: '/emails',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksRouteRoute =
  ConsoleOrgIdWorkloadManagerTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerRouteRoute,
  } as any);
const PublicOrgIdComplaintNewRouteRoute =
  PublicOrgIdComplaintNewRouteRouteImport.update({
    id: '/complaint/new',
    path: '/complaint/new',
    getParentRoute: () => PublicOrgIdRouteRoute,
  } as any);
const AdminConsoleAdvancedAppSettingsAllAddRoute =
  AdminConsoleAdvancedAppSettingsAllAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AdminConsoleAdvancedAppSettingsAllRouteRoute,
  } as any);
const AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute =
  AdminConsoleAdvancedJobsDynamicRecurringJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AdminConsoleAdvancedJobsDynamicRecurringRoute,
  } as any);
const AdminConsoleAdvancedJobsOnDemandJobIdRoute =
  AdminConsoleAdvancedJobsOnDemandJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AdminConsoleAdvancedJobsOnDemandRoute,
  } as any);
const AdminConsoleAdvancedJobsRecurringJobIdRoute =
  AdminConsoleAdvancedJobsRecurringJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AdminConsoleAdvancedJobsRecurringRoute,
  } as any);
const AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute =
  AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRouteImport.update(
    {
      id: '/subscriptions',
      path: '/subscriptions',
      getParentRoute: () =>
        AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute,
    } as any,
  );
const AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRoute =
  AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteImport.update(
    {
      id: '/users',
      path: '/users',
      getParentRoute: () =>
        AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute,
    } as any,
  );
const AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute =
  AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRouteImport.update({
    id: '/wallet',
    path: '/wallet',
    getParentRoute: () =>
      AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute,
  } as any);
const AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute =
  AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute =
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRouteImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentCommsAndContentAppTextAddRoute =
  AdminConsolePlatformContentCommsAndContentAppTextAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      AdminConsolePlatformContentCommsAndContentAppTextRouteRoute,
  } as any);
const AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute =
  AdminConsolePlatformContentCommsAndContentCommTemplatesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute,
  } as any);
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteImport.update(
    {
      id: '/details/$complianceAuditTemplateId',
      path: '/details/$complianceAuditTemplateId',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentMarketPdsEditIdRoute =
  AdminConsolePlatformContentMarketPdsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AdminConsolePlatformContentMarketPdsRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsControlsLibraryIndexRoute =
  AdminConsolePlatformContentObligationsControlsLibraryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AdminConsolePlatformContentObligationsControlsLibraryRouteRoute,
  } as any);
const AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute =
  AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteImport.update(
    {
      id: '/$id',
      path: '/$id',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsControlsLibraryRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsLibraryIndexRoute =
  AdminConsolePlatformContentObligationsLibraryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AdminConsolePlatformContentObligationsLibraryRouteRoute,
  } as any);
const AdminConsoleUserAccessAdminUsersEditUserIdRoute =
  AdminConsoleUserAccessAdminUsersEditUserIdRouteImport.update({
    id: '/edit/$userId',
    path: '/edit/$userId',
    getParentRoute: () => AdminConsoleUserAccessAdminUsersRouteRoute,
  } as any);
const AdminConsoleUserAccessUsersEditUserIdRoute =
  AdminConsoleUserAccessUsersEditUserIdRouteImport.update({
    id: '/edit/$userId',
    path: '/edit/$userId',
    getParentRoute: () => AdminConsoleUserAccessUsersRouteRoute,
  } as any);
const AdminConsoleUserAccessUsersViewUserIdRoute =
  AdminConsoleUserAccessUsersViewUserIdRouteImport.update({
    id: '/view/$userId',
    path: '/view/$userId',
    getParentRoute: () => AdminConsoleUserAccessUsersRouteRoute,
  } as any);
const ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute =
  ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRouteImport.update(
    {
      id: '/$scheduleId',
      path: '/$scheduleId',
      getParentRoute: () =>
        ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdAttestationsScheduledAttestationsNewRoute =
  ConsoleOrgIdAttestationsScheduledAttestationsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute,
  } as any);
const ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute =
  ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRouteImport.update({
    id: '/$attestationId',
    path: '/$attestationId',
    getParentRoute: () => ConsoleOrgIdAttestationsUserAttestationsRouteRoute,
  } as any);
const ConsoleOrgIdAttestationsUserAttestationsSendRoute =
  ConsoleOrgIdAttestationsUserAttestationsSendRouteImport.update({
    id: '/send',
    path: '/send',
    getParentRoute: () => ConsoleOrgIdAttestationsUserAttestationsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdClaimsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiIndexRoute =
  ConsoleOrgIdComplianceCoiIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceCoiRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiAddRouteRoute =
  ConsoleOrgIdComplianceCoiAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceCoiRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsIndexRoute =
  ConsoleOrgIdComplianceComplaintsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsAddRouteRoute =
  ConsoleOrgIdComplianceComplaintsAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsIndexRoute =
  ConsoleOrgIdComplianceIncidentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsAddRoute =
  ConsoleOrgIdComplianceIncidentsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceObligationsIndexRoute =
  ConsoleOrgIdComplianceObligationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceObligationsAddRouteRoute =
  ConsoleOrgIdComplianceObligationsAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceRegistersIndexRoute =
  ConsoleOrgIdComplianceRegistersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRouteRoute,
  } as any);
const ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute =
  ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteImport.update({
    id: '/$registerId',
    path: '/$registerId',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingIndexRoute =
  ConsoleOrgIdComplianceTrainingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingSearchRouteRoute =
  ConsoleOrgIdComplianceTrainingSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteImport.update({
    id: '/api-tokens',
    path: '/api-tokens',
    getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteImport.update({
    id: '/form-designer',
    path: '/form-designer',
    getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRouteImport.update({
    id: '/mcp-access',
    path: '/mcp-access',
    getParentRoute: () => ConsoleOrgIdConfigurationApiIntegrationsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRouteImport.update({
    id: '/insurers',
    path: '/insurers',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteImport.update({
    id: '/product-types',
    path: '/product-types',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteImport.update({
    id: '/products-v2',
    path: '/products-v2',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteImport.update({
    id: '/questionnaire',
    path: '/questionnaire',
    getParentRoute: () => ConsoleOrgIdConfigurationClaimsProductsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClientDatabaseSplatRoute =
  ConsoleOrgIdConfigurationClientDatabaseSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ConsoleOrgIdConfigurationClientDatabaseRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIndexRoute =
  ConsoleOrgIdConfigurationComplianceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteImport.update({
    id: '/attestations',
    path: '/attestations',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute =
  ConsoleOrgIdConfigurationComplianceAutoDetectRouteRouteImport.update({
    id: '/auto-detect',
    path: '/auto-detect',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRouteImport.update({
    id: '/compliance-audit',
    path: '/compliance-audit',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceGeneralRouteRoute =
  ConsoleOrgIdConfigurationComplianceGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceMsprRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprRouteRouteImport.update({
    id: '/mspr',
    path: '/mspr',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceObligationsRoute =
  ConsoleOrgIdConfigurationComplianceObligationsRouteImport.update({
    id: '/obligations',
    path: '/obligations',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceTrainingRouteRoute =
  ConsoleOrgIdConfigurationComplianceTrainingRouteRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingRouteRoute =
  ConsoleOrgIdConfigurationFinancialsBillingRouteRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute =
  ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRouteImport.update({
    id: '/expenses-billing',
    path: '/expenses-billing',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute =
  ConsoleOrgIdConfigurationFinancialsPaymentsRouteRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetIndexRoute =
  ConsoleOrgIdConfigurationFleetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteImport.update({
    id: '/client-database',
    path: '/client-database',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute =
  ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRouteImport.update({
    id: '/delegated-authority',
    path: '/delegated-authority',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetEscalationsRouteRoute =
  ConsoleOrgIdConfigurationFleetEscalationsRouteRouteImport.update({
    id: '/escalations',
    path: '/escalations',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute =
  ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRouteImport.update({
    id: '/portal-claim-page',
    path: '/portal-claim-page',
    getParentRoute: () => ConsoleOrgIdConfigurationFleetRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute =
  ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRouteImport.update({
    id: '/audit-trail',
    path: '/audit-trail',
    getParentRoute: () => ConsoleOrgIdConfigurationMonitoringRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute =
  ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRouteImport.update({
    id: '/email-activity',
    path: '/email-activity',
    getParentRoute: () => ConsoleOrgIdConfigurationMonitoringRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute =
  ConsoleOrgIdConfigurationMonitoringStatisticsRouteRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => ConsoleOrgIdConfigurationMonitoringRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteImport.update({
    id: '/communication',
    path: '/communication',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute =
  ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRouteImport.update({
    id: '/fleet-escalations',
    path: '/fleet-escalations',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteImport.update({
    id: '/handling-parties',
    path: '/handling-parties',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRouteImport.update({
    id: '/support-sessions',
    path: '/support-sessions',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsSystemRouteRouteImport.update({
    id: '/system',
    path: '/system',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteImport.update({
    id: '/trash',
    path: '/trash',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationRiskIndexRoute =
  ConsoleOrgIdConfigurationRiskIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationRiskAppetiteRoute =
  ConsoleOrgIdConfigurationRiskAppetiteRouteImport.update({
    id: '/appetite',
    path: '/appetite',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationRiskCategoriesRoute =
  ConsoleOrgIdConfigurationRiskCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationRiskMatrixRoute =
  ConsoleOrgIdConfigurationRiskMatrixRouteImport.update({
    id: '/matrix',
    path: '/matrix',
    getParentRoute: () => ConsoleOrgIdConfigurationRiskRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => ConsoleOrgIdConfigurationVendorManagementRouteRoute,
  } as any);
const ConsoleOrgIdControlsRegisterIndexRoute =
  ConsoleOrgIdControlsRegisterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdControlsRegisterRouteRoute,
  } as any);
const ConsoleOrgIdControlsRegisterAddRouteRoute =
  ConsoleOrgIdControlsRegisterAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdControlsRegisterRouteRoute,
  } as any);
const ConsoleOrgIdDocumentsDetailsFileIdRouteRoute =
  ConsoleOrgIdDocumentsDetailsFileIdRouteRouteImport.update({
    id: '/details/$fileId',
    path: '/details/$fileId',
    getParentRoute: () => ConsoleOrgIdDocumentsRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalClaimsIndexRoute =
  ConsoleOrgIdFleetPortalClaimsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdFleetPortalClaimsRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersIndexRoute =
  ConsoleOrgIdMsprServiceProvidersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersSearchRouteRoute =
  ConsoleOrgIdMsprServiceProvidersSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersRouteRoute,
  } as any);
const ConsoleOrgIdRiskRasIndexRoute =
  ConsoleOrgIdRiskRasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdRiskRasRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterIndexRoute =
  ConsoleOrgIdRiskRegisterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdRiskRegisterRouteRoute,
  } as any);
const ConsoleOrgIdToolsAutoDetectDashboardRoute =
  ConsoleOrgIdToolsAutoDetectDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => ConsoleOrgIdToolsAutoDetectRouteRoute,
  } as any);
const ConsoleOrgIdToolsAutoDetectInboxRouteRoute =
  ConsoleOrgIdToolsAutoDetectInboxRouteRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => ConsoleOrgIdToolsAutoDetectRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditIndexRoute =
  ConsoleOrgIdToolsComplianceAuditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditRouteRoute,
  } as any);
const ConsoleOrgIdToolsDocumentAnalyzerIndexRoute =
  ConsoleOrgIdToolsDocumentAnalyzerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerRouteRoute,
  } as any);
const ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute =
  ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerRouteRoute,
  } as any);
const ConsoleOrgIdToolsDocumentAnalyzerUploadRoute =
  ConsoleOrgIdToolsDocumentAnalyzerUploadRouteImport.update({
    id: '/upload',
    path: '/upload',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerRouteRoute,
  } as any);
const ConsoleOrgIdToolsPdsCompareIndexRoute =
  ConsoleOrgIdToolsPdsCompareIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsPdsCompareRouteRoute,
  } as any);
const ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute =
  ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteImport.update({
    id: '/pds-documents',
    path: '/pds-documents',
    getParentRoute: () => ConsoleOrgIdToolsPdsCompareRouteRoute,
  } as any);
const ConsoleOrgIdToolsWebsiteCheckerIndexRoute =
  ConsoleOrgIdToolsWebsiteCheckerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsWebsiteCheckerRouteRoute,
  } as any);
const ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute =
  ConsoleOrgIdUserSettingsAuthorisedAppsIndexRouteImport.update({
    id: '/authorised-apps/',
    path: '/authorised-apps/',
    getParentRoute: () => ConsoleOrgIdUserSettingsRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksIndexRoute =
  ConsoleOrgIdWorkloadManagerTasksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksListRouteRoute =
  ConsoleOrgIdWorkloadManagerTasksListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksRouteRoute,
  } as any);
const PublicOrgIdInvoiceViewAccessKeyRouteRoute =
  PublicOrgIdInvoiceViewAccessKeyRouteRouteImport.update({
    id: '/invoice/view/$accessKey',
    path: '/invoice/view/$accessKey',
    getParentRoute: () => PublicOrgIdRouteRoute,
  } as any);
const AdminConsoleAdvancedAppSettingsAllEditNameRoute =
  AdminConsoleAdvancedAppSettingsAllEditNameRouteImport.update({
    id: '/edit/$name',
    path: '/edit/$name',
    getParentRoute: () => AdminConsoleAdvancedAppSettingsAllRouteRoute,
  } as any);
const AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute =
  AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRouteImport.update(
    {
      id: '/$orgId/$complianceAuditId/statistics',
      path: '/$orgId/$complianceAuditId/statistics',
      getParentRoute: () => AdminConsoleMonitoringComplianceAuditRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute =
  AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute =
  AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRouteImport.update(
    {
      id: '/view/$id',
      path: '/view/$id',
      getParentRoute: () =>
        AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute =
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute =
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRouteImport.update(
    {
      id: '/view/$id',
      path: '/view/$id',
      getParentRoute: () =>
        AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute =
  AdminConsolePlatformContentCommsAndContentAppTextEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () =>
      AdminConsolePlatformContentCommsAndContentAppTextRouteRoute,
  } as any);
const AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute =
  AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRouteImport.update(
    {
      id: '/edit/$commTemplateId',
      path: '/edit/$commTemplateId',
      getParentRoute: () =>
        AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRouteImport.update(
    {
      id: '/changes',
      path: '/changes',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteImport.update(
    {
      id: '/evidence-types',
      path: '/evidence-types',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteImport.update(
    {
      id: '/principles',
      path: '/principles',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRouteImport.update(
    {
      id: '/structure',
      path: '/structure',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute =
  AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRouteImport.update(
    {
      id: '/details',
      path: '/details',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute =
  AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRouteImport.update(
    {
      id: '/history',
      path: '/history',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute =
  AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteImport.update(
    {
      id: '/details/$id',
      path: '/details/$id',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsLibraryRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdActivityRouteRoute =
  ConsoleOrgIdClaimsDetailsIdActivityRouteRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute =
  ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRouteImport.update({
    id: '/ai-assessment',
    path: '/ai-assessment',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdCommsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsRouteRouteImport.update({
    id: '/comms',
    path: '/comms',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdContactsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdContactsRouteRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute =
  ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute =
  ConsoleOrgIdClaimsDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute =
  ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdManageRouteRoute =
  ConsoleOrgIdClaimsDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute =
  ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRouteImport.update({
    id: '/policy-info',
    path: '/policy-info',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute =
  ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRouteImport.update({
    id: '/product-type-data',
    path: '/product-type-data',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute =
  ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteImport.update({
    id: '/vehicle',
    path: '/vehicle',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiDetailsIdRouteRoute =
  ConsoleOrgIdComplianceCoiDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceCoiRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute =
  ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsRouteRoute,
  } as any);
const ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute =
  ConsoleOrgIdComplianceRegistersRegisterIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingSearchAddRoute =
  ConsoleOrgIdComplianceTrainingSearchAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingSearchRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute =
  ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteImport.update({
    id: '/user/$userId',
    path: '/user/$userId',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRoute =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteImport.update(
    {
      id: '/$formDefinitionId',
      path: '/$formDefinitionId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteImport.update(
    {
      id: '/catastrophe-events',
      path: '/catastrophe-events',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteImport.update(
    {
      id: '/claim-flags',
      path: '/claim-flags',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRouteImport.update(
    {
      id: '/handling-standards',
      path: '/handling-standards',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsIdRouteImport.update({
    id: '/id',
    path: '/id',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteImport.update(
    {
      id: '/task-lists',
      path: '/task-lists',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteImport.update(
    {
      id: '/$productTypeId',
      path: '/$productTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteImport.update(
    {
      id: '/user-attestations',
      path: '/user-attestations',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsBrandsRouteImport.update({
    id: '/brands',
    path: '/brands',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceGeneralIndexRoute =
  ConsoleOrgIdConfigurationComplianceGeneralIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceGeneralRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute =
  ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRouteImport.update({
    id: '/asic-products',
    path: '/asic-products',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceGeneralRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute =
  ConsoleOrgIdConfigurationComplianceGeneralDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceGeneralRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteImport.update(
    {
      id: '/critical-operations',
      path: '/critical-operations',
      getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteImport.update({
    id: '/definitions',
    path: '/definitions',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute =
  ConsoleOrgIdConfigurationComplianceMsprDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteImport.update(
    {
      id: '/governance-config',
      path: '/governance-config',
      getParentRoute: () => ConsoleOrgIdConfigurationComplianceMsprRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceTrainingIndexRoute =
  ConsoleOrgIdConfigurationComplianceTrainingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceTrainingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute =
  ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceTrainingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute =
  ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRouteImport.update({
    id: '/training-periods',
    path: '/training-periods',
    getParentRoute: () => ConsoleOrgIdConfigurationComplianceTrainingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute =
  ConsoleOrgIdConfigurationFinancialsBillingBalanceRouteImport.update({
    id: '/balance',
    path: '/balance',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute =
  ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRouteImport.update({
    id: '/billing-info',
    path: '/billing-info',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute =
  ConsoleOrgIdConfigurationFinancialsBillingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute =
  ConsoleOrgIdConfigurationFinancialsBillingTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingUsageRoute =
  ConsoleOrgIdConfigurationFinancialsBillingUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteImport.update(
    {
      id: '/comm-signatures',
      path: '/comm-signatures',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteImport.update(
    {
      id: '/comm-templates',
      path: '/comm-templates',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute =
  ConsoleOrgIdConfigurationOrgSettingsUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRouteImport.update(
    {
      id: '/definitions',
      path: '/definitions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdControlsRegisterDetailsIdRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdControlsRegisterRouteRoute,
  } as any);
const ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute =
  ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRouteImport.update({
    id: '/details/$claimId',
    path: '/details/$claimId',
    getParentRoute: () => ConsoleOrgIdFleetPortalClaimsRouteRoute,
  } as any);
const ConsoleOrgIdMsprMspExceptionsEditIdRoute =
  ConsoleOrgIdMsprMspExceptionsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => ConsoleOrgIdMsprMspExceptionsRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersSearchAddRoute =
  ConsoleOrgIdMsprServiceProvidersSearchAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersSearchRouteRoute,
  } as any);
const ConsoleOrgIdRiskRasDetailsIdRouteRoute =
  ConsoleOrgIdRiskRasDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdRiskRasRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterDetailsIdRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdRiskRegisterRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteImport.update({
    id: '/details/$complianceAuditId',
    path: '/details/$complianceAuditId',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute,
  } as any);
const ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute,
  } as any);
const ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute =
  ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRouteImport.update({
    id: '/report/$id',
    path: '/report/$id',
    getParentRoute: () => ConsoleOrgIdToolsWebsiteCheckerRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksListAddRoute =
  ConsoleOrgIdWorkloadManagerTasksListAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksListRouteRoute,
  } as any);
const PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute =
  PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport.update(
    {
      id: '/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId',
      path: '/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId',
      getParentRoute: () => PublicRouteRoute,
    } as any,
  );
const AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute =
  AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRouteImport.update(
    {
      id: '/edit/$userId',
      path: '/edit/$userId',
      getParentRoute: () =>
        AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute =
  AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRouteImport.update(
    {
      id: '/ai-related',
      path: '/ai-related',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute =
  AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRouteImport.update(
    {
      id: '/document-analyser',
      path: '/document-analyser',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute =
  AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRouteImport.update(
    {
      id: '/history',
      path: '/history',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute =
  AdminConsolePlatformContentObligationsLibraryDetailsIdManageRouteImport.update(
    {
      id: '/manage',
      path: '/manage',
      getParentRoute: () =>
        AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdContactsAddRoute =
  ConsoleOrgIdClaimsDetailsIdContactsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdExpensesAddRoute =
  ConsoleOrgIdClaimsDetailsIdExpensesAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiDetailsIdIndexRoute =
  ConsoleOrgIdComplianceCoiDetailsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceCoiDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute =
  ConsoleOrgIdComplianceCoiDetailsIdLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdComplianceCoiDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceCoiDetailsIdManageRoute =
  ConsoleOrgIdComplianceCoiDetailsIdManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceCoiDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRouteImport.update({
    id: '/comms',
    path: '/comms',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute =
  ConsoleOrgIdComplianceObligationsDetailsIdDebugRouteImport.update({
    id: '/debug',
    path: '/debug',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceObligationsDetailsIdManageRoute =
  ConsoleOrgIdComplianceObligationsDetailsIdManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute =
  ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRouteImport.update({
    id: '/records/$recordId',
    path: '/records/$recordId',
    getParentRoute: () => ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingUserUserIdAddRoute =
  ConsoleOrgIdComplianceTrainingUserUserIdAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteImport.update(
    {
      id: '/search',
      path: '/search',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteImport.update(
    {
      id: '/decision-engine',
      path: '/decision-engine',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteImport.update(
    {
      id: '/edit/$productTypeId',
      path: '/edit/$productTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteImport.update(
    {
      id: '/financials/$id',
      path: '/financials/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRouteImport.update(
    {
      id: '/states/$id',
      path: '/states/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteImport.update(
    {
      id: '/details/$productId',
      path: '/details/$productId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRouteImport.update(
    {
      id: '/edit/$productId',
      path: '/edit/$productId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRouteImport.update(
    {
      id: '/edit/$questionnaireId',
      path: '/edit/$questionnaireId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRouteImport.update(
    {
      id: '/incident-details',
      path: '/incident-details',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRouteImport.update(
    {
      id: '/lodgement',
      path: '/lodgement',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRouteImport.update(
    {
      id: '/rectification',
      path: '/rectification',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteImport.update(
    {
      id: '/timeline',
      path: '/timeline',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute =
  ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRouteImport.update({
    id: '/payment/success',
    path: '/payment/success',
    getParentRoute: () => ConsoleOrgIdConfigurationFinancialsBillingRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () =>
      ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteImport.update(
    {
      id: '/details/$id',
      path: '/details/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute =
  ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRouteImport.update(
    {
      id: '/details/$userId',
      path: '/details/$userId',
      getParentRoute: () => ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRouteImport.update(
    {
      id: '/list/',
      path: '/list/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRouteImport.update(
    {
      id: '/search/',
      path: '/search/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRouteImport.update(
    {
      id: '/search/definitions',
      path: '/search/definitions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRouteImport.update(
    {
      id: '/search/list',
      path: '/search/list',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteImport.update({
    id: '/action-plan',
    path: '/action-plan',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteImport.update({
    id: '/assessment',
    path: '/assessment',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute =
  ConsoleOrgIdRiskRegisterDetailsIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute =
  ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRouteImport.update(
    {
      id: '/$id/review-email-classification',
      path: '/$id/review-email-classification',
      getParentRoute: () => ConsoleOrgIdToolsAutoDetectInboxRouteRoute,
    } as any,
  );
const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRouteImport.update(
    {
      id: '/statistics',
      path: '/statistics',
      getParentRoute: () =>
        ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute,
    } as any,
  );
const ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute =
  ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute,
  } as any);
const ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute =
  ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRouteImport.update({
    id: '/$id/results',
    path: '/$id/results',
    getParentRoute: () => ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute,
  } as any);
const ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute =
  ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute =
  ConsoleOrgIdWorkloadManagerTasksListDetailsIdRouteImport.update({
    id: '/details/$id',
    path: '/details/$id',
    getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksListRouteRoute,
  } as any);
const PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute =
  PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport.update(
    {
      id: '/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId',
      path: '/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId',
      getParentRoute: () => PublicOrgIdRouteRoute,
    } as any,
  );
const PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute =
  PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport.update(
    {
      id: '/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId',
      path: '/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId',
      getParentRoute: () => PublicOrgIdRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRouteImport.update(
    {
      id: '/edit/$complianceAuditTemplateEvidenceTypeId',
      path: '/edit/$complianceAuditTemplateEvidenceTypeId',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute,
    } as any,
  );
const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRouteImport.update(
    {
      id: '/edit/$complianceAuditTemplatePrincipleId',
      path: '/edit/$complianceAuditTemplatePrincipleId',
      getParentRoute: () =>
        AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute =
  ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRouteImport.update({
    id: '/add/phone',
    path: '/add/phone',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdActivityRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute =
  ConsoleOrgIdClaimsDetailsIdCommsAddEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute =
  ConsoleOrgIdClaimsDetailsIdCommsAddSmsRouteImport.update({
    id: '/sms',
    path: '/sms',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRouteImport.update({
    id: '/message/$messageId',
    path: '/message/$messageId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRouteImport.update({
    id: '/reply/$messageId',
    path: '/reply/$messageId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdCommsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute =
  ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRouteImport.update({
    id: '/edit/$contactId',
    path: '/edit/$contactId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute =
  ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRouteImport.update({
    id: '/edit/$expenseItemId',
    path: '/edit/$expenseItemId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteImport.update({
    id: '/compensations/add',
    path: '/compensations/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRouteImport.update({
    id: '/excesses/add',
    path: '/excesses/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRouteImport.update({
    id: '/reserves/add',
    path: '/reserves/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute =
  ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRouteImport.update({
    id: '/strategies/add',
    path: '/strategies/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute =
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRouteImport.update({
    id: '/supplier-jobs/add',
    path: '/supplier-jobs/add',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute =
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRouteImport.update({
    id: '/supplier-jobs/add-supplier',
    path: '/supplier-jobs/add-supplier',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () =>
      ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRouteImport.update({
    id: '/complaints',
    path: '/complaints',
    getParentRoute: () =>
      ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute =
  ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRouteImport.update({
    id: '/edit/$recordId',
    path: '/edit/$recordId',
    getParentRoute: () => ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRouteImport.update(
    {
      id: '/edit/$catastropheEventId',
      path: '/edit/$catastropheEventId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRouteImport.update(
    {
      id: '/edit/$claimFlagId',
      path: '/edit/$claimFlagId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRouteImport.update(
    {
      id: '/claim-statuses/add',
      path: '/claim-statuses/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRouteImport.update(
    {
      id: '/conditions',
      path: '/conditions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRouteImport.update(
    {
      id: '/exclusions',
      path: '/exclusions',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRouteImport.update(
    {
      id: '/guide',
      path: '/guide',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRouteImport.update(
    {
      id: '/limits-excesses',
      path: '/limits-excesses',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRouteImport.update(
    {
      id: '/loss-causes',
      path: '/loss-causes',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRouteImport.update(
    {
      id: '/policy-trigger-mapping',
      path: '/policy-trigger-mapping',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRouteImport.update(
    {
      id: '/product-info',
      path: '/product-info',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRouteImport.update(
    {
      id: '/red-flags',
      path: '/red-flags',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRouteImport.update(
    {
      id: '/edit/$pdsId',
      path: '/edit/$pdsId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRouteImport.update(
    {
      id: '/pds-text/$pdsId',
      path: '/pds-text/$pdsId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRouteImport.update(
    {
      id: '/pds/$pdsId',
      path: '/pds/$pdsId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRouteImport.update(
    {
      id: '/data-fields',
      path: '/data-fields',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRouteImport.update(
    {
      id: '/policy-fields',
      path: '/policy-fields',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteImport.update(
    {
      id: '/third-party-contact-type',
      path: '/third-party-contact-type',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRouteImport.update(
    {
      id: '/cost-codes',
      path: '/cost-codes',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRouteImport.update(
    {
      id: '/sections',
      path: '/sections',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRouteImport.update(
    {
      id: '/tax',
      path: '/tax',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteImport.update(
    {
      id: '/transaction-types',
      path: '/transaction-types',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRouteImport.update(
    {
      id: '/edit/$complaintFlagId',
      path: '/edit/$complaintFlagId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRouteImport.update(
    {
      id: '/edit/$incidentFlagId',
      path: '/edit/$incidentFlagId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRouteImport.update(
    {
      id: '/identified/add',
      path: '/identified/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRouteImport.update(
    {
      id: '/categories/add',
      path: '/categories/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRouteImport.update(
    {
      id: '/clients',
      path: '/clients',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRouteImport.update(
    {
      id: '/drivers',
      path: '/drivers',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRouteImport.update(
    {
      id: '/portal-access',
      path: '/portal-access',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRouteImport.update(
    {
      id: '/vehicles',
      path: '/vehicles',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRouteImport.update(
    {
      id: '/edit/$commSignatureId',
      path: '/edit/$commSignatureId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRouteImport.update(
    {
      id: '/edit/$communicationTemplateId',
      path: '/edit/$communicationTemplateId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRouteImport.update(
    {
      id: '/users',
      path: '/users',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRouteImport.update(
    {
      id: '/details/$id/',
      path: '/details/$id/',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRouteImport.update(
    {
      id: '/details/$id/$',
      path: '/details/$id/$',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteImport.update(
    {
      id: '/list/details/$id',
      path: '/list/details/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute,
    } as any,
  );
const ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRouteImport.update(
    {
      id: '/activity/$activityId',
      path: '/activity/$activityId',
      getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRouteImport.update({
    id: '/activity/add',
    path: '/activity/add',
    getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRouteImport.update({
    id: '/test/$testId',
    path: '/test/$testId',
    getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute =
  ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRouteImport.update({
    id: '/test/add',
    path: '/test/add',
    getParentRoute: () => ConsoleOrgIdControlsRegisterDetailsIdRouteRoute,
  } as any);
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () =>
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute =
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute,
  } as any);
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRouteImport.update(
    {
      id: '/details/control_activity/$id',
      path: '/details/control_activity/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    } as any,
  );
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRouteImport.update(
    {
      id: '/details/control_test/$id',
      path: '/details/control_test/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    } as any,
  );
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRouteImport.update(
    {
      id: '/details/msp_governance_check/$id',
      path: '/details/msp_governance_check/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    } as any,
  );
const ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute =
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRouteImport.update(
    {
      id: '/details/risk_action/$id',
      path: '/details/risk_action/$id',
      getParentRoute: () => ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute =
  ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRouteImport.update({
    id: '/edit/phone/$callLogId',
    path: '/edit/phone/$callLogId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdActivityRouteRoute,
  } as any);
const ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRouteImport.update(
    {
      id: '/suppliers/details/$supplierId',
      path: '/suppliers/details/$supplierId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteImport.update(
    {
      id: '/suppliers/reassign/$supplierId',
      path: '/suppliers/reassign/$supplierId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdContactsRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteImport.update(
    {
      id: '/compensations/details/$compensationId',
      path: '/compensations/details/$compensationId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteImport.update(
    {
      id: '/excesses/details/$excessId',
      path: '/excesses/details/$excessId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteImport.update(
    {
      id: '/reserves/details/$reserveId',
      path: '/reserves/details/$reserveId',
      getParentRoute: () => ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute =
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRouteImport.update({
    id: '/supplier-jobs/edit/$jobId',
    path: '/supplier-jobs/edit/$jobId',
    getParentRoute: () => ConsoleOrgIdClaimsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRouteImport.update(
    {
      id: '/note/add',
      path: '/note/add',
      getParentRoute: () =>
        ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute,
    } as any,
  );
const ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRouteImport.update({
    id: '/note/add',
    path: '/note/add',
    getParentRoute: () =>
      ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute,
  } as any);
const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRouteImport.update(
    {
      id: '/claim-statuses/edit/$claimStatusId',
      path: '/claim-statuses/edit/$claimStatusId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteImport.update(
    {
      id: '/$taskListId/tasks',
      path: '/$taskListId/tasks',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRouteImport.update(
    {
      id: '/excluded/edit/$id',
      path: '/excluded/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRouteImport.update(
    {
      id: '/identified/edit/$id',
      path: '/identified/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRouteImport.update(
    {
      id: '/categories/edit/$id',
      path: '/categories/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute,
    } as any,
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRouteImport.update(
    {
      id: '/check/$checkId',
      path: '/check/$checkId',
      getParentRoute: () =>
        ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
    } as any,
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRouteImport.update(
    {
      id: '/check/add',
      path: '/check/add',
      getParentRoute: () =>
        ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
    } as any,
  );
const ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRouteImport.update(
    {
      id: '/edit/$arrangementId',
      path: '/edit/$arrangementId',
      getParentRoute: () =>
        ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute,
    } as any,
  );
const ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRouteImport.update(
    {
      id: '/action-plan/$actionPlanId',
      path: '/action-plan/$actionPlanId',
      getParentRoute: () =>
        ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute,
    } as any,
  );
const ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRouteImport.update(
    {
      id: '/action-plan/add',
      path: '/action-plan/add',
      getParentRoute: () =>
        ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRouteImport.update(
    {
      id: '/compensation-payments/add',
      path: '/compensation-payments/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRouteImport.update(
    {
      id: '/excess-payments/add',
      path: '/excess-payments/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRouteImport.update(
    {
      id: '/suppliers/add',
      path: '/suppliers/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteImport.update(
    {
      id: '/financials',
      path: '/financials',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRouteImport.update(
    {
      id: '/library',
      path: '/library',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRouteImport.update(
    {
      id: '/payee',
      path: '/payee',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRouteImport.update(
    {
      id: '/payment',
      path: '/payment',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRouteImport.update(
    {
      id: '/library',
      path: '/library',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRouteImport.update(
    {
      id: '/manage',
      path: '/manage',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRouteImport.update(
    {
      id: '/payments',
      path: '/payments',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRouteImport.update(
    {
      id: '/compensation-payments',
      path: '/compensation-payments',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRouteImport.update(
    {
      id: '/library',
      path: '/library',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteImport.update(
    {
      id: '/reserve-adjustments',
      path: '/reserve-adjustments',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRouteImport.update(
    {
      id: '/edit/$thirdPartyContactTypeId',
      path: '/edit/$thirdPartyContactTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRouteImport.update(
    {
      id: '/edit/$transactionTypeId',
      path: '/edit/$transactionTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteImport.update(
    {
      id: '/product-versions/details/$productVersionId',
      path: '/product-versions/details/$productVersionId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRouteImport.update(
    {
      id: '/contacts/add',
      path: '/contacts/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRouteImport.update(
    {
      id: '/edit/$id',
      path: '/edit/$id',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteImport.update(
    {
      id: '/contact-types',
      path: '/contact-types',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRouteImport.update(
    {
      id: '/details',
      path: '/details',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRouteImport.update(
    {
      id: '/documents',
      path: '/documents',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRouteImport.update(
    {
      id: '/fields',
      path: '/fields',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRouteImport.update(
    {
      id: '/contacts/edit/$contactId',
      path: '/contacts/edit/$contactId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRouteImport.update(
    {
      id: '/compensation-payments/details/$compensationPaymentId',
      path: '/compensation-payments/details/$compensationPaymentId',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute,
    } as any,
  );
const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRouteImport.update(
    {
      id: '/excess-payments/details/$excessPaymentId',
      path: '/excess-payments/details/$excessPaymentId',
      getParentRoute: () =>
        ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute,
    } as any,
  );
const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRouteImport.update(
    {
      id: '/edit/$contactTypeId',
      path: '/edit/$contactTypeId',
      getParentRoute: () =>
        ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/admin-consent': typeof AdminConsentRoute;
  '/admin-console': typeof AdminConsoleRouteRouteWithChildren;
  '/attestation': typeof AttestationRouteRouteWithChildren;
  '/invite': typeof InviteRouteRoute;
  '/maintenance': typeof MaintenanceRoute;
  '/not-found': typeof NotFoundRoute;
  '/not-supported': typeof NotSupportedRoute;
  '/oauth': typeof OauthRouteRouteWithChildren;
  '/org-switched': typeof OrgSwitchedRoute;
  '/public': typeof PublicRouteRouteWithChildren;
  '/status': typeof StatusRoute;
  '/terms-acceptance': typeof TermsAcceptanceRouteRoute;
  '/admin-console/': typeof AdminConsoleIndexRoute;
  '/admin-login': typeof authenticationAdminLoginRoute;
  '/callback': typeof authenticationCallbackRoute;
  '/login': typeof authenticationLoginRoute;
  '/logout': typeof authenticationLogoutRoute;
  '/logoutin': typeof authenticationLogoutinRoute;
  '/org-mismatch': typeof authenticationOrgMismatchRoute;
  '/payment-pending': typeof authenticationPaymentPendingRoute;
  '/admin-console/advanced': typeof AdminConsoleAdvancedRouteRouteWithChildren;
  '/admin-console/ai': typeof AdminConsoleAiRouteRouteWithChildren;
  '/admin-console/authorised-apps': typeof AdminConsoleAuthorisedAppsRouteRoute;
  '/admin-console/monitoring': typeof AdminConsoleMonitoringRouteRouteWithChildren;
  '/admin-console/organisation-management': typeof AdminConsoleOrganisationManagementRouteRouteWithChildren;
  '/admin-console/platform-content': typeof AdminConsolePlatformContentRouteRouteWithChildren;
  '/admin-console/tools': typeof AdminConsoleToolsRouteRouteWithChildren;
  '/admin-console/user-access': typeof AdminConsoleUserAccessRouteRouteWithChildren;
  '/attestation/$token': typeof AttestationTokenRoute;
  '/console/$orgId': typeof ConsoleOrgIdRouteRouteWithChildren;
  '/oauth/authorize': typeof OauthAuthorizeRoute;
  '/password-reset/request': typeof PasswordResetRequestRoute;
  '/password-reset/reset': typeof PasswordResetResetRoute;
  '/public/$orgId': typeof PublicOrgIdRouteRouteWithChildren;
  '/whats-new/$releaseId': typeof WhatsNewReleaseIdRoute;
  '/admin-console/advanced/': typeof AdminConsoleAdvancedIndexRoute;
  '/admin-console/monitoring/': typeof AdminConsoleMonitoringIndexRoute;
  '/admin-console/platform-content/': typeof AdminConsolePlatformContentIndexRoute;
  '/admin-console/tools/': typeof AdminConsoleToolsIndexRoute;
  '/admin-console/user-access/': typeof AdminConsoleUserAccessIndexRoute;
  '/console/$orgId/': typeof ConsoleOrgIdIndexRoute;
  '/change-org/$orgId': typeof authenticationChangeOrgOrgIdRoute;
  '/admin-console/advanced/app-settings': typeof AdminConsoleAdvancedAppSettingsRouteRouteWithChildren;
  '/admin-console/advanced/claims': typeof AdminConsoleAdvancedClaimsRoute;
  '/admin-console/advanced/db-stats': typeof AdminConsoleAdvancedDbStatsRoute;
  '/admin-console/advanced/db-upgrades': typeof AdminConsoleAdvancedDbUpgradesRoute;
  '/admin-console/advanced/inbound-email-archive': typeof AdminConsoleAdvancedInboundEmailArchiveRouteRoute;
  '/admin-console/advanced/inbound-parse': typeof AdminConsoleAdvancedInboundParseRouteRouteWithChildren;
  '/admin-console/advanced/indicators': typeof AdminConsoleAdvancedIndicatorsRouteRouteWithChildren;
  '/admin-console/advanced/integration-tests': typeof AdminConsoleAdvancedIntegrationTestsRoute;
  '/admin-console/advanced/jobs': typeof AdminConsoleAdvancedJobsRouteRouteWithChildren;
  '/admin-console/advanced/playground': typeof AdminConsoleAdvancedPlaygroundRouteRoute;
  '/admin-console/advanced/weaviate': typeof AdminConsoleAdvancedWeaviateRoute;
  '/admin-console/ai/ai-feedback': typeof AdminConsoleAiAiFeedbackRouteRoute;
  '/admin-console/ai/ai-prompts': typeof AdminConsoleAiAiPromptsRouteRoute;
  '/admin-console/ai/eval-runs': typeof AdminConsoleAiEvalRunsRouteRouteWithChildren;
  '/admin-console/ai/model-pricing': typeof AdminConsoleAiModelPricingRouteRoute;
  '/admin-console/ai/model-tiers': typeof AdminConsoleAiModelTiersRouteRoute;
  '/admin-console/ai/request-analytics': typeof AdminConsoleAiRequestAnalyticsRouteRoute;
  '/admin-console/ai/statistics': typeof AdminConsoleAiStatisticsRouteRoute;
  '/admin-console/ai/usage-billing': typeof AdminConsoleAiUsageBillingRouteRoute;
  '/admin-console/monitoring/audit-trail': typeof AdminConsoleMonitoringAuditTrailRouteRoute;
  '/admin-console/monitoring/axiom-logs': typeof AdminConsoleMonitoringAxiomLogsRouteRoute;
  '/admin-console/monitoring/compliance': typeof AdminConsoleMonitoringComplianceRouteRoute;
  '/admin-console/monitoring/compliance-audit': typeof AdminConsoleMonitoringComplianceAuditRouteRouteWithChildren;
  '/admin-console/monitoring/email-activity': typeof AdminConsoleMonitoringEmailActivityRouteRouteWithChildren;
  '/admin-console/monitoring/engagement': typeof AdminConsoleMonitoringEngagementRouteRouteWithChildren;
  '/admin-console/monitoring/llm-logs': typeof AdminConsoleMonitoringLlmLogsRouteRoute;
  '/admin-console/monitoring/llm-stats': typeof AdminConsoleMonitoringLlmStatsRouteRoute;
  '/admin-console/monitoring/memory': typeof AdminConsoleMonitoringMemoryRouteRoute;
  '/admin-console/monitoring/reports': typeof AdminConsoleMonitoringReportsRouteRoute;
  '/admin-console/monitoring/statistics': typeof AdminConsoleMonitoringStatisticsRouteRoute;
  '/admin-console/organisation-management/new': typeof AdminConsoleOrganisationManagementNewRouteRoute;
  '/admin-console/organisation-management/new-from-template': typeof AdminConsoleOrganisationManagementNewFromTemplateRouteRoute;
  '/admin-console/organisation-management/organisations': typeof AdminConsoleOrganisationManagementOrganisationsRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training': typeof AdminConsolePlatformContentAiTrainingRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content': typeof AdminConsolePlatformContentCommsAndContentRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates': typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteWithChildren;
  '/admin-console/platform-content/market-pds': typeof AdminConsolePlatformContentMarketPdsRouteRouteWithChildren;
  '/admin-console/platform-content/obligations': typeof AdminConsolePlatformContentObligationsRouteRouteWithChildren;
  '/admin-console/platform-content/products': typeof AdminConsolePlatformContentProductsRouteRouteWithChildren;
  '/admin-console/platform-content/whats-new': typeof AdminConsolePlatformContentWhatsNewRouteRouteWithChildren;
  '/admin-console/tools/document-to-markdown': typeof AdminConsoleToolsDocumentToMarkdownRoute;
  '/admin-console/tools/feature-flags': typeof AdminConsoleToolsFeatureFlagsRoute;
  '/admin-console/tools/sanitise-text-pii': typeof AdminConsoleToolsSanitiseTextPiiRouteRouteWithChildren;
  '/admin-console/user-access/admin-users': typeof AdminConsoleUserAccessAdminUsersRouteRouteWithChildren;
  '/admin-console/user-access/support-sessions': typeof AdminConsoleUserAccessSupportSessionsRouteRoute;
  '/admin-console/user-access/users': typeof AdminConsoleUserAccessUsersRouteRouteWithChildren;
  '/console/$orgId/attestations': typeof ConsoleOrgIdAttestationsRouteRouteWithChildren;
  '/console/$orgId/claims': typeof ConsoleOrgIdClaimsRouteRouteWithChildren;
  '/console/$orgId/compliance': typeof ConsoleOrgIdComplianceRouteRouteWithChildren;
  '/console/$orgId/component-showcase': typeof ConsoleOrgIdComponentShowcaseRouteRouteWithChildren;
  '/console/$orgId/configuration': typeof ConsoleOrgIdConfigurationRouteRouteWithChildren;
  '/console/$orgId/controls': typeof ConsoleOrgIdControlsRouteRouteWithChildren;
  '/console/$orgId/dashboard': typeof ConsoleOrgIdDashboardRouteRouteWithChildren;
  '/console/$orgId/documents': typeof ConsoleOrgIdDocumentsRouteRouteWithChildren;
  '/console/$orgId/faq': typeof ConsoleOrgIdFaqRouteRoute;
  '/console/$orgId/fleet-portal': typeof ConsoleOrgIdFleetPortalRouteRouteWithChildren;
  '/console/$orgId/get-file': typeof ConsoleOrgIdGetFileRouteRoute;
  '/console/$orgId/mspr': typeof ConsoleOrgIdMsprRouteRouteWithChildren;
  '/console/$orgId/reporting': typeof ConsoleOrgIdReportingRouteRouteWithChildren;
  '/console/$orgId/risk': typeof ConsoleOrgIdRiskRouteRouteWithChildren;
  '/console/$orgId/tools': typeof ConsoleOrgIdToolsRouteRouteWithChildren;
  '/console/$orgId/tools-only-home-page': typeof ConsoleOrgIdToolsOnlyHomePageRoute;
  '/console/$orgId/user-settings': typeof ConsoleOrgIdUserSettingsRouteRouteWithChildren;
  '/console/$orgId/workload-manager': typeof ConsoleOrgIdWorkloadManagerRouteRouteWithChildren;
  '/public/lodgement-summary/$accessKey': typeof PublicLodgementSummaryAccessKeyRouteRoute;
  '/public/new-complaint-by-key/$key': typeof PublicNewComplaintByKeyKeyRouteRoute;
  '/public/new-complaint/$orgId': typeof PublicNewComplaintOrgIdRouteRoute;
  '/admin-console/advanced/inbound-parse/': typeof AdminConsoleAdvancedInboundParseIndexRoute;
  '/admin-console/advanced/jobs/': typeof AdminConsoleAdvancedJobsIndexRoute;
  '/admin-console/monitoring/email-activity/': typeof AdminConsoleMonitoringEmailActivityIndexRoute;
  '/admin-console/monitoring/engagement/': typeof AdminConsoleMonitoringEngagementIndexRoute;
  '/admin-console/organisation-management/organisations/': typeof AdminConsoleOrganisationManagementOrganisationsIndexRoute;
  '/admin-console/platform-content/ai-training/': typeof AdminConsolePlatformContentAiTrainingIndexRoute;
  '/admin-console/platform-content/compliance-audit-templates/': typeof AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute;
  '/admin-console/platform-content/obligations/': typeof AdminConsolePlatformContentObligationsIndexRoute;
  '/admin-console/platform-content/whats-new/': typeof AdminConsolePlatformContentWhatsNewIndexRoute;
  '/console/$orgId/attestations/': typeof ConsoleOrgIdAttestationsIndexRoute;
  '/console/$orgId/claims/': typeof ConsoleOrgIdClaimsIndexRoute;
  '/console/$orgId/compliance/': typeof ConsoleOrgIdComplianceIndexRoute;
  '/console/$orgId/component-showcase/': typeof ConsoleOrgIdComponentShowcaseIndexRoute;
  '/console/$orgId/configuration/': typeof ConsoleOrgIdConfigurationIndexRoute;
  '/console/$orgId/controls/': typeof ConsoleOrgIdControlsIndexRoute;
  '/console/$orgId/dashboard/': typeof ConsoleOrgIdDashboardIndexRoute;
  '/console/$orgId/debug/': typeof ConsoleOrgIdDebugIndexRoute;
  '/console/$orgId/fleet-portal/': typeof ConsoleOrgIdFleetPortalIndexRoute;
  '/console/$orgId/risk/': typeof ConsoleOrgIdRiskIndexRoute;
  '/console/$orgId/tools/': typeof ConsoleOrgIdToolsIndexRoute;
  '/console/$orgId/user-settings/': typeof ConsoleOrgIdUserSettingsIndexRoute;
  '/console/$orgId/workload-manager/': typeof ConsoleOrgIdWorkloadManagerIndexRoute;
  '/admin-console/advanced/app-settings/all': typeof AdminConsoleAdvancedAppSettingsAllRouteRouteWithChildren;
  '/admin-console/advanced/app-settings/well-known': typeof AdminConsoleAdvancedAppSettingsWellKnownRoute;
  '/admin-console/advanced/indicators/complaints': typeof AdminConsoleAdvancedIndicatorsComplaintsRoute;
  '/admin-console/advanced/indicators/incidents': typeof AdminConsoleAdvancedIndicatorsIncidentsRoute;
  '/admin-console/advanced/jobs/dynamic-recurring': typeof AdminConsoleAdvancedJobsDynamicRecurringRouteWithChildren;
  '/admin-console/advanced/jobs/on-demand': typeof AdminConsoleAdvancedJobsOnDemandRouteWithChildren;
  '/admin-console/advanced/jobs/recurring': typeof AdminConsoleAdvancedJobsRecurringRouteWithChildren;
  '/admin-console/ai/eval-runs/$evalRunId': typeof AdminConsoleAiEvalRunsEvalRunIdRouteRoute;
  '/admin-console/ai/eval-runs/compare': typeof AdminConsoleAiEvalRunsCompareRouteRoute;
  '/admin-console/organisation-management/organisations/$orgId': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training/classification-example': typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training/vulnerability-example': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/app-text': typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/comm-templates': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/faq': typeof AdminConsolePlatformContentCommsAndContentFaqRouteRoute;
  '/admin-console/platform-content/compliance-audit-templates/search': typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteWithChildren;
  '/admin-console/platform-content/market-pds/add': typeof AdminConsolePlatformContentMarketPdsAddRoute;
  '/admin-console/platform-content/obligations/configuration': typeof AdminConsolePlatformContentObligationsConfigurationRouteRoute;
  '/admin-console/platform-content/obligations/controls-library': typeof AdminConsolePlatformContentObligationsControlsLibraryRouteRouteWithChildren;
  '/admin-console/platform-content/obligations/library': typeof AdminConsolePlatformContentObligationsLibraryRouteRouteWithChildren;
  '/admin-console/platform-content/products/$serviceId': typeof AdminConsolePlatformContentProductsServiceIdRoute;
  '/admin-console/platform-content/whats-new/$id': typeof AdminConsolePlatformContentWhatsNewIdRoute;
  '/admin-console/platform-content/whats-new/new': typeof AdminConsolePlatformContentWhatsNewNewRoute;
  '/admin-console/tools/sanitise-text-pii/compare': typeof AdminConsoleToolsSanitiseTextPiiCompareRoute;
  '/admin-console/tools/sanitise-text-pii/tool': typeof AdminConsoleToolsSanitiseTextPiiToolRoute;
  '/admin-console/user-access/admin-users/grant': typeof AdminConsoleUserAccessAdminUsersGrantRoute;
  '/console/$orgId/attestations/scheduled-attestations': typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren;
  '/console/$orgId/attestations/user-attestations': typeof ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren;
  '/console/$orgId/compliance/coi': typeof ConsoleOrgIdComplianceCoiRouteRouteWithChildren;
  '/console/$orgId/compliance/complaints': typeof ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents': typeof ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren;
  '/console/$orgId/compliance/intake': typeof ConsoleOrgIdComplianceIntakeRouteRoute;
  '/console/$orgId/compliance/obligations': typeof ConsoleOrgIdComplianceObligationsRouteRouteWithChildren;
  '/console/$orgId/compliance/registers': typeof ConsoleOrgIdComplianceRegistersRouteRouteWithChildren;
  '/console/$orgId/compliance/training': typeof ConsoleOrgIdComplianceTrainingRouteRouteWithChildren;
  '/console/$orgId/component-showcase/ai-chat-test': typeof ConsoleOrgIdComponentShowcaseAiChatTestRoute;
  '/console/$orgId/component-showcase/button-icon-test': typeof ConsoleOrgIdComponentShowcaseButtonIconTestRoute;
  '/console/$orgId/component-showcase/button-variants': typeof ConsoleOrgIdComponentShowcaseButtonVariantsRoute;
  '/console/$orgId/component-showcase/component-showcase': typeof ConsoleOrgIdComponentShowcaseComponentShowcaseRoute;
  '/console/$orgId/component-showcase/date-picker-test': typeof ConsoleOrgIdComponentShowcaseDatePickerTestRoute;
  '/console/$orgId/component-showcase/fit-on-page': typeof ConsoleOrgIdComponentShowcaseFitOnPageRoute;
  '/console/$orgId/component-showcase/markdown-showcase': typeof ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute;
  '/console/$orgId/component-showcase/table-showcase': typeof ConsoleOrgIdComponentShowcaseTableShowcaseRoute;
  '/console/$orgId/component-showcase/tag-variants': typeof ConsoleOrgIdComponentShowcaseTagVariantsRoute;
  '/console/$orgId/component-showcase/tiptap-test': typeof ConsoleOrgIdComponentShowcaseTiptapTestRoute;
  '/console/$orgId/configuration/api-integrations': typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products': typeof ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren;
  '/console/$orgId/configuration/client-database': typeof ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren;
  '/console/$orgId/configuration/compliance': typeof ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren;
  '/console/$orgId/configuration/financials': typeof ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren;
  '/console/$orgId/configuration/fleet': typeof ConsoleOrgIdConfigurationFleetRouteRouteWithChildren;
  '/console/$orgId/configuration/monitoring': typeof ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings': typeof ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren;
  '/console/$orgId/configuration/risk': typeof ConsoleOrgIdConfigurationRiskRouteRouteWithChildren;
  '/console/$orgId/configuration/vendor-management': typeof ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren;
  '/console/$orgId/controls/activities': typeof ConsoleOrgIdControlsActivitiesRouteRoute;
  '/console/$orgId/controls/register': typeof ConsoleOrgIdControlsRegisterRouteRouteWithChildren;
  '/console/$orgId/controls/tests': typeof ConsoleOrgIdControlsTestsRouteRoute;
  '/console/$orgId/dashboard/claims': typeof ConsoleOrgIdDashboardClaimsRoute;
  '/console/$orgId/dashboard/complaints': typeof ConsoleOrgIdDashboardComplaintsRoute;
  '/console/$orgId/dashboard/incidents': typeof ConsoleOrgIdDashboardIncidentsRoute;
  '/console/$orgId/dashboard/management': typeof ConsoleOrgIdDashboardManagementRoute;
  '/console/$orgId/dashboard/people-and-culture': typeof ConsoleOrgIdDashboardPeopleAndCultureRoute;
  '/console/$orgId/dashboard/risks': typeof ConsoleOrgIdDashboardRisksRoute;
  '/console/$orgId/fleet-portal/authorisations': typeof ConsoleOrgIdFleetPortalAuthorisationsRoute;
  '/console/$orgId/fleet-portal/claims': typeof ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren;
  '/console/$orgId/fleet-portal/dashboard': typeof ConsoleOrgIdFleetPortalDashboardRoute;
  '/console/$orgId/fleet-portal/fleet': typeof ConsoleOrgIdFleetPortalFleetRoute;
  '/console/$orgId/fleet-portal/sla': typeof ConsoleOrgIdFleetPortalSlaRoute;
  '/console/$orgId/mspr/msp-exceptions': typeof ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren;
  '/console/$orgId/mspr/service-providers': typeof ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren;
  '/console/$orgId/reporting/add': typeof ConsoleOrgIdReportingAddRoute;
  '/console/$orgId/risk/ras': typeof ConsoleOrgIdRiskRasRouteRouteWithChildren;
  '/console/$orgId/risk/register': typeof ConsoleOrgIdRiskRegisterRouteRouteWithChildren;
  '/console/$orgId/tools/auto-detect': typeof ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit': typeof ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer': typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren;
  '/console/$orgId/tools/pds-compare': typeof ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren;
  '/console/$orgId/tools/website-checker': typeof ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren;
  '/console/$orgId/user-settings/notifications': typeof ConsoleOrgIdUserSettingsNotificationsRoute;
  '/console/$orgId/user-settings/profile': typeof ConsoleOrgIdUserSettingsProfileRoute;
  '/console/$orgId/workload-manager/complaints': typeof ConsoleOrgIdWorkloadManagerComplaintsRoute;
  '/console/$orgId/workload-manager/emails': typeof ConsoleOrgIdWorkloadManagerEmailsRouteRoute;
  '/console/$orgId/workload-manager/tasks': typeof ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren;
  '/public/$orgId/complaint/new': typeof PublicOrgIdComplaintNewRouteRoute;
  '/admin-console/platform-content/obligations/controls-library/': typeof AdminConsolePlatformContentObligationsControlsLibraryIndexRoute;
  '/admin-console/platform-content/obligations/library/': typeof AdminConsolePlatformContentObligationsLibraryIndexRoute;
  '/console/$orgId/compliance/coi/': typeof ConsoleOrgIdComplianceCoiIndexRoute;
  '/console/$orgId/compliance/complaints/': typeof ConsoleOrgIdComplianceComplaintsIndexRoute;
  '/console/$orgId/compliance/incidents/': typeof ConsoleOrgIdComplianceIncidentsIndexRoute;
  '/console/$orgId/compliance/obligations/': typeof ConsoleOrgIdComplianceObligationsIndexRoute;
  '/console/$orgId/compliance/registers/': typeof ConsoleOrgIdComplianceRegistersIndexRoute;
  '/console/$orgId/compliance/training/': typeof ConsoleOrgIdComplianceTrainingIndexRoute;
  '/console/$orgId/configuration/compliance/': typeof ConsoleOrgIdConfigurationComplianceIndexRoute;
  '/console/$orgId/configuration/fleet/': typeof ConsoleOrgIdConfigurationFleetIndexRoute;
  '/console/$orgId/configuration/risk/': typeof ConsoleOrgIdConfigurationRiskIndexRoute;
  '/console/$orgId/controls/register/': typeof ConsoleOrgIdControlsRegisterIndexRoute;
  '/console/$orgId/fleet-portal/claims/': typeof ConsoleOrgIdFleetPortalClaimsIndexRoute;
  '/console/$orgId/mspr/service-providers/': typeof ConsoleOrgIdMsprServiceProvidersIndexRoute;
  '/console/$orgId/risk/ras/': typeof ConsoleOrgIdRiskRasIndexRoute;
  '/console/$orgId/risk/register/': typeof ConsoleOrgIdRiskRegisterIndexRoute;
  '/console/$orgId/tools/compliance-audit/': typeof ConsoleOrgIdToolsComplianceAuditIndexRoute;
  '/console/$orgId/tools/document-analyzer/': typeof ConsoleOrgIdToolsDocumentAnalyzerIndexRoute;
  '/console/$orgId/tools/pds-compare/': typeof ConsoleOrgIdToolsPdsCompareIndexRoute;
  '/console/$orgId/tools/website-checker/': typeof ConsoleOrgIdToolsWebsiteCheckerIndexRoute;
  '/console/$orgId/user-settings/authorised-apps/': typeof ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute;
  '/console/$orgId/workload-manager/tasks/': typeof ConsoleOrgIdWorkloadManagerTasksIndexRoute;
  '/admin-console/advanced/app-settings/all/add': typeof AdminConsoleAdvancedAppSettingsAllAddRoute;
  '/admin-console/advanced/jobs/dynamic-recurring/$jobId': typeof AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute;
  '/admin-console/advanced/jobs/on-demand/$jobId': typeof AdminConsoleAdvancedJobsOnDemandJobIdRoute;
  '/admin-console/advanced/jobs/recurring/$jobId': typeof AdminConsoleAdvancedJobsRecurringJobIdRoute;
  '/admin-console/organisation-management/organisations/$orgId/subscriptions': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute;
  '/admin-console/organisation-management/organisations/$orgId/users': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteWithChildren;
  '/admin-console/organisation-management/organisations/$orgId/wallet': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute;
  '/admin-console/platform-content/ai-training/classification-example/create': typeof AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/create': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute;
  '/admin-console/platform-content/comms-and-content/app-text/add': typeof AdminConsolePlatformContentCommsAndContentAppTextAddRoute;
  '/admin-console/platform-content/comms-and-content/comm-templates/add': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/search/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute;
  '/admin-console/platform-content/market-pds/edit/$id': typeof AdminConsolePlatformContentMarketPdsEditIdRoute;
  '/admin-console/platform-content/obligations/controls-library/$id': typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteWithChildren;
  '/admin-console/user-access/admin-users/edit/$userId': typeof AdminConsoleUserAccessAdminUsersEditUserIdRoute;
  '/admin-console/user-access/users/edit/$userId': typeof AdminConsoleUserAccessUsersEditUserIdRoute;
  '/admin-console/user-access/users/view/$userId': typeof AdminConsoleUserAccessUsersViewUserIdRoute;
  '/console/$orgId/attestations/scheduled-attestations/$scheduleId': typeof ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute;
  '/console/$orgId/attestations/scheduled-attestations/new': typeof ConsoleOrgIdAttestationsScheduledAttestationsNewRoute;
  '/console/$orgId/attestations/user-attestations/$attestationId': typeof ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute;
  '/console/$orgId/attestations/user-attestations/send': typeof ConsoleOrgIdAttestationsUserAttestationsSendRoute;
  '/console/$orgId/claims/details/$id': typeof ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/coi/add': typeof ConsoleOrgIdComplianceCoiAddRouteRoute;
  '/console/$orgId/compliance/complaints/add': typeof ConsoleOrgIdComplianceComplaintsAddRouteRoute;
  '/console/$orgId/compliance/incidents/add': typeof ConsoleOrgIdComplianceIncidentsAddRoute;
  '/console/$orgId/compliance/obligations/add': typeof ConsoleOrgIdComplianceObligationsAddRouteRoute;
  '/console/$orgId/compliance/registers/$registerId': typeof ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren;
  '/console/$orgId/compliance/training/search': typeof ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/api-tokens': typeof ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute;
  '/console/$orgId/configuration/api-integrations/form-designer': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/mcp-access': typeof ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute;
  '/console/$orgId/configuration/claims-products/claims': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/insurers': typeof ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute;
  '/console/$orgId/configuration/claims-products/product-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/questionnaire': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren;
  '/console/$orgId/configuration/client-database/$': typeof ConsoleOrgIdConfigurationClientDatabaseSplatRoute;
  '/console/$orgId/configuration/compliance/attestations': typeof ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/auto-detect': typeof ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute;
  '/console/$orgId/configuration/compliance/complaints': typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/compliance-audit': typeof ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute;
  '/console/$orgId/configuration/compliance/general': typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents': typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr': typeof ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/obligations': typeof ConsoleOrgIdConfigurationComplianceObligationsRoute;
  '/console/$orgId/configuration/compliance/training': typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren;
  '/console/$orgId/configuration/financials/billing': typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren;
  '/console/$orgId/configuration/financials/expenses-billing': typeof ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute;
  '/console/$orgId/configuration/financials/payments': typeof ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute;
  '/console/$orgId/configuration/fleet/client-database': typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren;
  '/console/$orgId/configuration/fleet/delegated-authority': typeof ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute;
  '/console/$orgId/configuration/fleet/escalations': typeof ConsoleOrgIdConfigurationFleetEscalationsRouteRoute;
  '/console/$orgId/configuration/fleet/portal-claim-page': typeof ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute;
  '/console/$orgId/configuration/monitoring/audit-trail': typeof ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute;
  '/console/$orgId/configuration/monitoring/email-activity': typeof ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute;
  '/console/$orgId/configuration/monitoring/statistics': typeof ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute;
  '/console/$orgId/configuration/org-settings/communication': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/fleet-escalations': typeof ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute;
  '/console/$orgId/configuration/org-settings/handling-parties': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/support-sessions': typeof ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute;
  '/console/$orgId/configuration/org-settings/system': typeof ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute;
  '/console/$orgId/configuration/org-settings/tasks': typeof ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute;
  '/console/$orgId/configuration/org-settings/trash': typeof ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute;
  '/console/$orgId/configuration/org-settings/users': typeof ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren;
  '/console/$orgId/configuration/risk/appetite': typeof ConsoleOrgIdConfigurationRiskAppetiteRoute;
  '/console/$orgId/configuration/risk/categories': typeof ConsoleOrgIdConfigurationRiskCategoriesRoute;
  '/console/$orgId/configuration/risk/matrix': typeof ConsoleOrgIdConfigurationRiskMatrixRoute;
  '/console/$orgId/configuration/vendor-management/suppliers': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren;
  '/console/$orgId/controls/register/add': typeof ConsoleOrgIdControlsRegisterAddRouteRoute;
  '/console/$orgId/documents/details/$fileId': typeof ConsoleOrgIdDocumentsDetailsFileIdRouteRoute;
  '/console/$orgId/mspr/service-providers/search': typeof ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren;
  '/console/$orgId/tools/auto-detect/dashboard': typeof ConsoleOrgIdToolsAutoDetectDashboardRoute;
  '/console/$orgId/tools/auto-detect/inbox': typeof ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/overview': typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer/history': typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer/upload': typeof ConsoleOrgIdToolsDocumentAnalyzerUploadRoute;
  '/console/$orgId/tools/pds-compare/pds-documents': typeof ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren;
  '/console/$orgId/workload-manager/tasks/calendar': typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren;
  '/console/$orgId/workload-manager/tasks/list': typeof ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren;
  '/public/$orgId/invoice/view/$accessKey': typeof PublicOrgIdInvoiceViewAccessKeyRouteRoute;
  '/console/$orgId/compliance/registers/$registerId/': typeof ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute;
  '/console/$orgId/configuration/api-integrations/form-designer/': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute;
  '/console/$orgId/configuration/claims-products/claims/': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute;
  '/console/$orgId/configuration/compliance/complaints/': typeof ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute;
  '/console/$orgId/configuration/compliance/general/': typeof ConsoleOrgIdConfigurationComplianceGeneralIndexRoute;
  '/console/$orgId/configuration/compliance/incidents/': typeof ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute;
  '/console/$orgId/configuration/compliance/training/': typeof ConsoleOrgIdConfigurationComplianceTrainingIndexRoute;
  '/console/$orgId/configuration/org-settings/users/': typeof ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute;
  '/console/$orgId/tools/compliance-audit/overview/': typeof ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute;
  '/admin-console/advanced/app-settings/all/edit/$name': typeof AdminConsoleAdvancedAppSettingsAllEditNameRoute;
  '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics': typeof AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute;
  '/admin-console/platform-content/ai-training/classification-example/edit/$id': typeof AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute;
  '/admin-console/platform-content/ai-training/classification-example/view/$id': typeof AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/view/$id': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute;
  '/admin-console/platform-content/comms-and-content/app-text/edit/$id': typeof AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute;
  '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute;
  '/admin-console/platform-content/obligations/controls-library/$id/details': typeof AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute;
  '/admin-console/platform-content/obligations/controls-library/$id/history': typeof AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute;
  '/admin-console/platform-content/obligations/library/details/$id': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/activity': typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/ai-assessment': typeof ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute;
  '/console/$orgId/claims/details/$id/comms': typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/contacts': typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/expenses': typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials': typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/history': typeof ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute;
  '/console/$orgId/claims/details/$id/library': typeof ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute;
  '/console/$orgId/claims/details/$id/manage': typeof ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/policy-info': typeof ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute;
  '/console/$orgId/claims/details/$id/product-type-data': typeof ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute;
  '/console/$orgId/claims/details/$id/vehicle': typeof ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute;
  '/console/$orgId/compliance/coi/details/$id': typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/complaints/details/$id': typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents/details/$id': typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/obligations/details/$id': typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/training/search/add': typeof ConsoleOrgIdComplianceTrainingSearchAddRoute;
  '/console/$orgId/compliance/training/user/$userId': typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/claim-flags': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/documents': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute;
  '/console/$orgId/configuration/claims-products/claims/general': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/handling-standards': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute;
  '/console/$orgId/configuration/claims-products/claims/id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute;
  '/console/$orgId/configuration/claims-products/products-v2/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute;
  '/console/$orgId/configuration/claims-products/questionnaire/add': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute;
  '/console/$orgId/configuration/compliance/attestations/user-attestations': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/complaints/brands': typeof ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute;
  '/console/$orgId/configuration/compliance/complaints/custom-fields': typeof ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/complaints/flags': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/complaints/general': typeof ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute;
  '/console/$orgId/configuration/compliance/complaints/rules': typeof ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute;
  '/console/$orgId/configuration/compliance/general/asic-products': typeof ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute;
  '/console/$orgId/configuration/compliance/general/documents': typeof ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute;
  '/console/$orgId/configuration/compliance/incidents/custom-fields': typeof ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/incidents/flags': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents/general': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents/rules': typeof ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr/definitions': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr/documents': typeof ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/training/custom-fields': typeof ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/training/training-periods': typeof ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute;
  '/console/$orgId/configuration/financials/billing/balance': typeof ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute;
  '/console/$orgId/configuration/financials/billing/billing-info': typeof ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute;
  '/console/$orgId/configuration/financials/billing/invoices': typeof ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute;
  '/console/$orgId/configuration/financials/billing/transactions': typeof ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute;
  '/console/$orgId/configuration/financials/billing/usage': typeof ConsoleOrgIdConfigurationFinancialsBillingUsageRoute;
  '/console/$orgId/configuration/fleet/client-database/add': typeof ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/communication/comm-templates': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/handling-parties/add': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/add': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/definitions': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute;
  '/console/$orgId/controls/register/details/$id': typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren;
  '/console/$orgId/fleet-portal/claims/details/$claimId': typeof ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute;
  '/console/$orgId/mspr/msp-exceptions/edit/$id': typeof ConsoleOrgIdMsprMspExceptionsEditIdRoute;
  '/console/$orgId/mspr/service-providers/details/$id': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren;
  '/console/$orgId/mspr/service-providers/search/add': typeof ConsoleOrgIdMsprServiceProvidersSearchAddRoute;
  '/console/$orgId/risk/ras/details/$id': typeof ConsoleOrgIdRiskRasDetailsIdRouteRoute;
  '/console/$orgId/risk/register/details/$id': typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/details/$complianceAuditId': typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/overview/insights': typeof ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute;
  '/console/$orgId/tools/compliance-audit/overview/search': typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren;
  '/console/$orgId/tools/website-checker/report/$id': typeof ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute;
  '/console/$orgId/workload-manager/tasks/calendar/add': typeof ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute;
  '/console/$orgId/workload-manager/tasks/list/add': typeof ConsoleOrgIdWorkloadManagerTasksListAddRoute;
  '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/console/$orgId/compliance/coi/details/$id/': typeof ConsoleOrgIdComplianceCoiDetailsIdIndexRoute;
  '/console/$orgId/compliance/complaints/details/$id/': typeof ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute;
  '/console/$orgId/compliance/incidents/details/$id/': typeof ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute;
  '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute;
  '/console/$orgId/configuration/compliance/incidents/general/': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute;
  '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute;
  '/admin-console/platform-content/obligations/library/details/$id/ai-related': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute;
  '/admin-console/platform-content/obligations/library/details/$id/document-analyser': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute;
  '/admin-console/platform-content/obligations/library/details/$id/history': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute;
  '/admin-console/platform-content/obligations/library/details/$id/manage': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute;
  '/console/$orgId/claims/details/$id/comms/add': typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/contacts/add': typeof ConsoleOrgIdClaimsDetailsIdContactsAddRoute;
  '/console/$orgId/claims/details/$id/expenses/add': typeof ConsoleOrgIdClaimsDetailsIdExpensesAddRoute;
  '/console/$orgId/compliance/coi/details/$id/library': typeof ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute;
  '/console/$orgId/compliance/coi/details/$id/manage': typeof ConsoleOrgIdComplianceCoiDetailsIdManageRoute;
  '/console/$orgId/compliance/complaints/details/$id/comms': typeof ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/history': typeof ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/library': typeof ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents/details/$id/history': typeof ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/library': typeof ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/compliance/obligations/details/$id/debug': typeof ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute;
  '/console/$orgId/compliance/obligations/details/$id/manage': typeof ConsoleOrgIdComplianceObligationsDetailsIdManageRoute;
  '/console/$orgId/compliance/registers/$registerId/records/$recordId': typeof ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute;
  '/console/$orgId/compliance/training/user/$userId/add': typeof ConsoleOrgIdComplianceTrainingUserUserIdAddRoute;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/claim-flags/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/states/$id': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2/edit/$productId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute;
  '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute;
  '/console/$orgId/configuration/compliance/attestations/user-attestations/add': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute;
  '/console/$orgId/configuration/compliance/complaints/flags/add': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute;
  '/console/$orgId/configuration/compliance/incidents/flags/add': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute;
  '/console/$orgId/configuration/compliance/incidents/general/incident-details': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute;
  '/console/$orgId/configuration/compliance/incidents/general/lodgement': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute;
  '/console/$orgId/configuration/compliance/incidents/general/rectification': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute;
  '/console/$orgId/configuration/compliance/incidents/general/timeline': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config/add': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute;
  '/console/$orgId/configuration/financials/billing/payment/success': typeof ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures/add': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-templates/add': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute;
  '/console/$orgId/configuration/org-settings/handling-parties/details/$id': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/users/details/$userId': typeof ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/definitions': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/list': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute;
  '/console/$orgId/mspr/service-providers/details/$id/history': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/library': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/action-plan': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/assessment': typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/history': typeof ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute;
  '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification': typeof ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute;
  '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics': typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute;
  '/console/$orgId/tools/compliance-audit/overview/search/add': typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute;
  '/console/$orgId/tools/document-analyzer/history/$id/results': typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute;
  '/console/$orgId/tools/pds-compare/pds-documents/edit/$id': typeof ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute;
  '/console/$orgId/workload-manager/tasks/list/details/$id': typeof ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute;
  '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/details/$id/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute;
  '/console/$orgId/claims/details/$id/activity/add/phone': typeof ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute;
  '/console/$orgId/claims/details/$id/comms/add/email': typeof ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute;
  '/console/$orgId/claims/details/$id/comms/add/sms': typeof ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute;
  '/console/$orgId/claims/details/$id/comms/message/$messageId': typeof ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute;
  '/console/$orgId/claims/details/$id/comms/reply/$messageId': typeof ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute;
  '/console/$orgId/claims/details/$id/contacts/edit/$contactId': typeof ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute;
  '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId': typeof ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/excesses/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute;
  '/console/$orgId/claims/details/$id/manage/strategies/add': typeof ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/add': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage/incidents': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage/complaints': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute;
  '/console/$orgId/compliance/training/user/$userId/edit/$recordId': typeof ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute;
  '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute;
  '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute;
  '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute;
  '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute;
  '/console/$orgId/configuration/compliance/mspr/definitions/categories/add': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/clients': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/drivers': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/overview': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute;
  '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren;
  '/console/$orgId/controls/register/details/$id/activity/$activityId': typeof ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute;
  '/console/$orgId/controls/register/details/$id/activity/add': typeof ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute;
  '/console/$orgId/controls/register/details/$id/test/$testId': typeof ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute;
  '/console/$orgId/controls/register/details/$id/test/add': typeof ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/add': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute;
  '/console/$orgId/risk/register/details/$id/assessment/incidents': typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute;
  '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId': typeof ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage/note/add': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage/note/add': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute;
  '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute;
  '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/check/add': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute;
  '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute;
  '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/admin-consent': typeof AdminConsentRoute;
  '/attestation': typeof AttestationRouteRouteWithChildren;
  '/invite': typeof InviteRouteRoute;
  '/maintenance': typeof MaintenanceRoute;
  '/not-found': typeof NotFoundRoute;
  '/not-supported': typeof NotSupportedRoute;
  '/oauth': typeof OauthRouteRouteWithChildren;
  '/org-switched': typeof OrgSwitchedRoute;
  '/public': typeof PublicRouteRouteWithChildren;
  '/status': typeof StatusRoute;
  '/terms-acceptance': typeof TermsAcceptanceRouteRoute;
  '/admin-console': typeof AdminConsoleIndexRoute;
  '/admin-login': typeof authenticationAdminLoginRoute;
  '/callback': typeof authenticationCallbackRoute;
  '/login': typeof authenticationLoginRoute;
  '/logout': typeof authenticationLogoutRoute;
  '/logoutin': typeof authenticationLogoutinRoute;
  '/org-mismatch': typeof authenticationOrgMismatchRoute;
  '/payment-pending': typeof authenticationPaymentPendingRoute;
  '/admin-console/ai': typeof AdminConsoleAiRouteRouteWithChildren;
  '/admin-console/authorised-apps': typeof AdminConsoleAuthorisedAppsRouteRoute;
  '/admin-console/organisation-management': typeof AdminConsoleOrganisationManagementRouteRouteWithChildren;
  '/attestation/$token': typeof AttestationTokenRoute;
  '/oauth/authorize': typeof OauthAuthorizeRoute;
  '/password-reset/request': typeof PasswordResetRequestRoute;
  '/password-reset/reset': typeof PasswordResetResetRoute;
  '/public/$orgId': typeof PublicOrgIdRouteRouteWithChildren;
  '/whats-new/$releaseId': typeof WhatsNewReleaseIdRoute;
  '/admin-console/advanced': typeof AdminConsoleAdvancedIndexRoute;
  '/admin-console/monitoring': typeof AdminConsoleMonitoringIndexRoute;
  '/admin-console/platform-content': typeof AdminConsolePlatformContentIndexRoute;
  '/admin-console/tools': typeof AdminConsoleToolsIndexRoute;
  '/admin-console/user-access': typeof AdminConsoleUserAccessIndexRoute;
  '/console/$orgId': typeof ConsoleOrgIdIndexRoute;
  '/change-org/$orgId': typeof authenticationChangeOrgOrgIdRoute;
  '/admin-console/advanced/app-settings': typeof AdminConsoleAdvancedAppSettingsRouteRouteWithChildren;
  '/admin-console/advanced/claims': typeof AdminConsoleAdvancedClaimsRoute;
  '/admin-console/advanced/db-stats': typeof AdminConsoleAdvancedDbStatsRoute;
  '/admin-console/advanced/db-upgrades': typeof AdminConsoleAdvancedDbUpgradesRoute;
  '/admin-console/advanced/inbound-email-archive': typeof AdminConsoleAdvancedInboundEmailArchiveRouteRoute;
  '/admin-console/advanced/indicators': typeof AdminConsoleAdvancedIndicatorsRouteRouteWithChildren;
  '/admin-console/advanced/integration-tests': typeof AdminConsoleAdvancedIntegrationTestsRoute;
  '/admin-console/advanced/playground': typeof AdminConsoleAdvancedPlaygroundRouteRoute;
  '/admin-console/advanced/weaviate': typeof AdminConsoleAdvancedWeaviateRoute;
  '/admin-console/ai/ai-feedback': typeof AdminConsoleAiAiFeedbackRouteRoute;
  '/admin-console/ai/ai-prompts': typeof AdminConsoleAiAiPromptsRouteRoute;
  '/admin-console/ai/eval-runs': typeof AdminConsoleAiEvalRunsRouteRouteWithChildren;
  '/admin-console/ai/model-pricing': typeof AdminConsoleAiModelPricingRouteRoute;
  '/admin-console/ai/model-tiers': typeof AdminConsoleAiModelTiersRouteRoute;
  '/admin-console/ai/request-analytics': typeof AdminConsoleAiRequestAnalyticsRouteRoute;
  '/admin-console/ai/statistics': typeof AdminConsoleAiStatisticsRouteRoute;
  '/admin-console/ai/usage-billing': typeof AdminConsoleAiUsageBillingRouteRoute;
  '/admin-console/monitoring/audit-trail': typeof AdminConsoleMonitoringAuditTrailRouteRoute;
  '/admin-console/monitoring/axiom-logs': typeof AdminConsoleMonitoringAxiomLogsRouteRoute;
  '/admin-console/monitoring/compliance': typeof AdminConsoleMonitoringComplianceRouteRoute;
  '/admin-console/monitoring/compliance-audit': typeof AdminConsoleMonitoringComplianceAuditRouteRouteWithChildren;
  '/admin-console/monitoring/llm-logs': typeof AdminConsoleMonitoringLlmLogsRouteRoute;
  '/admin-console/monitoring/llm-stats': typeof AdminConsoleMonitoringLlmStatsRouteRoute;
  '/admin-console/monitoring/memory': typeof AdminConsoleMonitoringMemoryRouteRoute;
  '/admin-console/monitoring/reports': typeof AdminConsoleMonitoringReportsRouteRoute;
  '/admin-console/monitoring/statistics': typeof AdminConsoleMonitoringStatisticsRouteRoute;
  '/admin-console/organisation-management/new': typeof AdminConsoleOrganisationManagementNewRouteRoute;
  '/admin-console/organisation-management/new-from-template': typeof AdminConsoleOrganisationManagementNewFromTemplateRouteRoute;
  '/admin-console/platform-content/comms-and-content': typeof AdminConsolePlatformContentCommsAndContentRouteRouteWithChildren;
  '/admin-console/platform-content/market-pds': typeof AdminConsolePlatformContentMarketPdsRouteRouteWithChildren;
  '/admin-console/platform-content/products': typeof AdminConsolePlatformContentProductsRouteRouteWithChildren;
  '/admin-console/tools/document-to-markdown': typeof AdminConsoleToolsDocumentToMarkdownRoute;
  '/admin-console/tools/feature-flags': typeof AdminConsoleToolsFeatureFlagsRoute;
  '/admin-console/tools/sanitise-text-pii': typeof AdminConsoleToolsSanitiseTextPiiRouteRouteWithChildren;
  '/admin-console/user-access/admin-users': typeof AdminConsoleUserAccessAdminUsersRouteRouteWithChildren;
  '/admin-console/user-access/support-sessions': typeof AdminConsoleUserAccessSupportSessionsRouteRoute;
  '/admin-console/user-access/users': typeof AdminConsoleUserAccessUsersRouteRouteWithChildren;
  '/console/$orgId/documents': typeof ConsoleOrgIdDocumentsRouteRouteWithChildren;
  '/console/$orgId/faq': typeof ConsoleOrgIdFaqRouteRoute;
  '/console/$orgId/get-file': typeof ConsoleOrgIdGetFileRouteRoute;
  '/console/$orgId/mspr': typeof ConsoleOrgIdMsprRouteRouteWithChildren;
  '/console/$orgId/reporting': typeof ConsoleOrgIdReportingRouteRouteWithChildren;
  '/console/$orgId/tools-only-home-page': typeof ConsoleOrgIdToolsOnlyHomePageRoute;
  '/public/lodgement-summary/$accessKey': typeof PublicLodgementSummaryAccessKeyRouteRoute;
  '/public/new-complaint-by-key/$key': typeof PublicNewComplaintByKeyKeyRouteRoute;
  '/public/new-complaint/$orgId': typeof PublicNewComplaintOrgIdRouteRoute;
  '/admin-console/advanced/inbound-parse': typeof AdminConsoleAdvancedInboundParseIndexRoute;
  '/admin-console/advanced/jobs': typeof AdminConsoleAdvancedJobsIndexRoute;
  '/admin-console/monitoring/email-activity': typeof AdminConsoleMonitoringEmailActivityIndexRoute;
  '/admin-console/monitoring/engagement': typeof AdminConsoleMonitoringEngagementIndexRoute;
  '/admin-console/organisation-management/organisations': typeof AdminConsoleOrganisationManagementOrganisationsIndexRoute;
  '/admin-console/platform-content/ai-training': typeof AdminConsolePlatformContentAiTrainingIndexRoute;
  '/admin-console/platform-content/compliance-audit-templates': typeof AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute;
  '/admin-console/platform-content/obligations': typeof AdminConsolePlatformContentObligationsIndexRoute;
  '/admin-console/platform-content/whats-new': typeof AdminConsolePlatformContentWhatsNewIndexRoute;
  '/console/$orgId/attestations': typeof ConsoleOrgIdAttestationsIndexRoute;
  '/console/$orgId/claims': typeof ConsoleOrgIdClaimsIndexRoute;
  '/console/$orgId/compliance': typeof ConsoleOrgIdComplianceIndexRoute;
  '/console/$orgId/component-showcase': typeof ConsoleOrgIdComponentShowcaseIndexRoute;
  '/console/$orgId/configuration': typeof ConsoleOrgIdConfigurationIndexRoute;
  '/console/$orgId/controls': typeof ConsoleOrgIdControlsIndexRoute;
  '/console/$orgId/dashboard': typeof ConsoleOrgIdDashboardIndexRoute;
  '/console/$orgId/debug': typeof ConsoleOrgIdDebugIndexRoute;
  '/console/$orgId/fleet-portal': typeof ConsoleOrgIdFleetPortalIndexRoute;
  '/console/$orgId/risk': typeof ConsoleOrgIdRiskIndexRoute;
  '/console/$orgId/tools': typeof ConsoleOrgIdToolsIndexRoute;
  '/console/$orgId/user-settings': typeof ConsoleOrgIdUserSettingsIndexRoute;
  '/console/$orgId/workload-manager': typeof ConsoleOrgIdWorkloadManagerIndexRoute;
  '/admin-console/advanced/app-settings/all': typeof AdminConsoleAdvancedAppSettingsAllRouteRouteWithChildren;
  '/admin-console/advanced/app-settings/well-known': typeof AdminConsoleAdvancedAppSettingsWellKnownRoute;
  '/admin-console/advanced/indicators/complaints': typeof AdminConsoleAdvancedIndicatorsComplaintsRoute;
  '/admin-console/advanced/indicators/incidents': typeof AdminConsoleAdvancedIndicatorsIncidentsRoute;
  '/admin-console/advanced/jobs/dynamic-recurring': typeof AdminConsoleAdvancedJobsDynamicRecurringRouteWithChildren;
  '/admin-console/advanced/jobs/on-demand': typeof AdminConsoleAdvancedJobsOnDemandRouteWithChildren;
  '/admin-console/advanced/jobs/recurring': typeof AdminConsoleAdvancedJobsRecurringRouteWithChildren;
  '/admin-console/ai/eval-runs/$evalRunId': typeof AdminConsoleAiEvalRunsEvalRunIdRouteRoute;
  '/admin-console/ai/eval-runs/compare': typeof AdminConsoleAiEvalRunsCompareRouteRoute;
  '/admin-console/organisation-management/organisations/$orgId': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training/classification-example': typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training/vulnerability-example': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/app-text': typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/comm-templates': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/faq': typeof AdminConsolePlatformContentCommsAndContentFaqRouteRoute;
  '/admin-console/platform-content/compliance-audit-templates/search': typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteWithChildren;
  '/admin-console/platform-content/market-pds/add': typeof AdminConsolePlatformContentMarketPdsAddRoute;
  '/admin-console/platform-content/obligations/configuration': typeof AdminConsolePlatformContentObligationsConfigurationRouteRoute;
  '/admin-console/platform-content/products/$serviceId': typeof AdminConsolePlatformContentProductsServiceIdRoute;
  '/admin-console/platform-content/whats-new/$id': typeof AdminConsolePlatformContentWhatsNewIdRoute;
  '/admin-console/platform-content/whats-new/new': typeof AdminConsolePlatformContentWhatsNewNewRoute;
  '/admin-console/tools/sanitise-text-pii/compare': typeof AdminConsoleToolsSanitiseTextPiiCompareRoute;
  '/admin-console/tools/sanitise-text-pii/tool': typeof AdminConsoleToolsSanitiseTextPiiToolRoute;
  '/admin-console/user-access/admin-users/grant': typeof AdminConsoleUserAccessAdminUsersGrantRoute;
  '/console/$orgId/attestations/scheduled-attestations': typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren;
  '/console/$orgId/attestations/user-attestations': typeof ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren;
  '/console/$orgId/compliance/intake': typeof ConsoleOrgIdComplianceIntakeRouteRoute;
  '/console/$orgId/component-showcase/ai-chat-test': typeof ConsoleOrgIdComponentShowcaseAiChatTestRoute;
  '/console/$orgId/component-showcase/button-icon-test': typeof ConsoleOrgIdComponentShowcaseButtonIconTestRoute;
  '/console/$orgId/component-showcase/button-variants': typeof ConsoleOrgIdComponentShowcaseButtonVariantsRoute;
  '/console/$orgId/component-showcase/component-showcase': typeof ConsoleOrgIdComponentShowcaseComponentShowcaseRoute;
  '/console/$orgId/component-showcase/date-picker-test': typeof ConsoleOrgIdComponentShowcaseDatePickerTestRoute;
  '/console/$orgId/component-showcase/fit-on-page': typeof ConsoleOrgIdComponentShowcaseFitOnPageRoute;
  '/console/$orgId/component-showcase/markdown-showcase': typeof ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute;
  '/console/$orgId/component-showcase/table-showcase': typeof ConsoleOrgIdComponentShowcaseTableShowcaseRoute;
  '/console/$orgId/component-showcase/tag-variants': typeof ConsoleOrgIdComponentShowcaseTagVariantsRoute;
  '/console/$orgId/component-showcase/tiptap-test': typeof ConsoleOrgIdComponentShowcaseTiptapTestRoute;
  '/console/$orgId/configuration/api-integrations': typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products': typeof ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren;
  '/console/$orgId/configuration/client-database': typeof ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren;
  '/console/$orgId/configuration/financials': typeof ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren;
  '/console/$orgId/configuration/monitoring': typeof ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings': typeof ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren;
  '/console/$orgId/configuration/vendor-management': typeof ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren;
  '/console/$orgId/controls/activities': typeof ConsoleOrgIdControlsActivitiesRouteRoute;
  '/console/$orgId/controls/tests': typeof ConsoleOrgIdControlsTestsRouteRoute;
  '/console/$orgId/dashboard/claims': typeof ConsoleOrgIdDashboardClaimsRoute;
  '/console/$orgId/dashboard/complaints': typeof ConsoleOrgIdDashboardComplaintsRoute;
  '/console/$orgId/dashboard/incidents': typeof ConsoleOrgIdDashboardIncidentsRoute;
  '/console/$orgId/dashboard/management': typeof ConsoleOrgIdDashboardManagementRoute;
  '/console/$orgId/dashboard/people-and-culture': typeof ConsoleOrgIdDashboardPeopleAndCultureRoute;
  '/console/$orgId/dashboard/risks': typeof ConsoleOrgIdDashboardRisksRoute;
  '/console/$orgId/fleet-portal/authorisations': typeof ConsoleOrgIdFleetPortalAuthorisationsRoute;
  '/console/$orgId/fleet-portal/dashboard': typeof ConsoleOrgIdFleetPortalDashboardRoute;
  '/console/$orgId/fleet-portal/fleet': typeof ConsoleOrgIdFleetPortalFleetRoute;
  '/console/$orgId/fleet-portal/sla': typeof ConsoleOrgIdFleetPortalSlaRoute;
  '/console/$orgId/mspr/msp-exceptions': typeof ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren;
  '/console/$orgId/reporting/add': typeof ConsoleOrgIdReportingAddRoute;
  '/console/$orgId/tools/auto-detect': typeof ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren;
  '/console/$orgId/user-settings/notifications': typeof ConsoleOrgIdUserSettingsNotificationsRoute;
  '/console/$orgId/user-settings/profile': typeof ConsoleOrgIdUserSettingsProfileRoute;
  '/console/$orgId/workload-manager/complaints': typeof ConsoleOrgIdWorkloadManagerComplaintsRoute;
  '/console/$orgId/workload-manager/emails': typeof ConsoleOrgIdWorkloadManagerEmailsRouteRoute;
  '/public/$orgId/complaint/new': typeof PublicOrgIdComplaintNewRouteRoute;
  '/admin-console/platform-content/obligations/controls-library': typeof AdminConsolePlatformContentObligationsControlsLibraryIndexRoute;
  '/admin-console/platform-content/obligations/library': typeof AdminConsolePlatformContentObligationsLibraryIndexRoute;
  '/console/$orgId/compliance/coi': typeof ConsoleOrgIdComplianceCoiIndexRoute;
  '/console/$orgId/compliance/complaints': typeof ConsoleOrgIdComplianceComplaintsIndexRoute;
  '/console/$orgId/compliance/incidents': typeof ConsoleOrgIdComplianceIncidentsIndexRoute;
  '/console/$orgId/compliance/obligations': typeof ConsoleOrgIdComplianceObligationsIndexRoute;
  '/console/$orgId/compliance/registers': typeof ConsoleOrgIdComplianceRegistersIndexRoute;
  '/console/$orgId/compliance/training': typeof ConsoleOrgIdComplianceTrainingIndexRoute;
  '/console/$orgId/configuration/compliance': typeof ConsoleOrgIdConfigurationComplianceIndexRoute;
  '/console/$orgId/configuration/fleet': typeof ConsoleOrgIdConfigurationFleetIndexRoute;
  '/console/$orgId/configuration/risk': typeof ConsoleOrgIdConfigurationRiskIndexRoute;
  '/console/$orgId/controls/register': typeof ConsoleOrgIdControlsRegisterIndexRoute;
  '/console/$orgId/fleet-portal/claims': typeof ConsoleOrgIdFleetPortalClaimsIndexRoute;
  '/console/$orgId/mspr/service-providers': typeof ConsoleOrgIdMsprServiceProvidersIndexRoute;
  '/console/$orgId/risk/ras': typeof ConsoleOrgIdRiskRasIndexRoute;
  '/console/$orgId/risk/register': typeof ConsoleOrgIdRiskRegisterIndexRoute;
  '/console/$orgId/tools/compliance-audit': typeof ConsoleOrgIdToolsComplianceAuditIndexRoute;
  '/console/$orgId/tools/document-analyzer': typeof ConsoleOrgIdToolsDocumentAnalyzerIndexRoute;
  '/console/$orgId/tools/pds-compare': typeof ConsoleOrgIdToolsPdsCompareIndexRoute;
  '/console/$orgId/tools/website-checker': typeof ConsoleOrgIdToolsWebsiteCheckerIndexRoute;
  '/console/$orgId/user-settings/authorised-apps': typeof ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute;
  '/console/$orgId/workload-manager/tasks': typeof ConsoleOrgIdWorkloadManagerTasksIndexRoute;
  '/admin-console/advanced/app-settings/all/add': typeof AdminConsoleAdvancedAppSettingsAllAddRoute;
  '/admin-console/advanced/jobs/dynamic-recurring/$jobId': typeof AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute;
  '/admin-console/advanced/jobs/on-demand/$jobId': typeof AdminConsoleAdvancedJobsOnDemandJobIdRoute;
  '/admin-console/advanced/jobs/recurring/$jobId': typeof AdminConsoleAdvancedJobsRecurringJobIdRoute;
  '/admin-console/organisation-management/organisations/$orgId/subscriptions': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute;
  '/admin-console/organisation-management/organisations/$orgId/users': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteWithChildren;
  '/admin-console/organisation-management/organisations/$orgId/wallet': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute;
  '/admin-console/platform-content/ai-training/classification-example/create': typeof AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/create': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute;
  '/admin-console/platform-content/comms-and-content/app-text/add': typeof AdminConsolePlatformContentCommsAndContentAppTextAddRoute;
  '/admin-console/platform-content/comms-and-content/comm-templates/add': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/search/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute;
  '/admin-console/platform-content/market-pds/edit/$id': typeof AdminConsolePlatformContentMarketPdsEditIdRoute;
  '/admin-console/platform-content/obligations/controls-library/$id': typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteWithChildren;
  '/admin-console/user-access/admin-users/edit/$userId': typeof AdminConsoleUserAccessAdminUsersEditUserIdRoute;
  '/admin-console/user-access/users/edit/$userId': typeof AdminConsoleUserAccessUsersEditUserIdRoute;
  '/admin-console/user-access/users/view/$userId': typeof AdminConsoleUserAccessUsersViewUserIdRoute;
  '/console/$orgId/attestations/scheduled-attestations/$scheduleId': typeof ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute;
  '/console/$orgId/attestations/scheduled-attestations/new': typeof ConsoleOrgIdAttestationsScheduledAttestationsNewRoute;
  '/console/$orgId/attestations/user-attestations/$attestationId': typeof ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute;
  '/console/$orgId/attestations/user-attestations/send': typeof ConsoleOrgIdAttestationsUserAttestationsSendRoute;
  '/console/$orgId/claims/details/$id': typeof ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/coi/add': typeof ConsoleOrgIdComplianceCoiAddRouteRoute;
  '/console/$orgId/compliance/complaints/add': typeof ConsoleOrgIdComplianceComplaintsAddRouteRoute;
  '/console/$orgId/compliance/incidents/add': typeof ConsoleOrgIdComplianceIncidentsAddRoute;
  '/console/$orgId/compliance/obligations/add': typeof ConsoleOrgIdComplianceObligationsAddRouteRoute;
  '/console/$orgId/compliance/training/search': typeof ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/api-tokens': typeof ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute;
  '/console/$orgId/configuration/api-integrations/mcp-access': typeof ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute;
  '/console/$orgId/configuration/claims-products/insurers': typeof ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute;
  '/console/$orgId/configuration/claims-products/product-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/questionnaire': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren;
  '/console/$orgId/configuration/client-database/$': typeof ConsoleOrgIdConfigurationClientDatabaseSplatRoute;
  '/console/$orgId/configuration/compliance/attestations': typeof ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/auto-detect': typeof ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute;
  '/console/$orgId/configuration/compliance/compliance-audit': typeof ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute;
  '/console/$orgId/configuration/compliance/mspr': typeof ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/obligations': typeof ConsoleOrgIdConfigurationComplianceObligationsRoute;
  '/console/$orgId/configuration/financials/billing': typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren;
  '/console/$orgId/configuration/financials/expenses-billing': typeof ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute;
  '/console/$orgId/configuration/financials/payments': typeof ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute;
  '/console/$orgId/configuration/fleet/client-database': typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren;
  '/console/$orgId/configuration/fleet/delegated-authority': typeof ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute;
  '/console/$orgId/configuration/fleet/escalations': typeof ConsoleOrgIdConfigurationFleetEscalationsRouteRoute;
  '/console/$orgId/configuration/fleet/portal-claim-page': typeof ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute;
  '/console/$orgId/configuration/monitoring/audit-trail': typeof ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute;
  '/console/$orgId/configuration/monitoring/email-activity': typeof ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute;
  '/console/$orgId/configuration/monitoring/statistics': typeof ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute;
  '/console/$orgId/configuration/org-settings/communication': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/fleet-escalations': typeof ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute;
  '/console/$orgId/configuration/org-settings/handling-parties': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/support-sessions': typeof ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute;
  '/console/$orgId/configuration/org-settings/system': typeof ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute;
  '/console/$orgId/configuration/org-settings/tasks': typeof ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute;
  '/console/$orgId/configuration/org-settings/trash': typeof ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute;
  '/console/$orgId/configuration/risk/appetite': typeof ConsoleOrgIdConfigurationRiskAppetiteRoute;
  '/console/$orgId/configuration/risk/categories': typeof ConsoleOrgIdConfigurationRiskCategoriesRoute;
  '/console/$orgId/configuration/risk/matrix': typeof ConsoleOrgIdConfigurationRiskMatrixRoute;
  '/console/$orgId/controls/register/add': typeof ConsoleOrgIdControlsRegisterAddRouteRoute;
  '/console/$orgId/documents/details/$fileId': typeof ConsoleOrgIdDocumentsDetailsFileIdRouteRoute;
  '/console/$orgId/mspr/service-providers/search': typeof ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren;
  '/console/$orgId/tools/auto-detect/dashboard': typeof ConsoleOrgIdToolsAutoDetectDashboardRoute;
  '/console/$orgId/tools/auto-detect/inbox': typeof ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer/history': typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer/upload': typeof ConsoleOrgIdToolsDocumentAnalyzerUploadRoute;
  '/console/$orgId/tools/pds-compare/pds-documents': typeof ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren;
  '/console/$orgId/workload-manager/tasks/calendar': typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren;
  '/console/$orgId/workload-manager/tasks/list': typeof ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren;
  '/public/$orgId/invoice/view/$accessKey': typeof PublicOrgIdInvoiceViewAccessKeyRouteRoute;
  '/console/$orgId/compliance/registers/$registerId': typeof ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute;
  '/console/$orgId/configuration/api-integrations/form-designer': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute;
  '/console/$orgId/configuration/claims-products/claims': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute;
  '/console/$orgId/configuration/compliance/complaints': typeof ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute;
  '/console/$orgId/configuration/compliance/general': typeof ConsoleOrgIdConfigurationComplianceGeneralIndexRoute;
  '/console/$orgId/configuration/compliance/incidents': typeof ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute;
  '/console/$orgId/configuration/compliance/training': typeof ConsoleOrgIdConfigurationComplianceTrainingIndexRoute;
  '/console/$orgId/configuration/org-settings/users': typeof ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute;
  '/console/$orgId/tools/compliance-audit/overview': typeof ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute;
  '/admin-console/advanced/app-settings/all/edit/$name': typeof AdminConsoleAdvancedAppSettingsAllEditNameRoute;
  '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics': typeof AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute;
  '/admin-console/platform-content/ai-training/classification-example/edit/$id': typeof AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute;
  '/admin-console/platform-content/ai-training/classification-example/view/$id': typeof AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/view/$id': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute;
  '/admin-console/platform-content/comms-and-content/app-text/edit/$id': typeof AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute;
  '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute;
  '/admin-console/platform-content/obligations/controls-library/$id/details': typeof AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute;
  '/admin-console/platform-content/obligations/controls-library/$id/history': typeof AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute;
  '/admin-console/platform-content/obligations/library/details/$id': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/activity': typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/ai-assessment': typeof ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute;
  '/console/$orgId/claims/details/$id/comms': typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/contacts': typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/expenses': typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials': typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/history': typeof ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute;
  '/console/$orgId/claims/details/$id/library': typeof ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute;
  '/console/$orgId/claims/details/$id/manage': typeof ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/policy-info': typeof ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute;
  '/console/$orgId/claims/details/$id/product-type-data': typeof ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute;
  '/console/$orgId/claims/details/$id/vehicle': typeof ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute;
  '/console/$orgId/compliance/obligations/details/$id': typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/training/search/add': typeof ConsoleOrgIdComplianceTrainingSearchAddRoute;
  '/console/$orgId/compliance/training/user/$userId': typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/claim-flags': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/documents': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute;
  '/console/$orgId/configuration/claims-products/claims/general': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/handling-standards': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute;
  '/console/$orgId/configuration/claims-products/claims/id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute;
  '/console/$orgId/configuration/claims-products/products-v2/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute;
  '/console/$orgId/configuration/claims-products/questionnaire/add': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute;
  '/console/$orgId/configuration/compliance/attestations/user-attestations': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/complaints/brands': typeof ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute;
  '/console/$orgId/configuration/compliance/complaints/custom-fields': typeof ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/complaints/flags': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/complaints/general': typeof ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute;
  '/console/$orgId/configuration/compliance/complaints/rules': typeof ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute;
  '/console/$orgId/configuration/compliance/general/asic-products': typeof ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute;
  '/console/$orgId/configuration/compliance/general/documents': typeof ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute;
  '/console/$orgId/configuration/compliance/incidents/custom-fields': typeof ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/incidents/flags': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents/rules': typeof ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr/definitions': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr/documents': typeof ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/training/custom-fields': typeof ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/training/training-periods': typeof ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute;
  '/console/$orgId/configuration/financials/billing/balance': typeof ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute;
  '/console/$orgId/configuration/financials/billing/billing-info': typeof ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute;
  '/console/$orgId/configuration/financials/billing/invoices': typeof ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute;
  '/console/$orgId/configuration/financials/billing/transactions': typeof ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute;
  '/console/$orgId/configuration/financials/billing/usage': typeof ConsoleOrgIdConfigurationFinancialsBillingUsageRoute;
  '/console/$orgId/configuration/fleet/client-database/add': typeof ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/communication/comm-templates': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/handling-parties/add': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/add': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/definitions': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute;
  '/console/$orgId/controls/register/details/$id': typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren;
  '/console/$orgId/fleet-portal/claims/details/$claimId': typeof ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute;
  '/console/$orgId/mspr/msp-exceptions/edit/$id': typeof ConsoleOrgIdMsprMspExceptionsEditIdRoute;
  '/console/$orgId/mspr/service-providers/details/$id': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren;
  '/console/$orgId/mspr/service-providers/search/add': typeof ConsoleOrgIdMsprServiceProvidersSearchAddRoute;
  '/console/$orgId/risk/ras/details/$id': typeof ConsoleOrgIdRiskRasDetailsIdRouteRoute;
  '/console/$orgId/risk/register/details/$id': typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/details/$complianceAuditId': typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/overview/insights': typeof ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute;
  '/console/$orgId/tools/compliance-audit/overview/search': typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren;
  '/console/$orgId/tools/website-checker/report/$id': typeof ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute;
  '/console/$orgId/workload-manager/tasks/calendar/add': typeof ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute;
  '/console/$orgId/workload-manager/tasks/list/add': typeof ConsoleOrgIdWorkloadManagerTasksListAddRoute;
  '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/console/$orgId/compliance/coi/details/$id': typeof ConsoleOrgIdComplianceCoiDetailsIdIndexRoute;
  '/console/$orgId/compliance/complaints/details/$id': typeof ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute;
  '/console/$orgId/compliance/incidents/details/$id': typeof ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute;
  '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute;
  '/console/$orgId/configuration/compliance/incidents/general': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute;
  '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute;
  '/admin-console/platform-content/obligations/library/details/$id/ai-related': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute;
  '/admin-console/platform-content/obligations/library/details/$id/document-analyser': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute;
  '/admin-console/platform-content/obligations/library/details/$id/history': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute;
  '/admin-console/platform-content/obligations/library/details/$id/manage': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute;
  '/console/$orgId/claims/details/$id/comms/add': typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/contacts/add': typeof ConsoleOrgIdClaimsDetailsIdContactsAddRoute;
  '/console/$orgId/claims/details/$id/expenses/add': typeof ConsoleOrgIdClaimsDetailsIdExpensesAddRoute;
  '/console/$orgId/compliance/coi/details/$id/library': typeof ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute;
  '/console/$orgId/compliance/coi/details/$id/manage': typeof ConsoleOrgIdComplianceCoiDetailsIdManageRoute;
  '/console/$orgId/compliance/complaints/details/$id/comms': typeof ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/history': typeof ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/library': typeof ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents/details/$id/history': typeof ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/library': typeof ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/compliance/obligations/details/$id/debug': typeof ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute;
  '/console/$orgId/compliance/obligations/details/$id/manage': typeof ConsoleOrgIdComplianceObligationsDetailsIdManageRoute;
  '/console/$orgId/compliance/registers/$registerId/records/$recordId': typeof ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute;
  '/console/$orgId/compliance/training/user/$userId/add': typeof ConsoleOrgIdComplianceTrainingUserUserIdAddRoute;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/claim-flags/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/states/$id': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2/edit/$productId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute;
  '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute;
  '/console/$orgId/configuration/compliance/attestations/user-attestations/add': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute;
  '/console/$orgId/configuration/compliance/complaints/flags/add': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute;
  '/console/$orgId/configuration/compliance/incidents/flags/add': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute;
  '/console/$orgId/configuration/compliance/incidents/general/incident-details': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute;
  '/console/$orgId/configuration/compliance/incidents/general/lodgement': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute;
  '/console/$orgId/configuration/compliance/incidents/general/rectification': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute;
  '/console/$orgId/configuration/compliance/incidents/general/timeline': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config/add': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute;
  '/console/$orgId/configuration/financials/billing/payment/success': typeof ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures/add': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-templates/add': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute;
  '/console/$orgId/configuration/org-settings/handling-parties/details/$id': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/users/details/$userId': typeof ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/definitions': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/list': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute;
  '/console/$orgId/mspr/service-providers/details/$id/history': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/library': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/action-plan': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/assessment': typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/history': typeof ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute;
  '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification': typeof ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute;
  '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics': typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute;
  '/console/$orgId/tools/compliance-audit/overview/search/add': typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute;
  '/console/$orgId/tools/document-analyzer/history/$id/results': typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute;
  '/console/$orgId/tools/pds-compare/pds-documents/edit/$id': typeof ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute;
  '/console/$orgId/workload-manager/tasks/list/details/$id': typeof ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute;
  '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/details/$id': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute;
  '/console/$orgId/claims/details/$id/activity/add/phone': typeof ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute;
  '/console/$orgId/claims/details/$id/comms/add/email': typeof ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute;
  '/console/$orgId/claims/details/$id/comms/add/sms': typeof ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute;
  '/console/$orgId/claims/details/$id/comms/message/$messageId': typeof ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute;
  '/console/$orgId/claims/details/$id/comms/reply/$messageId': typeof ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute;
  '/console/$orgId/claims/details/$id/contacts/edit/$contactId': typeof ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute;
  '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId': typeof ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/excesses/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute;
  '/console/$orgId/claims/details/$id/manage/strategies/add': typeof ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/add': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage/incidents': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage/complaints': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute;
  '/console/$orgId/compliance/training/user/$userId/edit/$recordId': typeof ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute;
  '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute;
  '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute;
  '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute;
  '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute;
  '/console/$orgId/configuration/compliance/mspr/definitions/categories/add': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/clients': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/drivers': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/overview': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute;
  '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren;
  '/console/$orgId/controls/register/details/$id/activity/$activityId': typeof ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute;
  '/console/$orgId/controls/register/details/$id/activity/add': typeof ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute;
  '/console/$orgId/controls/register/details/$id/test/$testId': typeof ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute;
  '/console/$orgId/controls/register/details/$id/test/add': typeof ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/add': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute;
  '/console/$orgId/risk/register/details/$id/assessment/incidents': typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute;
  '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId': typeof ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage/note/add': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage/note/add': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute;
  '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute;
  '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/check/add': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute;
  '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute;
  '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/admin-consent': typeof AdminConsentRoute;
  '/admin-console': typeof AdminConsoleRouteRouteWithChildren;
  '/attestation': typeof AttestationRouteRouteWithChildren;
  '/invite': typeof InviteRouteRoute;
  '/maintenance': typeof MaintenanceRoute;
  '/not-found': typeof NotFoundRoute;
  '/not-supported': typeof NotSupportedRoute;
  '/oauth': typeof OauthRouteRouteWithChildren;
  '/org-switched': typeof OrgSwitchedRoute;
  '/public': typeof PublicRouteRouteWithChildren;
  '/status': typeof StatusRoute;
  '/terms-acceptance': typeof TermsAcceptanceRouteRoute;
  '/admin-console/': typeof AdminConsoleIndexRoute;
  '/(authentication)/admin-login': typeof authenticationAdminLoginRoute;
  '/(authentication)/callback': typeof authenticationCallbackRoute;
  '/(authentication)/login': typeof authenticationLoginRoute;
  '/(authentication)/logout': typeof authenticationLogoutRoute;
  '/(authentication)/logoutin': typeof authenticationLogoutinRoute;
  '/(authentication)/org-mismatch': typeof authenticationOrgMismatchRoute;
  '/(authentication)/payment-pending': typeof authenticationPaymentPendingRoute;
  '/admin-console/advanced': typeof AdminConsoleAdvancedRouteRouteWithChildren;
  '/admin-console/ai': typeof AdminConsoleAiRouteRouteWithChildren;
  '/admin-console/authorised-apps': typeof AdminConsoleAuthorisedAppsRouteRoute;
  '/admin-console/monitoring': typeof AdminConsoleMonitoringRouteRouteWithChildren;
  '/admin-console/organisation-management': typeof AdminConsoleOrganisationManagementRouteRouteWithChildren;
  '/admin-console/platform-content': typeof AdminConsolePlatformContentRouteRouteWithChildren;
  '/admin-console/tools': typeof AdminConsoleToolsRouteRouteWithChildren;
  '/admin-console/user-access': typeof AdminConsoleUserAccessRouteRouteWithChildren;
  '/attestation/$token': typeof AttestationTokenRoute;
  '/console/$orgId': typeof ConsoleOrgIdRouteRouteWithChildren;
  '/oauth/authorize': typeof OauthAuthorizeRoute;
  '/password-reset/request': typeof PasswordResetRequestRoute;
  '/password-reset/reset': typeof PasswordResetResetRoute;
  '/public/$orgId': typeof PublicOrgIdRouteRouteWithChildren;
  '/whats-new/$releaseId': typeof WhatsNewReleaseIdRoute;
  '/admin-console/advanced/': typeof AdminConsoleAdvancedIndexRoute;
  '/admin-console/monitoring/': typeof AdminConsoleMonitoringIndexRoute;
  '/admin-console/platform-content/': typeof AdminConsolePlatformContentIndexRoute;
  '/admin-console/tools/': typeof AdminConsoleToolsIndexRoute;
  '/admin-console/user-access/': typeof AdminConsoleUserAccessIndexRoute;
  '/console/$orgId/': typeof ConsoleOrgIdIndexRoute;
  '/(authentication)/change-org/$orgId': typeof authenticationChangeOrgOrgIdRoute;
  '/admin-console/advanced/app-settings': typeof AdminConsoleAdvancedAppSettingsRouteRouteWithChildren;
  '/admin-console/advanced/claims': typeof AdminConsoleAdvancedClaimsRoute;
  '/admin-console/advanced/db-stats': typeof AdminConsoleAdvancedDbStatsRoute;
  '/admin-console/advanced/db-upgrades': typeof AdminConsoleAdvancedDbUpgradesRoute;
  '/admin-console/advanced/inbound-email-archive': typeof AdminConsoleAdvancedInboundEmailArchiveRouteRoute;
  '/admin-console/advanced/inbound-parse': typeof AdminConsoleAdvancedInboundParseRouteRouteWithChildren;
  '/admin-console/advanced/indicators': typeof AdminConsoleAdvancedIndicatorsRouteRouteWithChildren;
  '/admin-console/advanced/integration-tests': typeof AdminConsoleAdvancedIntegrationTestsRoute;
  '/admin-console/advanced/jobs': typeof AdminConsoleAdvancedJobsRouteRouteWithChildren;
  '/admin-console/advanced/playground': typeof AdminConsoleAdvancedPlaygroundRouteRoute;
  '/admin-console/advanced/weaviate': typeof AdminConsoleAdvancedWeaviateRoute;
  '/admin-console/ai/ai-feedback': typeof AdminConsoleAiAiFeedbackRouteRoute;
  '/admin-console/ai/ai-prompts': typeof AdminConsoleAiAiPromptsRouteRoute;
  '/admin-console/ai/eval-runs': typeof AdminConsoleAiEvalRunsRouteRouteWithChildren;
  '/admin-console/ai/model-pricing': typeof AdminConsoleAiModelPricingRouteRoute;
  '/admin-console/ai/model-tiers': typeof AdminConsoleAiModelTiersRouteRoute;
  '/admin-console/ai/request-analytics': typeof AdminConsoleAiRequestAnalyticsRouteRoute;
  '/admin-console/ai/statistics': typeof AdminConsoleAiStatisticsRouteRoute;
  '/admin-console/ai/usage-billing': typeof AdminConsoleAiUsageBillingRouteRoute;
  '/admin-console/monitoring/audit-trail': typeof AdminConsoleMonitoringAuditTrailRouteRoute;
  '/admin-console/monitoring/axiom-logs': typeof AdminConsoleMonitoringAxiomLogsRouteRoute;
  '/admin-console/monitoring/compliance': typeof AdminConsoleMonitoringComplianceRouteRoute;
  '/admin-console/monitoring/compliance-audit': typeof AdminConsoleMonitoringComplianceAuditRouteRouteWithChildren;
  '/admin-console/monitoring/email-activity': typeof AdminConsoleMonitoringEmailActivityRouteRouteWithChildren;
  '/admin-console/monitoring/engagement': typeof AdminConsoleMonitoringEngagementRouteRouteWithChildren;
  '/admin-console/monitoring/llm-logs': typeof AdminConsoleMonitoringLlmLogsRouteRoute;
  '/admin-console/monitoring/llm-stats': typeof AdminConsoleMonitoringLlmStatsRouteRoute;
  '/admin-console/monitoring/memory': typeof AdminConsoleMonitoringMemoryRouteRoute;
  '/admin-console/monitoring/reports': typeof AdminConsoleMonitoringReportsRouteRoute;
  '/admin-console/monitoring/statistics': typeof AdminConsoleMonitoringStatisticsRouteRoute;
  '/admin-console/organisation-management/new': typeof AdminConsoleOrganisationManagementNewRouteRoute;
  '/admin-console/organisation-management/new-from-template': typeof AdminConsoleOrganisationManagementNewFromTemplateRouteRoute;
  '/admin-console/organisation-management/organisations': typeof AdminConsoleOrganisationManagementOrganisationsRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training': typeof AdminConsolePlatformContentAiTrainingRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content': typeof AdminConsolePlatformContentCommsAndContentRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates': typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteWithChildren;
  '/admin-console/platform-content/market-pds': typeof AdminConsolePlatformContentMarketPdsRouteRouteWithChildren;
  '/admin-console/platform-content/obligations': typeof AdminConsolePlatformContentObligationsRouteRouteWithChildren;
  '/admin-console/platform-content/products': typeof AdminConsolePlatformContentProductsRouteRouteWithChildren;
  '/admin-console/platform-content/whats-new': typeof AdminConsolePlatformContentWhatsNewRouteRouteWithChildren;
  '/admin-console/tools/document-to-markdown': typeof AdminConsoleToolsDocumentToMarkdownRoute;
  '/admin-console/tools/feature-flags': typeof AdminConsoleToolsFeatureFlagsRoute;
  '/admin-console/tools/sanitise-text-pii': typeof AdminConsoleToolsSanitiseTextPiiRouteRouteWithChildren;
  '/admin-console/user-access/admin-users': typeof AdminConsoleUserAccessAdminUsersRouteRouteWithChildren;
  '/admin-console/user-access/support-sessions': typeof AdminConsoleUserAccessSupportSessionsRouteRoute;
  '/admin-console/user-access/users': typeof AdminConsoleUserAccessUsersRouteRouteWithChildren;
  '/console/$orgId/attestations': typeof ConsoleOrgIdAttestationsRouteRouteWithChildren;
  '/console/$orgId/claims': typeof ConsoleOrgIdClaimsRouteRouteWithChildren;
  '/console/$orgId/compliance': typeof ConsoleOrgIdComplianceRouteRouteWithChildren;
  '/console/$orgId/component-showcase': typeof ConsoleOrgIdComponentShowcaseRouteRouteWithChildren;
  '/console/$orgId/configuration': typeof ConsoleOrgIdConfigurationRouteRouteWithChildren;
  '/console/$orgId/controls': typeof ConsoleOrgIdControlsRouteRouteWithChildren;
  '/console/$orgId/dashboard': typeof ConsoleOrgIdDashboardRouteRouteWithChildren;
  '/console/$orgId/documents': typeof ConsoleOrgIdDocumentsRouteRouteWithChildren;
  '/console/$orgId/faq': typeof ConsoleOrgIdFaqRouteRoute;
  '/console/$orgId/fleet-portal': typeof ConsoleOrgIdFleetPortalRouteRouteWithChildren;
  '/console/$orgId/get-file': typeof ConsoleOrgIdGetFileRouteRoute;
  '/console/$orgId/mspr': typeof ConsoleOrgIdMsprRouteRouteWithChildren;
  '/console/$orgId/reporting': typeof ConsoleOrgIdReportingRouteRouteWithChildren;
  '/console/$orgId/risk': typeof ConsoleOrgIdRiskRouteRouteWithChildren;
  '/console/$orgId/tools': typeof ConsoleOrgIdToolsRouteRouteWithChildren;
  '/console/$orgId/tools-only-home-page': typeof ConsoleOrgIdToolsOnlyHomePageRoute;
  '/console/$orgId/user-settings': typeof ConsoleOrgIdUserSettingsRouteRouteWithChildren;
  '/console/$orgId/workload-manager': typeof ConsoleOrgIdWorkloadManagerRouteRouteWithChildren;
  '/public/lodgement-summary/$accessKey': typeof PublicLodgementSummaryAccessKeyRouteRoute;
  '/public/new-complaint-by-key/$key': typeof PublicNewComplaintByKeyKeyRouteRoute;
  '/public/new-complaint/$orgId': typeof PublicNewComplaintOrgIdRouteRoute;
  '/admin-console/advanced/inbound-parse/': typeof AdminConsoleAdvancedInboundParseIndexRoute;
  '/admin-console/advanced/jobs/': typeof AdminConsoleAdvancedJobsIndexRoute;
  '/admin-console/monitoring/email-activity/': typeof AdminConsoleMonitoringEmailActivityIndexRoute;
  '/admin-console/monitoring/engagement/': typeof AdminConsoleMonitoringEngagementIndexRoute;
  '/admin-console/organisation-management/organisations/': typeof AdminConsoleOrganisationManagementOrganisationsIndexRoute;
  '/admin-console/platform-content/ai-training/': typeof AdminConsolePlatformContentAiTrainingIndexRoute;
  '/admin-console/platform-content/compliance-audit-templates/': typeof AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute;
  '/admin-console/platform-content/obligations/': typeof AdminConsolePlatformContentObligationsIndexRoute;
  '/admin-console/platform-content/whats-new/': typeof AdminConsolePlatformContentWhatsNewIndexRoute;
  '/console/$orgId/attestations/': typeof ConsoleOrgIdAttestationsIndexRoute;
  '/console/$orgId/claims/': typeof ConsoleOrgIdClaimsIndexRoute;
  '/console/$orgId/compliance/': typeof ConsoleOrgIdComplianceIndexRoute;
  '/console/$orgId/component-showcase/': typeof ConsoleOrgIdComponentShowcaseIndexRoute;
  '/console/$orgId/configuration/': typeof ConsoleOrgIdConfigurationIndexRoute;
  '/console/$orgId/controls/': typeof ConsoleOrgIdControlsIndexRoute;
  '/console/$orgId/dashboard/': typeof ConsoleOrgIdDashboardIndexRoute;
  '/console/$orgId/debug/': typeof ConsoleOrgIdDebugIndexRoute;
  '/console/$orgId/fleet-portal/': typeof ConsoleOrgIdFleetPortalIndexRoute;
  '/console/$orgId/risk/': typeof ConsoleOrgIdRiskIndexRoute;
  '/console/$orgId/tools/': typeof ConsoleOrgIdToolsIndexRoute;
  '/console/$orgId/user-settings/': typeof ConsoleOrgIdUserSettingsIndexRoute;
  '/console/$orgId/workload-manager/': typeof ConsoleOrgIdWorkloadManagerIndexRoute;
  '/admin-console/advanced/app-settings/all': typeof AdminConsoleAdvancedAppSettingsAllRouteRouteWithChildren;
  '/admin-console/advanced/app-settings/well-known': typeof AdminConsoleAdvancedAppSettingsWellKnownRoute;
  '/admin-console/advanced/indicators/complaints': typeof AdminConsoleAdvancedIndicatorsComplaintsRoute;
  '/admin-console/advanced/indicators/incidents': typeof AdminConsoleAdvancedIndicatorsIncidentsRoute;
  '/admin-console/advanced/jobs/dynamic-recurring': typeof AdminConsoleAdvancedJobsDynamicRecurringRouteWithChildren;
  '/admin-console/advanced/jobs/on-demand': typeof AdminConsoleAdvancedJobsOnDemandRouteWithChildren;
  '/admin-console/advanced/jobs/recurring': typeof AdminConsoleAdvancedJobsRecurringRouteWithChildren;
  '/admin-console/ai/eval-runs/$evalRunId': typeof AdminConsoleAiEvalRunsEvalRunIdRouteRoute;
  '/admin-console/ai/eval-runs/compare': typeof AdminConsoleAiEvalRunsCompareRouteRoute;
  '/admin-console/organisation-management/organisations/$orgId': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training/classification-example': typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteWithChildren;
  '/admin-console/platform-content/ai-training/vulnerability-example': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/app-text': typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/comm-templates': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteWithChildren;
  '/admin-console/platform-content/comms-and-content/faq': typeof AdminConsolePlatformContentCommsAndContentFaqRouteRoute;
  '/admin-console/platform-content/compliance-audit-templates/search': typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteWithChildren;
  '/admin-console/platform-content/market-pds/add': typeof AdminConsolePlatformContentMarketPdsAddRoute;
  '/admin-console/platform-content/obligations/configuration': typeof AdminConsolePlatformContentObligationsConfigurationRouteRoute;
  '/admin-console/platform-content/obligations/controls-library': typeof AdminConsolePlatformContentObligationsControlsLibraryRouteRouteWithChildren;
  '/admin-console/platform-content/obligations/library': typeof AdminConsolePlatformContentObligationsLibraryRouteRouteWithChildren;
  '/admin-console/platform-content/products/$serviceId': typeof AdminConsolePlatformContentProductsServiceIdRoute;
  '/admin-console/platform-content/whats-new/$id': typeof AdminConsolePlatformContentWhatsNewIdRoute;
  '/admin-console/platform-content/whats-new/new': typeof AdminConsolePlatformContentWhatsNewNewRoute;
  '/admin-console/tools/sanitise-text-pii/compare': typeof AdminConsoleToolsSanitiseTextPiiCompareRoute;
  '/admin-console/tools/sanitise-text-pii/tool': typeof AdminConsoleToolsSanitiseTextPiiToolRoute;
  '/admin-console/user-access/admin-users/grant': typeof AdminConsoleUserAccessAdminUsersGrantRoute;
  '/console/$orgId/attestations/scheduled-attestations': typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren;
  '/console/$orgId/attestations/user-attestations': typeof ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren;
  '/console/$orgId/compliance/coi': typeof ConsoleOrgIdComplianceCoiRouteRouteWithChildren;
  '/console/$orgId/compliance/complaints': typeof ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents': typeof ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren;
  '/console/$orgId/compliance/intake': typeof ConsoleOrgIdComplianceIntakeRouteRoute;
  '/console/$orgId/compliance/obligations': typeof ConsoleOrgIdComplianceObligationsRouteRouteWithChildren;
  '/console/$orgId/compliance/registers': typeof ConsoleOrgIdComplianceRegistersRouteRouteWithChildren;
  '/console/$orgId/compliance/training': typeof ConsoleOrgIdComplianceTrainingRouteRouteWithChildren;
  '/console/$orgId/component-showcase/ai-chat-test': typeof ConsoleOrgIdComponentShowcaseAiChatTestRoute;
  '/console/$orgId/component-showcase/button-icon-test': typeof ConsoleOrgIdComponentShowcaseButtonIconTestRoute;
  '/console/$orgId/component-showcase/button-variants': typeof ConsoleOrgIdComponentShowcaseButtonVariantsRoute;
  '/console/$orgId/component-showcase/component-showcase': typeof ConsoleOrgIdComponentShowcaseComponentShowcaseRoute;
  '/console/$orgId/component-showcase/date-picker-test': typeof ConsoleOrgIdComponentShowcaseDatePickerTestRoute;
  '/console/$orgId/component-showcase/fit-on-page': typeof ConsoleOrgIdComponentShowcaseFitOnPageRoute;
  '/console/$orgId/component-showcase/markdown-showcase': typeof ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute;
  '/console/$orgId/component-showcase/table-showcase': typeof ConsoleOrgIdComponentShowcaseTableShowcaseRoute;
  '/console/$orgId/component-showcase/tag-variants': typeof ConsoleOrgIdComponentShowcaseTagVariantsRoute;
  '/console/$orgId/component-showcase/tiptap-test': typeof ConsoleOrgIdComponentShowcaseTiptapTestRoute;
  '/console/$orgId/configuration/api-integrations': typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products': typeof ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren;
  '/console/$orgId/configuration/client-database': typeof ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren;
  '/console/$orgId/configuration/compliance': typeof ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren;
  '/console/$orgId/configuration/financials': typeof ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren;
  '/console/$orgId/configuration/fleet': typeof ConsoleOrgIdConfigurationFleetRouteRouteWithChildren;
  '/console/$orgId/configuration/monitoring': typeof ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings': typeof ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren;
  '/console/$orgId/configuration/risk': typeof ConsoleOrgIdConfigurationRiskRouteRouteWithChildren;
  '/console/$orgId/configuration/vendor-management': typeof ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren;
  '/console/$orgId/controls/activities': typeof ConsoleOrgIdControlsActivitiesRouteRoute;
  '/console/$orgId/controls/register': typeof ConsoleOrgIdControlsRegisterRouteRouteWithChildren;
  '/console/$orgId/controls/tests': typeof ConsoleOrgIdControlsTestsRouteRoute;
  '/console/$orgId/dashboard/claims': typeof ConsoleOrgIdDashboardClaimsRoute;
  '/console/$orgId/dashboard/complaints': typeof ConsoleOrgIdDashboardComplaintsRoute;
  '/console/$orgId/dashboard/incidents': typeof ConsoleOrgIdDashboardIncidentsRoute;
  '/console/$orgId/dashboard/management': typeof ConsoleOrgIdDashboardManagementRoute;
  '/console/$orgId/dashboard/people-and-culture': typeof ConsoleOrgIdDashboardPeopleAndCultureRoute;
  '/console/$orgId/dashboard/risks': typeof ConsoleOrgIdDashboardRisksRoute;
  '/console/$orgId/fleet-portal/authorisations': typeof ConsoleOrgIdFleetPortalAuthorisationsRoute;
  '/console/$orgId/fleet-portal/claims': typeof ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren;
  '/console/$orgId/fleet-portal/dashboard': typeof ConsoleOrgIdFleetPortalDashboardRoute;
  '/console/$orgId/fleet-portal/fleet': typeof ConsoleOrgIdFleetPortalFleetRoute;
  '/console/$orgId/fleet-portal/sla': typeof ConsoleOrgIdFleetPortalSlaRoute;
  '/console/$orgId/mspr/msp-exceptions': typeof ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren;
  '/console/$orgId/mspr/service-providers': typeof ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren;
  '/console/$orgId/reporting/add': typeof ConsoleOrgIdReportingAddRoute;
  '/console/$orgId/risk/ras': typeof ConsoleOrgIdRiskRasRouteRouteWithChildren;
  '/console/$orgId/risk/register': typeof ConsoleOrgIdRiskRegisterRouteRouteWithChildren;
  '/console/$orgId/tools/auto-detect': typeof ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit': typeof ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer': typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren;
  '/console/$orgId/tools/pds-compare': typeof ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren;
  '/console/$orgId/tools/website-checker': typeof ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren;
  '/console/$orgId/user-settings/notifications': typeof ConsoleOrgIdUserSettingsNotificationsRoute;
  '/console/$orgId/user-settings/profile': typeof ConsoleOrgIdUserSettingsProfileRoute;
  '/console/$orgId/workload-manager/complaints': typeof ConsoleOrgIdWorkloadManagerComplaintsRoute;
  '/console/$orgId/workload-manager/emails': typeof ConsoleOrgIdWorkloadManagerEmailsRouteRoute;
  '/console/$orgId/workload-manager/tasks': typeof ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren;
  '/public/$orgId/complaint/new': typeof PublicOrgIdComplaintNewRouteRoute;
  '/admin-console/platform-content/obligations/controls-library/': typeof AdminConsolePlatformContentObligationsControlsLibraryIndexRoute;
  '/admin-console/platform-content/obligations/library/': typeof AdminConsolePlatformContentObligationsLibraryIndexRoute;
  '/console/$orgId/compliance/coi/': typeof ConsoleOrgIdComplianceCoiIndexRoute;
  '/console/$orgId/compliance/complaints/': typeof ConsoleOrgIdComplianceComplaintsIndexRoute;
  '/console/$orgId/compliance/incidents/': typeof ConsoleOrgIdComplianceIncidentsIndexRoute;
  '/console/$orgId/compliance/obligations/': typeof ConsoleOrgIdComplianceObligationsIndexRoute;
  '/console/$orgId/compliance/registers/': typeof ConsoleOrgIdComplianceRegistersIndexRoute;
  '/console/$orgId/compliance/training/': typeof ConsoleOrgIdComplianceTrainingIndexRoute;
  '/console/$orgId/configuration/compliance/': typeof ConsoleOrgIdConfigurationComplianceIndexRoute;
  '/console/$orgId/configuration/fleet/': typeof ConsoleOrgIdConfigurationFleetIndexRoute;
  '/console/$orgId/configuration/risk/': typeof ConsoleOrgIdConfigurationRiskIndexRoute;
  '/console/$orgId/controls/register/': typeof ConsoleOrgIdControlsRegisterIndexRoute;
  '/console/$orgId/fleet-portal/claims/': typeof ConsoleOrgIdFleetPortalClaimsIndexRoute;
  '/console/$orgId/mspr/service-providers/': typeof ConsoleOrgIdMsprServiceProvidersIndexRoute;
  '/console/$orgId/risk/ras/': typeof ConsoleOrgIdRiskRasIndexRoute;
  '/console/$orgId/risk/register/': typeof ConsoleOrgIdRiskRegisterIndexRoute;
  '/console/$orgId/tools/compliance-audit/': typeof ConsoleOrgIdToolsComplianceAuditIndexRoute;
  '/console/$orgId/tools/document-analyzer/': typeof ConsoleOrgIdToolsDocumentAnalyzerIndexRoute;
  '/console/$orgId/tools/pds-compare/': typeof ConsoleOrgIdToolsPdsCompareIndexRoute;
  '/console/$orgId/tools/website-checker/': typeof ConsoleOrgIdToolsWebsiteCheckerIndexRoute;
  '/console/$orgId/user-settings/authorised-apps/': typeof ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute;
  '/console/$orgId/workload-manager/tasks/': typeof ConsoleOrgIdWorkloadManagerTasksIndexRoute;
  '/admin-console/advanced/app-settings/all/add': typeof AdminConsoleAdvancedAppSettingsAllAddRoute;
  '/admin-console/advanced/jobs/dynamic-recurring/$jobId': typeof AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute;
  '/admin-console/advanced/jobs/on-demand/$jobId': typeof AdminConsoleAdvancedJobsOnDemandJobIdRoute;
  '/admin-console/advanced/jobs/recurring/$jobId': typeof AdminConsoleAdvancedJobsRecurringJobIdRoute;
  '/admin-console/organisation-management/organisations/$orgId/subscriptions': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute;
  '/admin-console/organisation-management/organisations/$orgId/users': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteWithChildren;
  '/admin-console/organisation-management/organisations/$orgId/wallet': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute;
  '/admin-console/platform-content/ai-training/classification-example/create': typeof AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/create': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute;
  '/admin-console/platform-content/comms-and-content/app-text/add': typeof AdminConsolePlatformContentCommsAndContentAppTextAddRoute;
  '/admin-console/platform-content/comms-and-content/comm-templates/add': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/search/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute;
  '/admin-console/platform-content/market-pds/edit/$id': typeof AdminConsolePlatformContentMarketPdsEditIdRoute;
  '/admin-console/platform-content/obligations/controls-library/$id': typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteWithChildren;
  '/admin-console/user-access/admin-users/edit/$userId': typeof AdminConsoleUserAccessAdminUsersEditUserIdRoute;
  '/admin-console/user-access/users/edit/$userId': typeof AdminConsoleUserAccessUsersEditUserIdRoute;
  '/admin-console/user-access/users/view/$userId': typeof AdminConsoleUserAccessUsersViewUserIdRoute;
  '/console/$orgId/attestations/scheduled-attestations/$scheduleId': typeof ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute;
  '/console/$orgId/attestations/scheduled-attestations/new': typeof ConsoleOrgIdAttestationsScheduledAttestationsNewRoute;
  '/console/$orgId/attestations/user-attestations/$attestationId': typeof ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute;
  '/console/$orgId/attestations/user-attestations/send': typeof ConsoleOrgIdAttestationsUserAttestationsSendRoute;
  '/console/$orgId/claims/details/$id': typeof ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/coi/add': typeof ConsoleOrgIdComplianceCoiAddRouteRoute;
  '/console/$orgId/compliance/complaints/add': typeof ConsoleOrgIdComplianceComplaintsAddRouteRoute;
  '/console/$orgId/compliance/incidents/add': typeof ConsoleOrgIdComplianceIncidentsAddRoute;
  '/console/$orgId/compliance/obligations/add': typeof ConsoleOrgIdComplianceObligationsAddRouteRoute;
  '/console/$orgId/compliance/registers/$registerId': typeof ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren;
  '/console/$orgId/compliance/training/search': typeof ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/api-tokens': typeof ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute;
  '/console/$orgId/configuration/api-integrations/form-designer': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/mcp-access': typeof ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute;
  '/console/$orgId/configuration/claims-products/claims': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/insurers': typeof ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute;
  '/console/$orgId/configuration/claims-products/product-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/questionnaire': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren;
  '/console/$orgId/configuration/client-database/$': typeof ConsoleOrgIdConfigurationClientDatabaseSplatRoute;
  '/console/$orgId/configuration/compliance/attestations': typeof ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/auto-detect': typeof ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute;
  '/console/$orgId/configuration/compliance/complaints': typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/compliance-audit': typeof ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute;
  '/console/$orgId/configuration/compliance/general': typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents': typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr': typeof ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/obligations': typeof ConsoleOrgIdConfigurationComplianceObligationsRoute;
  '/console/$orgId/configuration/compliance/training': typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren;
  '/console/$orgId/configuration/financials/billing': typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren;
  '/console/$orgId/configuration/financials/expenses-billing': typeof ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute;
  '/console/$orgId/configuration/financials/payments': typeof ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute;
  '/console/$orgId/configuration/fleet/client-database': typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren;
  '/console/$orgId/configuration/fleet/delegated-authority': typeof ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute;
  '/console/$orgId/configuration/fleet/escalations': typeof ConsoleOrgIdConfigurationFleetEscalationsRouteRoute;
  '/console/$orgId/configuration/fleet/portal-claim-page': typeof ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute;
  '/console/$orgId/configuration/monitoring/audit-trail': typeof ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute;
  '/console/$orgId/configuration/monitoring/email-activity': typeof ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute;
  '/console/$orgId/configuration/monitoring/statistics': typeof ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute;
  '/console/$orgId/configuration/org-settings/communication': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/fleet-escalations': typeof ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute;
  '/console/$orgId/configuration/org-settings/handling-parties': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/support-sessions': typeof ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute;
  '/console/$orgId/configuration/org-settings/system': typeof ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute;
  '/console/$orgId/configuration/org-settings/tasks': typeof ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute;
  '/console/$orgId/configuration/org-settings/trash': typeof ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute;
  '/console/$orgId/configuration/org-settings/users': typeof ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren;
  '/console/$orgId/configuration/risk/appetite': typeof ConsoleOrgIdConfigurationRiskAppetiteRoute;
  '/console/$orgId/configuration/risk/categories': typeof ConsoleOrgIdConfigurationRiskCategoriesRoute;
  '/console/$orgId/configuration/risk/matrix': typeof ConsoleOrgIdConfigurationRiskMatrixRoute;
  '/console/$orgId/configuration/vendor-management/suppliers': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren;
  '/console/$orgId/controls/register/add': typeof ConsoleOrgIdControlsRegisterAddRouteRoute;
  '/console/$orgId/documents/details/$fileId': typeof ConsoleOrgIdDocumentsDetailsFileIdRouteRoute;
  '/console/$orgId/mspr/service-providers/search': typeof ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren;
  '/console/$orgId/tools/auto-detect/dashboard': typeof ConsoleOrgIdToolsAutoDetectDashboardRoute;
  '/console/$orgId/tools/auto-detect/inbox': typeof ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/overview': typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer/history': typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren;
  '/console/$orgId/tools/document-analyzer/upload': typeof ConsoleOrgIdToolsDocumentAnalyzerUploadRoute;
  '/console/$orgId/tools/pds-compare/pds-documents': typeof ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren;
  '/console/$orgId/workload-manager/tasks/calendar': typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren;
  '/console/$orgId/workload-manager/tasks/list': typeof ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren;
  '/public/$orgId/invoice/view/$accessKey': typeof PublicOrgIdInvoiceViewAccessKeyRouteRoute;
  '/console/$orgId/compliance/registers/$registerId/': typeof ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute;
  '/console/$orgId/configuration/api-integrations/form-designer/': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute;
  '/console/$orgId/configuration/claims-products/claims/': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute;
  '/console/$orgId/configuration/compliance/complaints/': typeof ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute;
  '/console/$orgId/configuration/compliance/general/': typeof ConsoleOrgIdConfigurationComplianceGeneralIndexRoute;
  '/console/$orgId/configuration/compliance/incidents/': typeof ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute;
  '/console/$orgId/configuration/compliance/training/': typeof ConsoleOrgIdConfigurationComplianceTrainingIndexRoute;
  '/console/$orgId/configuration/org-settings/users/': typeof ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute;
  '/console/$orgId/tools/compliance-audit/overview/': typeof ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute;
  '/admin-console/advanced/app-settings/all/edit/$name': typeof AdminConsoleAdvancedAppSettingsAllEditNameRoute;
  '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics': typeof AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute;
  '/admin-console/platform-content/ai-training/classification-example/edit/$id': typeof AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute;
  '/admin-console/platform-content/ai-training/classification-example/view/$id': typeof AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute;
  '/admin-console/platform-content/ai-training/vulnerability-example/view/$id': typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute;
  '/admin-console/platform-content/comms-and-content/app-text/edit/$id': typeof AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute;
  '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId': typeof AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteWithChildren;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute;
  '/admin-console/platform-content/obligations/controls-library/$id/details': typeof AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute;
  '/admin-console/platform-content/obligations/controls-library/$id/history': typeof AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute;
  '/admin-console/platform-content/obligations/library/details/$id': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/activity': typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/ai-assessment': typeof ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute;
  '/console/$orgId/claims/details/$id/comms': typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/contacts': typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/expenses': typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials': typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/history': typeof ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute;
  '/console/$orgId/claims/details/$id/library': typeof ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute;
  '/console/$orgId/claims/details/$id/manage': typeof ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/policy-info': typeof ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute;
  '/console/$orgId/claims/details/$id/product-type-data': typeof ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute;
  '/console/$orgId/claims/details/$id/vehicle': typeof ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute;
  '/console/$orgId/compliance/coi/details/$id': typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/complaints/details/$id': typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents/details/$id': typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/obligations/details/$id': typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren;
  '/console/$orgId/compliance/training/search/add': typeof ConsoleOrgIdComplianceTrainingSearchAddRoute;
  '/console/$orgId/compliance/training/user/$userId': typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren;
  '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/claim-flags': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/documents': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute;
  '/console/$orgId/configuration/claims-products/claims/general': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/handling-standards': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute;
  '/console/$orgId/configuration/claims-products/claims/id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute;
  '/console/$orgId/configuration/claims-products/products-v2/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute;
  '/console/$orgId/configuration/claims-products/questionnaire/add': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute;
  '/console/$orgId/configuration/compliance/attestations/user-attestations': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/complaints/brands': typeof ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute;
  '/console/$orgId/configuration/compliance/complaints/custom-fields': typeof ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/complaints/flags': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/complaints/general': typeof ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute;
  '/console/$orgId/configuration/compliance/complaints/rules': typeof ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute;
  '/console/$orgId/configuration/compliance/general/asic-products': typeof ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute;
  '/console/$orgId/configuration/compliance/general/documents': typeof ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute;
  '/console/$orgId/configuration/compliance/incidents/custom-fields': typeof ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/incidents/flags': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents/general': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/incidents/rules': typeof ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr/definitions': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/mspr/documents': typeof ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/training/custom-fields': typeof ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute;
  '/console/$orgId/configuration/compliance/training/training-periods': typeof ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute;
  '/console/$orgId/configuration/financials/billing/balance': typeof ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute;
  '/console/$orgId/configuration/financials/billing/billing-info': typeof ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute;
  '/console/$orgId/configuration/financials/billing/invoices': typeof ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute;
  '/console/$orgId/configuration/financials/billing/transactions': typeof ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute;
  '/console/$orgId/configuration/financials/billing/usage': typeof ConsoleOrgIdConfigurationFinancialsBillingUsageRoute;
  '/console/$orgId/configuration/fleet/client-database/add': typeof ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/communication/comm-templates': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/handling-parties/add': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/add': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/definitions': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute;
  '/console/$orgId/controls/register/details/$id': typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren;
  '/console/$orgId/fleet-portal/claims/details/$claimId': typeof ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute;
  '/console/$orgId/mspr/msp-exceptions/edit/$id': typeof ConsoleOrgIdMsprMspExceptionsEditIdRoute;
  '/console/$orgId/mspr/service-providers/details/$id': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren;
  '/console/$orgId/mspr/service-providers/search/add': typeof ConsoleOrgIdMsprServiceProvidersSearchAddRoute;
  '/console/$orgId/risk/ras/details/$id': typeof ConsoleOrgIdRiskRasDetailsIdRouteRoute;
  '/console/$orgId/risk/register/details/$id': typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/details/$complianceAuditId': typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren;
  '/console/$orgId/tools/compliance-audit/overview/insights': typeof ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute;
  '/console/$orgId/tools/compliance-audit/overview/search': typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren;
  '/console/$orgId/tools/website-checker/report/$id': typeof ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute;
  '/console/$orgId/workload-manager/tasks/calendar/add': typeof ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute;
  '/console/$orgId/workload-manager/tasks/list/add': typeof ConsoleOrgIdWorkloadManagerTasksListAddRoute;
  '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/console/$orgId/compliance/coi/details/$id/': typeof ConsoleOrgIdComplianceCoiDetailsIdIndexRoute;
  '/console/$orgId/compliance/complaints/details/$id/': typeof ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute;
  '/console/$orgId/compliance/incidents/details/$id/': typeof ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute;
  '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/': typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute;
  '/console/$orgId/configuration/compliance/incidents/general/': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute;
  '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId': typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute;
  '/admin-console/platform-content/obligations/library/details/$id/ai-related': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute;
  '/admin-console/platform-content/obligations/library/details/$id/document-analyser': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute;
  '/admin-console/platform-content/obligations/library/details/$id/history': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute;
  '/admin-console/platform-content/obligations/library/details/$id/manage': typeof AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute;
  '/console/$orgId/claims/details/$id/comms/add': typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/contacts/add': typeof ConsoleOrgIdClaimsDetailsIdContactsAddRoute;
  '/console/$orgId/claims/details/$id/expenses/add': typeof ConsoleOrgIdClaimsDetailsIdExpensesAddRoute;
  '/console/$orgId/compliance/coi/details/$id/library': typeof ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute;
  '/console/$orgId/compliance/coi/details/$id/manage': typeof ConsoleOrgIdComplianceCoiDetailsIdManageRoute;
  '/console/$orgId/compliance/complaints/details/$id/comms': typeof ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/history': typeof ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/library': typeof ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/compliance/incidents/details/$id/history': typeof ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/library': typeof ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/compliance/obligations/details/$id/debug': typeof ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute;
  '/console/$orgId/compliance/obligations/details/$id/manage': typeof ConsoleOrgIdComplianceObligationsDetailsIdManageRoute;
  '/console/$orgId/compliance/registers/$registerId/records/$recordId': typeof ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute;
  '/console/$orgId/compliance/training/user/$userId/add': typeof ConsoleOrgIdComplianceTrainingUserUserIdAddRoute;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/claim-flags/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/states/$id': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2/edit/$productId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute;
  '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId': typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute;
  '/console/$orgId/configuration/compliance/attestations/user-attestations/add': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute;
  '/console/$orgId/configuration/compliance/complaints/flags/add': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute;
  '/console/$orgId/configuration/compliance/incidents/flags/add': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute;
  '/console/$orgId/configuration/compliance/incidents/general/incident-details': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute;
  '/console/$orgId/configuration/compliance/incidents/general/lodgement': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute;
  '/console/$orgId/configuration/compliance/incidents/general/rectification': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute;
  '/console/$orgId/configuration/compliance/incidents/general/timeline': typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config/add': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute;
  '/console/$orgId/configuration/financials/billing/payment/success': typeof ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures/add': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-templates/add': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute;
  '/console/$orgId/configuration/org-settings/handling-parties/details/$id': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren;
  '/console/$orgId/configuration/org-settings/users/details/$userId': typeof ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/definitions': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/search/list': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute;
  '/console/$orgId/mspr/service-providers/details/$id/history': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/library': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/action-plan': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/assessment': typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren;
  '/console/$orgId/risk/register/details/$id/history': typeof ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute;
  '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification': typeof ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute;
  '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics': typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute;
  '/console/$orgId/tools/compliance-audit/overview/search/add': typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute;
  '/console/$orgId/tools/document-analyzer/history/$id/results': typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute;
  '/console/$orgId/tools/pds-compare/pds-documents/edit/$id': typeof ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute;
  '/console/$orgId/workload-manager/tasks/list/details/$id': typeof ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute;
  '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId': typeof PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/details/$id/': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute;
  '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId': typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute;
  '/console/$orgId/claims/details/$id/activity/add/phone': typeof ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute;
  '/console/$orgId/claims/details/$id/comms/add/email': typeof ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute;
  '/console/$orgId/claims/details/$id/comms/add/sms': typeof ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute;
  '/console/$orgId/claims/details/$id/comms/message/$messageId': typeof ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute;
  '/console/$orgId/claims/details/$id/comms/reply/$messageId': typeof ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute;
  '/console/$orgId/claims/details/$id/contacts/edit/$contactId': typeof ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute;
  '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId': typeof ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/excesses/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute;
  '/console/$orgId/claims/details/$id/manage/strategies/add': typeof ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/add': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage/incidents': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage/complaints': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute;
  '/console/$orgId/compliance/training/user/$userId/edit/$recordId': typeof ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute;
  '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute;
  '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute;
  '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id': typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute;
  '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId': typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute;
  '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId': typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute;
  '/console/$orgId/configuration/compliance/mspr/definitions/categories/add': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute;
  '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/clients': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/drivers': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/overview': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute;
  '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles': typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute;
  '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId': typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute;
  '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users': typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren;
  '/console/$orgId/controls/register/details/$id/activity/$activityId': typeof ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute;
  '/console/$orgId/controls/register/details/$id/activity/add': typeof ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute;
  '/console/$orgId/controls/register/details/$id/test/$testId': typeof ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute;
  '/console/$orgId/controls/register/details/$id/test/add': typeof ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/add': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute;
  '/console/$orgId/risk/register/details/$id/assessment/incidents': typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute;
  '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id': typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute;
  '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId': typeof ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId': typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute;
  '/console/$orgId/compliance/complaints/details/$id/manage/note/add': typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute;
  '/console/$orgId/compliance/incidents/details/$id/manage/note/add': typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute;
  '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute;
  '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute;
  '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id': typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/check/add': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute;
  '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId': typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute;
  '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute;
  '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add': typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute;
  '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add': typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute;
  '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute;
  '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute;
  '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute;
  '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add': typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute;
  '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id': typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute;
  '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId': typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute;
  '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId': typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute;
  '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId': typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/admin-consent'
    | '/admin-console'
    | '/attestation'
    | '/invite'
    | '/maintenance'
    | '/not-found'
    | '/not-supported'
    | '/oauth'
    | '/org-switched'
    | '/public'
    | '/status'
    | '/terms-acceptance'
    | '/admin-console/'
    | '/admin-login'
    | '/callback'
    | '/login'
    | '/logout'
    | '/logoutin'
    | '/org-mismatch'
    | '/payment-pending'
    | '/admin-console/advanced'
    | '/admin-console/ai'
    | '/admin-console/authorised-apps'
    | '/admin-console/monitoring'
    | '/admin-console/organisation-management'
    | '/admin-console/platform-content'
    | '/admin-console/tools'
    | '/admin-console/user-access'
    | '/attestation/$token'
    | '/console/$orgId'
    | '/oauth/authorize'
    | '/password-reset/request'
    | '/password-reset/reset'
    | '/public/$orgId'
    | '/whats-new/$releaseId'
    | '/admin-console/advanced/'
    | '/admin-console/monitoring/'
    | '/admin-console/platform-content/'
    | '/admin-console/tools/'
    | '/admin-console/user-access/'
    | '/console/$orgId/'
    | '/change-org/$orgId'
    | '/admin-console/advanced/app-settings'
    | '/admin-console/advanced/claims'
    | '/admin-console/advanced/db-stats'
    | '/admin-console/advanced/db-upgrades'
    | '/admin-console/advanced/inbound-email-archive'
    | '/admin-console/advanced/inbound-parse'
    | '/admin-console/advanced/indicators'
    | '/admin-console/advanced/integration-tests'
    | '/admin-console/advanced/jobs'
    | '/admin-console/advanced/playground'
    | '/admin-console/advanced/weaviate'
    | '/admin-console/ai/ai-feedback'
    | '/admin-console/ai/ai-prompts'
    | '/admin-console/ai/eval-runs'
    | '/admin-console/ai/model-pricing'
    | '/admin-console/ai/model-tiers'
    | '/admin-console/ai/request-analytics'
    | '/admin-console/ai/statistics'
    | '/admin-console/ai/usage-billing'
    | '/admin-console/monitoring/audit-trail'
    | '/admin-console/monitoring/axiom-logs'
    | '/admin-console/monitoring/compliance'
    | '/admin-console/monitoring/compliance-audit'
    | '/admin-console/monitoring/email-activity'
    | '/admin-console/monitoring/engagement'
    | '/admin-console/monitoring/llm-logs'
    | '/admin-console/monitoring/llm-stats'
    | '/admin-console/monitoring/memory'
    | '/admin-console/monitoring/reports'
    | '/admin-console/monitoring/statistics'
    | '/admin-console/organisation-management/new'
    | '/admin-console/organisation-management/new-from-template'
    | '/admin-console/organisation-management/organisations'
    | '/admin-console/platform-content/ai-training'
    | '/admin-console/platform-content/comms-and-content'
    | '/admin-console/platform-content/compliance-audit-templates'
    | '/admin-console/platform-content/market-pds'
    | '/admin-console/platform-content/obligations'
    | '/admin-console/platform-content/products'
    | '/admin-console/platform-content/whats-new'
    | '/admin-console/tools/document-to-markdown'
    | '/admin-console/tools/feature-flags'
    | '/admin-console/tools/sanitise-text-pii'
    | '/admin-console/user-access/admin-users'
    | '/admin-console/user-access/support-sessions'
    | '/admin-console/user-access/users'
    | '/console/$orgId/attestations'
    | '/console/$orgId/claims'
    | '/console/$orgId/compliance'
    | '/console/$orgId/component-showcase'
    | '/console/$orgId/configuration'
    | '/console/$orgId/controls'
    | '/console/$orgId/dashboard'
    | '/console/$orgId/documents'
    | '/console/$orgId/faq'
    | '/console/$orgId/fleet-portal'
    | '/console/$orgId/get-file'
    | '/console/$orgId/mspr'
    | '/console/$orgId/reporting'
    | '/console/$orgId/risk'
    | '/console/$orgId/tools'
    | '/console/$orgId/tools-only-home-page'
    | '/console/$orgId/user-settings'
    | '/console/$orgId/workload-manager'
    | '/public/lodgement-summary/$accessKey'
    | '/public/new-complaint-by-key/$key'
    | '/public/new-complaint/$orgId'
    | '/admin-console/advanced/inbound-parse/'
    | '/admin-console/advanced/jobs/'
    | '/admin-console/monitoring/email-activity/'
    | '/admin-console/monitoring/engagement/'
    | '/admin-console/organisation-management/organisations/'
    | '/admin-console/platform-content/ai-training/'
    | '/admin-console/platform-content/compliance-audit-templates/'
    | '/admin-console/platform-content/obligations/'
    | '/admin-console/platform-content/whats-new/'
    | '/console/$orgId/attestations/'
    | '/console/$orgId/claims/'
    | '/console/$orgId/compliance/'
    | '/console/$orgId/component-showcase/'
    | '/console/$orgId/configuration/'
    | '/console/$orgId/controls/'
    | '/console/$orgId/dashboard/'
    | '/console/$orgId/debug/'
    | '/console/$orgId/fleet-portal/'
    | '/console/$orgId/risk/'
    | '/console/$orgId/tools/'
    | '/console/$orgId/user-settings/'
    | '/console/$orgId/workload-manager/'
    | '/admin-console/advanced/app-settings/all'
    | '/admin-console/advanced/app-settings/well-known'
    | '/admin-console/advanced/indicators/complaints'
    | '/admin-console/advanced/indicators/incidents'
    | '/admin-console/advanced/jobs/dynamic-recurring'
    | '/admin-console/advanced/jobs/on-demand'
    | '/admin-console/advanced/jobs/recurring'
    | '/admin-console/ai/eval-runs/$evalRunId'
    | '/admin-console/ai/eval-runs/compare'
    | '/admin-console/organisation-management/organisations/$orgId'
    | '/admin-console/platform-content/ai-training/classification-example'
    | '/admin-console/platform-content/ai-training/vulnerability-example'
    | '/admin-console/platform-content/comms-and-content/app-text'
    | '/admin-console/platform-content/comms-and-content/comm-templates'
    | '/admin-console/platform-content/comms-and-content/faq'
    | '/admin-console/platform-content/compliance-audit-templates/search'
    | '/admin-console/platform-content/market-pds/add'
    | '/admin-console/platform-content/obligations/configuration'
    | '/admin-console/platform-content/obligations/controls-library'
    | '/admin-console/platform-content/obligations/library'
    | '/admin-console/platform-content/products/$serviceId'
    | '/admin-console/platform-content/whats-new/$id'
    | '/admin-console/platform-content/whats-new/new'
    | '/admin-console/tools/sanitise-text-pii/compare'
    | '/admin-console/tools/sanitise-text-pii/tool'
    | '/admin-console/user-access/admin-users/grant'
    | '/console/$orgId/attestations/scheduled-attestations'
    | '/console/$orgId/attestations/user-attestations'
    | '/console/$orgId/compliance/coi'
    | '/console/$orgId/compliance/complaints'
    | '/console/$orgId/compliance/incidents'
    | '/console/$orgId/compliance/intake'
    | '/console/$orgId/compliance/obligations'
    | '/console/$orgId/compliance/registers'
    | '/console/$orgId/compliance/training'
    | '/console/$orgId/component-showcase/ai-chat-test'
    | '/console/$orgId/component-showcase/button-icon-test'
    | '/console/$orgId/component-showcase/button-variants'
    | '/console/$orgId/component-showcase/component-showcase'
    | '/console/$orgId/component-showcase/date-picker-test'
    | '/console/$orgId/component-showcase/fit-on-page'
    | '/console/$orgId/component-showcase/markdown-showcase'
    | '/console/$orgId/component-showcase/table-showcase'
    | '/console/$orgId/component-showcase/tag-variants'
    | '/console/$orgId/component-showcase/tiptap-test'
    | '/console/$orgId/configuration/api-integrations'
    | '/console/$orgId/configuration/claims-products'
    | '/console/$orgId/configuration/client-database'
    | '/console/$orgId/configuration/compliance'
    | '/console/$orgId/configuration/financials'
    | '/console/$orgId/configuration/fleet'
    | '/console/$orgId/configuration/monitoring'
    | '/console/$orgId/configuration/org-settings'
    | '/console/$orgId/configuration/risk'
    | '/console/$orgId/configuration/vendor-management'
    | '/console/$orgId/controls/activities'
    | '/console/$orgId/controls/register'
    | '/console/$orgId/controls/tests'
    | '/console/$orgId/dashboard/claims'
    | '/console/$orgId/dashboard/complaints'
    | '/console/$orgId/dashboard/incidents'
    | '/console/$orgId/dashboard/management'
    | '/console/$orgId/dashboard/people-and-culture'
    | '/console/$orgId/dashboard/risks'
    | '/console/$orgId/fleet-portal/authorisations'
    | '/console/$orgId/fleet-portal/claims'
    | '/console/$orgId/fleet-portal/dashboard'
    | '/console/$orgId/fleet-portal/fleet'
    | '/console/$orgId/fleet-portal/sla'
    | '/console/$orgId/mspr/msp-exceptions'
    | '/console/$orgId/mspr/service-providers'
    | '/console/$orgId/reporting/add'
    | '/console/$orgId/risk/ras'
    | '/console/$orgId/risk/register'
    | '/console/$orgId/tools/auto-detect'
    | '/console/$orgId/tools/compliance-audit'
    | '/console/$orgId/tools/document-analyzer'
    | '/console/$orgId/tools/pds-compare'
    | '/console/$orgId/tools/website-checker'
    | '/console/$orgId/user-settings/notifications'
    | '/console/$orgId/user-settings/profile'
    | '/console/$orgId/workload-manager/complaints'
    | '/console/$orgId/workload-manager/emails'
    | '/console/$orgId/workload-manager/tasks'
    | '/public/$orgId/complaint/new'
    | '/admin-console/platform-content/obligations/controls-library/'
    | '/admin-console/platform-content/obligations/library/'
    | '/console/$orgId/compliance/coi/'
    | '/console/$orgId/compliance/complaints/'
    | '/console/$orgId/compliance/incidents/'
    | '/console/$orgId/compliance/obligations/'
    | '/console/$orgId/compliance/registers/'
    | '/console/$orgId/compliance/training/'
    | '/console/$orgId/configuration/compliance/'
    | '/console/$orgId/configuration/fleet/'
    | '/console/$orgId/configuration/risk/'
    | '/console/$orgId/controls/register/'
    | '/console/$orgId/fleet-portal/claims/'
    | '/console/$orgId/mspr/service-providers/'
    | '/console/$orgId/risk/ras/'
    | '/console/$orgId/risk/register/'
    | '/console/$orgId/tools/compliance-audit/'
    | '/console/$orgId/tools/document-analyzer/'
    | '/console/$orgId/tools/pds-compare/'
    | '/console/$orgId/tools/website-checker/'
    | '/console/$orgId/user-settings/authorised-apps/'
    | '/console/$orgId/workload-manager/tasks/'
    | '/admin-console/advanced/app-settings/all/add'
    | '/admin-console/advanced/jobs/dynamic-recurring/$jobId'
    | '/admin-console/advanced/jobs/on-demand/$jobId'
    | '/admin-console/advanced/jobs/recurring/$jobId'
    | '/admin-console/organisation-management/organisations/$orgId/subscriptions'
    | '/admin-console/organisation-management/organisations/$orgId/users'
    | '/admin-console/organisation-management/organisations/$orgId/wallet'
    | '/admin-console/platform-content/ai-training/classification-example/create'
    | '/admin-console/platform-content/ai-training/vulnerability-example/create'
    | '/admin-console/platform-content/comms-and-content/app-text/add'
    | '/admin-console/platform-content/comms-and-content/comm-templates/add'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId'
    | '/admin-console/platform-content/compliance-audit-templates/search/add'
    | '/admin-console/platform-content/market-pds/edit/$id'
    | '/admin-console/platform-content/obligations/controls-library/$id'
    | '/admin-console/user-access/admin-users/edit/$userId'
    | '/admin-console/user-access/users/edit/$userId'
    | '/admin-console/user-access/users/view/$userId'
    | '/console/$orgId/attestations/scheduled-attestations/$scheduleId'
    | '/console/$orgId/attestations/scheduled-attestations/new'
    | '/console/$orgId/attestations/user-attestations/$attestationId'
    | '/console/$orgId/attestations/user-attestations/send'
    | '/console/$orgId/claims/details/$id'
    | '/console/$orgId/compliance/coi/add'
    | '/console/$orgId/compliance/complaints/add'
    | '/console/$orgId/compliance/incidents/add'
    | '/console/$orgId/compliance/obligations/add'
    | '/console/$orgId/compliance/registers/$registerId'
    | '/console/$orgId/compliance/training/search'
    | '/console/$orgId/configuration/api-integrations/api-tokens'
    | '/console/$orgId/configuration/api-integrations/form-designer'
    | '/console/$orgId/configuration/api-integrations/mcp-access'
    | '/console/$orgId/configuration/claims-products/claims'
    | '/console/$orgId/configuration/claims-products/insurers'
    | '/console/$orgId/configuration/claims-products/product-types'
    | '/console/$orgId/configuration/claims-products/products-v2'
    | '/console/$orgId/configuration/claims-products/questionnaire'
    | '/console/$orgId/configuration/client-database/$'
    | '/console/$orgId/configuration/compliance/attestations'
    | '/console/$orgId/configuration/compliance/auto-detect'
    | '/console/$orgId/configuration/compliance/complaints'
    | '/console/$orgId/configuration/compliance/compliance-audit'
    | '/console/$orgId/configuration/compliance/general'
    | '/console/$orgId/configuration/compliance/incidents'
    | '/console/$orgId/configuration/compliance/mspr'
    | '/console/$orgId/configuration/compliance/obligations'
    | '/console/$orgId/configuration/compliance/training'
    | '/console/$orgId/configuration/financials/billing'
    | '/console/$orgId/configuration/financials/expenses-billing'
    | '/console/$orgId/configuration/financials/payments'
    | '/console/$orgId/configuration/fleet/client-database'
    | '/console/$orgId/configuration/fleet/delegated-authority'
    | '/console/$orgId/configuration/fleet/escalations'
    | '/console/$orgId/configuration/fleet/portal-claim-page'
    | '/console/$orgId/configuration/monitoring/audit-trail'
    | '/console/$orgId/configuration/monitoring/email-activity'
    | '/console/$orgId/configuration/monitoring/statistics'
    | '/console/$orgId/configuration/org-settings/communication'
    | '/console/$orgId/configuration/org-settings/fleet-escalations'
    | '/console/$orgId/configuration/org-settings/handling-parties'
    | '/console/$orgId/configuration/org-settings/support-sessions'
    | '/console/$orgId/configuration/org-settings/system'
    | '/console/$orgId/configuration/org-settings/tasks'
    | '/console/$orgId/configuration/org-settings/trash'
    | '/console/$orgId/configuration/org-settings/users'
    | '/console/$orgId/configuration/risk/appetite'
    | '/console/$orgId/configuration/risk/categories'
    | '/console/$orgId/configuration/risk/matrix'
    | '/console/$orgId/configuration/vendor-management/suppliers'
    | '/console/$orgId/controls/register/add'
    | '/console/$orgId/documents/details/$fileId'
    | '/console/$orgId/mspr/service-providers/search'
    | '/console/$orgId/tools/auto-detect/dashboard'
    | '/console/$orgId/tools/auto-detect/inbox'
    | '/console/$orgId/tools/compliance-audit/overview'
    | '/console/$orgId/tools/document-analyzer/history'
    | '/console/$orgId/tools/document-analyzer/upload'
    | '/console/$orgId/tools/pds-compare/pds-documents'
    | '/console/$orgId/workload-manager/tasks/calendar'
    | '/console/$orgId/workload-manager/tasks/list'
    | '/public/$orgId/invoice/view/$accessKey'
    | '/console/$orgId/compliance/registers/$registerId/'
    | '/console/$orgId/configuration/api-integrations/form-designer/'
    | '/console/$orgId/configuration/claims-products/claims/'
    | '/console/$orgId/configuration/compliance/complaints/'
    | '/console/$orgId/configuration/compliance/general/'
    | '/console/$orgId/configuration/compliance/incidents/'
    | '/console/$orgId/configuration/compliance/training/'
    | '/console/$orgId/configuration/org-settings/users/'
    | '/console/$orgId/configuration/vendor-management/suppliers/'
    | '/console/$orgId/tools/compliance-audit/overview/'
    | '/admin-console/advanced/app-settings/all/edit/$name'
    | '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics'
    | '/admin-console/platform-content/ai-training/classification-example/edit/$id'
    | '/admin-console/platform-content/ai-training/classification-example/view/$id'
    | '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id'
    | '/admin-console/platform-content/ai-training/vulnerability-example/view/$id'
    | '/admin-console/platform-content/comms-and-content/app-text/edit/$id'
    | '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure'
    | '/admin-console/platform-content/obligations/controls-library/$id/details'
    | '/admin-console/platform-content/obligations/controls-library/$id/history'
    | '/admin-console/platform-content/obligations/library/details/$id'
    | '/console/$orgId/claims/details/$id/activity'
    | '/console/$orgId/claims/details/$id/ai-assessment'
    | '/console/$orgId/claims/details/$id/comms'
    | '/console/$orgId/claims/details/$id/contacts'
    | '/console/$orgId/claims/details/$id/expenses'
    | '/console/$orgId/claims/details/$id/financials'
    | '/console/$orgId/claims/details/$id/history'
    | '/console/$orgId/claims/details/$id/library'
    | '/console/$orgId/claims/details/$id/manage'
    | '/console/$orgId/claims/details/$id/policy-info'
    | '/console/$orgId/claims/details/$id/product-type-data'
    | '/console/$orgId/claims/details/$id/vehicle'
    | '/console/$orgId/compliance/coi/details/$id'
    | '/console/$orgId/compliance/complaints/details/$id'
    | '/console/$orgId/compliance/incidents/details/$id'
    | '/console/$orgId/compliance/obligations/details/$id'
    | '/console/$orgId/compliance/training/search/add'
    | '/console/$orgId/compliance/training/user/$userId'
    | '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags'
    | '/console/$orgId/configuration/claims-products/claims/documents'
    | '/console/$orgId/configuration/claims-products/claims/general'
    | '/console/$orgId/configuration/claims-products/claims/handling-standards'
    | '/console/$orgId/configuration/claims-products/claims/id'
    | '/console/$orgId/configuration/claims-products/claims/task-lists'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/add'
    | '/console/$orgId/configuration/claims-products/products-v2/add'
    | '/console/$orgId/configuration/claims-products/questionnaire/add'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations'
    | '/console/$orgId/configuration/compliance/complaints/brands'
    | '/console/$orgId/configuration/compliance/complaints/custom-fields'
    | '/console/$orgId/configuration/compliance/complaints/flags'
    | '/console/$orgId/configuration/compliance/complaints/general'
    | '/console/$orgId/configuration/compliance/complaints/rules'
    | '/console/$orgId/configuration/compliance/general/asic-products'
    | '/console/$orgId/configuration/compliance/general/documents'
    | '/console/$orgId/configuration/compliance/incidents/custom-fields'
    | '/console/$orgId/configuration/compliance/incidents/flags'
    | '/console/$orgId/configuration/compliance/incidents/general'
    | '/console/$orgId/configuration/compliance/incidents/rules'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations'
    | '/console/$orgId/configuration/compliance/mspr/definitions'
    | '/console/$orgId/configuration/compliance/mspr/documents'
    | '/console/$orgId/configuration/compliance/mspr/governance-config'
    | '/console/$orgId/configuration/compliance/training/custom-fields'
    | '/console/$orgId/configuration/compliance/training/training-periods'
    | '/console/$orgId/configuration/financials/billing/balance'
    | '/console/$orgId/configuration/financials/billing/billing-info'
    | '/console/$orgId/configuration/financials/billing/invoices'
    | '/console/$orgId/configuration/financials/billing/transactions'
    | '/console/$orgId/configuration/financials/billing/usage'
    | '/console/$orgId/configuration/fleet/client-database/add'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates'
    | '/console/$orgId/configuration/org-settings/handling-parties/add'
    | '/console/$orgId/configuration/vendor-management/suppliers/add'
    | '/console/$orgId/configuration/vendor-management/suppliers/definitions'
    | '/console/$orgId/controls/register/details/$id'
    | '/console/$orgId/fleet-portal/claims/details/$claimId'
    | '/console/$orgId/mspr/msp-exceptions/edit/$id'
    | '/console/$orgId/mspr/service-providers/details/$id'
    | '/console/$orgId/mspr/service-providers/search/add'
    | '/console/$orgId/risk/ras/details/$id'
    | '/console/$orgId/risk/register/details/$id'
    | '/console/$orgId/tools/compliance-audit/details/$complianceAuditId'
    | '/console/$orgId/tools/compliance-audit/overview/insights'
    | '/console/$orgId/tools/compliance-audit/overview/search'
    | '/console/$orgId/tools/website-checker/report/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/add'
    | '/console/$orgId/workload-manager/tasks/list/add'
    | '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/console/$orgId/compliance/coi/details/$id/'
    | '/console/$orgId/compliance/complaints/details/$id/'
    | '/console/$orgId/compliance/incidents/details/$id/'
    | '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/'
    | '/console/$orgId/configuration/compliance/incidents/general/'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/'
    | '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add'
    | '/admin-console/platform-content/obligations/library/details/$id/ai-related'
    | '/admin-console/platform-content/obligations/library/details/$id/document-analyser'
    | '/admin-console/platform-content/obligations/library/details/$id/history'
    | '/admin-console/platform-content/obligations/library/details/$id/manage'
    | '/console/$orgId/claims/details/$id/comms/add'
    | '/console/$orgId/claims/details/$id/contacts/add'
    | '/console/$orgId/claims/details/$id/expenses/add'
    | '/console/$orgId/compliance/coi/details/$id/library'
    | '/console/$orgId/compliance/coi/details/$id/manage'
    | '/console/$orgId/compliance/complaints/details/$id/comms'
    | '/console/$orgId/compliance/complaints/details/$id/history'
    | '/console/$orgId/compliance/complaints/details/$id/library'
    | '/console/$orgId/compliance/complaints/details/$id/manage'
    | '/console/$orgId/compliance/incidents/details/$id/history'
    | '/console/$orgId/compliance/incidents/details/$id/library'
    | '/console/$orgId/compliance/incidents/details/$id/manage'
    | '/console/$orgId/compliance/obligations/details/$id/debug'
    | '/console/$orgId/compliance/obligations/details/$id/manage'
    | '/console/$orgId/compliance/registers/$registerId/records/$recordId'
    | '/console/$orgId/compliance/training/user/$userId/add'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id'
    | '/console/$orgId/configuration/claims-products/product-types/states/$id'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId'
    | '/console/$orgId/configuration/claims-products/products-v2/edit/$productId'
    | '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations/add'
    | '/console/$orgId/configuration/compliance/complaints/flags/add'
    | '/console/$orgId/configuration/compliance/incidents/flags/add'
    | '/console/$orgId/configuration/compliance/incidents/general/incident-details'
    | '/console/$orgId/configuration/compliance/incidents/general/lodgement'
    | '/console/$orgId/configuration/compliance/incidents/general/rectification'
    | '/console/$orgId/configuration/compliance/incidents/general/timeline'
    | '/console/$orgId/configuration/compliance/mspr/governance-config/add'
    | '/console/$orgId/configuration/financials/billing/payment/success'
    | '/console/$orgId/configuration/fleet/client-database/details/$id'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures/add'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates/add'
    | '/console/$orgId/configuration/org-settings/handling-parties/details/$id'
    | '/console/$orgId/configuration/org-settings/users/details/$userId'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/definitions'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/list'
    | '/console/$orgId/mspr/service-providers/details/$id/history'
    | '/console/$orgId/mspr/service-providers/details/$id/library'
    | '/console/$orgId/mspr/service-providers/details/$id/manage'
    | '/console/$orgId/risk/register/details/$id/action-plan'
    | '/console/$orgId/risk/register/details/$id/assessment'
    | '/console/$orgId/risk/register/details/$id/history'
    | '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification'
    | '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics'
    | '/console/$orgId/tools/compliance-audit/overview/search/add'
    | '/console/$orgId/tools/document-analyzer/history/$id/results'
    | '/console/$orgId/tools/pds-compare/pds-documents/edit/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/$id'
    | '/console/$orgId/workload-manager/tasks/list/details/$id'
    | '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/console/$orgId/configuration/vendor-management/suppliers/details/$id/'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId'
    | '/console/$orgId/claims/details/$id/activity/add/phone'
    | '/console/$orgId/claims/details/$id/comms/add/email'
    | '/console/$orgId/claims/details/$id/comms/add/sms'
    | '/console/$orgId/claims/details/$id/comms/message/$messageId'
    | '/console/$orgId/claims/details/$id/comms/reply/$messageId'
    | '/console/$orgId/claims/details/$id/contacts/edit/$contactId'
    | '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId'
    | '/console/$orgId/claims/details/$id/financials/compensations/add'
    | '/console/$orgId/claims/details/$id/financials/excesses/add'
    | '/console/$orgId/claims/details/$id/financials/reserves/add'
    | '/console/$orgId/claims/details/$id/manage/strategies/add'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/add'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier'
    | '/console/$orgId/compliance/complaints/details/$id/manage/incidents'
    | '/console/$orgId/compliance/incidents/details/$id/manage/complaints'
    | '/console/$orgId/compliance/training/user/$userId/edit/$recordId'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId'
    | '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/add'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id'
    | '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId'
    | '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add'
    | '/console/$orgId/configuration/compliance/mspr/definitions/categories/add'
    | '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/clients'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/drivers'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/overview'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId'
    | '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users'
    | '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id'
    | '/console/$orgId/controls/register/details/$id/activity/$activityId'
    | '/console/$orgId/controls/register/details/$id/activity/add'
    | '/console/$orgId/controls/register/details/$id/test/$testId'
    | '/console/$orgId/controls/register/details/$id/test/add'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/add'
    | '/console/$orgId/risk/register/details/$id/assessment/incidents'
    | '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id'
    | '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId'
    | '/console/$orgId/compliance/complaints/details/$id/manage/note/add'
    | '/console/$orgId/compliance/incidents/details/$id/manage/note/add'
    | '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id'
    | '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/check/add'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId'
    | '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId'
    | '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/admin-consent'
    | '/attestation'
    | '/invite'
    | '/maintenance'
    | '/not-found'
    | '/not-supported'
    | '/oauth'
    | '/org-switched'
    | '/public'
    | '/status'
    | '/terms-acceptance'
    | '/admin-console'
    | '/admin-login'
    | '/callback'
    | '/login'
    | '/logout'
    | '/logoutin'
    | '/org-mismatch'
    | '/payment-pending'
    | '/admin-console/ai'
    | '/admin-console/authorised-apps'
    | '/admin-console/organisation-management'
    | '/attestation/$token'
    | '/oauth/authorize'
    | '/password-reset/request'
    | '/password-reset/reset'
    | '/public/$orgId'
    | '/whats-new/$releaseId'
    | '/admin-console/advanced'
    | '/admin-console/monitoring'
    | '/admin-console/platform-content'
    | '/admin-console/tools'
    | '/admin-console/user-access'
    | '/console/$orgId'
    | '/change-org/$orgId'
    | '/admin-console/advanced/app-settings'
    | '/admin-console/advanced/claims'
    | '/admin-console/advanced/db-stats'
    | '/admin-console/advanced/db-upgrades'
    | '/admin-console/advanced/inbound-email-archive'
    | '/admin-console/advanced/indicators'
    | '/admin-console/advanced/integration-tests'
    | '/admin-console/advanced/playground'
    | '/admin-console/advanced/weaviate'
    | '/admin-console/ai/ai-feedback'
    | '/admin-console/ai/ai-prompts'
    | '/admin-console/ai/eval-runs'
    | '/admin-console/ai/model-pricing'
    | '/admin-console/ai/model-tiers'
    | '/admin-console/ai/request-analytics'
    | '/admin-console/ai/statistics'
    | '/admin-console/ai/usage-billing'
    | '/admin-console/monitoring/audit-trail'
    | '/admin-console/monitoring/axiom-logs'
    | '/admin-console/monitoring/compliance'
    | '/admin-console/monitoring/compliance-audit'
    | '/admin-console/monitoring/llm-logs'
    | '/admin-console/monitoring/llm-stats'
    | '/admin-console/monitoring/memory'
    | '/admin-console/monitoring/reports'
    | '/admin-console/monitoring/statistics'
    | '/admin-console/organisation-management/new'
    | '/admin-console/organisation-management/new-from-template'
    | '/admin-console/platform-content/comms-and-content'
    | '/admin-console/platform-content/market-pds'
    | '/admin-console/platform-content/products'
    | '/admin-console/tools/document-to-markdown'
    | '/admin-console/tools/feature-flags'
    | '/admin-console/tools/sanitise-text-pii'
    | '/admin-console/user-access/admin-users'
    | '/admin-console/user-access/support-sessions'
    | '/admin-console/user-access/users'
    | '/console/$orgId/documents'
    | '/console/$orgId/faq'
    | '/console/$orgId/get-file'
    | '/console/$orgId/mspr'
    | '/console/$orgId/reporting'
    | '/console/$orgId/tools-only-home-page'
    | '/public/lodgement-summary/$accessKey'
    | '/public/new-complaint-by-key/$key'
    | '/public/new-complaint/$orgId'
    | '/admin-console/advanced/inbound-parse'
    | '/admin-console/advanced/jobs'
    | '/admin-console/monitoring/email-activity'
    | '/admin-console/monitoring/engagement'
    | '/admin-console/organisation-management/organisations'
    | '/admin-console/platform-content/ai-training'
    | '/admin-console/platform-content/compliance-audit-templates'
    | '/admin-console/platform-content/obligations'
    | '/admin-console/platform-content/whats-new'
    | '/console/$orgId/attestations'
    | '/console/$orgId/claims'
    | '/console/$orgId/compliance'
    | '/console/$orgId/component-showcase'
    | '/console/$orgId/configuration'
    | '/console/$orgId/controls'
    | '/console/$orgId/dashboard'
    | '/console/$orgId/debug'
    | '/console/$orgId/fleet-portal'
    | '/console/$orgId/risk'
    | '/console/$orgId/tools'
    | '/console/$orgId/user-settings'
    | '/console/$orgId/workload-manager'
    | '/admin-console/advanced/app-settings/all'
    | '/admin-console/advanced/app-settings/well-known'
    | '/admin-console/advanced/indicators/complaints'
    | '/admin-console/advanced/indicators/incidents'
    | '/admin-console/advanced/jobs/dynamic-recurring'
    | '/admin-console/advanced/jobs/on-demand'
    | '/admin-console/advanced/jobs/recurring'
    | '/admin-console/ai/eval-runs/$evalRunId'
    | '/admin-console/ai/eval-runs/compare'
    | '/admin-console/organisation-management/organisations/$orgId'
    | '/admin-console/platform-content/ai-training/classification-example'
    | '/admin-console/platform-content/ai-training/vulnerability-example'
    | '/admin-console/platform-content/comms-and-content/app-text'
    | '/admin-console/platform-content/comms-and-content/comm-templates'
    | '/admin-console/platform-content/comms-and-content/faq'
    | '/admin-console/platform-content/compliance-audit-templates/search'
    | '/admin-console/platform-content/market-pds/add'
    | '/admin-console/platform-content/obligations/configuration'
    | '/admin-console/platform-content/products/$serviceId'
    | '/admin-console/platform-content/whats-new/$id'
    | '/admin-console/platform-content/whats-new/new'
    | '/admin-console/tools/sanitise-text-pii/compare'
    | '/admin-console/tools/sanitise-text-pii/tool'
    | '/admin-console/user-access/admin-users/grant'
    | '/console/$orgId/attestations/scheduled-attestations'
    | '/console/$orgId/attestations/user-attestations'
    | '/console/$orgId/compliance/intake'
    | '/console/$orgId/component-showcase/ai-chat-test'
    | '/console/$orgId/component-showcase/button-icon-test'
    | '/console/$orgId/component-showcase/button-variants'
    | '/console/$orgId/component-showcase/component-showcase'
    | '/console/$orgId/component-showcase/date-picker-test'
    | '/console/$orgId/component-showcase/fit-on-page'
    | '/console/$orgId/component-showcase/markdown-showcase'
    | '/console/$orgId/component-showcase/table-showcase'
    | '/console/$orgId/component-showcase/tag-variants'
    | '/console/$orgId/component-showcase/tiptap-test'
    | '/console/$orgId/configuration/api-integrations'
    | '/console/$orgId/configuration/claims-products'
    | '/console/$orgId/configuration/client-database'
    | '/console/$orgId/configuration/financials'
    | '/console/$orgId/configuration/monitoring'
    | '/console/$orgId/configuration/org-settings'
    | '/console/$orgId/configuration/vendor-management'
    | '/console/$orgId/controls/activities'
    | '/console/$orgId/controls/tests'
    | '/console/$orgId/dashboard/claims'
    | '/console/$orgId/dashboard/complaints'
    | '/console/$orgId/dashboard/incidents'
    | '/console/$orgId/dashboard/management'
    | '/console/$orgId/dashboard/people-and-culture'
    | '/console/$orgId/dashboard/risks'
    | '/console/$orgId/fleet-portal/authorisations'
    | '/console/$orgId/fleet-portal/dashboard'
    | '/console/$orgId/fleet-portal/fleet'
    | '/console/$orgId/fleet-portal/sla'
    | '/console/$orgId/mspr/msp-exceptions'
    | '/console/$orgId/reporting/add'
    | '/console/$orgId/tools/auto-detect'
    | '/console/$orgId/user-settings/notifications'
    | '/console/$orgId/user-settings/profile'
    | '/console/$orgId/workload-manager/complaints'
    | '/console/$orgId/workload-manager/emails'
    | '/public/$orgId/complaint/new'
    | '/admin-console/platform-content/obligations/controls-library'
    | '/admin-console/platform-content/obligations/library'
    | '/console/$orgId/compliance/coi'
    | '/console/$orgId/compliance/complaints'
    | '/console/$orgId/compliance/incidents'
    | '/console/$orgId/compliance/obligations'
    | '/console/$orgId/compliance/registers'
    | '/console/$orgId/compliance/training'
    | '/console/$orgId/configuration/compliance'
    | '/console/$orgId/configuration/fleet'
    | '/console/$orgId/configuration/risk'
    | '/console/$orgId/controls/register'
    | '/console/$orgId/fleet-portal/claims'
    | '/console/$orgId/mspr/service-providers'
    | '/console/$orgId/risk/ras'
    | '/console/$orgId/risk/register'
    | '/console/$orgId/tools/compliance-audit'
    | '/console/$orgId/tools/document-analyzer'
    | '/console/$orgId/tools/pds-compare'
    | '/console/$orgId/tools/website-checker'
    | '/console/$orgId/user-settings/authorised-apps'
    | '/console/$orgId/workload-manager/tasks'
    | '/admin-console/advanced/app-settings/all/add'
    | '/admin-console/advanced/jobs/dynamic-recurring/$jobId'
    | '/admin-console/advanced/jobs/on-demand/$jobId'
    | '/admin-console/advanced/jobs/recurring/$jobId'
    | '/admin-console/organisation-management/organisations/$orgId/subscriptions'
    | '/admin-console/organisation-management/organisations/$orgId/users'
    | '/admin-console/organisation-management/organisations/$orgId/wallet'
    | '/admin-console/platform-content/ai-training/classification-example/create'
    | '/admin-console/platform-content/ai-training/vulnerability-example/create'
    | '/admin-console/platform-content/comms-and-content/app-text/add'
    | '/admin-console/platform-content/comms-and-content/comm-templates/add'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId'
    | '/admin-console/platform-content/compliance-audit-templates/search/add'
    | '/admin-console/platform-content/market-pds/edit/$id'
    | '/admin-console/platform-content/obligations/controls-library/$id'
    | '/admin-console/user-access/admin-users/edit/$userId'
    | '/admin-console/user-access/users/edit/$userId'
    | '/admin-console/user-access/users/view/$userId'
    | '/console/$orgId/attestations/scheduled-attestations/$scheduleId'
    | '/console/$orgId/attestations/scheduled-attestations/new'
    | '/console/$orgId/attestations/user-attestations/$attestationId'
    | '/console/$orgId/attestations/user-attestations/send'
    | '/console/$orgId/claims/details/$id'
    | '/console/$orgId/compliance/coi/add'
    | '/console/$orgId/compliance/complaints/add'
    | '/console/$orgId/compliance/incidents/add'
    | '/console/$orgId/compliance/obligations/add'
    | '/console/$orgId/compliance/training/search'
    | '/console/$orgId/configuration/api-integrations/api-tokens'
    | '/console/$orgId/configuration/api-integrations/mcp-access'
    | '/console/$orgId/configuration/claims-products/insurers'
    | '/console/$orgId/configuration/claims-products/product-types'
    | '/console/$orgId/configuration/claims-products/products-v2'
    | '/console/$orgId/configuration/claims-products/questionnaire'
    | '/console/$orgId/configuration/client-database/$'
    | '/console/$orgId/configuration/compliance/attestations'
    | '/console/$orgId/configuration/compliance/auto-detect'
    | '/console/$orgId/configuration/compliance/compliance-audit'
    | '/console/$orgId/configuration/compliance/mspr'
    | '/console/$orgId/configuration/compliance/obligations'
    | '/console/$orgId/configuration/financials/billing'
    | '/console/$orgId/configuration/financials/expenses-billing'
    | '/console/$orgId/configuration/financials/payments'
    | '/console/$orgId/configuration/fleet/client-database'
    | '/console/$orgId/configuration/fleet/delegated-authority'
    | '/console/$orgId/configuration/fleet/escalations'
    | '/console/$orgId/configuration/fleet/portal-claim-page'
    | '/console/$orgId/configuration/monitoring/audit-trail'
    | '/console/$orgId/configuration/monitoring/email-activity'
    | '/console/$orgId/configuration/monitoring/statistics'
    | '/console/$orgId/configuration/org-settings/communication'
    | '/console/$orgId/configuration/org-settings/fleet-escalations'
    | '/console/$orgId/configuration/org-settings/handling-parties'
    | '/console/$orgId/configuration/org-settings/support-sessions'
    | '/console/$orgId/configuration/org-settings/system'
    | '/console/$orgId/configuration/org-settings/tasks'
    | '/console/$orgId/configuration/org-settings/trash'
    | '/console/$orgId/configuration/risk/appetite'
    | '/console/$orgId/configuration/risk/categories'
    | '/console/$orgId/configuration/risk/matrix'
    | '/console/$orgId/controls/register/add'
    | '/console/$orgId/documents/details/$fileId'
    | '/console/$orgId/mspr/service-providers/search'
    | '/console/$orgId/tools/auto-detect/dashboard'
    | '/console/$orgId/tools/auto-detect/inbox'
    | '/console/$orgId/tools/document-analyzer/history'
    | '/console/$orgId/tools/document-analyzer/upload'
    | '/console/$orgId/tools/pds-compare/pds-documents'
    | '/console/$orgId/workload-manager/tasks/calendar'
    | '/console/$orgId/workload-manager/tasks/list'
    | '/public/$orgId/invoice/view/$accessKey'
    | '/console/$orgId/compliance/registers/$registerId'
    | '/console/$orgId/configuration/api-integrations/form-designer'
    | '/console/$orgId/configuration/claims-products/claims'
    | '/console/$orgId/configuration/compliance/complaints'
    | '/console/$orgId/configuration/compliance/general'
    | '/console/$orgId/configuration/compliance/incidents'
    | '/console/$orgId/configuration/compliance/training'
    | '/console/$orgId/configuration/org-settings/users'
    | '/console/$orgId/configuration/vendor-management/suppliers'
    | '/console/$orgId/tools/compliance-audit/overview'
    | '/admin-console/advanced/app-settings/all/edit/$name'
    | '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics'
    | '/admin-console/platform-content/ai-training/classification-example/edit/$id'
    | '/admin-console/platform-content/ai-training/classification-example/view/$id'
    | '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id'
    | '/admin-console/platform-content/ai-training/vulnerability-example/view/$id'
    | '/admin-console/platform-content/comms-and-content/app-text/edit/$id'
    | '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure'
    | '/admin-console/platform-content/obligations/controls-library/$id/details'
    | '/admin-console/platform-content/obligations/controls-library/$id/history'
    | '/admin-console/platform-content/obligations/library/details/$id'
    | '/console/$orgId/claims/details/$id/activity'
    | '/console/$orgId/claims/details/$id/ai-assessment'
    | '/console/$orgId/claims/details/$id/comms'
    | '/console/$orgId/claims/details/$id/contacts'
    | '/console/$orgId/claims/details/$id/expenses'
    | '/console/$orgId/claims/details/$id/financials'
    | '/console/$orgId/claims/details/$id/history'
    | '/console/$orgId/claims/details/$id/library'
    | '/console/$orgId/claims/details/$id/manage'
    | '/console/$orgId/claims/details/$id/policy-info'
    | '/console/$orgId/claims/details/$id/product-type-data'
    | '/console/$orgId/claims/details/$id/vehicle'
    | '/console/$orgId/compliance/obligations/details/$id'
    | '/console/$orgId/compliance/training/search/add'
    | '/console/$orgId/compliance/training/user/$userId'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags'
    | '/console/$orgId/configuration/claims-products/claims/documents'
    | '/console/$orgId/configuration/claims-products/claims/general'
    | '/console/$orgId/configuration/claims-products/claims/handling-standards'
    | '/console/$orgId/configuration/claims-products/claims/id'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/add'
    | '/console/$orgId/configuration/claims-products/products-v2/add'
    | '/console/$orgId/configuration/claims-products/questionnaire/add'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations'
    | '/console/$orgId/configuration/compliance/complaints/brands'
    | '/console/$orgId/configuration/compliance/complaints/custom-fields'
    | '/console/$orgId/configuration/compliance/complaints/flags'
    | '/console/$orgId/configuration/compliance/complaints/general'
    | '/console/$orgId/configuration/compliance/complaints/rules'
    | '/console/$orgId/configuration/compliance/general/asic-products'
    | '/console/$orgId/configuration/compliance/general/documents'
    | '/console/$orgId/configuration/compliance/incidents/custom-fields'
    | '/console/$orgId/configuration/compliance/incidents/flags'
    | '/console/$orgId/configuration/compliance/incidents/rules'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations'
    | '/console/$orgId/configuration/compliance/mspr/definitions'
    | '/console/$orgId/configuration/compliance/mspr/documents'
    | '/console/$orgId/configuration/compliance/mspr/governance-config'
    | '/console/$orgId/configuration/compliance/training/custom-fields'
    | '/console/$orgId/configuration/compliance/training/training-periods'
    | '/console/$orgId/configuration/financials/billing/balance'
    | '/console/$orgId/configuration/financials/billing/billing-info'
    | '/console/$orgId/configuration/financials/billing/invoices'
    | '/console/$orgId/configuration/financials/billing/transactions'
    | '/console/$orgId/configuration/financials/billing/usage'
    | '/console/$orgId/configuration/fleet/client-database/add'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates'
    | '/console/$orgId/configuration/org-settings/handling-parties/add'
    | '/console/$orgId/configuration/vendor-management/suppliers/add'
    | '/console/$orgId/configuration/vendor-management/suppliers/definitions'
    | '/console/$orgId/controls/register/details/$id'
    | '/console/$orgId/fleet-portal/claims/details/$claimId'
    | '/console/$orgId/mspr/msp-exceptions/edit/$id'
    | '/console/$orgId/mspr/service-providers/details/$id'
    | '/console/$orgId/mspr/service-providers/search/add'
    | '/console/$orgId/risk/ras/details/$id'
    | '/console/$orgId/risk/register/details/$id'
    | '/console/$orgId/tools/compliance-audit/details/$complianceAuditId'
    | '/console/$orgId/tools/compliance-audit/overview/insights'
    | '/console/$orgId/tools/compliance-audit/overview/search'
    | '/console/$orgId/tools/website-checker/report/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/add'
    | '/console/$orgId/workload-manager/tasks/list/add'
    | '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/console/$orgId/compliance/coi/details/$id'
    | '/console/$orgId/compliance/complaints/details/$id'
    | '/console/$orgId/compliance/incidents/details/$id'
    | '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId'
    | '/console/$orgId/configuration/claims-products/claims/task-lists'
    | '/console/$orgId/configuration/compliance/incidents/general'
    | '/console/$orgId/configuration/vendor-management/suppliers/list'
    | '/console/$orgId/configuration/vendor-management/suppliers/search'
    | '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add'
    | '/admin-console/platform-content/obligations/library/details/$id/ai-related'
    | '/admin-console/platform-content/obligations/library/details/$id/document-analyser'
    | '/admin-console/platform-content/obligations/library/details/$id/history'
    | '/admin-console/platform-content/obligations/library/details/$id/manage'
    | '/console/$orgId/claims/details/$id/comms/add'
    | '/console/$orgId/claims/details/$id/contacts/add'
    | '/console/$orgId/claims/details/$id/expenses/add'
    | '/console/$orgId/compliance/coi/details/$id/library'
    | '/console/$orgId/compliance/coi/details/$id/manage'
    | '/console/$orgId/compliance/complaints/details/$id/comms'
    | '/console/$orgId/compliance/complaints/details/$id/history'
    | '/console/$orgId/compliance/complaints/details/$id/library'
    | '/console/$orgId/compliance/complaints/details/$id/manage'
    | '/console/$orgId/compliance/incidents/details/$id/history'
    | '/console/$orgId/compliance/incidents/details/$id/library'
    | '/console/$orgId/compliance/incidents/details/$id/manage'
    | '/console/$orgId/compliance/obligations/details/$id/debug'
    | '/console/$orgId/compliance/obligations/details/$id/manage'
    | '/console/$orgId/compliance/registers/$registerId/records/$recordId'
    | '/console/$orgId/compliance/training/user/$userId/add'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id'
    | '/console/$orgId/configuration/claims-products/product-types/states/$id'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId'
    | '/console/$orgId/configuration/claims-products/products-v2/edit/$productId'
    | '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations/add'
    | '/console/$orgId/configuration/compliance/complaints/flags/add'
    | '/console/$orgId/configuration/compliance/incidents/flags/add'
    | '/console/$orgId/configuration/compliance/incidents/general/incident-details'
    | '/console/$orgId/configuration/compliance/incidents/general/lodgement'
    | '/console/$orgId/configuration/compliance/incidents/general/rectification'
    | '/console/$orgId/configuration/compliance/incidents/general/timeline'
    | '/console/$orgId/configuration/compliance/mspr/governance-config/add'
    | '/console/$orgId/configuration/financials/billing/payment/success'
    | '/console/$orgId/configuration/fleet/client-database/details/$id'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures/add'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates/add'
    | '/console/$orgId/configuration/org-settings/handling-parties/details/$id'
    | '/console/$orgId/configuration/org-settings/users/details/$userId'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/definitions'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/list'
    | '/console/$orgId/mspr/service-providers/details/$id/history'
    | '/console/$orgId/mspr/service-providers/details/$id/library'
    | '/console/$orgId/mspr/service-providers/details/$id/manage'
    | '/console/$orgId/risk/register/details/$id/action-plan'
    | '/console/$orgId/risk/register/details/$id/assessment'
    | '/console/$orgId/risk/register/details/$id/history'
    | '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification'
    | '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics'
    | '/console/$orgId/tools/compliance-audit/overview/search/add'
    | '/console/$orgId/tools/document-analyzer/history/$id/results'
    | '/console/$orgId/tools/pds-compare/pds-documents/edit/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/$id'
    | '/console/$orgId/workload-manager/tasks/list/details/$id'
    | '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/console/$orgId/configuration/vendor-management/suppliers/details/$id'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId'
    | '/console/$orgId/claims/details/$id/activity/add/phone'
    | '/console/$orgId/claims/details/$id/comms/add/email'
    | '/console/$orgId/claims/details/$id/comms/add/sms'
    | '/console/$orgId/claims/details/$id/comms/message/$messageId'
    | '/console/$orgId/claims/details/$id/comms/reply/$messageId'
    | '/console/$orgId/claims/details/$id/contacts/edit/$contactId'
    | '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId'
    | '/console/$orgId/claims/details/$id/financials/compensations/add'
    | '/console/$orgId/claims/details/$id/financials/excesses/add'
    | '/console/$orgId/claims/details/$id/financials/reserves/add'
    | '/console/$orgId/claims/details/$id/manage/strategies/add'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/add'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier'
    | '/console/$orgId/compliance/complaints/details/$id/manage/incidents'
    | '/console/$orgId/compliance/incidents/details/$id/manage/complaints'
    | '/console/$orgId/compliance/training/user/$userId/edit/$recordId'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId'
    | '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/add'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id'
    | '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId'
    | '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add'
    | '/console/$orgId/configuration/compliance/mspr/definitions/categories/add'
    | '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/clients'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/drivers'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/overview'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId'
    | '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users'
    | '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id'
    | '/console/$orgId/controls/register/details/$id/activity/$activityId'
    | '/console/$orgId/controls/register/details/$id/activity/add'
    | '/console/$orgId/controls/register/details/$id/test/$testId'
    | '/console/$orgId/controls/register/details/$id/test/add'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/add'
    | '/console/$orgId/risk/register/details/$id/assessment/incidents'
    | '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id'
    | '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId'
    | '/console/$orgId/compliance/complaints/details/$id/manage/note/add'
    | '/console/$orgId/compliance/incidents/details/$id/manage/note/add'
    | '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id'
    | '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/check/add'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId'
    | '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId'
    | '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId';
  id:
    | '__root__'
    | '/'
    | '/admin-consent'
    | '/admin-console'
    | '/attestation'
    | '/invite'
    | '/maintenance'
    | '/not-found'
    | '/not-supported'
    | '/oauth'
    | '/org-switched'
    | '/public'
    | '/status'
    | '/terms-acceptance'
    | '/admin-console/'
    | '/(authentication)/admin-login'
    | '/(authentication)/callback'
    | '/(authentication)/login'
    | '/(authentication)/logout'
    | '/(authentication)/logoutin'
    | '/(authentication)/org-mismatch'
    | '/(authentication)/payment-pending'
    | '/admin-console/advanced'
    | '/admin-console/ai'
    | '/admin-console/authorised-apps'
    | '/admin-console/monitoring'
    | '/admin-console/organisation-management'
    | '/admin-console/platform-content'
    | '/admin-console/tools'
    | '/admin-console/user-access'
    | '/attestation/$token'
    | '/console/$orgId'
    | '/oauth/authorize'
    | '/password-reset/request'
    | '/password-reset/reset'
    | '/public/$orgId'
    | '/whats-new/$releaseId'
    | '/admin-console/advanced/'
    | '/admin-console/monitoring/'
    | '/admin-console/platform-content/'
    | '/admin-console/tools/'
    | '/admin-console/user-access/'
    | '/console/$orgId/'
    | '/(authentication)/change-org/$orgId'
    | '/admin-console/advanced/app-settings'
    | '/admin-console/advanced/claims'
    | '/admin-console/advanced/db-stats'
    | '/admin-console/advanced/db-upgrades'
    | '/admin-console/advanced/inbound-email-archive'
    | '/admin-console/advanced/inbound-parse'
    | '/admin-console/advanced/indicators'
    | '/admin-console/advanced/integration-tests'
    | '/admin-console/advanced/jobs'
    | '/admin-console/advanced/playground'
    | '/admin-console/advanced/weaviate'
    | '/admin-console/ai/ai-feedback'
    | '/admin-console/ai/ai-prompts'
    | '/admin-console/ai/eval-runs'
    | '/admin-console/ai/model-pricing'
    | '/admin-console/ai/model-tiers'
    | '/admin-console/ai/request-analytics'
    | '/admin-console/ai/statistics'
    | '/admin-console/ai/usage-billing'
    | '/admin-console/monitoring/audit-trail'
    | '/admin-console/monitoring/axiom-logs'
    | '/admin-console/monitoring/compliance'
    | '/admin-console/monitoring/compliance-audit'
    | '/admin-console/monitoring/email-activity'
    | '/admin-console/monitoring/engagement'
    | '/admin-console/monitoring/llm-logs'
    | '/admin-console/monitoring/llm-stats'
    | '/admin-console/monitoring/memory'
    | '/admin-console/monitoring/reports'
    | '/admin-console/monitoring/statistics'
    | '/admin-console/organisation-management/new'
    | '/admin-console/organisation-management/new-from-template'
    | '/admin-console/organisation-management/organisations'
    | '/admin-console/platform-content/ai-training'
    | '/admin-console/platform-content/comms-and-content'
    | '/admin-console/platform-content/compliance-audit-templates'
    | '/admin-console/platform-content/market-pds'
    | '/admin-console/platform-content/obligations'
    | '/admin-console/platform-content/products'
    | '/admin-console/platform-content/whats-new'
    | '/admin-console/tools/document-to-markdown'
    | '/admin-console/tools/feature-flags'
    | '/admin-console/tools/sanitise-text-pii'
    | '/admin-console/user-access/admin-users'
    | '/admin-console/user-access/support-sessions'
    | '/admin-console/user-access/users'
    | '/console/$orgId/attestations'
    | '/console/$orgId/claims'
    | '/console/$orgId/compliance'
    | '/console/$orgId/component-showcase'
    | '/console/$orgId/configuration'
    | '/console/$orgId/controls'
    | '/console/$orgId/dashboard'
    | '/console/$orgId/documents'
    | '/console/$orgId/faq'
    | '/console/$orgId/fleet-portal'
    | '/console/$orgId/get-file'
    | '/console/$orgId/mspr'
    | '/console/$orgId/reporting'
    | '/console/$orgId/risk'
    | '/console/$orgId/tools'
    | '/console/$orgId/tools-only-home-page'
    | '/console/$orgId/user-settings'
    | '/console/$orgId/workload-manager'
    | '/public/lodgement-summary/$accessKey'
    | '/public/new-complaint-by-key/$key'
    | '/public/new-complaint/$orgId'
    | '/admin-console/advanced/inbound-parse/'
    | '/admin-console/advanced/jobs/'
    | '/admin-console/monitoring/email-activity/'
    | '/admin-console/monitoring/engagement/'
    | '/admin-console/organisation-management/organisations/'
    | '/admin-console/platform-content/ai-training/'
    | '/admin-console/platform-content/compliance-audit-templates/'
    | '/admin-console/platform-content/obligations/'
    | '/admin-console/platform-content/whats-new/'
    | '/console/$orgId/attestations/'
    | '/console/$orgId/claims/'
    | '/console/$orgId/compliance/'
    | '/console/$orgId/component-showcase/'
    | '/console/$orgId/configuration/'
    | '/console/$orgId/controls/'
    | '/console/$orgId/dashboard/'
    | '/console/$orgId/debug/'
    | '/console/$orgId/fleet-portal/'
    | '/console/$orgId/risk/'
    | '/console/$orgId/tools/'
    | '/console/$orgId/user-settings/'
    | '/console/$orgId/workload-manager/'
    | '/admin-console/advanced/app-settings/all'
    | '/admin-console/advanced/app-settings/well-known'
    | '/admin-console/advanced/indicators/complaints'
    | '/admin-console/advanced/indicators/incidents'
    | '/admin-console/advanced/jobs/dynamic-recurring'
    | '/admin-console/advanced/jobs/on-demand'
    | '/admin-console/advanced/jobs/recurring'
    | '/admin-console/ai/eval-runs/$evalRunId'
    | '/admin-console/ai/eval-runs/compare'
    | '/admin-console/organisation-management/organisations/$orgId'
    | '/admin-console/platform-content/ai-training/classification-example'
    | '/admin-console/platform-content/ai-training/vulnerability-example'
    | '/admin-console/platform-content/comms-and-content/app-text'
    | '/admin-console/platform-content/comms-and-content/comm-templates'
    | '/admin-console/platform-content/comms-and-content/faq'
    | '/admin-console/platform-content/compliance-audit-templates/search'
    | '/admin-console/platform-content/market-pds/add'
    | '/admin-console/platform-content/obligations/configuration'
    | '/admin-console/platform-content/obligations/controls-library'
    | '/admin-console/platform-content/obligations/library'
    | '/admin-console/platform-content/products/$serviceId'
    | '/admin-console/platform-content/whats-new/$id'
    | '/admin-console/platform-content/whats-new/new'
    | '/admin-console/tools/sanitise-text-pii/compare'
    | '/admin-console/tools/sanitise-text-pii/tool'
    | '/admin-console/user-access/admin-users/grant'
    | '/console/$orgId/attestations/scheduled-attestations'
    | '/console/$orgId/attestations/user-attestations'
    | '/console/$orgId/compliance/coi'
    | '/console/$orgId/compliance/complaints'
    | '/console/$orgId/compliance/incidents'
    | '/console/$orgId/compliance/intake'
    | '/console/$orgId/compliance/obligations'
    | '/console/$orgId/compliance/registers'
    | '/console/$orgId/compliance/training'
    | '/console/$orgId/component-showcase/ai-chat-test'
    | '/console/$orgId/component-showcase/button-icon-test'
    | '/console/$orgId/component-showcase/button-variants'
    | '/console/$orgId/component-showcase/component-showcase'
    | '/console/$orgId/component-showcase/date-picker-test'
    | '/console/$orgId/component-showcase/fit-on-page'
    | '/console/$orgId/component-showcase/markdown-showcase'
    | '/console/$orgId/component-showcase/table-showcase'
    | '/console/$orgId/component-showcase/tag-variants'
    | '/console/$orgId/component-showcase/tiptap-test'
    | '/console/$orgId/configuration/api-integrations'
    | '/console/$orgId/configuration/claims-products'
    | '/console/$orgId/configuration/client-database'
    | '/console/$orgId/configuration/compliance'
    | '/console/$orgId/configuration/financials'
    | '/console/$orgId/configuration/fleet'
    | '/console/$orgId/configuration/monitoring'
    | '/console/$orgId/configuration/org-settings'
    | '/console/$orgId/configuration/risk'
    | '/console/$orgId/configuration/vendor-management'
    | '/console/$orgId/controls/activities'
    | '/console/$orgId/controls/register'
    | '/console/$orgId/controls/tests'
    | '/console/$orgId/dashboard/claims'
    | '/console/$orgId/dashboard/complaints'
    | '/console/$orgId/dashboard/incidents'
    | '/console/$orgId/dashboard/management'
    | '/console/$orgId/dashboard/people-and-culture'
    | '/console/$orgId/dashboard/risks'
    | '/console/$orgId/fleet-portal/authorisations'
    | '/console/$orgId/fleet-portal/claims'
    | '/console/$orgId/fleet-portal/dashboard'
    | '/console/$orgId/fleet-portal/fleet'
    | '/console/$orgId/fleet-portal/sla'
    | '/console/$orgId/mspr/msp-exceptions'
    | '/console/$orgId/mspr/service-providers'
    | '/console/$orgId/reporting/add'
    | '/console/$orgId/risk/ras'
    | '/console/$orgId/risk/register'
    | '/console/$orgId/tools/auto-detect'
    | '/console/$orgId/tools/compliance-audit'
    | '/console/$orgId/tools/document-analyzer'
    | '/console/$orgId/tools/pds-compare'
    | '/console/$orgId/tools/website-checker'
    | '/console/$orgId/user-settings/notifications'
    | '/console/$orgId/user-settings/profile'
    | '/console/$orgId/workload-manager/complaints'
    | '/console/$orgId/workload-manager/emails'
    | '/console/$orgId/workload-manager/tasks'
    | '/public/$orgId/complaint/new'
    | '/admin-console/platform-content/obligations/controls-library/'
    | '/admin-console/platform-content/obligations/library/'
    | '/console/$orgId/compliance/coi/'
    | '/console/$orgId/compliance/complaints/'
    | '/console/$orgId/compliance/incidents/'
    | '/console/$orgId/compliance/obligations/'
    | '/console/$orgId/compliance/registers/'
    | '/console/$orgId/compliance/training/'
    | '/console/$orgId/configuration/compliance/'
    | '/console/$orgId/configuration/fleet/'
    | '/console/$orgId/configuration/risk/'
    | '/console/$orgId/controls/register/'
    | '/console/$orgId/fleet-portal/claims/'
    | '/console/$orgId/mspr/service-providers/'
    | '/console/$orgId/risk/ras/'
    | '/console/$orgId/risk/register/'
    | '/console/$orgId/tools/compliance-audit/'
    | '/console/$orgId/tools/document-analyzer/'
    | '/console/$orgId/tools/pds-compare/'
    | '/console/$orgId/tools/website-checker/'
    | '/console/$orgId/user-settings/authorised-apps/'
    | '/console/$orgId/workload-manager/tasks/'
    | '/admin-console/advanced/app-settings/all/add'
    | '/admin-console/advanced/jobs/dynamic-recurring/$jobId'
    | '/admin-console/advanced/jobs/on-demand/$jobId'
    | '/admin-console/advanced/jobs/recurring/$jobId'
    | '/admin-console/organisation-management/organisations/$orgId/subscriptions'
    | '/admin-console/organisation-management/organisations/$orgId/users'
    | '/admin-console/organisation-management/organisations/$orgId/wallet'
    | '/admin-console/platform-content/ai-training/classification-example/create'
    | '/admin-console/platform-content/ai-training/vulnerability-example/create'
    | '/admin-console/platform-content/comms-and-content/app-text/add'
    | '/admin-console/platform-content/comms-and-content/comm-templates/add'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId'
    | '/admin-console/platform-content/compliance-audit-templates/search/add'
    | '/admin-console/platform-content/market-pds/edit/$id'
    | '/admin-console/platform-content/obligations/controls-library/$id'
    | '/admin-console/user-access/admin-users/edit/$userId'
    | '/admin-console/user-access/users/edit/$userId'
    | '/admin-console/user-access/users/view/$userId'
    | '/console/$orgId/attestations/scheduled-attestations/$scheduleId'
    | '/console/$orgId/attestations/scheduled-attestations/new'
    | '/console/$orgId/attestations/user-attestations/$attestationId'
    | '/console/$orgId/attestations/user-attestations/send'
    | '/console/$orgId/claims/details/$id'
    | '/console/$orgId/compliance/coi/add'
    | '/console/$orgId/compliance/complaints/add'
    | '/console/$orgId/compliance/incidents/add'
    | '/console/$orgId/compliance/obligations/add'
    | '/console/$orgId/compliance/registers/$registerId'
    | '/console/$orgId/compliance/training/search'
    | '/console/$orgId/configuration/api-integrations/api-tokens'
    | '/console/$orgId/configuration/api-integrations/form-designer'
    | '/console/$orgId/configuration/api-integrations/mcp-access'
    | '/console/$orgId/configuration/claims-products/claims'
    | '/console/$orgId/configuration/claims-products/insurers'
    | '/console/$orgId/configuration/claims-products/product-types'
    | '/console/$orgId/configuration/claims-products/products-v2'
    | '/console/$orgId/configuration/claims-products/questionnaire'
    | '/console/$orgId/configuration/client-database/$'
    | '/console/$orgId/configuration/compliance/attestations'
    | '/console/$orgId/configuration/compliance/auto-detect'
    | '/console/$orgId/configuration/compliance/complaints'
    | '/console/$orgId/configuration/compliance/compliance-audit'
    | '/console/$orgId/configuration/compliance/general'
    | '/console/$orgId/configuration/compliance/incidents'
    | '/console/$orgId/configuration/compliance/mspr'
    | '/console/$orgId/configuration/compliance/obligations'
    | '/console/$orgId/configuration/compliance/training'
    | '/console/$orgId/configuration/financials/billing'
    | '/console/$orgId/configuration/financials/expenses-billing'
    | '/console/$orgId/configuration/financials/payments'
    | '/console/$orgId/configuration/fleet/client-database'
    | '/console/$orgId/configuration/fleet/delegated-authority'
    | '/console/$orgId/configuration/fleet/escalations'
    | '/console/$orgId/configuration/fleet/portal-claim-page'
    | '/console/$orgId/configuration/monitoring/audit-trail'
    | '/console/$orgId/configuration/monitoring/email-activity'
    | '/console/$orgId/configuration/monitoring/statistics'
    | '/console/$orgId/configuration/org-settings/communication'
    | '/console/$orgId/configuration/org-settings/fleet-escalations'
    | '/console/$orgId/configuration/org-settings/handling-parties'
    | '/console/$orgId/configuration/org-settings/support-sessions'
    | '/console/$orgId/configuration/org-settings/system'
    | '/console/$orgId/configuration/org-settings/tasks'
    | '/console/$orgId/configuration/org-settings/trash'
    | '/console/$orgId/configuration/org-settings/users'
    | '/console/$orgId/configuration/risk/appetite'
    | '/console/$orgId/configuration/risk/categories'
    | '/console/$orgId/configuration/risk/matrix'
    | '/console/$orgId/configuration/vendor-management/suppliers'
    | '/console/$orgId/controls/register/add'
    | '/console/$orgId/documents/details/$fileId'
    | '/console/$orgId/mspr/service-providers/search'
    | '/console/$orgId/tools/auto-detect/dashboard'
    | '/console/$orgId/tools/auto-detect/inbox'
    | '/console/$orgId/tools/compliance-audit/overview'
    | '/console/$orgId/tools/document-analyzer/history'
    | '/console/$orgId/tools/document-analyzer/upload'
    | '/console/$orgId/tools/pds-compare/pds-documents'
    | '/console/$orgId/workload-manager/tasks/calendar'
    | '/console/$orgId/workload-manager/tasks/list'
    | '/public/$orgId/invoice/view/$accessKey'
    | '/console/$orgId/compliance/registers/$registerId/'
    | '/console/$orgId/configuration/api-integrations/form-designer/'
    | '/console/$orgId/configuration/claims-products/claims/'
    | '/console/$orgId/configuration/compliance/complaints/'
    | '/console/$orgId/configuration/compliance/general/'
    | '/console/$orgId/configuration/compliance/incidents/'
    | '/console/$orgId/configuration/compliance/training/'
    | '/console/$orgId/configuration/org-settings/users/'
    | '/console/$orgId/configuration/vendor-management/suppliers/'
    | '/console/$orgId/tools/compliance-audit/overview/'
    | '/admin-console/advanced/app-settings/all/edit/$name'
    | '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics'
    | '/admin-console/platform-content/ai-training/classification-example/edit/$id'
    | '/admin-console/platform-content/ai-training/classification-example/view/$id'
    | '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id'
    | '/admin-console/platform-content/ai-training/vulnerability-example/view/$id'
    | '/admin-console/platform-content/comms-and-content/app-text/edit/$id'
    | '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure'
    | '/admin-console/platform-content/obligations/controls-library/$id/details'
    | '/admin-console/platform-content/obligations/controls-library/$id/history'
    | '/admin-console/platform-content/obligations/library/details/$id'
    | '/console/$orgId/claims/details/$id/activity'
    | '/console/$orgId/claims/details/$id/ai-assessment'
    | '/console/$orgId/claims/details/$id/comms'
    | '/console/$orgId/claims/details/$id/contacts'
    | '/console/$orgId/claims/details/$id/expenses'
    | '/console/$orgId/claims/details/$id/financials'
    | '/console/$orgId/claims/details/$id/history'
    | '/console/$orgId/claims/details/$id/library'
    | '/console/$orgId/claims/details/$id/manage'
    | '/console/$orgId/claims/details/$id/policy-info'
    | '/console/$orgId/claims/details/$id/product-type-data'
    | '/console/$orgId/claims/details/$id/vehicle'
    | '/console/$orgId/compliance/coi/details/$id'
    | '/console/$orgId/compliance/complaints/details/$id'
    | '/console/$orgId/compliance/incidents/details/$id'
    | '/console/$orgId/compliance/obligations/details/$id'
    | '/console/$orgId/compliance/training/search/add'
    | '/console/$orgId/compliance/training/user/$userId'
    | '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags'
    | '/console/$orgId/configuration/claims-products/claims/documents'
    | '/console/$orgId/configuration/claims-products/claims/general'
    | '/console/$orgId/configuration/claims-products/claims/handling-standards'
    | '/console/$orgId/configuration/claims-products/claims/id'
    | '/console/$orgId/configuration/claims-products/claims/task-lists'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/add'
    | '/console/$orgId/configuration/claims-products/products-v2/add'
    | '/console/$orgId/configuration/claims-products/questionnaire/add'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations'
    | '/console/$orgId/configuration/compliance/complaints/brands'
    | '/console/$orgId/configuration/compliance/complaints/custom-fields'
    | '/console/$orgId/configuration/compliance/complaints/flags'
    | '/console/$orgId/configuration/compliance/complaints/general'
    | '/console/$orgId/configuration/compliance/complaints/rules'
    | '/console/$orgId/configuration/compliance/general/asic-products'
    | '/console/$orgId/configuration/compliance/general/documents'
    | '/console/$orgId/configuration/compliance/incidents/custom-fields'
    | '/console/$orgId/configuration/compliance/incidents/flags'
    | '/console/$orgId/configuration/compliance/incidents/general'
    | '/console/$orgId/configuration/compliance/incidents/rules'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations'
    | '/console/$orgId/configuration/compliance/mspr/definitions'
    | '/console/$orgId/configuration/compliance/mspr/documents'
    | '/console/$orgId/configuration/compliance/mspr/governance-config'
    | '/console/$orgId/configuration/compliance/training/custom-fields'
    | '/console/$orgId/configuration/compliance/training/training-periods'
    | '/console/$orgId/configuration/financials/billing/balance'
    | '/console/$orgId/configuration/financials/billing/billing-info'
    | '/console/$orgId/configuration/financials/billing/invoices'
    | '/console/$orgId/configuration/financials/billing/transactions'
    | '/console/$orgId/configuration/financials/billing/usage'
    | '/console/$orgId/configuration/fleet/client-database/add'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates'
    | '/console/$orgId/configuration/org-settings/handling-parties/add'
    | '/console/$orgId/configuration/vendor-management/suppliers/add'
    | '/console/$orgId/configuration/vendor-management/suppliers/definitions'
    | '/console/$orgId/controls/register/details/$id'
    | '/console/$orgId/fleet-portal/claims/details/$claimId'
    | '/console/$orgId/mspr/msp-exceptions/edit/$id'
    | '/console/$orgId/mspr/service-providers/details/$id'
    | '/console/$orgId/mspr/service-providers/search/add'
    | '/console/$orgId/risk/ras/details/$id'
    | '/console/$orgId/risk/register/details/$id'
    | '/console/$orgId/tools/compliance-audit/details/$complianceAuditId'
    | '/console/$orgId/tools/compliance-audit/overview/insights'
    | '/console/$orgId/tools/compliance-audit/overview/search'
    | '/console/$orgId/tools/website-checker/report/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/add'
    | '/console/$orgId/workload-manager/tasks/list/add'
    | '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/console/$orgId/compliance/coi/details/$id/'
    | '/console/$orgId/compliance/complaints/details/$id/'
    | '/console/$orgId/compliance/incidents/details/$id/'
    | '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/'
    | '/console/$orgId/configuration/compliance/incidents/general/'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/'
    | '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add'
    | '/admin-console/platform-content/obligations/library/details/$id/ai-related'
    | '/admin-console/platform-content/obligations/library/details/$id/document-analyser'
    | '/admin-console/platform-content/obligations/library/details/$id/history'
    | '/admin-console/platform-content/obligations/library/details/$id/manage'
    | '/console/$orgId/claims/details/$id/comms/add'
    | '/console/$orgId/claims/details/$id/contacts/add'
    | '/console/$orgId/claims/details/$id/expenses/add'
    | '/console/$orgId/compliance/coi/details/$id/library'
    | '/console/$orgId/compliance/coi/details/$id/manage'
    | '/console/$orgId/compliance/complaints/details/$id/comms'
    | '/console/$orgId/compliance/complaints/details/$id/history'
    | '/console/$orgId/compliance/complaints/details/$id/library'
    | '/console/$orgId/compliance/complaints/details/$id/manage'
    | '/console/$orgId/compliance/incidents/details/$id/history'
    | '/console/$orgId/compliance/incidents/details/$id/library'
    | '/console/$orgId/compliance/incidents/details/$id/manage'
    | '/console/$orgId/compliance/obligations/details/$id/debug'
    | '/console/$orgId/compliance/obligations/details/$id/manage'
    | '/console/$orgId/compliance/registers/$registerId/records/$recordId'
    | '/console/$orgId/compliance/training/user/$userId/add'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id'
    | '/console/$orgId/configuration/claims-products/product-types/states/$id'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId'
    | '/console/$orgId/configuration/claims-products/products-v2/edit/$productId'
    | '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations/add'
    | '/console/$orgId/configuration/compliance/complaints/flags/add'
    | '/console/$orgId/configuration/compliance/incidents/flags/add'
    | '/console/$orgId/configuration/compliance/incidents/general/incident-details'
    | '/console/$orgId/configuration/compliance/incidents/general/lodgement'
    | '/console/$orgId/configuration/compliance/incidents/general/rectification'
    | '/console/$orgId/configuration/compliance/incidents/general/timeline'
    | '/console/$orgId/configuration/compliance/mspr/governance-config/add'
    | '/console/$orgId/configuration/financials/billing/payment/success'
    | '/console/$orgId/configuration/fleet/client-database/details/$id'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures/add'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates/add'
    | '/console/$orgId/configuration/org-settings/handling-parties/details/$id'
    | '/console/$orgId/configuration/org-settings/users/details/$userId'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/definitions'
    | '/console/$orgId/configuration/vendor-management/suppliers/search/list'
    | '/console/$orgId/mspr/service-providers/details/$id/history'
    | '/console/$orgId/mspr/service-providers/details/$id/library'
    | '/console/$orgId/mspr/service-providers/details/$id/manage'
    | '/console/$orgId/risk/register/details/$id/action-plan'
    | '/console/$orgId/risk/register/details/$id/assessment'
    | '/console/$orgId/risk/register/details/$id/history'
    | '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification'
    | '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics'
    | '/console/$orgId/tools/compliance-audit/overview/search/add'
    | '/console/$orgId/tools/document-analyzer/history/$id/results'
    | '/console/$orgId/tools/pds-compare/pds-documents/edit/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/$id'
    | '/console/$orgId/workload-manager/tasks/list/details/$id'
    | '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId'
    | '/console/$orgId/configuration/vendor-management/suppliers/details/$id/'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId'
    | '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId'
    | '/console/$orgId/claims/details/$id/activity/add/phone'
    | '/console/$orgId/claims/details/$id/comms/add/email'
    | '/console/$orgId/claims/details/$id/comms/add/sms'
    | '/console/$orgId/claims/details/$id/comms/message/$messageId'
    | '/console/$orgId/claims/details/$id/comms/reply/$messageId'
    | '/console/$orgId/claims/details/$id/contacts/edit/$contactId'
    | '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId'
    | '/console/$orgId/claims/details/$id/financials/compensations/add'
    | '/console/$orgId/claims/details/$id/financials/excesses/add'
    | '/console/$orgId/claims/details/$id/financials/reserves/add'
    | '/console/$orgId/claims/details/$id/manage/strategies/add'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/add'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier'
    | '/console/$orgId/compliance/complaints/details/$id/manage/incidents'
    | '/console/$orgId/compliance/incidents/details/$id/manage/complaints'
    | '/console/$orgId/compliance/training/user/$userId/edit/$recordId'
    | '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId'
    | '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId'
    | '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/add'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types'
    | '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id'
    | '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId'
    | '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add'
    | '/console/$orgId/configuration/compliance/mspr/definitions/categories/add'
    | '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/clients'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/drivers'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/overview'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access'
    | '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles'
    | '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId'
    | '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId'
    | '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users'
    | '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id'
    | '/console/$orgId/controls/register/details/$id/activity/$activityId'
    | '/console/$orgId/controls/register/details/$id/activity/add'
    | '/console/$orgId/controls/register/details/$id/test/$testId'
    | '/console/$orgId/controls/register/details/$id/test/add'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/add'
    | '/console/$orgId/risk/register/details/$id/assessment/incidents'
    | '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id'
    | '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id'
    | '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId'
    | '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId'
    | '/console/$orgId/compliance/complaints/details/$id/manage/note/add'
    | '/console/$orgId/compliance/incidents/details/$id/manage/note/add'
    | '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id'
    | '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id'
    | '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/check/add'
    | '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId'
    | '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId'
    | '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add'
    | '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage'
    | '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add'
    | '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId'
    | '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add'
    | '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add'
    | '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields'
    | '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId'
    | '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId'
    | '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AdminConsentRoute: typeof AdminConsentRoute;
  AdminConsoleRouteRoute: typeof AdminConsoleRouteRouteWithChildren;
  AttestationRouteRoute: typeof AttestationRouteRouteWithChildren;
  InviteRouteRoute: typeof InviteRouteRoute;
  MaintenanceRoute: typeof MaintenanceRoute;
  NotFoundRoute: typeof NotFoundRoute;
  NotSupportedRoute: typeof NotSupportedRoute;
  OauthRouteRoute: typeof OauthRouteRouteWithChildren;
  OrgSwitchedRoute: typeof OrgSwitchedRoute;
  PublicRouteRoute: typeof PublicRouteRouteWithChildren;
  StatusRoute: typeof StatusRoute;
  TermsAcceptanceRouteRoute: typeof TermsAcceptanceRouteRoute;
  authenticationAdminLoginRoute: typeof authenticationAdminLoginRoute;
  authenticationCallbackRoute: typeof authenticationCallbackRoute;
  authenticationLoginRoute: typeof authenticationLoginRoute;
  authenticationLogoutRoute: typeof authenticationLogoutRoute;
  authenticationLogoutinRoute: typeof authenticationLogoutinRoute;
  authenticationOrgMismatchRoute: typeof authenticationOrgMismatchRoute;
  authenticationPaymentPendingRoute: typeof authenticationPaymentPendingRoute;
  ConsoleOrgIdRouteRoute: typeof ConsoleOrgIdRouteRouteWithChildren;
  PasswordResetRequestRoute: typeof PasswordResetRequestRoute;
  PasswordResetResetRoute: typeof PasswordResetResetRoute;
  WhatsNewReleaseIdRoute: typeof WhatsNewReleaseIdRoute;
  authenticationChangeOrgOrgIdRoute: typeof authenticationChangeOrgOrgIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin-consent': {
      id: '/admin-consent';
      path: '/admin-consent';
      fullPath: '/admin-consent';
      preLoaderRoute: typeof AdminConsentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin-console': {
      id: '/admin-console';
      path: '/admin-console';
      fullPath: '/admin-console';
      preLoaderRoute: typeof AdminConsoleRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/attestation': {
      id: '/attestation';
      path: '/attestation';
      fullPath: '/attestation';
      preLoaderRoute: typeof AttestationRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invite': {
      id: '/invite';
      path: '/invite';
      fullPath: '/invite';
      preLoaderRoute: typeof InviteRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/maintenance': {
      id: '/maintenance';
      path: '/maintenance';
      fullPath: '/maintenance';
      preLoaderRoute: typeof MaintenanceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/not-found': {
      id: '/not-found';
      path: '/not-found';
      fullPath: '/not-found';
      preLoaderRoute: typeof NotFoundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/not-supported': {
      id: '/not-supported';
      path: '/not-supported';
      fullPath: '/not-supported';
      preLoaderRoute: typeof NotSupportedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/oauth': {
      id: '/oauth';
      path: '/oauth';
      fullPath: '/oauth';
      preLoaderRoute: typeof OauthRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/org-switched': {
      id: '/org-switched';
      path: '/org-switched';
      fullPath: '/org-switched';
      preLoaderRoute: typeof OrgSwitchedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/public': {
      id: '/public';
      path: '/public';
      fullPath: '/public';
      preLoaderRoute: typeof PublicRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/status': {
      id: '/status';
      path: '/status';
      fullPath: '/status';
      preLoaderRoute: typeof StatusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/terms-acceptance': {
      id: '/terms-acceptance';
      path: '/terms-acceptance';
      fullPath: '/terms-acceptance';
      preLoaderRoute: typeof TermsAcceptanceRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/admin-login': {
      id: '/(authentication)/admin-login';
      path: '/admin-login';
      fullPath: '/admin-login';
      preLoaderRoute: typeof authenticationAdminLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/callback': {
      id: '/(authentication)/callback';
      path: '/callback';
      fullPath: '/callback';
      preLoaderRoute: typeof authenticationCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/login': {
      id: '/(authentication)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof authenticationLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/logout': {
      id: '/(authentication)/logout';
      path: '/logout';
      fullPath: '/logout';
      preLoaderRoute: typeof authenticationLogoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/logoutin': {
      id: '/(authentication)/logoutin';
      path: '/logoutin';
      fullPath: '/logoutin';
      preLoaderRoute: typeof authenticationLogoutinRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/org-mismatch': {
      id: '/(authentication)/org-mismatch';
      path: '/org-mismatch';
      fullPath: '/org-mismatch';
      preLoaderRoute: typeof authenticationOrgMismatchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/payment-pending': {
      id: '/(authentication)/payment-pending';
      path: '/payment-pending';
      fullPath: '/payment-pending';
      preLoaderRoute: typeof authenticationPaymentPendingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin-console/': {
      id: '/admin-console/';
      path: '/';
      fullPath: '/admin-console/';
      preLoaderRoute: typeof AdminConsoleIndexRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/advanced': {
      id: '/admin-console/advanced';
      path: '/advanced';
      fullPath: '/admin-console/advanced';
      preLoaderRoute: typeof AdminConsoleAdvancedRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/ai': {
      id: '/admin-console/ai';
      path: '/ai';
      fullPath: '/admin-console/ai';
      preLoaderRoute: typeof AdminConsoleAiRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/authorised-apps': {
      id: '/admin-console/authorised-apps';
      path: '/authorised-apps';
      fullPath: '/admin-console/authorised-apps';
      preLoaderRoute: typeof AdminConsoleAuthorisedAppsRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/monitoring': {
      id: '/admin-console/monitoring';
      path: '/monitoring';
      fullPath: '/admin-console/monitoring';
      preLoaderRoute: typeof AdminConsoleMonitoringRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/organisation-management': {
      id: '/admin-console/organisation-management';
      path: '/organisation-management';
      fullPath: '/admin-console/organisation-management';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/platform-content': {
      id: '/admin-console/platform-content';
      path: '/platform-content';
      fullPath: '/admin-console/platform-content';
      preLoaderRoute: typeof AdminConsolePlatformContentRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/tools': {
      id: '/admin-console/tools';
      path: '/tools';
      fullPath: '/admin-console/tools';
      preLoaderRoute: typeof AdminConsoleToolsRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/admin-console/user-access': {
      id: '/admin-console/user-access';
      path: '/user-access';
      fullPath: '/admin-console/user-access';
      preLoaderRoute: typeof AdminConsoleUserAccessRouteRouteImport;
      parentRoute: typeof AdminConsoleRouteRoute;
    };
    '/attestation/$token': {
      id: '/attestation/$token';
      path: '/$token';
      fullPath: '/attestation/$token';
      preLoaderRoute: typeof AttestationTokenRouteImport;
      parentRoute: typeof AttestationRouteRoute;
    };
    '/console/$orgId': {
      id: '/console/$orgId';
      path: '/console/$orgId';
      fullPath: '/console/$orgId';
      preLoaderRoute: typeof ConsoleOrgIdRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/oauth/authorize': {
      id: '/oauth/authorize';
      path: '/authorize';
      fullPath: '/oauth/authorize';
      preLoaderRoute: typeof OauthAuthorizeRouteImport;
      parentRoute: typeof OauthRouteRoute;
    };
    '/password-reset/request': {
      id: '/password-reset/request';
      path: '/password-reset/request';
      fullPath: '/password-reset/request';
      preLoaderRoute: typeof PasswordResetRequestRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/password-reset/reset': {
      id: '/password-reset/reset';
      path: '/password-reset/reset';
      fullPath: '/password-reset/reset';
      preLoaderRoute: typeof PasswordResetResetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/public/$orgId': {
      id: '/public/$orgId';
      path: '/$orgId';
      fullPath: '/public/$orgId';
      preLoaderRoute: typeof PublicOrgIdRouteRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    '/whats-new/$releaseId': {
      id: '/whats-new/$releaseId';
      path: '/whats-new/$releaseId';
      fullPath: '/whats-new/$releaseId';
      preLoaderRoute: typeof WhatsNewReleaseIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(authentication)/change-org/$orgId': {
      id: '/(authentication)/change-org/$orgId';
      path: '/change-org/$orgId';
      fullPath: '/change-org/$orgId';
      preLoaderRoute: typeof authenticationChangeOrgOrgIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/admin-console/advanced/': {
      id: '/admin-console/advanced/';
      path: '/';
      fullPath: '/admin-console/advanced/';
      preLoaderRoute: typeof AdminConsoleAdvancedIndexRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/app-settings': {
      id: '/admin-console/advanced/app-settings';
      path: '/app-settings';
      fullPath: '/admin-console/advanced/app-settings';
      preLoaderRoute: typeof AdminConsoleAdvancedAppSettingsRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/claims': {
      id: '/admin-console/advanced/claims';
      path: '/claims';
      fullPath: '/admin-console/advanced/claims';
      preLoaderRoute: typeof AdminConsoleAdvancedClaimsRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/db-stats': {
      id: '/admin-console/advanced/db-stats';
      path: '/db-stats';
      fullPath: '/admin-console/advanced/db-stats';
      preLoaderRoute: typeof AdminConsoleAdvancedDbStatsRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/db-upgrades': {
      id: '/admin-console/advanced/db-upgrades';
      path: '/db-upgrades';
      fullPath: '/admin-console/advanced/db-upgrades';
      preLoaderRoute: typeof AdminConsoleAdvancedDbUpgradesRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/inbound-email-archive': {
      id: '/admin-console/advanced/inbound-email-archive';
      path: '/inbound-email-archive';
      fullPath: '/admin-console/advanced/inbound-email-archive';
      preLoaderRoute: typeof AdminConsoleAdvancedInboundEmailArchiveRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/inbound-parse': {
      id: '/admin-console/advanced/inbound-parse';
      path: '/inbound-parse';
      fullPath: '/admin-console/advanced/inbound-parse';
      preLoaderRoute: typeof AdminConsoleAdvancedInboundParseRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/indicators': {
      id: '/admin-console/advanced/indicators';
      path: '/indicators';
      fullPath: '/admin-console/advanced/indicators';
      preLoaderRoute: typeof AdminConsoleAdvancedIndicatorsRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/integration-tests': {
      id: '/admin-console/advanced/integration-tests';
      path: '/integration-tests';
      fullPath: '/admin-console/advanced/integration-tests';
      preLoaderRoute: typeof AdminConsoleAdvancedIntegrationTestsRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/jobs': {
      id: '/admin-console/advanced/jobs';
      path: '/jobs';
      fullPath: '/admin-console/advanced/jobs';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/playground': {
      id: '/admin-console/advanced/playground';
      path: '/playground';
      fullPath: '/admin-console/advanced/playground';
      preLoaderRoute: typeof AdminConsoleAdvancedPlaygroundRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/advanced/weaviate': {
      id: '/admin-console/advanced/weaviate';
      path: '/weaviate';
      fullPath: '/admin-console/advanced/weaviate';
      preLoaderRoute: typeof AdminConsoleAdvancedWeaviateRouteImport;
      parentRoute: typeof AdminConsoleAdvancedRouteRoute;
    };
    '/admin-console/ai/ai-feedback': {
      id: '/admin-console/ai/ai-feedback';
      path: '/ai-feedback';
      fullPath: '/admin-console/ai/ai-feedback';
      preLoaderRoute: typeof AdminConsoleAiAiFeedbackRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/ai-prompts': {
      id: '/admin-console/ai/ai-prompts';
      path: '/ai-prompts';
      fullPath: '/admin-console/ai/ai-prompts';
      preLoaderRoute: typeof AdminConsoleAiAiPromptsRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/eval-runs': {
      id: '/admin-console/ai/eval-runs';
      path: '/eval-runs';
      fullPath: '/admin-console/ai/eval-runs';
      preLoaderRoute: typeof AdminConsoleAiEvalRunsRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/model-pricing': {
      id: '/admin-console/ai/model-pricing';
      path: '/model-pricing';
      fullPath: '/admin-console/ai/model-pricing';
      preLoaderRoute: typeof AdminConsoleAiModelPricingRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/model-tiers': {
      id: '/admin-console/ai/model-tiers';
      path: '/model-tiers';
      fullPath: '/admin-console/ai/model-tiers';
      preLoaderRoute: typeof AdminConsoleAiModelTiersRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/request-analytics': {
      id: '/admin-console/ai/request-analytics';
      path: '/request-analytics';
      fullPath: '/admin-console/ai/request-analytics';
      preLoaderRoute: typeof AdminConsoleAiRequestAnalyticsRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/statistics': {
      id: '/admin-console/ai/statistics';
      path: '/statistics';
      fullPath: '/admin-console/ai/statistics';
      preLoaderRoute: typeof AdminConsoleAiStatisticsRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/ai/usage-billing': {
      id: '/admin-console/ai/usage-billing';
      path: '/usage-billing';
      fullPath: '/admin-console/ai/usage-billing';
      preLoaderRoute: typeof AdminConsoleAiUsageBillingRouteRouteImport;
      parentRoute: typeof AdminConsoleAiRouteRoute;
    };
    '/admin-console/monitoring/': {
      id: '/admin-console/monitoring/';
      path: '/';
      fullPath: '/admin-console/monitoring/';
      preLoaderRoute: typeof AdminConsoleMonitoringIndexRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/audit-trail': {
      id: '/admin-console/monitoring/audit-trail';
      path: '/audit-trail';
      fullPath: '/admin-console/monitoring/audit-trail';
      preLoaderRoute: typeof AdminConsoleMonitoringAuditTrailRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/axiom-logs': {
      id: '/admin-console/monitoring/axiom-logs';
      path: '/axiom-logs';
      fullPath: '/admin-console/monitoring/axiom-logs';
      preLoaderRoute: typeof AdminConsoleMonitoringAxiomLogsRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/compliance': {
      id: '/admin-console/monitoring/compliance';
      path: '/compliance';
      fullPath: '/admin-console/monitoring/compliance';
      preLoaderRoute: typeof AdminConsoleMonitoringComplianceRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/compliance-audit': {
      id: '/admin-console/monitoring/compliance-audit';
      path: '/compliance-audit';
      fullPath: '/admin-console/monitoring/compliance-audit';
      preLoaderRoute: typeof AdminConsoleMonitoringComplianceAuditRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/email-activity': {
      id: '/admin-console/monitoring/email-activity';
      path: '/email-activity';
      fullPath: '/admin-console/monitoring/email-activity';
      preLoaderRoute: typeof AdminConsoleMonitoringEmailActivityRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/engagement': {
      id: '/admin-console/monitoring/engagement';
      path: '/engagement';
      fullPath: '/admin-console/monitoring/engagement';
      preLoaderRoute: typeof AdminConsoleMonitoringEngagementRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/llm-logs': {
      id: '/admin-console/monitoring/llm-logs';
      path: '/llm-logs';
      fullPath: '/admin-console/monitoring/llm-logs';
      preLoaderRoute: typeof AdminConsoleMonitoringLlmLogsRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/llm-stats': {
      id: '/admin-console/monitoring/llm-stats';
      path: '/llm-stats';
      fullPath: '/admin-console/monitoring/llm-stats';
      preLoaderRoute: typeof AdminConsoleMonitoringLlmStatsRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/memory': {
      id: '/admin-console/monitoring/memory';
      path: '/memory';
      fullPath: '/admin-console/monitoring/memory';
      preLoaderRoute: typeof AdminConsoleMonitoringMemoryRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/reports': {
      id: '/admin-console/monitoring/reports';
      path: '/reports';
      fullPath: '/admin-console/monitoring/reports';
      preLoaderRoute: typeof AdminConsoleMonitoringReportsRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/monitoring/statistics': {
      id: '/admin-console/monitoring/statistics';
      path: '/statistics';
      fullPath: '/admin-console/monitoring/statistics';
      preLoaderRoute: typeof AdminConsoleMonitoringStatisticsRouteRouteImport;
      parentRoute: typeof AdminConsoleMonitoringRouteRoute;
    };
    '/admin-console/organisation-management/new': {
      id: '/admin-console/organisation-management/new';
      path: '/new';
      fullPath: '/admin-console/organisation-management/new';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementNewRouteRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementRouteRoute;
    };
    '/admin-console/organisation-management/new-from-template': {
      id: '/admin-console/organisation-management/new-from-template';
      path: '/new-from-template';
      fullPath: '/admin-console/organisation-management/new-from-template';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementNewFromTemplateRouteRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementRouteRoute;
    };
    '/admin-console/organisation-management/organisations': {
      id: '/admin-console/organisation-management/organisations';
      path: '/organisations';
      fullPath: '/admin-console/organisation-management/organisations';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsRouteRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementRouteRoute;
    };
    '/admin-console/platform-content/': {
      id: '/admin-console/platform-content/';
      path: '/';
      fullPath: '/admin-console/platform-content/';
      preLoaderRoute: typeof AdminConsolePlatformContentIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/ai-training': {
      id: '/admin-console/platform-content/ai-training';
      path: '/ai-training';
      fullPath: '/admin-console/platform-content/ai-training';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content': {
      id: '/admin-console/platform-content/comms-and-content';
      path: '/comms-and-content';
      fullPath: '/admin-console/platform-content/comms-and-content';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates': {
      id: '/admin-console/platform-content/compliance-audit-templates';
      path: '/compliance-audit-templates';
      fullPath: '/admin-console/platform-content/compliance-audit-templates';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/market-pds': {
      id: '/admin-console/platform-content/market-pds';
      path: '/market-pds';
      fullPath: '/admin-console/platform-content/market-pds';
      preLoaderRoute: typeof AdminConsolePlatformContentMarketPdsRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/obligations': {
      id: '/admin-console/platform-content/obligations';
      path: '/obligations';
      fullPath: '/admin-console/platform-content/obligations';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/products': {
      id: '/admin-console/platform-content/products';
      path: '/products';
      fullPath: '/admin-console/platform-content/products';
      preLoaderRoute: typeof AdminConsolePlatformContentProductsRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/platform-content/whats-new': {
      id: '/admin-console/platform-content/whats-new';
      path: '/whats-new';
      fullPath: '/admin-console/platform-content/whats-new';
      preLoaderRoute: typeof AdminConsolePlatformContentWhatsNewRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentRouteRoute;
    };
    '/admin-console/tools/': {
      id: '/admin-console/tools/';
      path: '/';
      fullPath: '/admin-console/tools/';
      preLoaderRoute: typeof AdminConsoleToolsIndexRouteImport;
      parentRoute: typeof AdminConsoleToolsRouteRoute;
    };
    '/admin-console/tools/document-to-markdown': {
      id: '/admin-console/tools/document-to-markdown';
      path: '/document-to-markdown';
      fullPath: '/admin-console/tools/document-to-markdown';
      preLoaderRoute: typeof AdminConsoleToolsDocumentToMarkdownRouteImport;
      parentRoute: typeof AdminConsoleToolsRouteRoute;
    };
    '/admin-console/tools/feature-flags': {
      id: '/admin-console/tools/feature-flags';
      path: '/feature-flags';
      fullPath: '/admin-console/tools/feature-flags';
      preLoaderRoute: typeof AdminConsoleToolsFeatureFlagsRouteImport;
      parentRoute: typeof AdminConsoleToolsRouteRoute;
    };
    '/admin-console/tools/sanitise-text-pii': {
      id: '/admin-console/tools/sanitise-text-pii';
      path: '/sanitise-text-pii';
      fullPath: '/admin-console/tools/sanitise-text-pii';
      preLoaderRoute: typeof AdminConsoleToolsSanitiseTextPiiRouteRouteImport;
      parentRoute: typeof AdminConsoleToolsRouteRoute;
    };
    '/admin-console/user-access/': {
      id: '/admin-console/user-access/';
      path: '/';
      fullPath: '/admin-console/user-access/';
      preLoaderRoute: typeof AdminConsoleUserAccessIndexRouteImport;
      parentRoute: typeof AdminConsoleUserAccessRouteRoute;
    };
    '/admin-console/user-access/admin-users': {
      id: '/admin-console/user-access/admin-users';
      path: '/admin-users';
      fullPath: '/admin-console/user-access/admin-users';
      preLoaderRoute: typeof AdminConsoleUserAccessAdminUsersRouteRouteImport;
      parentRoute: typeof AdminConsoleUserAccessRouteRoute;
    };
    '/admin-console/user-access/support-sessions': {
      id: '/admin-console/user-access/support-sessions';
      path: '/support-sessions';
      fullPath: '/admin-console/user-access/support-sessions';
      preLoaderRoute: typeof AdminConsoleUserAccessSupportSessionsRouteRouteImport;
      parentRoute: typeof AdminConsoleUserAccessRouteRoute;
    };
    '/admin-console/user-access/users': {
      id: '/admin-console/user-access/users';
      path: '/users';
      fullPath: '/admin-console/user-access/users';
      preLoaderRoute: typeof AdminConsoleUserAccessUsersRouteRouteImport;
      parentRoute: typeof AdminConsoleUserAccessRouteRoute;
    };
    '/console/$orgId/': {
      id: '/console/$orgId/';
      path: '/';
      fullPath: '/console/$orgId/';
      preLoaderRoute: typeof ConsoleOrgIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/attestations': {
      id: '/console/$orgId/attestations';
      path: '/attestations';
      fullPath: '/console/$orgId/attestations';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/claims': {
      id: '/console/$orgId/claims';
      path: '/claims';
      fullPath: '/console/$orgId/claims';
      preLoaderRoute: typeof ConsoleOrgIdClaimsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/compliance': {
      id: '/console/$orgId/compliance';
      path: '/compliance';
      fullPath: '/console/$orgId/compliance';
      preLoaderRoute: typeof ConsoleOrgIdComplianceRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/component-showcase': {
      id: '/console/$orgId/component-showcase';
      path: '/component-showcase';
      fullPath: '/console/$orgId/component-showcase';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/configuration': {
      id: '/console/$orgId/configuration';
      path: '/configuration';
      fullPath: '/console/$orgId/configuration';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/controls': {
      id: '/console/$orgId/controls';
      path: '/controls';
      fullPath: '/console/$orgId/controls';
      preLoaderRoute: typeof ConsoleOrgIdControlsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/dashboard': {
      id: '/console/$orgId/dashboard';
      path: '/dashboard';
      fullPath: '/console/$orgId/dashboard';
      preLoaderRoute: typeof ConsoleOrgIdDashboardRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/documents': {
      id: '/console/$orgId/documents';
      path: '/documents';
      fullPath: '/console/$orgId/documents';
      preLoaderRoute: typeof ConsoleOrgIdDocumentsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/faq': {
      id: '/console/$orgId/faq';
      path: '/faq';
      fullPath: '/console/$orgId/faq';
      preLoaderRoute: typeof ConsoleOrgIdFaqRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/fleet-portal': {
      id: '/console/$orgId/fleet-portal';
      path: '/fleet-portal';
      fullPath: '/console/$orgId/fleet-portal';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/get-file': {
      id: '/console/$orgId/get-file';
      path: '/get-file';
      fullPath: '/console/$orgId/get-file';
      preLoaderRoute: typeof ConsoleOrgIdGetFileRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/mspr': {
      id: '/console/$orgId/mspr';
      path: '/mspr';
      fullPath: '/console/$orgId/mspr';
      preLoaderRoute: typeof ConsoleOrgIdMsprRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/reporting': {
      id: '/console/$orgId/reporting';
      path: '/reporting';
      fullPath: '/console/$orgId/reporting';
      preLoaderRoute: typeof ConsoleOrgIdReportingRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/risk': {
      id: '/console/$orgId/risk';
      path: '/risk';
      fullPath: '/console/$orgId/risk';
      preLoaderRoute: typeof ConsoleOrgIdRiskRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/tools': {
      id: '/console/$orgId/tools';
      path: '/tools';
      fullPath: '/console/$orgId/tools';
      preLoaderRoute: typeof ConsoleOrgIdToolsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/tools-only-home-page': {
      id: '/console/$orgId/tools-only-home-page';
      path: '/tools-only-home-page';
      fullPath: '/console/$orgId/tools-only-home-page';
      preLoaderRoute: typeof ConsoleOrgIdToolsOnlyHomePageRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/user-settings': {
      id: '/console/$orgId/user-settings';
      path: '/user-settings';
      fullPath: '/console/$orgId/user-settings';
      preLoaderRoute: typeof ConsoleOrgIdUserSettingsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/workload-manager': {
      id: '/console/$orgId/workload-manager';
      path: '/workload-manager';
      fullPath: '/console/$orgId/workload-manager';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/public/lodgement-summary/$accessKey': {
      id: '/public/lodgement-summary/$accessKey';
      path: '/lodgement-summary/$accessKey';
      fullPath: '/public/lodgement-summary/$accessKey';
      preLoaderRoute: typeof PublicLodgementSummaryAccessKeyRouteRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    '/public/new-complaint-by-key/$key': {
      id: '/public/new-complaint-by-key/$key';
      path: '/new-complaint-by-key/$key';
      fullPath: '/public/new-complaint-by-key/$key';
      preLoaderRoute: typeof PublicNewComplaintByKeyKeyRouteRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    '/public/new-complaint/$orgId': {
      id: '/public/new-complaint/$orgId';
      path: '/new-complaint/$orgId';
      fullPath: '/public/new-complaint/$orgId';
      preLoaderRoute: typeof PublicNewComplaintOrgIdRouteRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    '/admin-console/advanced/app-settings/all': {
      id: '/admin-console/advanced/app-settings/all';
      path: '/all';
      fullPath: '/admin-console/advanced/app-settings/all';
      preLoaderRoute: typeof AdminConsoleAdvancedAppSettingsAllRouteRouteImport;
      parentRoute: typeof AdminConsoleAdvancedAppSettingsRouteRoute;
    };
    '/admin-console/advanced/app-settings/well-known': {
      id: '/admin-console/advanced/app-settings/well-known';
      path: '/well-known';
      fullPath: '/admin-console/advanced/app-settings/well-known';
      preLoaderRoute: typeof AdminConsoleAdvancedAppSettingsWellKnownRouteImport;
      parentRoute: typeof AdminConsoleAdvancedAppSettingsRouteRoute;
    };
    '/admin-console/advanced/inbound-parse/': {
      id: '/admin-console/advanced/inbound-parse/';
      path: '/';
      fullPath: '/admin-console/advanced/inbound-parse/';
      preLoaderRoute: typeof AdminConsoleAdvancedInboundParseIndexRouteImport;
      parentRoute: typeof AdminConsoleAdvancedInboundParseRouteRoute;
    };
    '/admin-console/advanced/indicators/complaints': {
      id: '/admin-console/advanced/indicators/complaints';
      path: '/complaints';
      fullPath: '/admin-console/advanced/indicators/complaints';
      preLoaderRoute: typeof AdminConsoleAdvancedIndicatorsComplaintsRouteImport;
      parentRoute: typeof AdminConsoleAdvancedIndicatorsRouteRoute;
    };
    '/admin-console/advanced/indicators/incidents': {
      id: '/admin-console/advanced/indicators/incidents';
      path: '/incidents';
      fullPath: '/admin-console/advanced/indicators/incidents';
      preLoaderRoute: typeof AdminConsoleAdvancedIndicatorsIncidentsRouteImport;
      parentRoute: typeof AdminConsoleAdvancedIndicatorsRouteRoute;
    };
    '/admin-console/advanced/jobs/': {
      id: '/admin-console/advanced/jobs/';
      path: '/';
      fullPath: '/admin-console/advanced/jobs/';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsIndexRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsRouteRoute;
    };
    '/admin-console/advanced/jobs/dynamic-recurring': {
      id: '/admin-console/advanced/jobs/dynamic-recurring';
      path: '/dynamic-recurring';
      fullPath: '/admin-console/advanced/jobs/dynamic-recurring';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsDynamicRecurringRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsRouteRoute;
    };
    '/admin-console/advanced/jobs/on-demand': {
      id: '/admin-console/advanced/jobs/on-demand';
      path: '/on-demand';
      fullPath: '/admin-console/advanced/jobs/on-demand';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsOnDemandRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsRouteRoute;
    };
    '/admin-console/advanced/jobs/recurring': {
      id: '/admin-console/advanced/jobs/recurring';
      path: '/recurring';
      fullPath: '/admin-console/advanced/jobs/recurring';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsRecurringRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsRouteRoute;
    };
    '/admin-console/ai/eval-runs/$evalRunId': {
      id: '/admin-console/ai/eval-runs/$evalRunId';
      path: '/$evalRunId';
      fullPath: '/admin-console/ai/eval-runs/$evalRunId';
      preLoaderRoute: typeof AdminConsoleAiEvalRunsEvalRunIdRouteRouteImport;
      parentRoute: typeof AdminConsoleAiEvalRunsRouteRoute;
    };
    '/admin-console/ai/eval-runs/compare': {
      id: '/admin-console/ai/eval-runs/compare';
      path: '/compare';
      fullPath: '/admin-console/ai/eval-runs/compare';
      preLoaderRoute: typeof AdminConsoleAiEvalRunsCompareRouteRouteImport;
      parentRoute: typeof AdminConsoleAiEvalRunsRouteRoute;
    };
    '/admin-console/monitoring/email-activity/': {
      id: '/admin-console/monitoring/email-activity/';
      path: '/';
      fullPath: '/admin-console/monitoring/email-activity/';
      preLoaderRoute: typeof AdminConsoleMonitoringEmailActivityIndexRouteImport;
      parentRoute: typeof AdminConsoleMonitoringEmailActivityRouteRoute;
    };
    '/admin-console/monitoring/engagement/': {
      id: '/admin-console/monitoring/engagement/';
      path: '/';
      fullPath: '/admin-console/monitoring/engagement/';
      preLoaderRoute: typeof AdminConsoleMonitoringEngagementIndexRouteImport;
      parentRoute: typeof AdminConsoleMonitoringEngagementRouteRoute;
    };
    '/admin-console/organisation-management/organisations/': {
      id: '/admin-console/organisation-management/organisations/';
      path: '/';
      fullPath: '/admin-console/organisation-management/organisations/';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsIndexRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementOrganisationsRouteRoute;
    };
    '/admin-console/organisation-management/organisations/$orgId': {
      id: '/admin-console/organisation-management/organisations/$orgId';
      path: '/$orgId';
      fullPath: '/admin-console/organisation-management/organisations/$orgId';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementOrganisationsRouteRoute;
    };
    '/admin-console/platform-content/ai-training/': {
      id: '/admin-console/platform-content/ai-training/';
      path: '/';
      fullPath: '/admin-console/platform-content/ai-training/';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingRouteRoute;
    };
    '/admin-console/platform-content/ai-training/classification-example': {
      id: '/admin-console/platform-content/ai-training/classification-example';
      path: '/classification-example';
      fullPath: '/admin-console/platform-content/ai-training/classification-example';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingRouteRoute;
    };
    '/admin-console/platform-content/ai-training/vulnerability-example': {
      id: '/admin-console/platform-content/ai-training/vulnerability-example';
      path: '/vulnerability-example';
      fullPath: '/admin-console/platform-content/ai-training/vulnerability-example';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/app-text': {
      id: '/admin-console/platform-content/comms-and-content/app-text';
      path: '/app-text';
      fullPath: '/admin-console/platform-content/comms-and-content/app-text';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/comm-templates': {
      id: '/admin-console/platform-content/comms-and-content/comm-templates';
      path: '/comm-templates';
      fullPath: '/admin-console/platform-content/comms-and-content/comm-templates';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/faq': {
      id: '/admin-console/platform-content/comms-and-content/faq';
      path: '/faq';
      fullPath: '/admin-console/platform-content/comms-and-content/faq';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentFaqRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/': {
      id: '/admin-console/platform-content/compliance-audit-templates/';
      path: '/';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/search': {
      id: '/admin-console/platform-content/compliance-audit-templates/search';
      path: '/search';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/search';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute;
    };
    '/admin-console/platform-content/market-pds/add': {
      id: '/admin-console/platform-content/market-pds/add';
      path: '/add';
      fullPath: '/admin-console/platform-content/market-pds/add';
      preLoaderRoute: typeof AdminConsolePlatformContentMarketPdsAddRouteImport;
      parentRoute: typeof AdminConsolePlatformContentMarketPdsRouteRoute;
    };
    '/admin-console/platform-content/obligations/': {
      id: '/admin-console/platform-content/obligations/';
      path: '/';
      fullPath: '/admin-console/platform-content/obligations/';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsRouteRoute;
    };
    '/admin-console/platform-content/obligations/configuration': {
      id: '/admin-console/platform-content/obligations/configuration';
      path: '/configuration';
      fullPath: '/admin-console/platform-content/obligations/configuration';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsConfigurationRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsRouteRoute;
    };
    '/admin-console/platform-content/obligations/controls-library': {
      id: '/admin-console/platform-content/obligations/controls-library';
      path: '/controls-library';
      fullPath: '/admin-console/platform-content/obligations/controls-library';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsRouteRoute;
    };
    '/admin-console/platform-content/obligations/library': {
      id: '/admin-console/platform-content/obligations/library';
      path: '/library';
      fullPath: '/admin-console/platform-content/obligations/library';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsRouteRoute;
    };
    '/admin-console/platform-content/products/$serviceId': {
      id: '/admin-console/platform-content/products/$serviceId';
      path: '/$serviceId';
      fullPath: '/admin-console/platform-content/products/$serviceId';
      preLoaderRoute: typeof AdminConsolePlatformContentProductsServiceIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentProductsRouteRoute;
    };
    '/admin-console/platform-content/whats-new/': {
      id: '/admin-console/platform-content/whats-new/';
      path: '/';
      fullPath: '/admin-console/platform-content/whats-new/';
      preLoaderRoute: typeof AdminConsolePlatformContentWhatsNewIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentWhatsNewRouteRoute;
    };
    '/admin-console/platform-content/whats-new/$id': {
      id: '/admin-console/platform-content/whats-new/$id';
      path: '/$id';
      fullPath: '/admin-console/platform-content/whats-new/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentWhatsNewIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentWhatsNewRouteRoute;
    };
    '/admin-console/platform-content/whats-new/new': {
      id: '/admin-console/platform-content/whats-new/new';
      path: '/new';
      fullPath: '/admin-console/platform-content/whats-new/new';
      preLoaderRoute: typeof AdminConsolePlatformContentWhatsNewNewRouteImport;
      parentRoute: typeof AdminConsolePlatformContentWhatsNewRouteRoute;
    };
    '/admin-console/tools/sanitise-text-pii/compare': {
      id: '/admin-console/tools/sanitise-text-pii/compare';
      path: '/compare';
      fullPath: '/admin-console/tools/sanitise-text-pii/compare';
      preLoaderRoute: typeof AdminConsoleToolsSanitiseTextPiiCompareRouteImport;
      parentRoute: typeof AdminConsoleToolsSanitiseTextPiiRouteRoute;
    };
    '/admin-console/tools/sanitise-text-pii/tool': {
      id: '/admin-console/tools/sanitise-text-pii/tool';
      path: '/tool';
      fullPath: '/admin-console/tools/sanitise-text-pii/tool';
      preLoaderRoute: typeof AdminConsoleToolsSanitiseTextPiiToolRouteImport;
      parentRoute: typeof AdminConsoleToolsSanitiseTextPiiRouteRoute;
    };
    '/admin-console/user-access/admin-users/grant': {
      id: '/admin-console/user-access/admin-users/grant';
      path: '/grant';
      fullPath: '/admin-console/user-access/admin-users/grant';
      preLoaderRoute: typeof AdminConsoleUserAccessAdminUsersGrantRouteImport;
      parentRoute: typeof AdminConsoleUserAccessAdminUsersRouteRoute;
    };
    '/console/$orgId/attestations/': {
      id: '/console/$orgId/attestations/';
      path: '/';
      fullPath: '/console/$orgId/attestations/';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsRouteRoute;
    };
    '/console/$orgId/attestations/scheduled-attestations': {
      id: '/console/$orgId/attestations/scheduled-attestations';
      path: '/scheduled-attestations';
      fullPath: '/console/$orgId/attestations/scheduled-attestations';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsRouteRoute;
    };
    '/console/$orgId/attestations/user-attestations': {
      id: '/console/$orgId/attestations/user-attestations';
      path: '/user-attestations';
      fullPath: '/console/$orgId/attestations/user-attestations';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsUserAttestationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsRouteRoute;
    };
    '/console/$orgId/claims/': {
      id: '/console/$orgId/claims/';
      path: '/';
      fullPath: '/console/$orgId/claims/';
      preLoaderRoute: typeof ConsoleOrgIdClaimsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsRouteRoute;
    };
    '/console/$orgId/compliance/': {
      id: '/console/$orgId/compliance/';
      path: '/';
      fullPath: '/console/$orgId/compliance/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/coi': {
      id: '/console/$orgId/compliance/coi';
      path: '/coi';
      fullPath: '/console/$orgId/compliance/coi';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/complaints': {
      id: '/console/$orgId/compliance/complaints';
      path: '/complaints';
      fullPath: '/console/$orgId/compliance/complaints';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/incidents': {
      id: '/console/$orgId/compliance/incidents';
      path: '/incidents';
      fullPath: '/console/$orgId/compliance/incidents';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/intake': {
      id: '/console/$orgId/compliance/intake';
      path: '/intake';
      fullPath: '/console/$orgId/compliance/intake';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIntakeRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/obligations': {
      id: '/console/$orgId/compliance/obligations';
      path: '/obligations';
      fullPath: '/console/$orgId/compliance/obligations';
      preLoaderRoute: typeof ConsoleOrgIdComplianceObligationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/registers': {
      id: '/console/$orgId/compliance/registers';
      path: '/registers';
      fullPath: '/console/$orgId/compliance/registers';
      preLoaderRoute: typeof ConsoleOrgIdComplianceRegistersRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/compliance/training': {
      id: '/console/$orgId/compliance/training';
      path: '/training';
      fullPath: '/console/$orgId/compliance/training';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRouteRoute;
    };
    '/console/$orgId/component-showcase/': {
      id: '/console/$orgId/component-showcase/';
      path: '/';
      fullPath: '/console/$orgId/component-showcase/';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/ai-chat-test': {
      id: '/console/$orgId/component-showcase/ai-chat-test';
      path: '/ai-chat-test';
      fullPath: '/console/$orgId/component-showcase/ai-chat-test';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseAiChatTestRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/button-icon-test': {
      id: '/console/$orgId/component-showcase/button-icon-test';
      path: '/button-icon-test';
      fullPath: '/console/$orgId/component-showcase/button-icon-test';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseButtonIconTestRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/button-variants': {
      id: '/console/$orgId/component-showcase/button-variants';
      path: '/button-variants';
      fullPath: '/console/$orgId/component-showcase/button-variants';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseButtonVariantsRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/component-showcase': {
      id: '/console/$orgId/component-showcase/component-showcase';
      path: '/component-showcase';
      fullPath: '/console/$orgId/component-showcase/component-showcase';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseComponentShowcaseRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/date-picker-test': {
      id: '/console/$orgId/component-showcase/date-picker-test';
      path: '/date-picker-test';
      fullPath: '/console/$orgId/component-showcase/date-picker-test';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseDatePickerTestRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/fit-on-page': {
      id: '/console/$orgId/component-showcase/fit-on-page';
      path: '/fit-on-page';
      fullPath: '/console/$orgId/component-showcase/fit-on-page';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseFitOnPageRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/markdown-showcase': {
      id: '/console/$orgId/component-showcase/markdown-showcase';
      path: '/markdown-showcase';
      fullPath: '/console/$orgId/component-showcase/markdown-showcase';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseMarkdownShowcaseRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/table-showcase': {
      id: '/console/$orgId/component-showcase/table-showcase';
      path: '/table-showcase';
      fullPath: '/console/$orgId/component-showcase/table-showcase';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseTableShowcaseRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/tag-variants': {
      id: '/console/$orgId/component-showcase/tag-variants';
      path: '/tag-variants';
      fullPath: '/console/$orgId/component-showcase/tag-variants';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseTagVariantsRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/component-showcase/tiptap-test': {
      id: '/console/$orgId/component-showcase/tiptap-test';
      path: '/tiptap-test';
      fullPath: '/console/$orgId/component-showcase/tiptap-test';
      preLoaderRoute: typeof ConsoleOrgIdComponentShowcaseTiptapTestRouteImport;
      parentRoute: typeof ConsoleOrgIdComponentShowcaseRouteRoute;
    };
    '/console/$orgId/configuration/': {
      id: '/console/$orgId/configuration/';
      path: '/';
      fullPath: '/console/$orgId/configuration/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations': {
      id: '/console/$orgId/configuration/api-integrations';
      path: '/api-integrations';
      fullPath: '/console/$orgId/configuration/api-integrations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/claims-products': {
      id: '/console/$orgId/configuration/claims-products';
      path: '/claims-products';
      fullPath: '/console/$orgId/configuration/claims-products';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/client-database': {
      id: '/console/$orgId/configuration/client-database';
      path: '/client-database';
      fullPath: '/console/$orgId/configuration/client-database';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClientDatabaseRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/compliance': {
      id: '/console/$orgId/configuration/compliance';
      path: '/compliance';
      fullPath: '/console/$orgId/configuration/compliance';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/financials': {
      id: '/console/$orgId/configuration/financials';
      path: '/financials';
      fullPath: '/console/$orgId/configuration/financials';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/fleet': {
      id: '/console/$orgId/configuration/fleet';
      path: '/fleet';
      fullPath: '/console/$orgId/configuration/fleet';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/monitoring': {
      id: '/console/$orgId/configuration/monitoring';
      path: '/monitoring';
      fullPath: '/console/$orgId/configuration/monitoring';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationMonitoringRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/org-settings': {
      id: '/console/$orgId/configuration/org-settings';
      path: '/org-settings';
      fullPath: '/console/$orgId/configuration/org-settings';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/risk': {
      id: '/console/$orgId/configuration/risk';
      path: '/risk';
      fullPath: '/console/$orgId/configuration/risk';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationRiskRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management': {
      id: '/console/$orgId/configuration/vendor-management';
      path: '/vendor-management';
      fullPath: '/console/$orgId/configuration/vendor-management';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRouteRoute;
    };
    '/console/$orgId/controls/': {
      id: '/console/$orgId/controls/';
      path: '/';
      fullPath: '/console/$orgId/controls/';
      preLoaderRoute: typeof ConsoleOrgIdControlsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRouteRoute;
    };
    '/console/$orgId/controls/activities': {
      id: '/console/$orgId/controls/activities';
      path: '/activities';
      fullPath: '/console/$orgId/controls/activities';
      preLoaderRoute: typeof ConsoleOrgIdControlsActivitiesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRouteRoute;
    };
    '/console/$orgId/controls/register': {
      id: '/console/$orgId/controls/register';
      path: '/register';
      fullPath: '/console/$orgId/controls/register';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRouteRoute;
    };
    '/console/$orgId/controls/tests': {
      id: '/console/$orgId/controls/tests';
      path: '/tests';
      fullPath: '/console/$orgId/controls/tests';
      preLoaderRoute: typeof ConsoleOrgIdControlsTestsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRouteRoute;
    };
    '/console/$orgId/dashboard/': {
      id: '/console/$orgId/dashboard/';
      path: '/';
      fullPath: '/console/$orgId/dashboard/';
      preLoaderRoute: typeof ConsoleOrgIdDashboardIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/dashboard/claims': {
      id: '/console/$orgId/dashboard/claims';
      path: '/claims';
      fullPath: '/console/$orgId/dashboard/claims';
      preLoaderRoute: typeof ConsoleOrgIdDashboardClaimsRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/dashboard/complaints': {
      id: '/console/$orgId/dashboard/complaints';
      path: '/complaints';
      fullPath: '/console/$orgId/dashboard/complaints';
      preLoaderRoute: typeof ConsoleOrgIdDashboardComplaintsRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/dashboard/incidents': {
      id: '/console/$orgId/dashboard/incidents';
      path: '/incidents';
      fullPath: '/console/$orgId/dashboard/incidents';
      preLoaderRoute: typeof ConsoleOrgIdDashboardIncidentsRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/dashboard/management': {
      id: '/console/$orgId/dashboard/management';
      path: '/management';
      fullPath: '/console/$orgId/dashboard/management';
      preLoaderRoute: typeof ConsoleOrgIdDashboardManagementRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/dashboard/people-and-culture': {
      id: '/console/$orgId/dashboard/people-and-culture';
      path: '/people-and-culture';
      fullPath: '/console/$orgId/dashboard/people-and-culture';
      preLoaderRoute: typeof ConsoleOrgIdDashboardPeopleAndCultureRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/dashboard/risks': {
      id: '/console/$orgId/dashboard/risks';
      path: '/risks';
      fullPath: '/console/$orgId/dashboard/risks';
      preLoaderRoute: typeof ConsoleOrgIdDashboardRisksRouteImport;
      parentRoute: typeof ConsoleOrgIdDashboardRouteRoute;
    };
    '/console/$orgId/debug/': {
      id: '/console/$orgId/debug/';
      path: '/debug';
      fullPath: '/console/$orgId/debug/';
      preLoaderRoute: typeof ConsoleOrgIdDebugIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdRouteRoute;
    };
    '/console/$orgId/fleet-portal/': {
      id: '/console/$orgId/fleet-portal/';
      path: '/';
      fullPath: '/console/$orgId/fleet-portal/';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalRouteRoute;
    };
    '/console/$orgId/fleet-portal/authorisations': {
      id: '/console/$orgId/fleet-portal/authorisations';
      path: '/authorisations';
      fullPath: '/console/$orgId/fleet-portal/authorisations';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalAuthorisationsRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalRouteRoute;
    };
    '/console/$orgId/fleet-portal/claims': {
      id: '/console/$orgId/fleet-portal/claims';
      path: '/claims';
      fullPath: '/console/$orgId/fleet-portal/claims';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalClaimsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalRouteRoute;
    };
    '/console/$orgId/fleet-portal/dashboard': {
      id: '/console/$orgId/fleet-portal/dashboard';
      path: '/dashboard';
      fullPath: '/console/$orgId/fleet-portal/dashboard';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalDashboardRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalRouteRoute;
    };
    '/console/$orgId/fleet-portal/fleet': {
      id: '/console/$orgId/fleet-portal/fleet';
      path: '/fleet';
      fullPath: '/console/$orgId/fleet-portal/fleet';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalFleetRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalRouteRoute;
    };
    '/console/$orgId/fleet-portal/sla': {
      id: '/console/$orgId/fleet-portal/sla';
      path: '/sla';
      fullPath: '/console/$orgId/fleet-portal/sla';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalSlaRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalRouteRoute;
    };
    '/console/$orgId/mspr/msp-exceptions': {
      id: '/console/$orgId/mspr/msp-exceptions';
      path: '/msp-exceptions';
      fullPath: '/console/$orgId/mspr/msp-exceptions';
      preLoaderRoute: typeof ConsoleOrgIdMsprMspExceptionsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprRouteRoute;
    };
    '/console/$orgId/mspr/service-providers': {
      id: '/console/$orgId/mspr/service-providers';
      path: '/service-providers';
      fullPath: '/console/$orgId/mspr/service-providers';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprRouteRoute;
    };
    '/console/$orgId/reporting/add': {
      id: '/console/$orgId/reporting/add';
      path: '/add';
      fullPath: '/console/$orgId/reporting/add';
      preLoaderRoute: typeof ConsoleOrgIdReportingAddRouteImport;
      parentRoute: typeof ConsoleOrgIdReportingRouteRoute;
    };
    '/console/$orgId/risk/': {
      id: '/console/$orgId/risk/';
      path: '/';
      fullPath: '/console/$orgId/risk/';
      preLoaderRoute: typeof ConsoleOrgIdRiskIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRouteRoute;
    };
    '/console/$orgId/risk/ras': {
      id: '/console/$orgId/risk/ras';
      path: '/ras';
      fullPath: '/console/$orgId/risk/ras';
      preLoaderRoute: typeof ConsoleOrgIdRiskRasRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRouteRoute;
    };
    '/console/$orgId/risk/register': {
      id: '/console/$orgId/risk/register';
      path: '/register';
      fullPath: '/console/$orgId/risk/register';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRouteRoute;
    };
    '/console/$orgId/tools/': {
      id: '/console/$orgId/tools/';
      path: '/';
      fullPath: '/console/$orgId/tools/';
      preLoaderRoute: typeof ConsoleOrgIdToolsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsRouteRoute;
    };
    '/console/$orgId/tools/auto-detect': {
      id: '/console/$orgId/tools/auto-detect';
      path: '/auto-detect';
      fullPath: '/console/$orgId/tools/auto-detect';
      preLoaderRoute: typeof ConsoleOrgIdToolsAutoDetectRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit': {
      id: '/console/$orgId/tools/compliance-audit';
      path: '/compliance-audit';
      fullPath: '/console/$orgId/tools/compliance-audit';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsRouteRoute;
    };
    '/console/$orgId/tools/document-analyzer': {
      id: '/console/$orgId/tools/document-analyzer';
      path: '/document-analyzer';
      fullPath: '/console/$orgId/tools/document-analyzer';
      preLoaderRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsRouteRoute;
    };
    '/console/$orgId/tools/pds-compare': {
      id: '/console/$orgId/tools/pds-compare';
      path: '/pds-compare';
      fullPath: '/console/$orgId/tools/pds-compare';
      preLoaderRoute: typeof ConsoleOrgIdToolsPdsCompareRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsRouteRoute;
    };
    '/console/$orgId/tools/website-checker': {
      id: '/console/$orgId/tools/website-checker';
      path: '/website-checker';
      fullPath: '/console/$orgId/tools/website-checker';
      preLoaderRoute: typeof ConsoleOrgIdToolsWebsiteCheckerRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsRouteRoute;
    };
    '/console/$orgId/user-settings/': {
      id: '/console/$orgId/user-settings/';
      path: '/';
      fullPath: '/console/$orgId/user-settings/';
      preLoaderRoute: typeof ConsoleOrgIdUserSettingsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdUserSettingsRouteRoute;
    };
    '/console/$orgId/user-settings/notifications': {
      id: '/console/$orgId/user-settings/notifications';
      path: '/notifications';
      fullPath: '/console/$orgId/user-settings/notifications';
      preLoaderRoute: typeof ConsoleOrgIdUserSettingsNotificationsRouteImport;
      parentRoute: typeof ConsoleOrgIdUserSettingsRouteRoute;
    };
    '/console/$orgId/user-settings/profile': {
      id: '/console/$orgId/user-settings/profile';
      path: '/profile';
      fullPath: '/console/$orgId/user-settings/profile';
      preLoaderRoute: typeof ConsoleOrgIdUserSettingsProfileRouteImport;
      parentRoute: typeof ConsoleOrgIdUserSettingsRouteRoute;
    };
    '/console/$orgId/workload-manager/': {
      id: '/console/$orgId/workload-manager/';
      path: '/';
      fullPath: '/console/$orgId/workload-manager/';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerRouteRoute;
    };
    '/console/$orgId/workload-manager/complaints': {
      id: '/console/$orgId/workload-manager/complaints';
      path: '/complaints';
      fullPath: '/console/$orgId/workload-manager/complaints';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerComplaintsRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerRouteRoute;
    };
    '/console/$orgId/workload-manager/emails': {
      id: '/console/$orgId/workload-manager/emails';
      path: '/emails';
      fullPath: '/console/$orgId/workload-manager/emails';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerEmailsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks': {
      id: '/console/$orgId/workload-manager/tasks';
      path: '/tasks';
      fullPath: '/console/$orgId/workload-manager/tasks';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerRouteRoute;
    };
    '/public/$orgId/complaint/new': {
      id: '/public/$orgId/complaint/new';
      path: '/complaint/new';
      fullPath: '/public/$orgId/complaint/new';
      preLoaderRoute: typeof PublicOrgIdComplaintNewRouteRouteImport;
      parentRoute: typeof PublicOrgIdRouteRoute;
    };
    '/admin-console/advanced/app-settings/all/add': {
      id: '/admin-console/advanced/app-settings/all/add';
      path: '/add';
      fullPath: '/admin-console/advanced/app-settings/all/add';
      preLoaderRoute: typeof AdminConsoleAdvancedAppSettingsAllAddRouteImport;
      parentRoute: typeof AdminConsoleAdvancedAppSettingsAllRouteRoute;
    };
    '/admin-console/advanced/jobs/dynamic-recurring/$jobId': {
      id: '/admin-console/advanced/jobs/dynamic-recurring/$jobId';
      path: '/$jobId';
      fullPath: '/admin-console/advanced/jobs/dynamic-recurring/$jobId';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsDynamicRecurringJobIdRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsDynamicRecurringRoute;
    };
    '/admin-console/advanced/jobs/on-demand/$jobId': {
      id: '/admin-console/advanced/jobs/on-demand/$jobId';
      path: '/$jobId';
      fullPath: '/admin-console/advanced/jobs/on-demand/$jobId';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsOnDemandJobIdRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsOnDemandRoute;
    };
    '/admin-console/advanced/jobs/recurring/$jobId': {
      id: '/admin-console/advanced/jobs/recurring/$jobId';
      path: '/$jobId';
      fullPath: '/admin-console/advanced/jobs/recurring/$jobId';
      preLoaderRoute: typeof AdminConsoleAdvancedJobsRecurringJobIdRouteImport;
      parentRoute: typeof AdminConsoleAdvancedJobsRecurringRoute;
    };
    '/admin-console/organisation-management/organisations/$orgId/subscriptions': {
      id: '/admin-console/organisation-management/organisations/$orgId/subscriptions';
      path: '/subscriptions';
      fullPath: '/admin-console/organisation-management/organisations/$orgId/subscriptions';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute;
    };
    '/admin-console/organisation-management/organisations/$orgId/users': {
      id: '/admin-console/organisation-management/organisations/$orgId/users';
      path: '/users';
      fullPath: '/admin-console/organisation-management/organisations/$orgId/users';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute;
    };
    '/admin-console/organisation-management/organisations/$orgId/wallet': {
      id: '/admin-console/organisation-management/organisations/$orgId/wallet';
      path: '/wallet';
      fullPath: '/admin-console/organisation-management/organisations/$orgId/wallet';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute;
    };
    '/admin-console/platform-content/ai-training/classification-example/create': {
      id: '/admin-console/platform-content/ai-training/classification-example/create';
      path: '/create';
      fullPath: '/admin-console/platform-content/ai-training/classification-example/create';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute;
    };
    '/admin-console/platform-content/ai-training/vulnerability-example/create': {
      id: '/admin-console/platform-content/ai-training/vulnerability-example/create';
      path: '/create';
      fullPath: '/admin-console/platform-content/ai-training/vulnerability-example/create';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/app-text/add': {
      id: '/admin-console/platform-content/comms-and-content/app-text/add';
      path: '/add';
      fullPath: '/admin-console/platform-content/comms-and-content/app-text/add';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextAddRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/comm-templates/add': {
      id: '/admin-console/platform-content/comms-and-content/comm-templates/add';
      path: '/add';
      fullPath: '/admin-console/platform-content/comms-and-content/comm-templates/add';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesAddRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId';
      path: '/details/$complianceAuditTemplateId';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/search/add': {
      id: '/admin-console/platform-content/compliance-audit-templates/search/add';
      path: '/add';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/search/add';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRoute;
    };
    '/admin-console/platform-content/market-pds/edit/$id': {
      id: '/admin-console/platform-content/market-pds/edit/$id';
      path: '/edit/$id';
      fullPath: '/admin-console/platform-content/market-pds/edit/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentMarketPdsEditIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentMarketPdsRouteRoute;
    };
    '/admin-console/platform-content/obligations/controls-library/': {
      id: '/admin-console/platform-content/obligations/controls-library/';
      path: '/';
      fullPath: '/admin-console/platform-content/obligations/controls-library/';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryRouteRoute;
    };
    '/admin-console/platform-content/obligations/controls-library/$id': {
      id: '/admin-console/platform-content/obligations/controls-library/$id';
      path: '/$id';
      fullPath: '/admin-console/platform-content/obligations/controls-library/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryRouteRoute;
    };
    '/admin-console/platform-content/obligations/library/': {
      id: '/admin-console/platform-content/obligations/library/';
      path: '/';
      fullPath: '/admin-console/platform-content/obligations/library/';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryIndexRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsLibraryRouteRoute;
    };
    '/admin-console/user-access/admin-users/edit/$userId': {
      id: '/admin-console/user-access/admin-users/edit/$userId';
      path: '/edit/$userId';
      fullPath: '/admin-console/user-access/admin-users/edit/$userId';
      preLoaderRoute: typeof AdminConsoleUserAccessAdminUsersEditUserIdRouteImport;
      parentRoute: typeof AdminConsoleUserAccessAdminUsersRouteRoute;
    };
    '/admin-console/user-access/users/edit/$userId': {
      id: '/admin-console/user-access/users/edit/$userId';
      path: '/edit/$userId';
      fullPath: '/admin-console/user-access/users/edit/$userId';
      preLoaderRoute: typeof AdminConsoleUserAccessUsersEditUserIdRouteImport;
      parentRoute: typeof AdminConsoleUserAccessUsersRouteRoute;
    };
    '/admin-console/user-access/users/view/$userId': {
      id: '/admin-console/user-access/users/view/$userId';
      path: '/view/$userId';
      fullPath: '/admin-console/user-access/users/view/$userId';
      preLoaderRoute: typeof AdminConsoleUserAccessUsersViewUserIdRouteImport;
      parentRoute: typeof AdminConsoleUserAccessUsersRouteRoute;
    };
    '/console/$orgId/attestations/scheduled-attestations/$scheduleId': {
      id: '/console/$orgId/attestations/scheduled-attestations/$scheduleId';
      path: '/$scheduleId';
      fullPath: '/console/$orgId/attestations/scheduled-attestations/$scheduleId';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute;
    };
    '/console/$orgId/attestations/scheduled-attestations/new': {
      id: '/console/$orgId/attestations/scheduled-attestations/new';
      path: '/new';
      fullPath: '/console/$orgId/attestations/scheduled-attestations/new';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsNewRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute;
    };
    '/console/$orgId/attestations/user-attestations/$attestationId': {
      id: '/console/$orgId/attestations/user-attestations/$attestationId';
      path: '/$attestationId';
      fullPath: '/console/$orgId/attestations/user-attestations/$attestationId';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsUserAttestationsRouteRoute;
    };
    '/console/$orgId/attestations/user-attestations/send': {
      id: '/console/$orgId/attestations/user-attestations/send';
      path: '/send';
      fullPath: '/console/$orgId/attestations/user-attestations/send';
      preLoaderRoute: typeof ConsoleOrgIdAttestationsUserAttestationsSendRouteImport;
      parentRoute: typeof ConsoleOrgIdAttestationsUserAttestationsRouteRoute;
    };
    '/console/$orgId/claims/details/$id': {
      id: '/console/$orgId/claims/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/claims/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsRouteRoute;
    };
    '/console/$orgId/compliance/coi/': {
      id: '/console/$orgId/compliance/coi/';
      path: '/';
      fullPath: '/console/$orgId/compliance/coi/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceCoiRouteRoute;
    };
    '/console/$orgId/compliance/coi/add': {
      id: '/console/$orgId/compliance/coi/add';
      path: '/add';
      fullPath: '/console/$orgId/compliance/coi/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceCoiRouteRoute;
    };
    '/console/$orgId/compliance/complaints/': {
      id: '/console/$orgId/compliance/complaints/';
      path: '/';
      fullPath: '/console/$orgId/compliance/complaints/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/compliance/complaints/add': {
      id: '/console/$orgId/compliance/complaints/add';
      path: '/add';
      fullPath: '/console/$orgId/compliance/complaints/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/compliance/incidents/': {
      id: '/console/$orgId/compliance/incidents/';
      path: '/';
      fullPath: '/console/$orgId/compliance/incidents/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/compliance/incidents/add': {
      id: '/console/$orgId/compliance/incidents/add';
      path: '/add';
      fullPath: '/console/$orgId/compliance/incidents/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/compliance/obligations/': {
      id: '/console/$orgId/compliance/obligations/';
      path: '/';
      fullPath: '/console/$orgId/compliance/obligations/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceObligationsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceObligationsRouteRoute;
    };
    '/console/$orgId/compliance/obligations/add': {
      id: '/console/$orgId/compliance/obligations/add';
      path: '/add';
      fullPath: '/console/$orgId/compliance/obligations/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceObligationsAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceObligationsRouteRoute;
    };
    '/console/$orgId/compliance/registers/': {
      id: '/console/$orgId/compliance/registers/';
      path: '/';
      fullPath: '/console/$orgId/compliance/registers/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceRegistersIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRegistersRouteRoute;
    };
    '/console/$orgId/compliance/registers/$registerId': {
      id: '/console/$orgId/compliance/registers/$registerId';
      path: '/$registerId';
      fullPath: '/console/$orgId/compliance/registers/$registerId';
      preLoaderRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRegistersRouteRoute;
    };
    '/console/$orgId/compliance/training/': {
      id: '/console/$orgId/compliance/training/';
      path: '/';
      fullPath: '/console/$orgId/compliance/training/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceTrainingRouteRoute;
    };
    '/console/$orgId/compliance/training/search': {
      id: '/console/$orgId/compliance/training/search';
      path: '/search';
      fullPath: '/console/$orgId/compliance/training/search';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingSearchRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceTrainingRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations/api-tokens': {
      id: '/console/$orgId/configuration/api-integrations/api-tokens';
      path: '/api-tokens';
      fullPath: '/console/$orgId/configuration/api-integrations/api-tokens';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations/form-designer': {
      id: '/console/$orgId/configuration/api-integrations/form-designer';
      path: '/form-designer';
      fullPath: '/console/$orgId/configuration/api-integrations/form-designer';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations/mcp-access': {
      id: '/console/$orgId/configuration/api-integrations/mcp-access';
      path: '/mcp-access';
      fullPath: '/console/$orgId/configuration/api-integrations/mcp-access';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims': {
      id: '/console/$orgId/configuration/claims-products/claims';
      path: '/claims';
      fullPath: '/console/$orgId/configuration/claims-products/claims';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/insurers': {
      id: '/console/$orgId/configuration/claims-products/insurers';
      path: '/insurers';
      fullPath: '/console/$orgId/configuration/claims-products/insurers';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types': {
      id: '/console/$orgId/configuration/claims-products/product-types';
      path: '/product-types';
      fullPath: '/console/$orgId/configuration/claims-products/product-types';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2': {
      id: '/console/$orgId/configuration/claims-products/products-v2';
      path: '/products-v2';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/questionnaire': {
      id: '/console/$orgId/configuration/claims-products/questionnaire';
      path: '/questionnaire';
      fullPath: '/console/$orgId/configuration/claims-products/questionnaire';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRoute;
    };
    '/console/$orgId/configuration/client-database/$': {
      id: '/console/$orgId/configuration/client-database/$';
      path: '/$';
      fullPath: '/console/$orgId/configuration/client-database/$';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClientDatabaseSplatRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClientDatabaseRoute;
    };
    '/console/$orgId/configuration/compliance/': {
      id: '/console/$orgId/configuration/compliance/';
      path: '/';
      fullPath: '/console/$orgId/configuration/compliance/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/attestations': {
      id: '/console/$orgId/configuration/compliance/attestations';
      path: '/attestations';
      fullPath: '/console/$orgId/configuration/compliance/attestations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/auto-detect': {
      id: '/console/$orgId/configuration/compliance/auto-detect';
      path: '/auto-detect';
      fullPath: '/console/$orgId/configuration/compliance/auto-detect';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceAutoDetectRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints': {
      id: '/console/$orgId/configuration/compliance/complaints';
      path: '/complaints';
      fullPath: '/console/$orgId/configuration/compliance/complaints';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/compliance-audit': {
      id: '/console/$orgId/configuration/compliance/compliance-audit';
      path: '/compliance-audit';
      fullPath: '/console/$orgId/configuration/compliance/compliance-audit';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/general': {
      id: '/console/$orgId/configuration/compliance/general';
      path: '/general';
      fullPath: '/console/$orgId/configuration/compliance/general';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents': {
      id: '/console/$orgId/configuration/compliance/incidents';
      path: '/incidents';
      fullPath: '/console/$orgId/configuration/compliance/incidents';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr': {
      id: '/console/$orgId/configuration/compliance/mspr';
      path: '/mspr';
      fullPath: '/console/$orgId/configuration/compliance/mspr';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/obligations': {
      id: '/console/$orgId/configuration/compliance/obligations';
      path: '/obligations';
      fullPath: '/console/$orgId/configuration/compliance/obligations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceObligationsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/compliance/training': {
      id: '/console/$orgId/configuration/compliance/training';
      path: '/training';
      fullPath: '/console/$orgId/configuration/compliance/training';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing': {
      id: '/console/$orgId/configuration/financials/billing';
      path: '/billing';
      fullPath: '/console/$orgId/configuration/financials/billing';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsRouteRoute;
    };
    '/console/$orgId/configuration/financials/expenses-billing': {
      id: '/console/$orgId/configuration/financials/expenses-billing';
      path: '/expenses-billing';
      fullPath: '/console/$orgId/configuration/financials/expenses-billing';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsRouteRoute;
    };
    '/console/$orgId/configuration/financials/payments': {
      id: '/console/$orgId/configuration/financials/payments';
      path: '/payments';
      fullPath: '/console/$orgId/configuration/financials/payments';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsPaymentsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsRouteRoute;
    };
    '/console/$orgId/configuration/fleet/': {
      id: '/console/$orgId/configuration/fleet/';
      path: '/';
      fullPath: '/console/$orgId/configuration/fleet/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database': {
      id: '/console/$orgId/configuration/fleet/client-database';
      path: '/client-database';
      fullPath: '/console/$orgId/configuration/fleet/client-database';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetRouteRoute;
    };
    '/console/$orgId/configuration/fleet/delegated-authority': {
      id: '/console/$orgId/configuration/fleet/delegated-authority';
      path: '/delegated-authority';
      fullPath: '/console/$orgId/configuration/fleet/delegated-authority';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetRouteRoute;
    };
    '/console/$orgId/configuration/fleet/escalations': {
      id: '/console/$orgId/configuration/fleet/escalations';
      path: '/escalations';
      fullPath: '/console/$orgId/configuration/fleet/escalations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetEscalationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetRouteRoute;
    };
    '/console/$orgId/configuration/fleet/portal-claim-page': {
      id: '/console/$orgId/configuration/fleet/portal-claim-page';
      path: '/portal-claim-page';
      fullPath: '/console/$orgId/configuration/fleet/portal-claim-page';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetRouteRoute;
    };
    '/console/$orgId/configuration/monitoring/audit-trail': {
      id: '/console/$orgId/configuration/monitoring/audit-trail';
      path: '/audit-trail';
      fullPath: '/console/$orgId/configuration/monitoring/audit-trail';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationMonitoringRouteRoute;
    };
    '/console/$orgId/configuration/monitoring/email-activity': {
      id: '/console/$orgId/configuration/monitoring/email-activity';
      path: '/email-activity';
      fullPath: '/console/$orgId/configuration/monitoring/email-activity';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationMonitoringRouteRoute;
    };
    '/console/$orgId/configuration/monitoring/statistics': {
      id: '/console/$orgId/configuration/monitoring/statistics';
      path: '/statistics';
      fullPath: '/console/$orgId/configuration/monitoring/statistics';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationMonitoringStatisticsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationMonitoringRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication': {
      id: '/console/$orgId/configuration/org-settings/communication';
      path: '/communication';
      fullPath: '/console/$orgId/configuration/org-settings/communication';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/fleet-escalations': {
      id: '/console/$orgId/configuration/org-settings/fleet-escalations';
      path: '/fleet-escalations';
      fullPath: '/console/$orgId/configuration/org-settings/fleet-escalations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/handling-parties': {
      id: '/console/$orgId/configuration/org-settings/handling-parties';
      path: '/handling-parties';
      fullPath: '/console/$orgId/configuration/org-settings/handling-parties';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/support-sessions': {
      id: '/console/$orgId/configuration/org-settings/support-sessions';
      path: '/support-sessions';
      fullPath: '/console/$orgId/configuration/org-settings/support-sessions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/system': {
      id: '/console/$orgId/configuration/org-settings/system';
      path: '/system';
      fullPath: '/console/$orgId/configuration/org-settings/system';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsSystemRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/tasks': {
      id: '/console/$orgId/configuration/org-settings/tasks';
      path: '/tasks';
      fullPath: '/console/$orgId/configuration/org-settings/tasks';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsTasksRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/trash': {
      id: '/console/$orgId/configuration/org-settings/trash';
      path: '/trash';
      fullPath: '/console/$orgId/configuration/org-settings/trash';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsTrashRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/users': {
      id: '/console/$orgId/configuration/org-settings/users';
      path: '/users';
      fullPath: '/console/$orgId/configuration/org-settings/users';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRoute;
    };
    '/console/$orgId/configuration/risk/': {
      id: '/console/$orgId/configuration/risk/';
      path: '/';
      fullPath: '/console/$orgId/configuration/risk/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationRiskIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRiskRouteRoute;
    };
    '/console/$orgId/configuration/risk/appetite': {
      id: '/console/$orgId/configuration/risk/appetite';
      path: '/appetite';
      fullPath: '/console/$orgId/configuration/risk/appetite';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationRiskAppetiteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRiskRouteRoute;
    };
    '/console/$orgId/configuration/risk/categories': {
      id: '/console/$orgId/configuration/risk/categories';
      path: '/categories';
      fullPath: '/console/$orgId/configuration/risk/categories';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationRiskCategoriesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRiskRouteRoute;
    };
    '/console/$orgId/configuration/risk/matrix': {
      id: '/console/$orgId/configuration/risk/matrix';
      path: '/matrix';
      fullPath: '/console/$orgId/configuration/risk/matrix';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationRiskMatrixRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationRiskRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers': {
      id: '/console/$orgId/configuration/vendor-management/suppliers';
      path: '/suppliers';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementRouteRoute;
    };
    '/console/$orgId/controls/register/': {
      id: '/console/$orgId/controls/register/';
      path: '/';
      fullPath: '/console/$orgId/controls/register/';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterRouteRoute;
    };
    '/console/$orgId/controls/register/add': {
      id: '/console/$orgId/controls/register/add';
      path: '/add';
      fullPath: '/console/$orgId/controls/register/add';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterRouteRoute;
    };
    '/console/$orgId/documents/details/$fileId': {
      id: '/console/$orgId/documents/details/$fileId';
      path: '/details/$fileId';
      fullPath: '/console/$orgId/documents/details/$fileId';
      preLoaderRoute: typeof ConsoleOrgIdDocumentsDetailsFileIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdDocumentsRouteRoute;
    };
    '/console/$orgId/fleet-portal/claims/': {
      id: '/console/$orgId/fleet-portal/claims/';
      path: '/';
      fullPath: '/console/$orgId/fleet-portal/claims/';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalClaimsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalClaimsRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/': {
      id: '/console/$orgId/mspr/service-providers/';
      path: '/';
      fullPath: '/console/$orgId/mspr/service-providers/';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/search': {
      id: '/console/$orgId/mspr/service-providers/search';
      path: '/search';
      fullPath: '/console/$orgId/mspr/service-providers/search';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersSearchRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersRouteRoute;
    };
    '/console/$orgId/risk/ras/': {
      id: '/console/$orgId/risk/ras/';
      path: '/';
      fullPath: '/console/$orgId/risk/ras/';
      preLoaderRoute: typeof ConsoleOrgIdRiskRasIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRasRouteRoute;
    };
    '/console/$orgId/risk/register/': {
      id: '/console/$orgId/risk/register/';
      path: '/';
      fullPath: '/console/$orgId/risk/register/';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterRouteRoute;
    };
    '/console/$orgId/tools/auto-detect/dashboard': {
      id: '/console/$orgId/tools/auto-detect/dashboard';
      path: '/dashboard';
      fullPath: '/console/$orgId/tools/auto-detect/dashboard';
      preLoaderRoute: typeof ConsoleOrgIdToolsAutoDetectDashboardRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsAutoDetectRouteRoute;
    };
    '/console/$orgId/tools/auto-detect/inbox': {
      id: '/console/$orgId/tools/auto-detect/inbox';
      path: '/inbox';
      fullPath: '/console/$orgId/tools/auto-detect/inbox';
      preLoaderRoute: typeof ConsoleOrgIdToolsAutoDetectInboxRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsAutoDetectRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/': {
      id: '/console/$orgId/tools/compliance-audit/';
      path: '/';
      fullPath: '/console/$orgId/tools/compliance-audit/';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/overview': {
      id: '/console/$orgId/tools/compliance-audit/overview';
      path: '/overview';
      fullPath: '/console/$orgId/tools/compliance-audit/overview';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditRouteRoute;
    };
    '/console/$orgId/tools/document-analyzer/': {
      id: '/console/$orgId/tools/document-analyzer/';
      path: '/';
      fullPath: '/console/$orgId/tools/document-analyzer/';
      preLoaderRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRoute;
    };
    '/console/$orgId/tools/document-analyzer/history': {
      id: '/console/$orgId/tools/document-analyzer/history';
      path: '/history';
      fullPath: '/console/$orgId/tools/document-analyzer/history';
      preLoaderRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRoute;
    };
    '/console/$orgId/tools/document-analyzer/upload': {
      id: '/console/$orgId/tools/document-analyzer/upload';
      path: '/upload';
      fullPath: '/console/$orgId/tools/document-analyzer/upload';
      preLoaderRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerUploadRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRoute;
    };
    '/console/$orgId/tools/pds-compare/': {
      id: '/console/$orgId/tools/pds-compare/';
      path: '/';
      fullPath: '/console/$orgId/tools/pds-compare/';
      preLoaderRoute: typeof ConsoleOrgIdToolsPdsCompareIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsPdsCompareRouteRoute;
    };
    '/console/$orgId/tools/pds-compare/pds-documents': {
      id: '/console/$orgId/tools/pds-compare/pds-documents';
      path: '/pds-documents';
      fullPath: '/console/$orgId/tools/pds-compare/pds-documents';
      preLoaderRoute: typeof ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsPdsCompareRouteRoute;
    };
    '/console/$orgId/tools/website-checker/': {
      id: '/console/$orgId/tools/website-checker/';
      path: '/';
      fullPath: '/console/$orgId/tools/website-checker/';
      preLoaderRoute: typeof ConsoleOrgIdToolsWebsiteCheckerIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsWebsiteCheckerRouteRoute;
    };
    '/console/$orgId/user-settings/authorised-apps/': {
      id: '/console/$orgId/user-settings/authorised-apps/';
      path: '/authorised-apps';
      fullPath: '/console/$orgId/user-settings/authorised-apps/';
      preLoaderRoute: typeof ConsoleOrgIdUserSettingsAuthorisedAppsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdUserSettingsRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/': {
      id: '/console/$orgId/workload-manager/tasks/';
      path: '/';
      fullPath: '/console/$orgId/workload-manager/tasks/';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar': {
      id: '/console/$orgId/workload-manager/tasks/calendar';
      path: '/calendar';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/list': {
      id: '/console/$orgId/workload-manager/tasks/list';
      path: '/list';
      fullPath: '/console/$orgId/workload-manager/tasks/list';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksListRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksRouteRoute;
    };
    '/public/$orgId/invoice/view/$accessKey': {
      id: '/public/$orgId/invoice/view/$accessKey';
      path: '/invoice/view/$accessKey';
      fullPath: '/public/$orgId/invoice/view/$accessKey';
      preLoaderRoute: typeof PublicOrgIdInvoiceViewAccessKeyRouteRouteImport;
      parentRoute: typeof PublicOrgIdRouteRoute;
    };
    '/admin-console/advanced/app-settings/all/edit/$name': {
      id: '/admin-console/advanced/app-settings/all/edit/$name';
      path: '/edit/$name';
      fullPath: '/admin-console/advanced/app-settings/all/edit/$name';
      preLoaderRoute: typeof AdminConsoleAdvancedAppSettingsAllEditNameRouteImport;
      parentRoute: typeof AdminConsoleAdvancedAppSettingsAllRouteRoute;
    };
    '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics': {
      id: '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics';
      path: '/$orgId/$complianceAuditId/statistics';
      fullPath: '/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics';
      preLoaderRoute: typeof AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRouteImport;
      parentRoute: typeof AdminConsoleMonitoringComplianceAuditRouteRoute;
    };
    '/admin-console/platform-content/ai-training/classification-example/edit/$id': {
      id: '/admin-console/platform-content/ai-training/classification-example/edit/$id';
      path: '/edit/$id';
      fullPath: '/admin-console/platform-content/ai-training/classification-example/edit/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute;
    };
    '/admin-console/platform-content/ai-training/classification-example/view/$id': {
      id: '/admin-console/platform-content/ai-training/classification-example/view/$id';
      path: '/view/$id';
      fullPath: '/admin-console/platform-content/ai-training/classification-example/view/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute;
    };
    '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id': {
      id: '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id';
      path: '/edit/$id';
      fullPath: '/admin-console/platform-content/ai-training/vulnerability-example/edit/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute;
    };
    '/admin-console/platform-content/ai-training/vulnerability-example/view/$id': {
      id: '/admin-console/platform-content/ai-training/vulnerability-example/view/$id';
      path: '/view/$id';
      fullPath: '/admin-console/platform-content/ai-training/vulnerability-example/view/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/app-text/edit/$id': {
      id: '/admin-console/platform-content/comms-and-content/app-text/edit/$id';
      path: '/edit/$id';
      fullPath: '/admin-console/platform-content/comms-and-content/app-text/edit/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextEditIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRoute;
    };
    '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId': {
      id: '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId';
      path: '/edit/$commTemplateId';
      fullPath: '/admin-console/platform-content/comms-and-content/comm-templates/edit/$commTemplateId';
      preLoaderRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes';
      path: '/changes';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/changes';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types';
      path: '/evidence-types';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles';
      path: '/principles';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure';
      path: '/structure';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/structure';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute;
    };
    '/admin-console/platform-content/obligations/controls-library/$id/details': {
      id: '/admin-console/platform-content/obligations/controls-library/$id/details';
      path: '/details';
      fullPath: '/admin-console/platform-content/obligations/controls-library/$id/details';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute;
    };
    '/admin-console/platform-content/obligations/controls-library/$id/history': {
      id: '/admin-console/platform-content/obligations/controls-library/$id/history';
      path: '/history';
      fullPath: '/admin-console/platform-content/obligations/controls-library/$id/history';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute;
    };
    '/admin-console/platform-content/obligations/library/details/$id': {
      id: '/admin-console/platform-content/obligations/library/details/$id';
      path: '/details/$id';
      fullPath: '/admin-console/platform-content/obligations/library/details/$id';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsLibraryRouteRoute;
    };
    '/console/$orgId/claims/details/$id/activity': {
      id: '/console/$orgId/claims/details/$id/activity';
      path: '/activity';
      fullPath: '/console/$orgId/claims/details/$id/activity';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/ai-assessment': {
      id: '/console/$orgId/claims/details/$id/ai-assessment';
      path: '/ai-assessment';
      fullPath: '/console/$orgId/claims/details/$id/ai-assessment';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/comms': {
      id: '/console/$orgId/claims/details/$id/comms';
      path: '/comms';
      fullPath: '/console/$orgId/claims/details/$id/comms';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/contacts': {
      id: '/console/$orgId/claims/details/$id/contacts';
      path: '/contacts';
      fullPath: '/console/$orgId/claims/details/$id/contacts';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/expenses': {
      id: '/console/$orgId/claims/details/$id/expenses';
      path: '/expenses';
      fullPath: '/console/$orgId/claims/details/$id/expenses';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials': {
      id: '/console/$orgId/claims/details/$id/financials';
      path: '/financials';
      fullPath: '/console/$orgId/claims/details/$id/financials';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/history': {
      id: '/console/$orgId/claims/details/$id/history';
      path: '/history';
      fullPath: '/console/$orgId/claims/details/$id/history';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdHistoryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/library': {
      id: '/console/$orgId/claims/details/$id/library';
      path: '/library';
      fullPath: '/console/$orgId/claims/details/$id/library';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdLibraryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/manage': {
      id: '/console/$orgId/claims/details/$id/manage';
      path: '/manage';
      fullPath: '/console/$orgId/claims/details/$id/manage';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdManageRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/policy-info': {
      id: '/console/$orgId/claims/details/$id/policy-info';
      path: '/policy-info';
      fullPath: '/console/$orgId/claims/details/$id/policy-info';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/product-type-data': {
      id: '/console/$orgId/claims/details/$id/product-type-data';
      path: '/product-type-data';
      fullPath: '/console/$orgId/claims/details/$id/product-type-data';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/vehicle': {
      id: '/console/$orgId/claims/details/$id/vehicle';
      path: '/vehicle';
      fullPath: '/console/$orgId/claims/details/$id/vehicle';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdVehicleRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/coi/details/$id': {
      id: '/console/$orgId/compliance/coi/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/compliance/coi/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceCoiRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id': {
      id: '/console/$orgId/compliance/complaints/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/compliance/complaints/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id': {
      id: '/console/$orgId/compliance/incidents/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/compliance/incidents/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/compliance/obligations/details/$id': {
      id: '/console/$orgId/compliance/obligations/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/compliance/obligations/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceObligationsRouteRoute;
    };
    '/console/$orgId/compliance/registers/$registerId/': {
      id: '/console/$orgId/compliance/registers/$registerId/';
      path: '/';
      fullPath: '/console/$orgId/compliance/registers/$registerId/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute;
    };
    '/console/$orgId/compliance/training/search/add': {
      id: '/console/$orgId/compliance/training/search/add';
      path: '/add';
      fullPath: '/console/$orgId/compliance/training/search/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingSearchAddRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceTrainingSearchRouteRoute;
    };
    '/console/$orgId/compliance/training/user/$userId': {
      id: '/console/$orgId/compliance/training/user/$userId';
      path: '/user/$userId';
      fullPath: '/console/$orgId/compliance/training/user/$userId';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceTrainingRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations/form-designer/': {
      id: '/console/$orgId/configuration/api-integrations/form-designer/';
      path: '/';
      fullPath: '/console/$orgId/configuration/api-integrations/form-designer/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId': {
      id: '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId';
      path: '/$formDefinitionId';
      fullPath: '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/': {
      id: '/console/$orgId/configuration/claims-products/claims/';
      path: '/';
      fullPath: '/console/$orgId/configuration/claims-products/claims/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/catastrophe-events': {
      id: '/console/$orgId/configuration/claims-products/claims/catastrophe-events';
      path: '/catastrophe-events';
      fullPath: '/console/$orgId/configuration/claims-products/claims/catastrophe-events';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/claim-flags': {
      id: '/console/$orgId/configuration/claims-products/claims/claim-flags';
      path: '/claim-flags';
      fullPath: '/console/$orgId/configuration/claims-products/claims/claim-flags';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/documents': {
      id: '/console/$orgId/configuration/claims-products/claims/documents';
      path: '/documents';
      fullPath: '/console/$orgId/configuration/claims-products/claims/documents';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/general': {
      id: '/console/$orgId/configuration/claims-products/claims/general';
      path: '/general';
      fullPath: '/console/$orgId/configuration/claims-products/claims/general';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/handling-standards': {
      id: '/console/$orgId/configuration/claims-products/claims/handling-standards';
      path: '/handling-standards';
      fullPath: '/console/$orgId/configuration/claims-products/claims/handling-standards';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/id': {
      id: '/console/$orgId/configuration/claims-products/claims/id';
      path: '/id';
      fullPath: '/console/$orgId/configuration/claims-products/claims/id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists';
      path: '/task-lists';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId';
      path: '/$productTypeId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/add': {
      id: '/console/$orgId/configuration/claims-products/product-types/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/add': {
      id: '/console/$orgId/configuration/claims-products/products-v2/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute;
    };
    '/console/$orgId/configuration/claims-products/questionnaire/add': {
      id: '/console/$orgId/configuration/claims-products/questionnaire/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/questionnaire/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute;
    };
    '/console/$orgId/configuration/compliance/attestations/user-attestations': {
      id: '/console/$orgId/configuration/compliance/attestations/user-attestations';
      path: '/user-attestations';
      fullPath: '/console/$orgId/configuration/compliance/attestations/user-attestations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/': {
      id: '/console/$orgId/configuration/compliance/complaints/';
      path: '/';
      fullPath: '/console/$orgId/configuration/compliance/complaints/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/brands': {
      id: '/console/$orgId/configuration/compliance/complaints/brands';
      path: '/brands';
      fullPath: '/console/$orgId/configuration/compliance/complaints/brands';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsBrandsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/custom-fields': {
      id: '/console/$orgId/configuration/compliance/complaints/custom-fields';
      path: '/custom-fields';
      fullPath: '/console/$orgId/configuration/compliance/complaints/custom-fields';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/flags': {
      id: '/console/$orgId/configuration/compliance/complaints/flags';
      path: '/flags';
      fullPath: '/console/$orgId/configuration/compliance/complaints/flags';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/general': {
      id: '/console/$orgId/configuration/compliance/complaints/general';
      path: '/general';
      fullPath: '/console/$orgId/configuration/compliance/complaints/general';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsGeneralRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/rules': {
      id: '/console/$orgId/configuration/compliance/complaints/rules';
      path: '/rules';
      fullPath: '/console/$orgId/configuration/compliance/complaints/rules';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRulesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/general/': {
      id: '/console/$orgId/configuration/compliance/general/';
      path: '/';
      fullPath: '/console/$orgId/configuration/compliance/general/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/general/asic-products': {
      id: '/console/$orgId/configuration/compliance/general/asic-products';
      path: '/asic-products';
      fullPath: '/console/$orgId/configuration/compliance/general/asic-products';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/general/documents': {
      id: '/console/$orgId/configuration/compliance/general/documents';
      path: '/documents';
      fullPath: '/console/$orgId/configuration/compliance/general/documents';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralDocumentsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/': {
      id: '/console/$orgId/configuration/compliance/incidents/';
      path: '/';
      fullPath: '/console/$orgId/configuration/compliance/incidents/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/custom-fields': {
      id: '/console/$orgId/configuration/compliance/incidents/custom-fields';
      path: '/custom-fields';
      fullPath: '/console/$orgId/configuration/compliance/incidents/custom-fields';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/flags': {
      id: '/console/$orgId/configuration/compliance/incidents/flags';
      path: '/flags';
      fullPath: '/console/$orgId/configuration/compliance/incidents/flags';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/general': {
      id: '/console/$orgId/configuration/compliance/incidents/general';
      path: '/general';
      fullPath: '/console/$orgId/configuration/compliance/incidents/general';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/rules': {
      id: '/console/$orgId/configuration/compliance/incidents/rules';
      path: '/rules';
      fullPath: '/console/$orgId/configuration/compliance/incidents/rules';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRulesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/critical-operations': {
      id: '/console/$orgId/configuration/compliance/mspr/critical-operations';
      path: '/critical-operations';
      fullPath: '/console/$orgId/configuration/compliance/mspr/critical-operations';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/definitions': {
      id: '/console/$orgId/configuration/compliance/mspr/definitions';
      path: '/definitions';
      fullPath: '/console/$orgId/configuration/compliance/mspr/definitions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/documents': {
      id: '/console/$orgId/configuration/compliance/mspr/documents';
      path: '/documents';
      fullPath: '/console/$orgId/configuration/compliance/mspr/documents';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDocumentsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/governance-config': {
      id: '/console/$orgId/configuration/compliance/mspr/governance-config';
      path: '/governance-config';
      fullPath: '/console/$orgId/configuration/compliance/mspr/governance-config';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprRouteRoute;
    };
    '/console/$orgId/configuration/compliance/training/': {
      id: '/console/$orgId/configuration/compliance/training/';
      path: '/';
      fullPath: '/console/$orgId/configuration/compliance/training/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRoute;
    };
    '/console/$orgId/configuration/compliance/training/custom-fields': {
      id: '/console/$orgId/configuration/compliance/training/custom-fields';
      path: '/custom-fields';
      fullPath: '/console/$orgId/configuration/compliance/training/custom-fields';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRoute;
    };
    '/console/$orgId/configuration/compliance/training/training-periods': {
      id: '/console/$orgId/configuration/compliance/training/training-periods';
      path: '/training-periods';
      fullPath: '/console/$orgId/configuration/compliance/training/training-periods';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing/balance': {
      id: '/console/$orgId/configuration/financials/billing/balance';
      path: '/balance';
      fullPath: '/console/$orgId/configuration/financials/billing/balance';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingBalanceRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing/billing-info': {
      id: '/console/$orgId/configuration/financials/billing/billing-info';
      path: '/billing-info';
      fullPath: '/console/$orgId/configuration/financials/billing/billing-info';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing/invoices': {
      id: '/console/$orgId/configuration/financials/billing/invoices';
      path: '/invoices';
      fullPath: '/console/$orgId/configuration/financials/billing/invoices';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingInvoicesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing/transactions': {
      id: '/console/$orgId/configuration/financials/billing/transactions';
      path: '/transactions';
      fullPath: '/console/$orgId/configuration/financials/billing/transactions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingTransactionsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing/usage': {
      id: '/console/$orgId/configuration/financials/billing/usage';
      path: '/usage';
      fullPath: '/console/$orgId/configuration/financials/billing/usage';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingUsageRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/add': {
      id: '/console/$orgId/configuration/fleet/client-database/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/fleet/client-database/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication/comm-signatures': {
      id: '/console/$orgId/configuration/org-settings/communication/comm-signatures';
      path: '/comm-signatures';
      fullPath: '/console/$orgId/configuration/org-settings/communication/comm-signatures';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication/comm-templates': {
      id: '/console/$orgId/configuration/org-settings/communication/comm-templates';
      path: '/comm-templates';
      fullPath: '/console/$orgId/configuration/org-settings/communication/comm-templates';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/handling-parties/add': {
      id: '/console/$orgId/configuration/org-settings/handling-parties/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/org-settings/handling-parties/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/users/': {
      id: '/console/$orgId/configuration/org-settings/users/';
      path: '/';
      fullPath: '/console/$orgId/configuration/org-settings/users/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/';
      path: '/';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/add': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/definitions': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/definitions';
      path: '/definitions';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/definitions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/controls/register/details/$id': {
      id: '/console/$orgId/controls/register/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/controls/register/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterRouteRoute;
    };
    '/console/$orgId/fleet-portal/claims/details/$claimId': {
      id: '/console/$orgId/fleet-portal/claims/details/$claimId';
      path: '/details/$claimId';
      fullPath: '/console/$orgId/fleet-portal/claims/details/$claimId';
      preLoaderRoute: typeof ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRouteImport;
      parentRoute: typeof ConsoleOrgIdFleetPortalClaimsRouteRoute;
    };
    '/console/$orgId/mspr/msp-exceptions/edit/$id': {
      id: '/console/$orgId/mspr/msp-exceptions/edit/$id';
      path: '/edit/$id';
      fullPath: '/console/$orgId/mspr/msp-exceptions/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdMsprMspExceptionsEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprMspExceptionsRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id': {
      id: '/console/$orgId/mspr/service-providers/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/search/add': {
      id: '/console/$orgId/mspr/service-providers/search/add';
      path: '/add';
      fullPath: '/console/$orgId/mspr/service-providers/search/add';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersSearchAddRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersSearchRouteRoute;
    };
    '/console/$orgId/risk/ras/details/$id': {
      id: '/console/$orgId/risk/ras/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/risk/ras/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdRiskRasDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRasRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id': {
      id: '/console/$orgId/risk/register/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/risk/register/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/details/$complianceAuditId': {
      id: '/console/$orgId/tools/compliance-audit/details/$complianceAuditId';
      path: '/details/$complianceAuditId';
      fullPath: '/console/$orgId/tools/compliance-audit/details/$complianceAuditId';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/overview/': {
      id: '/console/$orgId/tools/compliance-audit/overview/';
      path: '/';
      fullPath: '/console/$orgId/tools/compliance-audit/overview/';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/overview/insights': {
      id: '/console/$orgId/tools/compliance-audit/overview/insights';
      path: '/insights';
      fullPath: '/console/$orgId/tools/compliance-audit/overview/insights';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewInsightsRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/overview/search': {
      id: '/console/$orgId/tools/compliance-audit/overview/search';
      path: '/search';
      fullPath: '/console/$orgId/tools/compliance-audit/overview/search';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute;
    };
    '/console/$orgId/tools/website-checker/report/$id': {
      id: '/console/$orgId/tools/website-checker/report/$id';
      path: '/report/$id';
      fullPath: '/console/$orgId/tools/website-checker/report/$id';
      preLoaderRoute: typeof ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsWebsiteCheckerRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar/add': {
      id: '/console/$orgId/workload-manager/tasks/calendar/add';
      path: '/add';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar/add';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarAddRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/list/add': {
      id: '/console/$orgId/workload-manager/tasks/list/add';
      path: '/add';
      fullPath: '/console/$orgId/workload-manager/tasks/list/add';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksListAddRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksListRouteRoute;
    };
    '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId': {
      id: '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId';
      path: '/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId';
      fullPath: '/public/claim-lodgement/$orgId/$pdsVersionId/$questionnaireId/$productTypeId';
      preLoaderRoute: typeof PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport;
      parentRoute: typeof PublicRouteRoute;
    };
    '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId': {
      id: '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId';
      path: '/edit/$userId';
      fullPath: '/admin-console/organisation-management/organisations/$orgId/users/edit/$userId';
      preLoaderRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRouteImport;
      parentRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add';
      path: '/add';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/add';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add';
      path: '/add';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute;
    };
    '/admin-console/platform-content/obligations/library/details/$id/ai-related': {
      id: '/admin-console/platform-content/obligations/library/details/$id/ai-related';
      path: '/ai-related';
      fullPath: '/admin-console/platform-content/obligations/library/details/$id/ai-related';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute;
    };
    '/admin-console/platform-content/obligations/library/details/$id/document-analyser': {
      id: '/admin-console/platform-content/obligations/library/details/$id/document-analyser';
      path: '/document-analyser';
      fullPath: '/admin-console/platform-content/obligations/library/details/$id/document-analyser';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute;
    };
    '/admin-console/platform-content/obligations/library/details/$id/history': {
      id: '/admin-console/platform-content/obligations/library/details/$id/history';
      path: '/history';
      fullPath: '/admin-console/platform-content/obligations/library/details/$id/history';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute;
    };
    '/admin-console/platform-content/obligations/library/details/$id/manage': {
      id: '/admin-console/platform-content/obligations/library/details/$id/manage';
      path: '/manage';
      fullPath: '/admin-console/platform-content/obligations/library/details/$id/manage';
      preLoaderRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdManageRouteImport;
      parentRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/comms/add': {
      id: '/console/$orgId/claims/details/$id/comms/add';
      path: '/add';
      fullPath: '/console/$orgId/claims/details/$id/comms/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/contacts/add': {
      id: '/console/$orgId/claims/details/$id/contacts/add';
      path: '/add';
      fullPath: '/console/$orgId/claims/details/$id/contacts/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/expenses/add': {
      id: '/console/$orgId/claims/details/$id/expenses/add';
      path: '/add';
      fullPath: '/console/$orgId/claims/details/$id/expenses/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute;
    };
    '/console/$orgId/compliance/coi/details/$id/': {
      id: '/console/$orgId/compliance/coi/details/$id/';
      path: '/';
      fullPath: '/console/$orgId/compliance/coi/details/$id/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/coi/details/$id/library': {
      id: '/console/$orgId/compliance/coi/details/$id/library';
      path: '/library';
      fullPath: '/console/$orgId/compliance/coi/details/$id/library';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdLibraryRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/coi/details/$id/manage': {
      id: '/console/$orgId/compliance/coi/details/$id/manage';
      path: '/manage';
      fullPath: '/console/$orgId/compliance/coi/details/$id/manage';
      preLoaderRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdManageRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/': {
      id: '/console/$orgId/compliance/complaints/details/$id/';
      path: '/';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/comms': {
      id: '/console/$orgId/compliance/complaints/details/$id/comms';
      path: '/comms';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/comms';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/history': {
      id: '/console/$orgId/compliance/complaints/details/$id/history';
      path: '/history';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/history';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/library': {
      id: '/console/$orgId/compliance/complaints/details/$id/library';
      path: '/library';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/library';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/manage': {
      id: '/console/$orgId/compliance/complaints/details/$id/manage';
      path: '/manage';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/manage';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id/': {
      id: '/console/$orgId/compliance/incidents/details/$id/';
      path: '/';
      fullPath: '/console/$orgId/compliance/incidents/details/$id/';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id/history': {
      id: '/console/$orgId/compliance/incidents/details/$id/history';
      path: '/history';
      fullPath: '/console/$orgId/compliance/incidents/details/$id/history';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id/library': {
      id: '/console/$orgId/compliance/incidents/details/$id/library';
      path: '/library';
      fullPath: '/console/$orgId/compliance/incidents/details/$id/library';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id/manage': {
      id: '/console/$orgId/compliance/incidents/details/$id/manage';
      path: '/manage';
      fullPath: '/console/$orgId/compliance/incidents/details/$id/manage';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/obligations/details/$id/debug': {
      id: '/console/$orgId/compliance/obligations/details/$id/debug';
      path: '/debug';
      fullPath: '/console/$orgId/compliance/obligations/details/$id/debug';
      preLoaderRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdDebugRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/obligations/details/$id/manage': {
      id: '/console/$orgId/compliance/obligations/details/$id/manage';
      path: '/manage';
      fullPath: '/console/$orgId/compliance/obligations/details/$id/manage';
      preLoaderRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdManageRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute;
    };
    '/console/$orgId/compliance/registers/$registerId/records/$recordId': {
      id: '/console/$orgId/compliance/registers/$registerId/records/$recordId';
      path: '/records/$recordId';
      fullPath: '/console/$orgId/compliance/registers/$registerId/records/$recordId';
      preLoaderRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute;
    };
    '/console/$orgId/compliance/training/user/$userId/add': {
      id: '/console/$orgId/compliance/training/user/$userId/add';
      path: '/add';
      fullPath: '/console/$orgId/compliance/training/user/$userId/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdAddRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute;
    };
    '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/': {
      id: '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/';
      path: '/';
      fullPath: '/console/$orgId/configuration/api-integrations/form-designer/$formDefinitionId/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add': {
      id: '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/claims/catastrophe-events/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/claim-flags/add': {
      id: '/console/$orgId/configuration/claims-products/claims/claim-flags/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/claims/claim-flags/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/';
      path: '/';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/search': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/search';
      path: '/search';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/search';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine';
      path: '/decision-engine';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId': {
      id: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId';
      path: '/edit/$productTypeId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id';
      path: '/financials/$id';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/states/$id': {
      id: '/console/$orgId/configuration/claims-products/product-types/states/$id';
      path: '/states/$id';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/states/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId';
      path: '/details/$productId';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/edit/$productId': {
      id: '/console/$orgId/configuration/claims-products/products-v2/edit/$productId';
      path: '/edit/$productId';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/edit/$productId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute;
    };
    '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId': {
      id: '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId';
      path: '/edit/$questionnaireId';
      fullPath: '/console/$orgId/configuration/claims-products/questionnaire/edit/$questionnaireId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute;
    };
    '/console/$orgId/configuration/compliance/attestations/user-attestations/add': {
      id: '/console/$orgId/configuration/compliance/attestations/user-attestations/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/compliance/attestations/user-attestations/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/flags/add': {
      id: '/console/$orgId/configuration/compliance/complaints/flags/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/compliance/complaints/flags/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/flags/add': {
      id: '/console/$orgId/configuration/compliance/incidents/flags/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/compliance/incidents/flags/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/general/': {
      id: '/console/$orgId/configuration/compliance/incidents/general/';
      path: '/';
      fullPath: '/console/$orgId/configuration/compliance/incidents/general/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/general/incident-details': {
      id: '/console/$orgId/configuration/compliance/incidents/general/incident-details';
      path: '/incident-details';
      fullPath: '/console/$orgId/configuration/compliance/incidents/general/incident-details';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/general/lodgement': {
      id: '/console/$orgId/configuration/compliance/incidents/general/lodgement';
      path: '/lodgement';
      fullPath: '/console/$orgId/configuration/compliance/incidents/general/lodgement';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/general/rectification': {
      id: '/console/$orgId/configuration/compliance/incidents/general/rectification';
      path: '/rectification';
      fullPath: '/console/$orgId/configuration/compliance/incidents/general/rectification';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/general/timeline': {
      id: '/console/$orgId/configuration/compliance/incidents/general/timeline';
      path: '/timeline';
      fullPath: '/console/$orgId/configuration/compliance/incidents/general/timeline';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/governance-config/add': {
      id: '/console/$orgId/configuration/compliance/mspr/governance-config/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/compliance/mspr/governance-config/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute;
    };
    '/console/$orgId/configuration/financials/billing/payment/success': {
      id: '/console/$orgId/configuration/financials/billing/payment/success';
      path: '/payment/success';
      fullPath: '/console/$orgId/configuration/financials/billing/payment/success';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/details/$id': {
      id: '/console/$orgId/configuration/fleet/client-database/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/configuration/fleet/client-database/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication/comm-signatures/add': {
      id: '/console/$orgId/configuration/org-settings/communication/comm-signatures/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/org-settings/communication/comm-signatures/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication/comm-templates/add': {
      id: '/console/$orgId/configuration/org-settings/communication/comm-templates/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/org-settings/communication/comm-templates/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/handling-parties/details/$id': {
      id: '/console/$orgId/configuration/org-settings/handling-parties/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/configuration/org-settings/handling-parties/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/users/details/$userId': {
      id: '/console/$orgId/configuration/org-settings/users/details/$userId';
      path: '/details/$userId';
      fullPath: '/console/$orgId/configuration/org-settings/users/details/$userId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/list/': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/list/';
      path: '/list';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/list/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/search/': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/search/';
      path: '/search';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/search/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/search/definitions': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/search/definitions';
      path: '/search/definitions';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/search/definitions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/search/list': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/search/list';
      path: '/search/list';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/search/list';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/history': {
      id: '/console/$orgId/mspr/service-providers/details/$id/history';
      path: '/history';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/history';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/library': {
      id: '/console/$orgId/mspr/service-providers/details/$id/library';
      path: '/library';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/library';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/manage': {
      id: '/console/$orgId/mspr/service-providers/details/$id/manage';
      path: '/manage';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/manage';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id/action-plan': {
      id: '/console/$orgId/risk/register/details/$id/action-plan';
      path: '/action-plan';
      fullPath: '/console/$orgId/risk/register/details/$id/action-plan';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id/assessment': {
      id: '/console/$orgId/risk/register/details/$id/assessment';
      path: '/assessment';
      fullPath: '/console/$orgId/risk/register/details/$id/assessment';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id/history': {
      id: '/console/$orgId/risk/register/details/$id/history';
      path: '/history';
      fullPath: '/console/$orgId/risk/register/details/$id/history';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdHistoryRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification': {
      id: '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification';
      path: '/$id/review-email-classification';
      fullPath: '/console/$orgId/tools/auto-detect/inbox/$id/review-email-classification';
      preLoaderRoute: typeof ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsAutoDetectInboxRouteRoute;
    };
    '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics': {
      id: '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics';
      path: '/statistics';
      fullPath: '/console/$orgId/tools/compliance-audit/details/$complianceAuditId/statistics';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute;
    };
    '/console/$orgId/tools/compliance-audit/overview/search/add': {
      id: '/console/$orgId/tools/compliance-audit/overview/search/add';
      path: '/add';
      fullPath: '/console/$orgId/tools/compliance-audit/overview/search/add';
      preLoaderRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute;
    };
    '/console/$orgId/tools/document-analyzer/history/$id/results': {
      id: '/console/$orgId/tools/document-analyzer/history/$id/results';
      path: '/$id/results';
      fullPath: '/console/$orgId/tools/document-analyzer/history/$id/results';
      preLoaderRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute;
    };
    '/console/$orgId/tools/pds-compare/pds-documents/edit/$id': {
      id: '/console/$orgId/tools/pds-compare/pds-documents/edit/$id';
      path: '/edit/$id';
      fullPath: '/console/$orgId/tools/pds-compare/pds-documents/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar/details/$id': {
      id: '/console/$orgId/workload-manager/tasks/calendar/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/list/details/$id': {
      id: '/console/$orgId/workload-manager/tasks/list/details/$id';
      path: '/details/$id';
      fullPath: '/console/$orgId/workload-manager/tasks/list/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksListDetailsIdRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksListRouteRoute;
    };
    '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId': {
      id: '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId';
      path: '/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId';
      fullPath: '/public/$orgId/claim/lodgement-lookup/$pdsVersionId/$questionnaireId/$productTypeId';
      preLoaderRoute: typeof PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport;
      parentRoute: typeof PublicOrgIdRouteRoute;
    };
    '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId': {
      id: '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId';
      path: '/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId';
      fullPath: '/public/$orgId/claim/lodgement/$pdsVersionId/$questionnaireId/$productTypeId';
      preLoaderRoute: typeof PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRouteImport;
      parentRoute: typeof PublicOrgIdRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId';
      path: '/edit/$complianceAuditTemplateEvidenceTypeId';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/evidence-types/edit/$complianceAuditTemplateEvidenceTypeId';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute;
    };
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId': {
      id: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId';
      path: '/edit/$complianceAuditTemplatePrincipleId';
      fullPath: '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/edit/$complianceAuditTemplatePrincipleId';
      preLoaderRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRouteImport;
      parentRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute;
    };
    '/console/$orgId/claims/details/$id/activity/add/phone': {
      id: '/console/$orgId/claims/details/$id/activity/add/phone';
      path: '/add/phone';
      fullPath: '/console/$orgId/claims/details/$id/activity/add/phone';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRoute;
    };
    '/console/$orgId/claims/details/$id/comms/add/email': {
      id: '/console/$orgId/claims/details/$id/comms/add/email';
      path: '/email';
      fullPath: '/console/$orgId/claims/details/$id/comms/add/email';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddEmailRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute;
    };
    '/console/$orgId/claims/details/$id/comms/add/sms': {
      id: '/console/$orgId/claims/details/$id/comms/add/sms';
      path: '/sms';
      fullPath: '/console/$orgId/claims/details/$id/comms/add/sms';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddSmsRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute;
    };
    '/console/$orgId/claims/details/$id/comms/message/$messageId': {
      id: '/console/$orgId/claims/details/$id/comms/message/$messageId';
      path: '/message/$messageId';
      fullPath: '/console/$orgId/claims/details/$id/comms/message/$messageId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/comms/reply/$messageId': {
      id: '/console/$orgId/claims/details/$id/comms/reply/$messageId';
      path: '/reply/$messageId';
      fullPath: '/console/$orgId/claims/details/$id/comms/reply/$messageId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/contacts/edit/$contactId': {
      id: '/console/$orgId/claims/details/$id/contacts/edit/$contactId';
      path: '/edit/$contactId';
      fullPath: '/console/$orgId/claims/details/$id/contacts/edit/$contactId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId': {
      id: '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId';
      path: '/edit/$expenseItemId';
      fullPath: '/console/$orgId/claims/details/$id/expenses/edit/$expenseItemId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/add': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/add';
      path: '/compensations/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/excesses/add': {
      id: '/console/$orgId/claims/details/$id/financials/excesses/add';
      path: '/excesses/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/excesses/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/reserves/add': {
      id: '/console/$orgId/claims/details/$id/financials/reserves/add';
      path: '/reserves/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/reserves/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/manage/strategies/add': {
      id: '/console/$orgId/claims/details/$id/manage/strategies/add';
      path: '/strategies/add';
      fullPath: '/console/$orgId/claims/details/$id/manage/strategies/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/claims/details/$id/manage/supplier-jobs/add': {
      id: '/console/$orgId/claims/details/$id/manage/supplier-jobs/add';
      path: '/supplier-jobs/add';
      fullPath: '/console/$orgId/claims/details/$id/manage/supplier-jobs/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier': {
      id: '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier';
      path: '/supplier-jobs/add-supplier';
      fullPath: '/console/$orgId/claims/details/$id/manage/supplier-jobs/add-supplier';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/manage/incidents': {
      id: '/console/$orgId/compliance/complaints/details/$id/manage/incidents';
      path: '/incidents';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/manage/incidents';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id/manage/complaints': {
      id: '/console/$orgId/compliance/incidents/details/$id/manage/complaints';
      path: '/complaints';
      fullPath: '/console/$orgId/compliance/incidents/details/$id/manage/complaints';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/compliance/training/user/$userId/edit/$recordId': {
      id: '/console/$orgId/compliance/training/user/$userId/edit/$recordId';
      path: '/edit/$recordId';
      fullPath: '/console/$orgId/compliance/training/user/$userId/edit/$recordId';
      preLoaderRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId': {
      id: '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId';
      path: '/edit/$catastropheEventId';
      fullPath: '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId': {
      id: '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId';
      path: '/edit/$claimFlagId';
      fullPath: '/console/$orgId/configuration/claims-products/claims/claim-flags/edit/$claimFlagId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add': {
      id: '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add';
      path: '/claim-statuses/add';
      fullPath: '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/search/add': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/search/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/search/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions';
      path: '/conditions';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/conditions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions';
      path: '/exclusions';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/exclusions';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide';
      path: '/guide';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/guide';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses';
      path: '/limits-excesses';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/limits-excesses';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes';
      path: '/loss-causes';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/loss-causes';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview';
      path: '/overview';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/overview';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping';
      path: '/policy-trigger-mapping';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/policy-trigger-mapping';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info';
      path: '/product-info';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/product-info';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags';
      path: '/red-flags';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/decision-engine/red-flags';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId';
      path: '/edit/$pdsId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/edit/$pdsId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId';
      path: '/pds-text/$pdsId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds-text/$pdsId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId': {
      id: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId';
      path: '/pds/$pdsId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/$productTypeId/pds/$pdsId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields': {
      id: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields';
      path: '/data-fields';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/data-fields';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields': {
      id: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields';
      path: '/policy-fields';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type': {
      id: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type';
      path: '/third-party-contact-type';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes';
      path: '/cost-codes';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections';
      path: '/sections';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax';
      path: '/tax';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types';
      path: '/transaction-types';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute;
    };
    '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id': {
      id: '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id';
      path: '/edit/$id';
      fullPath: '/console/$orgId/configuration/compliance/attestations/user-attestations/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId': {
      id: '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId';
      path: '/edit/$complaintFlagId';
      fullPath: '/console/$orgId/configuration/compliance/complaints/flags/edit/$complaintFlagId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId': {
      id: '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId';
      path: '/edit/$incidentFlagId';
      fullPath: '/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add': {
      id: '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add';
      path: '/identified/add';
      fullPath: '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/definitions/categories/add': {
      id: '/console/$orgId/configuration/compliance/mspr/definitions/categories/add';
      path: '/categories/add';
      fullPath: '/console/$orgId/configuration/compliance/mspr/definitions/categories/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id': {
      id: '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id';
      path: '/edit/$id';
      fullPath: '/console/$orgId/configuration/compliance/mspr/governance-config/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/details/$id/clients': {
      id: '/console/$orgId/configuration/fleet/client-database/details/$id/clients';
      path: '/clients';
      fullPath: '/console/$orgId/configuration/fleet/client-database/details/$id/clients';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/details/$id/drivers': {
      id: '/console/$orgId/configuration/fleet/client-database/details/$id/drivers';
      path: '/drivers';
      fullPath: '/console/$orgId/configuration/fleet/client-database/details/$id/drivers';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/details/$id/overview': {
      id: '/console/$orgId/configuration/fleet/client-database/details/$id/overview';
      path: '/overview';
      fullPath: '/console/$orgId/configuration/fleet/client-database/details/$id/overview';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access': {
      id: '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access';
      path: '/portal-access';
      fullPath: '/console/$orgId/configuration/fleet/client-database/details/$id/portal-access';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles': {
      id: '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles';
      path: '/vehicles';
      fullPath: '/console/$orgId/configuration/fleet/client-database/details/$id/vehicles';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId': {
      id: '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId';
      path: '/edit/$commSignatureId';
      fullPath: '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId': {
      id: '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId';
      path: '/edit/$communicationTemplateId';
      fullPath: '/console/$orgId/configuration/org-settings/communication/comm-templates/edit/$communicationTemplateId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute;
    };
    '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users': {
      id: '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users';
      path: '/users';
      fullPath: '/console/$orgId/configuration/org-settings/handling-parties/details/$id/users';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/details/$id/': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/details/$id/';
      path: '/details/$id';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/details/$id/';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$';
      path: '/details/$id/$';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/details/$id/$';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id';
      path: '/list/details/$id';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute;
    };
    '/console/$orgId/controls/register/details/$id/activity/$activityId': {
      id: '/console/$orgId/controls/register/details/$id/activity/$activityId';
      path: '/activity/$activityId';
      fullPath: '/console/$orgId/controls/register/details/$id/activity/$activityId';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/controls/register/details/$id/activity/add': {
      id: '/console/$orgId/controls/register/details/$id/activity/add';
      path: '/activity/add';
      fullPath: '/console/$orgId/controls/register/details/$id/activity/add';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/controls/register/details/$id/test/$testId': {
      id: '/console/$orgId/controls/register/details/$id/test/$testId';
      path: '/test/$testId';
      fullPath: '/console/$orgId/controls/register/details/$id/test/$testId';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/controls/register/details/$id/test/add': {
      id: '/console/$orgId/controls/register/details/$id/test/add';
      path: '/test/add';
      fullPath: '/console/$orgId/controls/register/details/$id/test/add';
      preLoaderRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/manage/add': {
      id: '/console/$orgId/mspr/service-providers/details/$id/manage/add';
      path: '/add';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/manage/add';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id/assessment/incidents': {
      id: '/console/$orgId/risk/register/details/$id/assessment/incidents';
      path: '/incidents';
      fullPath: '/console/$orgId/risk/register/details/$id/assessment/incidents';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id': {
      id: '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id';
      path: '/details/control_activity/$id';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar/details/control_activity/$id';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id': {
      id: '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id';
      path: '/details/control_test/$id';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar/details/control_test/$id';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id': {
      id: '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id';
      path: '/details/msp_governance_check/$id';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar/details/msp_governance_check/$id';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute;
    };
    '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id': {
      id: '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id';
      path: '/details/risk_action/$id';
      fullPath: '/console/$orgId/workload-manager/tasks/calendar/details/risk_action/$id';
      preLoaderRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRouteImport;
      parentRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute;
    };
    '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId': {
      id: '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId';
      path: '/edit/phone/$callLogId';
      fullPath: '/console/$orgId/claims/details/$id/activity/edit/phone/$callLogId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRoute;
    };
    '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId': {
      id: '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId';
      path: '/suppliers/details/$supplierId';
      fullPath: '/console/$orgId/claims/details/$id/contacts/suppliers/details/$supplierId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId': {
      id: '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId';
      path: '/suppliers/reassign/$supplierId';
      fullPath: '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId';
      path: '/compensations/details/$compensationId';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId': {
      id: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId';
      path: '/excesses/details/$excessId';
      fullPath: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId': {
      id: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId';
      path: '/reserves/details/$reserveId';
      fullPath: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId': {
      id: '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId';
      path: '/supplier-jobs/edit/$jobId';
      fullPath: '/console/$orgId/claims/details/$id/manage/supplier-jobs/edit/$jobId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/compliance/complaints/details/$id/manage/note/add': {
      id: '/console/$orgId/compliance/complaints/details/$id/manage/note/add';
      path: '/note/add';
      fullPath: '/console/$orgId/compliance/complaints/details/$id/manage/note/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/compliance/incidents/details/$id/manage/note/add': {
      id: '/console/$orgId/compliance/incidents/details/$id/manage/note/add';
      path: '/note/add';
      fullPath: '/console/$orgId/compliance/incidents/details/$id/manage/note/add';
      preLoaderRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId': {
      id: '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId';
      path: '/claim-statuses/edit/$claimStatusId';
      fullPath: '/console/$orgId/configuration/claims-products/claims/general/claim-statuses/edit/$claimStatusId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks';
      path: '/$taskListId/tasks';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id';
      path: '/edit/$id';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/search/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add': {
      id: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id': {
      id: '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id';
      path: '/excluded/edit/$id';
      fullPath: '/console/$orgId/configuration/compliance/mspr/critical-operations/excluded/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id': {
      id: '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id';
      path: '/identified/edit/$id';
      fullPath: '/console/$orgId/configuration/compliance/mspr/critical-operations/identified/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute;
    };
    '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id': {
      id: '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id';
      path: '/categories/edit/$id';
      fullPath: '/console/$orgId/configuration/compliance/mspr/definitions/categories/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId': {
      id: '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId';
      path: '/check/$checkId';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/manage/check/$checkId';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/manage/check/add': {
      id: '/console/$orgId/mspr/service-providers/details/$id/manage/check/add';
      path: '/check/add';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/manage/check/add';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute;
    };
    '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId': {
      id: '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId';
      path: '/edit/$arrangementId';
      fullPath: '/console/$orgId/mspr/service-providers/details/$id/manage/edit/$arrangementId';
      preLoaderRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRouteImport;
      parentRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId': {
      id: '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId';
      path: '/action-plan/$actionPlanId';
      fullPath: '/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute;
    };
    '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add': {
      id: '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add';
      path: '/action-plan/add';
      fullPath: '/console/$orgId/risk/register/details/$id/action-plan/action-plan/add';
      preLoaderRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute;
    };
    '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add': {
      id: '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add';
      path: '/add';
      fullPath: '/console/$orgId/claims/details/$id/contacts/suppliers/reassign/$supplierId/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add';
      path: '/compensation-payments/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/add/compensation-payments/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add';
      path: '/excess-payments/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/add/excess-payments/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add';
      path: '/suppliers/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/add/suppliers/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials';
      path: '/financials';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library';
      path: '/library';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee';
      path: '/payee';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payee';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment';
      path: '/payment';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/payment';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library': {
      id: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library';
      path: '/library';
      fullPath: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/library';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage': {
      id: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage';
      path: '/manage';
      fullPath: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments': {
      id: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments';
      path: '/payments';
      fullPath: '/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/payments';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments': {
      id: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments';
      path: '/compensation-payments';
      fullPath: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/compensation-payments';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library': {
      id: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library';
      path: '/library';
      fullPath: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/library';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments': {
      id: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments';
      path: '/reserve-adjustments';
      fullPath: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId': {
      id: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId';
      path: '/edit/$thirdPartyContactTypeId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/third-party-contact-type/edit/$thirdPartyContactTypeId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId': {
      id: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId';
      path: '/edit/$transactionTypeId';
      fullPath: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types/edit/$transactionTypeId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId';
      path: '/product-versions/details/$productVersionId';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add';
      path: '/contacts/add';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add': {
      id: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add';
      path: '/add';
      fullPath: '/console/$orgId/claims/details/$id/financials/reserves/details/$reserveId/reserve-adjustments/add';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id': {
      id: '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id';
      path: '/edit/$id';
      fullPath: '/console/$orgId/configuration/claims-products/claims/task-lists/search/$taskListId/tasks/edit/$id';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types';
      path: '/contact-types';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details';
      path: '/details';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/details';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents';
      path: '/documents';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/documents';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields';
      path: '/fields';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/fields';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute;
    };
    '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId': {
      id: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId';
      path: '/contacts/edit/$contactId';
      fullPath: '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add';
      path: '/add';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/add';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId';
      path: '/compensation-payments/details/$compensationPaymentId';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/compensation-payments/details/$compensationPaymentId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute;
    };
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId': {
      id: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId';
      path: '/excess-payments/details/$excessPaymentId';
      fullPath: '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/financials/excess-payments/details/$excessPaymentId';
      preLoaderRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRouteImport;
      parentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute;
    };
    '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId': {
      id: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId';
      path: '/edit/$contactTypeId';
      fullPath: '/console/$orgId/configuration/claims-products/products-v2/details/$productId/product-versions/details/$productVersionId/contact-types/edit/$contactTypeId';
      preLoaderRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRouteImport;
      parentRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute;
    };
  }
}

interface AdminConsoleAdvancedAppSettingsAllRouteRouteChildren {
  AdminConsoleAdvancedAppSettingsAllAddRoute: typeof AdminConsoleAdvancedAppSettingsAllAddRoute;
  AdminConsoleAdvancedAppSettingsAllEditNameRoute: typeof AdminConsoleAdvancedAppSettingsAllEditNameRoute;
}

const AdminConsoleAdvancedAppSettingsAllRouteRouteChildren: AdminConsoleAdvancedAppSettingsAllRouteRouteChildren =
  {
    AdminConsoleAdvancedAppSettingsAllAddRoute:
      AdminConsoleAdvancedAppSettingsAllAddRoute,
    AdminConsoleAdvancedAppSettingsAllEditNameRoute:
      AdminConsoleAdvancedAppSettingsAllEditNameRoute,
  };

const AdminConsoleAdvancedAppSettingsAllRouteRouteWithChildren =
  AdminConsoleAdvancedAppSettingsAllRouteRoute._addFileChildren(
    AdminConsoleAdvancedAppSettingsAllRouteRouteChildren,
  );

interface AdminConsoleAdvancedAppSettingsRouteRouteChildren {
  AdminConsoleAdvancedAppSettingsAllRouteRoute: typeof AdminConsoleAdvancedAppSettingsAllRouteRouteWithChildren;
  AdminConsoleAdvancedAppSettingsWellKnownRoute: typeof AdminConsoleAdvancedAppSettingsWellKnownRoute;
}

const AdminConsoleAdvancedAppSettingsRouteRouteChildren: AdminConsoleAdvancedAppSettingsRouteRouteChildren =
  {
    AdminConsoleAdvancedAppSettingsAllRouteRoute:
      AdminConsoleAdvancedAppSettingsAllRouteRouteWithChildren,
    AdminConsoleAdvancedAppSettingsWellKnownRoute:
      AdminConsoleAdvancedAppSettingsWellKnownRoute,
  };

const AdminConsoleAdvancedAppSettingsRouteRouteWithChildren =
  AdminConsoleAdvancedAppSettingsRouteRoute._addFileChildren(
    AdminConsoleAdvancedAppSettingsRouteRouteChildren,
  );

interface AdminConsoleAdvancedInboundParseRouteRouteChildren {
  AdminConsoleAdvancedInboundParseIndexRoute: typeof AdminConsoleAdvancedInboundParseIndexRoute;
}

const AdminConsoleAdvancedInboundParseRouteRouteChildren: AdminConsoleAdvancedInboundParseRouteRouteChildren =
  {
    AdminConsoleAdvancedInboundParseIndexRoute:
      AdminConsoleAdvancedInboundParseIndexRoute,
  };

const AdminConsoleAdvancedInboundParseRouteRouteWithChildren =
  AdminConsoleAdvancedInboundParseRouteRoute._addFileChildren(
    AdminConsoleAdvancedInboundParseRouteRouteChildren,
  );

interface AdminConsoleAdvancedIndicatorsRouteRouteChildren {
  AdminConsoleAdvancedIndicatorsComplaintsRoute: typeof AdminConsoleAdvancedIndicatorsComplaintsRoute;
  AdminConsoleAdvancedIndicatorsIncidentsRoute: typeof AdminConsoleAdvancedIndicatorsIncidentsRoute;
}

const AdminConsoleAdvancedIndicatorsRouteRouteChildren: AdminConsoleAdvancedIndicatorsRouteRouteChildren =
  {
    AdminConsoleAdvancedIndicatorsComplaintsRoute:
      AdminConsoleAdvancedIndicatorsComplaintsRoute,
    AdminConsoleAdvancedIndicatorsIncidentsRoute:
      AdminConsoleAdvancedIndicatorsIncidentsRoute,
  };

const AdminConsoleAdvancedIndicatorsRouteRouteWithChildren =
  AdminConsoleAdvancedIndicatorsRouteRoute._addFileChildren(
    AdminConsoleAdvancedIndicatorsRouteRouteChildren,
  );

interface AdminConsoleAdvancedJobsDynamicRecurringRouteChildren {
  AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute: typeof AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute;
}

const AdminConsoleAdvancedJobsDynamicRecurringRouteChildren: AdminConsoleAdvancedJobsDynamicRecurringRouteChildren =
  {
    AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute:
      AdminConsoleAdvancedJobsDynamicRecurringJobIdRoute,
  };

const AdminConsoleAdvancedJobsDynamicRecurringRouteWithChildren =
  AdminConsoleAdvancedJobsDynamicRecurringRoute._addFileChildren(
    AdminConsoleAdvancedJobsDynamicRecurringRouteChildren,
  );

interface AdminConsoleAdvancedJobsOnDemandRouteChildren {
  AdminConsoleAdvancedJobsOnDemandJobIdRoute: typeof AdminConsoleAdvancedJobsOnDemandJobIdRoute;
}

const AdminConsoleAdvancedJobsOnDemandRouteChildren: AdminConsoleAdvancedJobsOnDemandRouteChildren =
  {
    AdminConsoleAdvancedJobsOnDemandJobIdRoute:
      AdminConsoleAdvancedJobsOnDemandJobIdRoute,
  };

const AdminConsoleAdvancedJobsOnDemandRouteWithChildren =
  AdminConsoleAdvancedJobsOnDemandRoute._addFileChildren(
    AdminConsoleAdvancedJobsOnDemandRouteChildren,
  );

interface AdminConsoleAdvancedJobsRecurringRouteChildren {
  AdminConsoleAdvancedJobsRecurringJobIdRoute: typeof AdminConsoleAdvancedJobsRecurringJobIdRoute;
}

const AdminConsoleAdvancedJobsRecurringRouteChildren: AdminConsoleAdvancedJobsRecurringRouteChildren =
  {
    AdminConsoleAdvancedJobsRecurringJobIdRoute:
      AdminConsoleAdvancedJobsRecurringJobIdRoute,
  };

const AdminConsoleAdvancedJobsRecurringRouteWithChildren =
  AdminConsoleAdvancedJobsRecurringRoute._addFileChildren(
    AdminConsoleAdvancedJobsRecurringRouteChildren,
  );

interface AdminConsoleAdvancedJobsRouteRouteChildren {
  AdminConsoleAdvancedJobsIndexRoute: typeof AdminConsoleAdvancedJobsIndexRoute;
  AdminConsoleAdvancedJobsDynamicRecurringRoute: typeof AdminConsoleAdvancedJobsDynamicRecurringRouteWithChildren;
  AdminConsoleAdvancedJobsOnDemandRoute: typeof AdminConsoleAdvancedJobsOnDemandRouteWithChildren;
  AdminConsoleAdvancedJobsRecurringRoute: typeof AdminConsoleAdvancedJobsRecurringRouteWithChildren;
}

const AdminConsoleAdvancedJobsRouteRouteChildren: AdminConsoleAdvancedJobsRouteRouteChildren =
  {
    AdminConsoleAdvancedJobsIndexRoute: AdminConsoleAdvancedJobsIndexRoute,
    AdminConsoleAdvancedJobsDynamicRecurringRoute:
      AdminConsoleAdvancedJobsDynamicRecurringRouteWithChildren,
    AdminConsoleAdvancedJobsOnDemandRoute:
      AdminConsoleAdvancedJobsOnDemandRouteWithChildren,
    AdminConsoleAdvancedJobsRecurringRoute:
      AdminConsoleAdvancedJobsRecurringRouteWithChildren,
  };

const AdminConsoleAdvancedJobsRouteRouteWithChildren =
  AdminConsoleAdvancedJobsRouteRoute._addFileChildren(
    AdminConsoleAdvancedJobsRouteRouteChildren,
  );

interface AdminConsoleAdvancedRouteRouteChildren {
  AdminConsoleAdvancedIndexRoute: typeof AdminConsoleAdvancedIndexRoute;
  AdminConsoleAdvancedAppSettingsRouteRoute: typeof AdminConsoleAdvancedAppSettingsRouteRouteWithChildren;
  AdminConsoleAdvancedClaimsRoute: typeof AdminConsoleAdvancedClaimsRoute;
  AdminConsoleAdvancedDbStatsRoute: typeof AdminConsoleAdvancedDbStatsRoute;
  AdminConsoleAdvancedDbUpgradesRoute: typeof AdminConsoleAdvancedDbUpgradesRoute;
  AdminConsoleAdvancedInboundEmailArchiveRouteRoute: typeof AdminConsoleAdvancedInboundEmailArchiveRouteRoute;
  AdminConsoleAdvancedInboundParseRouteRoute: typeof AdminConsoleAdvancedInboundParseRouteRouteWithChildren;
  AdminConsoleAdvancedIndicatorsRouteRoute: typeof AdminConsoleAdvancedIndicatorsRouteRouteWithChildren;
  AdminConsoleAdvancedIntegrationTestsRoute: typeof AdminConsoleAdvancedIntegrationTestsRoute;
  AdminConsoleAdvancedJobsRouteRoute: typeof AdminConsoleAdvancedJobsRouteRouteWithChildren;
  AdminConsoleAdvancedPlaygroundRouteRoute: typeof AdminConsoleAdvancedPlaygroundRouteRoute;
  AdminConsoleAdvancedWeaviateRoute: typeof AdminConsoleAdvancedWeaviateRoute;
}

const AdminConsoleAdvancedRouteRouteChildren: AdminConsoleAdvancedRouteRouteChildren =
  {
    AdminConsoleAdvancedIndexRoute: AdminConsoleAdvancedIndexRoute,
    AdminConsoleAdvancedAppSettingsRouteRoute:
      AdminConsoleAdvancedAppSettingsRouteRouteWithChildren,
    AdminConsoleAdvancedClaimsRoute: AdminConsoleAdvancedClaimsRoute,
    AdminConsoleAdvancedDbStatsRoute: AdminConsoleAdvancedDbStatsRoute,
    AdminConsoleAdvancedDbUpgradesRoute: AdminConsoleAdvancedDbUpgradesRoute,
    AdminConsoleAdvancedInboundEmailArchiveRouteRoute:
      AdminConsoleAdvancedInboundEmailArchiveRouteRoute,
    AdminConsoleAdvancedInboundParseRouteRoute:
      AdminConsoleAdvancedInboundParseRouteRouteWithChildren,
    AdminConsoleAdvancedIndicatorsRouteRoute:
      AdminConsoleAdvancedIndicatorsRouteRouteWithChildren,
    AdminConsoleAdvancedIntegrationTestsRoute:
      AdminConsoleAdvancedIntegrationTestsRoute,
    AdminConsoleAdvancedJobsRouteRoute:
      AdminConsoleAdvancedJobsRouteRouteWithChildren,
    AdminConsoleAdvancedPlaygroundRouteRoute:
      AdminConsoleAdvancedPlaygroundRouteRoute,
    AdminConsoleAdvancedWeaviateRoute: AdminConsoleAdvancedWeaviateRoute,
  };

const AdminConsoleAdvancedRouteRouteWithChildren =
  AdminConsoleAdvancedRouteRoute._addFileChildren(
    AdminConsoleAdvancedRouteRouteChildren,
  );

interface AdminConsoleAiEvalRunsRouteRouteChildren {
  AdminConsoleAiEvalRunsEvalRunIdRouteRoute: typeof AdminConsoleAiEvalRunsEvalRunIdRouteRoute;
  AdminConsoleAiEvalRunsCompareRouteRoute: typeof AdminConsoleAiEvalRunsCompareRouteRoute;
}

const AdminConsoleAiEvalRunsRouteRouteChildren: AdminConsoleAiEvalRunsRouteRouteChildren =
  {
    AdminConsoleAiEvalRunsEvalRunIdRouteRoute:
      AdminConsoleAiEvalRunsEvalRunIdRouteRoute,
    AdminConsoleAiEvalRunsCompareRouteRoute:
      AdminConsoleAiEvalRunsCompareRouteRoute,
  };

const AdminConsoleAiEvalRunsRouteRouteWithChildren =
  AdminConsoleAiEvalRunsRouteRoute._addFileChildren(
    AdminConsoleAiEvalRunsRouteRouteChildren,
  );

interface AdminConsoleAiRouteRouteChildren {
  AdminConsoleAiAiFeedbackRouteRoute: typeof AdminConsoleAiAiFeedbackRouteRoute;
  AdminConsoleAiAiPromptsRouteRoute: typeof AdminConsoleAiAiPromptsRouteRoute;
  AdminConsoleAiEvalRunsRouteRoute: typeof AdminConsoleAiEvalRunsRouteRouteWithChildren;
  AdminConsoleAiModelPricingRouteRoute: typeof AdminConsoleAiModelPricingRouteRoute;
  AdminConsoleAiModelTiersRouteRoute: typeof AdminConsoleAiModelTiersRouteRoute;
  AdminConsoleAiRequestAnalyticsRouteRoute: typeof AdminConsoleAiRequestAnalyticsRouteRoute;
  AdminConsoleAiStatisticsRouteRoute: typeof AdminConsoleAiStatisticsRouteRoute;
  AdminConsoleAiUsageBillingRouteRoute: typeof AdminConsoleAiUsageBillingRouteRoute;
}

const AdminConsoleAiRouteRouteChildren: AdminConsoleAiRouteRouteChildren = {
  AdminConsoleAiAiFeedbackRouteRoute: AdminConsoleAiAiFeedbackRouteRoute,
  AdminConsoleAiAiPromptsRouteRoute: AdminConsoleAiAiPromptsRouteRoute,
  AdminConsoleAiEvalRunsRouteRoute:
    AdminConsoleAiEvalRunsRouteRouteWithChildren,
  AdminConsoleAiModelPricingRouteRoute: AdminConsoleAiModelPricingRouteRoute,
  AdminConsoleAiModelTiersRouteRoute: AdminConsoleAiModelTiersRouteRoute,
  AdminConsoleAiRequestAnalyticsRouteRoute:
    AdminConsoleAiRequestAnalyticsRouteRoute,
  AdminConsoleAiStatisticsRouteRoute: AdminConsoleAiStatisticsRouteRoute,
  AdminConsoleAiUsageBillingRouteRoute: AdminConsoleAiUsageBillingRouteRoute,
};

const AdminConsoleAiRouteRouteWithChildren =
  AdminConsoleAiRouteRoute._addFileChildren(AdminConsoleAiRouteRouteChildren);

interface AdminConsoleMonitoringComplianceAuditRouteRouteChildren {
  AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute: typeof AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute;
}

const AdminConsoleMonitoringComplianceAuditRouteRouteChildren: AdminConsoleMonitoringComplianceAuditRouteRouteChildren =
  {
    AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute:
      AdminConsoleMonitoringComplianceAuditOrgIdComplianceAuditIdStatisticsRoute,
  };

const AdminConsoleMonitoringComplianceAuditRouteRouteWithChildren =
  AdminConsoleMonitoringComplianceAuditRouteRoute._addFileChildren(
    AdminConsoleMonitoringComplianceAuditRouteRouteChildren,
  );

interface AdminConsoleMonitoringEmailActivityRouteRouteChildren {
  AdminConsoleMonitoringEmailActivityIndexRoute: typeof AdminConsoleMonitoringEmailActivityIndexRoute;
}

const AdminConsoleMonitoringEmailActivityRouteRouteChildren: AdminConsoleMonitoringEmailActivityRouteRouteChildren =
  {
    AdminConsoleMonitoringEmailActivityIndexRoute:
      AdminConsoleMonitoringEmailActivityIndexRoute,
  };

const AdminConsoleMonitoringEmailActivityRouteRouteWithChildren =
  AdminConsoleMonitoringEmailActivityRouteRoute._addFileChildren(
    AdminConsoleMonitoringEmailActivityRouteRouteChildren,
  );

interface AdminConsoleMonitoringEngagementRouteRouteChildren {
  AdminConsoleMonitoringEngagementIndexRoute: typeof AdminConsoleMonitoringEngagementIndexRoute;
}

const AdminConsoleMonitoringEngagementRouteRouteChildren: AdminConsoleMonitoringEngagementRouteRouteChildren =
  {
    AdminConsoleMonitoringEngagementIndexRoute:
      AdminConsoleMonitoringEngagementIndexRoute,
  };

const AdminConsoleMonitoringEngagementRouteRouteWithChildren =
  AdminConsoleMonitoringEngagementRouteRoute._addFileChildren(
    AdminConsoleMonitoringEngagementRouteRouteChildren,
  );

interface AdminConsoleMonitoringRouteRouteChildren {
  AdminConsoleMonitoringIndexRoute: typeof AdminConsoleMonitoringIndexRoute;
  AdminConsoleMonitoringAuditTrailRouteRoute: typeof AdminConsoleMonitoringAuditTrailRouteRoute;
  AdminConsoleMonitoringAxiomLogsRouteRoute: typeof AdminConsoleMonitoringAxiomLogsRouteRoute;
  AdminConsoleMonitoringComplianceRouteRoute: typeof AdminConsoleMonitoringComplianceRouteRoute;
  AdminConsoleMonitoringComplianceAuditRouteRoute: typeof AdminConsoleMonitoringComplianceAuditRouteRouteWithChildren;
  AdminConsoleMonitoringEmailActivityRouteRoute: typeof AdminConsoleMonitoringEmailActivityRouteRouteWithChildren;
  AdminConsoleMonitoringEngagementRouteRoute: typeof AdminConsoleMonitoringEngagementRouteRouteWithChildren;
  AdminConsoleMonitoringLlmLogsRouteRoute: typeof AdminConsoleMonitoringLlmLogsRouteRoute;
  AdminConsoleMonitoringLlmStatsRouteRoute: typeof AdminConsoleMonitoringLlmStatsRouteRoute;
  AdminConsoleMonitoringMemoryRouteRoute: typeof AdminConsoleMonitoringMemoryRouteRoute;
  AdminConsoleMonitoringReportsRouteRoute: typeof AdminConsoleMonitoringReportsRouteRoute;
  AdminConsoleMonitoringStatisticsRouteRoute: typeof AdminConsoleMonitoringStatisticsRouteRoute;
}

const AdminConsoleMonitoringRouteRouteChildren: AdminConsoleMonitoringRouteRouteChildren =
  {
    AdminConsoleMonitoringIndexRoute: AdminConsoleMonitoringIndexRoute,
    AdminConsoleMonitoringAuditTrailRouteRoute:
      AdminConsoleMonitoringAuditTrailRouteRoute,
    AdminConsoleMonitoringAxiomLogsRouteRoute:
      AdminConsoleMonitoringAxiomLogsRouteRoute,
    AdminConsoleMonitoringComplianceRouteRoute:
      AdminConsoleMonitoringComplianceRouteRoute,
    AdminConsoleMonitoringComplianceAuditRouteRoute:
      AdminConsoleMonitoringComplianceAuditRouteRouteWithChildren,
    AdminConsoleMonitoringEmailActivityRouteRoute:
      AdminConsoleMonitoringEmailActivityRouteRouteWithChildren,
    AdminConsoleMonitoringEngagementRouteRoute:
      AdminConsoleMonitoringEngagementRouteRouteWithChildren,
    AdminConsoleMonitoringLlmLogsRouteRoute:
      AdminConsoleMonitoringLlmLogsRouteRoute,
    AdminConsoleMonitoringLlmStatsRouteRoute:
      AdminConsoleMonitoringLlmStatsRouteRoute,
    AdminConsoleMonitoringMemoryRouteRoute:
      AdminConsoleMonitoringMemoryRouteRoute,
    AdminConsoleMonitoringReportsRouteRoute:
      AdminConsoleMonitoringReportsRouteRoute,
    AdminConsoleMonitoringStatisticsRouteRoute:
      AdminConsoleMonitoringStatisticsRouteRoute,
  };

const AdminConsoleMonitoringRouteRouteWithChildren =
  AdminConsoleMonitoringRouteRoute._addFileChildren(
    AdminConsoleMonitoringRouteRouteChildren,
  );

interface AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteChildren {
  AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute;
}

const AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteChildren: AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteChildren =
  {
    AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute:
      AdminConsoleOrganisationManagementOrganisationsOrgIdUsersEditUserIdRoute,
  };

const AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteWithChildren =
  AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRoute._addFileChildren(
    AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteChildren,
  );

interface AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteChildren {
  AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute;
  AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteWithChildren;
  AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute;
}

const AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteChildren: AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteChildren =
  {
    AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute:
      AdminConsoleOrganisationManagementOrganisationsOrgIdSubscriptionsRoute,
    AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRoute:
      AdminConsoleOrganisationManagementOrganisationsOrgIdUsersRouteRouteWithChildren,
    AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute:
      AdminConsoleOrganisationManagementOrganisationsOrgIdWalletRoute,
  };

const AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteWithChildren =
  AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute._addFileChildren(
    AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteChildren,
  );

interface AdminConsoleOrganisationManagementOrganisationsRouteRouteChildren {
  AdminConsoleOrganisationManagementOrganisationsIndexRoute: typeof AdminConsoleOrganisationManagementOrganisationsIndexRoute;
  AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute: typeof AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteWithChildren;
}

const AdminConsoleOrganisationManagementOrganisationsRouteRouteChildren: AdminConsoleOrganisationManagementOrganisationsRouteRouteChildren =
  {
    AdminConsoleOrganisationManagementOrganisationsIndexRoute:
      AdminConsoleOrganisationManagementOrganisationsIndexRoute,
    AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRoute:
      AdminConsoleOrganisationManagementOrganisationsOrgIdRouteRouteWithChildren,
  };

const AdminConsoleOrganisationManagementOrganisationsRouteRouteWithChildren =
  AdminConsoleOrganisationManagementOrganisationsRouteRoute._addFileChildren(
    AdminConsoleOrganisationManagementOrganisationsRouteRouteChildren,
  );

interface AdminConsoleOrganisationManagementRouteRouteChildren {
  AdminConsoleOrganisationManagementNewRouteRoute: typeof AdminConsoleOrganisationManagementNewRouteRoute;
  AdminConsoleOrganisationManagementNewFromTemplateRouteRoute: typeof AdminConsoleOrganisationManagementNewFromTemplateRouteRoute;
  AdminConsoleOrganisationManagementOrganisationsRouteRoute: typeof AdminConsoleOrganisationManagementOrganisationsRouteRouteWithChildren;
}

const AdminConsoleOrganisationManagementRouteRouteChildren: AdminConsoleOrganisationManagementRouteRouteChildren =
  {
    AdminConsoleOrganisationManagementNewRouteRoute:
      AdminConsoleOrganisationManagementNewRouteRoute,
    AdminConsoleOrganisationManagementNewFromTemplateRouteRoute:
      AdminConsoleOrganisationManagementNewFromTemplateRouteRoute,
    AdminConsoleOrganisationManagementOrganisationsRouteRoute:
      AdminConsoleOrganisationManagementOrganisationsRouteRouteWithChildren,
  };

const AdminConsoleOrganisationManagementRouteRouteWithChildren =
  AdminConsoleOrganisationManagementRouteRoute._addFileChildren(
    AdminConsoleOrganisationManagementRouteRouteChildren,
  );

interface AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteChildren {
  AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute;
  AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute;
  AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute;
}

const AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteChildren: AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteChildren =
  {
    AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute:
      AdminConsolePlatformContentAiTrainingClassificationExampleCreateRouteRoute,
    AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute:
      AdminConsolePlatformContentAiTrainingClassificationExampleEditIdRouteRoute,
    AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute:
      AdminConsolePlatformContentAiTrainingClassificationExampleViewIdRouteRoute,
  };

const AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteWithChildren =
  AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute._addFileChildren(
    AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteChildren,
  );

interface AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteChildren {
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute;
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute;
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute;
}

const AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteChildren: AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteChildren =
  {
    AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute:
      AdminConsolePlatformContentAiTrainingVulnerabilityExampleCreateRouteRoute,
    AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute:
      AdminConsolePlatformContentAiTrainingVulnerabilityExampleEditIdRouteRoute,
    AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute:
      AdminConsolePlatformContentAiTrainingVulnerabilityExampleViewIdRouteRoute,
  };

const AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteWithChildren =
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute._addFileChildren(
    AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteChildren,
  );

interface AdminConsolePlatformContentAiTrainingRouteRouteChildren {
  AdminConsolePlatformContentAiTrainingIndexRoute: typeof AdminConsolePlatformContentAiTrainingIndexRoute;
  AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute: typeof AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteWithChildren;
  AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute: typeof AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteWithChildren;
}

const AdminConsolePlatformContentAiTrainingRouteRouteChildren: AdminConsolePlatformContentAiTrainingRouteRouteChildren =
  {
    AdminConsolePlatformContentAiTrainingIndexRoute:
      AdminConsolePlatformContentAiTrainingIndexRoute,
    AdminConsolePlatformContentAiTrainingClassificationExampleRouteRoute:
      AdminConsolePlatformContentAiTrainingClassificationExampleRouteRouteWithChildren,
    AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRoute:
      AdminConsolePlatformContentAiTrainingVulnerabilityExampleRouteRouteWithChildren,
  };

const AdminConsolePlatformContentAiTrainingRouteRouteWithChildren =
  AdminConsolePlatformContentAiTrainingRouteRoute._addFileChildren(
    AdminConsolePlatformContentAiTrainingRouteRouteChildren,
  );

interface AdminConsolePlatformContentCommsAndContentAppTextRouteRouteChildren {
  AdminConsolePlatformContentCommsAndContentAppTextAddRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextAddRoute;
  AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute;
}

const AdminConsolePlatformContentCommsAndContentAppTextRouteRouteChildren: AdminConsolePlatformContentCommsAndContentAppTextRouteRouteChildren =
  {
    AdminConsolePlatformContentCommsAndContentAppTextAddRoute:
      AdminConsolePlatformContentCommsAndContentAppTextAddRoute,
    AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute:
      AdminConsolePlatformContentCommsAndContentAppTextEditIdRoute,
  };

const AdminConsolePlatformContentCommsAndContentAppTextRouteRouteWithChildren =
  AdminConsolePlatformContentCommsAndContentAppTextRouteRoute._addFileChildren(
    AdminConsolePlatformContentCommsAndContentAppTextRouteRouteChildren,
  );

interface AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteChildren {
  AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute;
  AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute;
}

const AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteChildren: AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteChildren =
  {
    AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute:
      AdminConsolePlatformContentCommsAndContentCommTemplatesAddRoute,
    AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute:
      AdminConsolePlatformContentCommsAndContentCommTemplatesEditCommTemplateIdRoute,
  };

const AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteWithChildren =
  AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute._addFileChildren(
    AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteChildren,
  );

interface AdminConsolePlatformContentCommsAndContentRouteRouteChildren {
  AdminConsolePlatformContentCommsAndContentAppTextRouteRoute: typeof AdminConsolePlatformContentCommsAndContentAppTextRouteRouteWithChildren;
  AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute: typeof AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteWithChildren;
  AdminConsolePlatformContentCommsAndContentFaqRouteRoute: typeof AdminConsolePlatformContentCommsAndContentFaqRouteRoute;
}

const AdminConsolePlatformContentCommsAndContentRouteRouteChildren: AdminConsolePlatformContentCommsAndContentRouteRouteChildren =
  {
    AdminConsolePlatformContentCommsAndContentAppTextRouteRoute:
      AdminConsolePlatformContentCommsAndContentAppTextRouteRouteWithChildren,
    AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRoute:
      AdminConsolePlatformContentCommsAndContentCommTemplatesRouteRouteWithChildren,
    AdminConsolePlatformContentCommsAndContentFaqRouteRoute:
      AdminConsolePlatformContentCommsAndContentFaqRouteRoute,
  };

const AdminConsolePlatformContentCommsAndContentRouteRouteWithChildren =
  AdminConsolePlatformContentCommsAndContentRouteRoute._addFileChildren(
    AdminConsolePlatformContentCommsAndContentRouteRouteChildren,
  );

interface AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteChildren {
  AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute;
}

const AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteChildren: AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteChildren =
  {
    AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesSearchAddRoute,
  };

const AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteWithChildren =
  AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRoute._addFileChildren(
    AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteChildren,
  );

interface AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteChildren {
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute;
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute;
}

const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteChildren: AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteChildren =
  {
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesAddRoute,
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesEditComplianceAuditTemplateEvidenceTypeIdRoute,
  };

const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteWithChildren =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute._addFileChildren(
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteChildren,
  );

interface AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteChildren {
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute;
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute;
}

const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteChildren: AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteChildren =
  {
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesAddRoute,
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesEditComplianceAuditTemplatePrincipleIdRoute,
  };

const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteWithChildren =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute._addFileChildren(
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteChildren,
  );

interface AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteChildren {
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute;
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteWithChildren;
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteWithChildren;
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute;
}

const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteChildren: AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteChildren =
  {
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdChangesRoute,
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdEvidenceTypesRouteRouteWithChildren,
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdPrinciplesRouteRouteWithChildren,
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdStructureRoute,
  };

const AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteWithChildren =
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute._addFileChildren(
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteChildren,
  );

interface AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteChildren {
  AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute;
  AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteWithChildren;
  AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteWithChildren;
}

const AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteChildren: AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteChildren =
  {
    AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesIndexRoute,
    AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesSearchRouteRouteWithChildren,
    AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesDetailsComplianceAuditTemplateIdRouteRouteWithChildren,
  };

const AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteWithChildren =
  AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute._addFileChildren(
    AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteChildren,
  );

interface AdminConsolePlatformContentMarketPdsRouteRouteChildren {
  AdminConsolePlatformContentMarketPdsAddRoute: typeof AdminConsolePlatformContentMarketPdsAddRoute;
  AdminConsolePlatformContentMarketPdsEditIdRoute: typeof AdminConsolePlatformContentMarketPdsEditIdRoute;
}

const AdminConsolePlatformContentMarketPdsRouteRouteChildren: AdminConsolePlatformContentMarketPdsRouteRouteChildren =
  {
    AdminConsolePlatformContentMarketPdsAddRoute:
      AdminConsolePlatformContentMarketPdsAddRoute,
    AdminConsolePlatformContentMarketPdsEditIdRoute:
      AdminConsolePlatformContentMarketPdsEditIdRoute,
  };

const AdminConsolePlatformContentMarketPdsRouteRouteWithChildren =
  AdminConsolePlatformContentMarketPdsRouteRoute._addFileChildren(
    AdminConsolePlatformContentMarketPdsRouteRouteChildren,
  );

interface AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteChildren {
  AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute;
  AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute;
}

const AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteChildren: AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteChildren =
  {
    AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute:
      AdminConsolePlatformContentObligationsControlsLibraryIdDetailsRoute,
    AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute:
      AdminConsolePlatformContentObligationsControlsLibraryIdHistoryRoute,
  };

const AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteWithChildren =
  AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute._addFileChildren(
    AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteChildren,
  );

interface AdminConsolePlatformContentObligationsControlsLibraryRouteRouteChildren {
  AdminConsolePlatformContentObligationsControlsLibraryIndexRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIndexRoute;
  AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteWithChildren;
}

const AdminConsolePlatformContentObligationsControlsLibraryRouteRouteChildren: AdminConsolePlatformContentObligationsControlsLibraryRouteRouteChildren =
  {
    AdminConsolePlatformContentObligationsControlsLibraryIndexRoute:
      AdminConsolePlatformContentObligationsControlsLibraryIndexRoute,
    AdminConsolePlatformContentObligationsControlsLibraryIdRouteRoute:
      AdminConsolePlatformContentObligationsControlsLibraryIdRouteRouteWithChildren,
  };

const AdminConsolePlatformContentObligationsControlsLibraryRouteRouteWithChildren =
  AdminConsolePlatformContentObligationsControlsLibraryRouteRoute._addFileChildren(
    AdminConsolePlatformContentObligationsControlsLibraryRouteRouteChildren,
  );

interface AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteChildren {
  AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute;
  AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute;
  AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute;
  AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute;
}

const AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteChildren: AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteChildren =
  {
    AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute:
      AdminConsolePlatformContentObligationsLibraryDetailsIdAiRelatedRoute,
    AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute:
      AdminConsolePlatformContentObligationsLibraryDetailsIdDocumentAnalyserRoute,
    AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute:
      AdminConsolePlatformContentObligationsLibraryDetailsIdHistoryRoute,
    AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute:
      AdminConsolePlatformContentObligationsLibraryDetailsIdManageRoute,
  };

const AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteWithChildren =
  AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute._addFileChildren(
    AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteChildren,
  );

interface AdminConsolePlatformContentObligationsLibraryRouteRouteChildren {
  AdminConsolePlatformContentObligationsLibraryIndexRoute: typeof AdminConsolePlatformContentObligationsLibraryIndexRoute;
  AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute: typeof AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteWithChildren;
}

const AdminConsolePlatformContentObligationsLibraryRouteRouteChildren: AdminConsolePlatformContentObligationsLibraryRouteRouteChildren =
  {
    AdminConsolePlatformContentObligationsLibraryIndexRoute:
      AdminConsolePlatformContentObligationsLibraryIndexRoute,
    AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRoute:
      AdminConsolePlatformContentObligationsLibraryDetailsIdRouteRouteWithChildren,
  };

const AdminConsolePlatformContentObligationsLibraryRouteRouteWithChildren =
  AdminConsolePlatformContentObligationsLibraryRouteRoute._addFileChildren(
    AdminConsolePlatformContentObligationsLibraryRouteRouteChildren,
  );

interface AdminConsolePlatformContentObligationsRouteRouteChildren {
  AdminConsolePlatformContentObligationsIndexRoute: typeof AdminConsolePlatformContentObligationsIndexRoute;
  AdminConsolePlatformContentObligationsConfigurationRouteRoute: typeof AdminConsolePlatformContentObligationsConfigurationRouteRoute;
  AdminConsolePlatformContentObligationsControlsLibraryRouteRoute: typeof AdminConsolePlatformContentObligationsControlsLibraryRouteRouteWithChildren;
  AdminConsolePlatformContentObligationsLibraryRouteRoute: typeof AdminConsolePlatformContentObligationsLibraryRouteRouteWithChildren;
}

const AdminConsolePlatformContentObligationsRouteRouteChildren: AdminConsolePlatformContentObligationsRouteRouteChildren =
  {
    AdminConsolePlatformContentObligationsIndexRoute:
      AdminConsolePlatformContentObligationsIndexRoute,
    AdminConsolePlatformContentObligationsConfigurationRouteRoute:
      AdminConsolePlatformContentObligationsConfigurationRouteRoute,
    AdminConsolePlatformContentObligationsControlsLibraryRouteRoute:
      AdminConsolePlatformContentObligationsControlsLibraryRouteRouteWithChildren,
    AdminConsolePlatformContentObligationsLibraryRouteRoute:
      AdminConsolePlatformContentObligationsLibraryRouteRouteWithChildren,
  };

const AdminConsolePlatformContentObligationsRouteRouteWithChildren =
  AdminConsolePlatformContentObligationsRouteRoute._addFileChildren(
    AdminConsolePlatformContentObligationsRouteRouteChildren,
  );

interface AdminConsolePlatformContentProductsRouteRouteChildren {
  AdminConsolePlatformContentProductsServiceIdRoute: typeof AdminConsolePlatformContentProductsServiceIdRoute;
}

const AdminConsolePlatformContentProductsRouteRouteChildren: AdminConsolePlatformContentProductsRouteRouteChildren =
  {
    AdminConsolePlatformContentProductsServiceIdRoute:
      AdminConsolePlatformContentProductsServiceIdRoute,
  };

const AdminConsolePlatformContentProductsRouteRouteWithChildren =
  AdminConsolePlatformContentProductsRouteRoute._addFileChildren(
    AdminConsolePlatformContentProductsRouteRouteChildren,
  );

interface AdminConsolePlatformContentWhatsNewRouteRouteChildren {
  AdminConsolePlatformContentWhatsNewIndexRoute: typeof AdminConsolePlatformContentWhatsNewIndexRoute;
  AdminConsolePlatformContentWhatsNewIdRoute: typeof AdminConsolePlatformContentWhatsNewIdRoute;
  AdminConsolePlatformContentWhatsNewNewRoute: typeof AdminConsolePlatformContentWhatsNewNewRoute;
}

const AdminConsolePlatformContentWhatsNewRouteRouteChildren: AdminConsolePlatformContentWhatsNewRouteRouteChildren =
  {
    AdminConsolePlatformContentWhatsNewIndexRoute:
      AdminConsolePlatformContentWhatsNewIndexRoute,
    AdminConsolePlatformContentWhatsNewIdRoute:
      AdminConsolePlatformContentWhatsNewIdRoute,
    AdminConsolePlatformContentWhatsNewNewRoute:
      AdminConsolePlatformContentWhatsNewNewRoute,
  };

const AdminConsolePlatformContentWhatsNewRouteRouteWithChildren =
  AdminConsolePlatformContentWhatsNewRouteRoute._addFileChildren(
    AdminConsolePlatformContentWhatsNewRouteRouteChildren,
  );

interface AdminConsolePlatformContentRouteRouteChildren {
  AdminConsolePlatformContentIndexRoute: typeof AdminConsolePlatformContentIndexRoute;
  AdminConsolePlatformContentAiTrainingRouteRoute: typeof AdminConsolePlatformContentAiTrainingRouteRouteWithChildren;
  AdminConsolePlatformContentCommsAndContentRouteRoute: typeof AdminConsolePlatformContentCommsAndContentRouteRouteWithChildren;
  AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute: typeof AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteWithChildren;
  AdminConsolePlatformContentMarketPdsRouteRoute: typeof AdminConsolePlatformContentMarketPdsRouteRouteWithChildren;
  AdminConsolePlatformContentObligationsRouteRoute: typeof AdminConsolePlatformContentObligationsRouteRouteWithChildren;
  AdminConsolePlatformContentProductsRouteRoute: typeof AdminConsolePlatformContentProductsRouteRouteWithChildren;
  AdminConsolePlatformContentWhatsNewRouteRoute: typeof AdminConsolePlatformContentWhatsNewRouteRouteWithChildren;
}

const AdminConsolePlatformContentRouteRouteChildren: AdminConsolePlatformContentRouteRouteChildren =
  {
    AdminConsolePlatformContentIndexRoute:
      AdminConsolePlatformContentIndexRoute,
    AdminConsolePlatformContentAiTrainingRouteRoute:
      AdminConsolePlatformContentAiTrainingRouteRouteWithChildren,
    AdminConsolePlatformContentCommsAndContentRouteRoute:
      AdminConsolePlatformContentCommsAndContentRouteRouteWithChildren,
    AdminConsolePlatformContentComplianceAuditTemplatesRouteRoute:
      AdminConsolePlatformContentComplianceAuditTemplatesRouteRouteWithChildren,
    AdminConsolePlatformContentMarketPdsRouteRoute:
      AdminConsolePlatformContentMarketPdsRouteRouteWithChildren,
    AdminConsolePlatformContentObligationsRouteRoute:
      AdminConsolePlatformContentObligationsRouteRouteWithChildren,
    AdminConsolePlatformContentProductsRouteRoute:
      AdminConsolePlatformContentProductsRouteRouteWithChildren,
    AdminConsolePlatformContentWhatsNewRouteRoute:
      AdminConsolePlatformContentWhatsNewRouteRouteWithChildren,
  };

const AdminConsolePlatformContentRouteRouteWithChildren =
  AdminConsolePlatformContentRouteRoute._addFileChildren(
    AdminConsolePlatformContentRouteRouteChildren,
  );

interface AdminConsoleToolsSanitiseTextPiiRouteRouteChildren {
  AdminConsoleToolsSanitiseTextPiiCompareRoute: typeof AdminConsoleToolsSanitiseTextPiiCompareRoute;
  AdminConsoleToolsSanitiseTextPiiToolRoute: typeof AdminConsoleToolsSanitiseTextPiiToolRoute;
}

const AdminConsoleToolsSanitiseTextPiiRouteRouteChildren: AdminConsoleToolsSanitiseTextPiiRouteRouteChildren =
  {
    AdminConsoleToolsSanitiseTextPiiCompareRoute:
      AdminConsoleToolsSanitiseTextPiiCompareRoute,
    AdminConsoleToolsSanitiseTextPiiToolRoute:
      AdminConsoleToolsSanitiseTextPiiToolRoute,
  };

const AdminConsoleToolsSanitiseTextPiiRouteRouteWithChildren =
  AdminConsoleToolsSanitiseTextPiiRouteRoute._addFileChildren(
    AdminConsoleToolsSanitiseTextPiiRouteRouteChildren,
  );

interface AdminConsoleToolsRouteRouteChildren {
  AdminConsoleToolsIndexRoute: typeof AdminConsoleToolsIndexRoute;
  AdminConsoleToolsDocumentToMarkdownRoute: typeof AdminConsoleToolsDocumentToMarkdownRoute;
  AdminConsoleToolsFeatureFlagsRoute: typeof AdminConsoleToolsFeatureFlagsRoute;
  AdminConsoleToolsSanitiseTextPiiRouteRoute: typeof AdminConsoleToolsSanitiseTextPiiRouteRouteWithChildren;
}

const AdminConsoleToolsRouteRouteChildren: AdminConsoleToolsRouteRouteChildren =
  {
    AdminConsoleToolsIndexRoute: AdminConsoleToolsIndexRoute,
    AdminConsoleToolsDocumentToMarkdownRoute:
      AdminConsoleToolsDocumentToMarkdownRoute,
    AdminConsoleToolsFeatureFlagsRoute: AdminConsoleToolsFeatureFlagsRoute,
    AdminConsoleToolsSanitiseTextPiiRouteRoute:
      AdminConsoleToolsSanitiseTextPiiRouteRouteWithChildren,
  };

const AdminConsoleToolsRouteRouteWithChildren =
  AdminConsoleToolsRouteRoute._addFileChildren(
    AdminConsoleToolsRouteRouteChildren,
  );

interface AdminConsoleUserAccessAdminUsersRouteRouteChildren {
  AdminConsoleUserAccessAdminUsersGrantRoute: typeof AdminConsoleUserAccessAdminUsersGrantRoute;
  AdminConsoleUserAccessAdminUsersEditUserIdRoute: typeof AdminConsoleUserAccessAdminUsersEditUserIdRoute;
}

const AdminConsoleUserAccessAdminUsersRouteRouteChildren: AdminConsoleUserAccessAdminUsersRouteRouteChildren =
  {
    AdminConsoleUserAccessAdminUsersGrantRoute:
      AdminConsoleUserAccessAdminUsersGrantRoute,
    AdminConsoleUserAccessAdminUsersEditUserIdRoute:
      AdminConsoleUserAccessAdminUsersEditUserIdRoute,
  };

const AdminConsoleUserAccessAdminUsersRouteRouteWithChildren =
  AdminConsoleUserAccessAdminUsersRouteRoute._addFileChildren(
    AdminConsoleUserAccessAdminUsersRouteRouteChildren,
  );

interface AdminConsoleUserAccessUsersRouteRouteChildren {
  AdminConsoleUserAccessUsersEditUserIdRoute: typeof AdminConsoleUserAccessUsersEditUserIdRoute;
  AdminConsoleUserAccessUsersViewUserIdRoute: typeof AdminConsoleUserAccessUsersViewUserIdRoute;
}

const AdminConsoleUserAccessUsersRouteRouteChildren: AdminConsoleUserAccessUsersRouteRouteChildren =
  {
    AdminConsoleUserAccessUsersEditUserIdRoute:
      AdminConsoleUserAccessUsersEditUserIdRoute,
    AdminConsoleUserAccessUsersViewUserIdRoute:
      AdminConsoleUserAccessUsersViewUserIdRoute,
  };

const AdminConsoleUserAccessUsersRouteRouteWithChildren =
  AdminConsoleUserAccessUsersRouteRoute._addFileChildren(
    AdminConsoleUserAccessUsersRouteRouteChildren,
  );

interface AdminConsoleUserAccessRouteRouteChildren {
  AdminConsoleUserAccessIndexRoute: typeof AdminConsoleUserAccessIndexRoute;
  AdminConsoleUserAccessAdminUsersRouteRoute: typeof AdminConsoleUserAccessAdminUsersRouteRouteWithChildren;
  AdminConsoleUserAccessSupportSessionsRouteRoute: typeof AdminConsoleUserAccessSupportSessionsRouteRoute;
  AdminConsoleUserAccessUsersRouteRoute: typeof AdminConsoleUserAccessUsersRouteRouteWithChildren;
}

const AdminConsoleUserAccessRouteRouteChildren: AdminConsoleUserAccessRouteRouteChildren =
  {
    AdminConsoleUserAccessIndexRoute: AdminConsoleUserAccessIndexRoute,
    AdminConsoleUserAccessAdminUsersRouteRoute:
      AdminConsoleUserAccessAdminUsersRouteRouteWithChildren,
    AdminConsoleUserAccessSupportSessionsRouteRoute:
      AdminConsoleUserAccessSupportSessionsRouteRoute,
    AdminConsoleUserAccessUsersRouteRoute:
      AdminConsoleUserAccessUsersRouteRouteWithChildren,
  };

const AdminConsoleUserAccessRouteRouteWithChildren =
  AdminConsoleUserAccessRouteRoute._addFileChildren(
    AdminConsoleUserAccessRouteRouteChildren,
  );

interface AdminConsoleRouteRouteChildren {
  AdminConsoleIndexRoute: typeof AdminConsoleIndexRoute;
  AdminConsoleAdvancedRouteRoute: typeof AdminConsoleAdvancedRouteRouteWithChildren;
  AdminConsoleAiRouteRoute: typeof AdminConsoleAiRouteRouteWithChildren;
  AdminConsoleAuthorisedAppsRouteRoute: typeof AdminConsoleAuthorisedAppsRouteRoute;
  AdminConsoleMonitoringRouteRoute: typeof AdminConsoleMonitoringRouteRouteWithChildren;
  AdminConsoleOrganisationManagementRouteRoute: typeof AdminConsoleOrganisationManagementRouteRouteWithChildren;
  AdminConsolePlatformContentRouteRoute: typeof AdminConsolePlatformContentRouteRouteWithChildren;
  AdminConsoleToolsRouteRoute: typeof AdminConsoleToolsRouteRouteWithChildren;
  AdminConsoleUserAccessRouteRoute: typeof AdminConsoleUserAccessRouteRouteWithChildren;
}

const AdminConsoleRouteRouteChildren: AdminConsoleRouteRouteChildren = {
  AdminConsoleIndexRoute: AdminConsoleIndexRoute,
  AdminConsoleAdvancedRouteRoute: AdminConsoleAdvancedRouteRouteWithChildren,
  AdminConsoleAiRouteRoute: AdminConsoleAiRouteRouteWithChildren,
  AdminConsoleAuthorisedAppsRouteRoute: AdminConsoleAuthorisedAppsRouteRoute,
  AdminConsoleMonitoringRouteRoute:
    AdminConsoleMonitoringRouteRouteWithChildren,
  AdminConsoleOrganisationManagementRouteRoute:
    AdminConsoleOrganisationManagementRouteRouteWithChildren,
  AdminConsolePlatformContentRouteRoute:
    AdminConsolePlatformContentRouteRouteWithChildren,
  AdminConsoleToolsRouteRoute: AdminConsoleToolsRouteRouteWithChildren,
  AdminConsoleUserAccessRouteRoute:
    AdminConsoleUserAccessRouteRouteWithChildren,
};

const AdminConsoleRouteRouteWithChildren =
  AdminConsoleRouteRoute._addFileChildren(AdminConsoleRouteRouteChildren);

interface AttestationRouteRouteChildren {
  AttestationTokenRoute: typeof AttestationTokenRoute;
}

const AttestationRouteRouteChildren: AttestationRouteRouteChildren = {
  AttestationTokenRoute: AttestationTokenRoute,
};

const AttestationRouteRouteWithChildren =
  AttestationRouteRoute._addFileChildren(AttestationRouteRouteChildren);

interface OauthRouteRouteChildren {
  OauthAuthorizeRoute: typeof OauthAuthorizeRoute;
}

const OauthRouteRouteChildren: OauthRouteRouteChildren = {
  OauthAuthorizeRoute: OauthAuthorizeRoute,
};

const OauthRouteRouteWithChildren = OauthRouteRoute._addFileChildren(
  OauthRouteRouteChildren,
);

interface PublicOrgIdRouteRouteChildren {
  PublicOrgIdComplaintNewRouteRoute: typeof PublicOrgIdComplaintNewRouteRoute;
  PublicOrgIdInvoiceViewAccessKeyRouteRoute: typeof PublicOrgIdInvoiceViewAccessKeyRouteRoute;
  PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute: typeof PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
  PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute: typeof PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
}

const PublicOrgIdRouteRouteChildren: PublicOrgIdRouteRouteChildren = {
  PublicOrgIdComplaintNewRouteRoute: PublicOrgIdComplaintNewRouteRoute,
  PublicOrgIdInvoiceViewAccessKeyRouteRoute:
    PublicOrgIdInvoiceViewAccessKeyRouteRoute,
  PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute:
    PublicOrgIdClaimLodgementLookupPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute,
  PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute:
    PublicOrgIdClaimLodgementPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute,
};

const PublicOrgIdRouteRouteWithChildren =
  PublicOrgIdRouteRoute._addFileChildren(PublicOrgIdRouteRouteChildren);

interface PublicRouteRouteChildren {
  PublicOrgIdRouteRoute: typeof PublicOrgIdRouteRouteWithChildren;
  PublicLodgementSummaryAccessKeyRouteRoute: typeof PublicLodgementSummaryAccessKeyRouteRoute;
  PublicNewComplaintByKeyKeyRouteRoute: typeof PublicNewComplaintByKeyKeyRouteRoute;
  PublicNewComplaintOrgIdRouteRoute: typeof PublicNewComplaintOrgIdRouteRoute;
  PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute: typeof PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute;
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicOrgIdRouteRoute: PublicOrgIdRouteRouteWithChildren,
  PublicLodgementSummaryAccessKeyRouteRoute:
    PublicLodgementSummaryAccessKeyRouteRoute,
  PublicNewComplaintByKeyKeyRouteRoute: PublicNewComplaintByKeyKeyRouteRoute,
  PublicNewComplaintOrgIdRouteRoute: PublicNewComplaintOrgIdRouteRoute,
  PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute:
    PublicClaimLodgementOrgIdPdsVersionIdQuestionnaireIdProductTypeIdRouteRoute,
};

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
);

interface ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteChildren {
  ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute;
  ConsoleOrgIdAttestationsScheduledAttestationsNewRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsNewRoute;
}

const ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteChildren: ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteChildren =
  {
    ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute:
      ConsoleOrgIdAttestationsScheduledAttestationsScheduleIdRouteRoute,
    ConsoleOrgIdAttestationsScheduledAttestationsNewRoute:
      ConsoleOrgIdAttestationsScheduledAttestationsNewRoute,
  };

const ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren =
  ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteChildren,
  );

interface ConsoleOrgIdAttestationsUserAttestationsRouteRouteChildren {
  ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute: typeof ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute;
  ConsoleOrgIdAttestationsUserAttestationsSendRoute: typeof ConsoleOrgIdAttestationsUserAttestationsSendRoute;
}

const ConsoleOrgIdAttestationsUserAttestationsRouteRouteChildren: ConsoleOrgIdAttestationsUserAttestationsRouteRouteChildren =
  {
    ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute:
      ConsoleOrgIdAttestationsUserAttestationsAttestationIdRouteRoute,
    ConsoleOrgIdAttestationsUserAttestationsSendRoute:
      ConsoleOrgIdAttestationsUserAttestationsSendRoute,
  };

const ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren =
  ConsoleOrgIdAttestationsUserAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsUserAttestationsRouteRouteChildren,
  );

interface ConsoleOrgIdAttestationsRouteRouteChildren {
  ConsoleOrgIdAttestationsIndexRoute: typeof ConsoleOrgIdAttestationsIndexRoute;
  ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute: typeof ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren;
  ConsoleOrgIdAttestationsUserAttestationsRouteRoute: typeof ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren;
}

const ConsoleOrgIdAttestationsRouteRouteChildren: ConsoleOrgIdAttestationsRouteRouteChildren =
  {
    ConsoleOrgIdAttestationsIndexRoute: ConsoleOrgIdAttestationsIndexRoute,
    ConsoleOrgIdAttestationsScheduledAttestationsRouteRoute:
      ConsoleOrgIdAttestationsScheduledAttestationsRouteRouteWithChildren,
    ConsoleOrgIdAttestationsUserAttestationsRouteRoute:
      ConsoleOrgIdAttestationsUserAttestationsRouteRouteWithChildren,
  };

const ConsoleOrgIdAttestationsRouteRouteWithChildren =
  ConsoleOrgIdAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdAttestationsRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdActivityRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute;
  ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute;
}

const ConsoleOrgIdClaimsDetailsIdActivityRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdActivityRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute:
      ConsoleOrgIdClaimsDetailsIdActivityAddPhoneRoute,
    ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute:
      ConsoleOrgIdClaimsDetailsIdActivityEditPhoneCallLogIdRoute,
  };

const ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdActivityRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdActivityRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute;
  ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute;
}

const ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute:
      ConsoleOrgIdClaimsDetailsIdCommsAddEmailRoute,
    ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute:
      ConsoleOrgIdClaimsDetailsIdCommsAddSmsRoute,
  };

const ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdCommsRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute;
  ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute;
}

const ConsoleOrgIdClaimsDetailsIdCommsRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdCommsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdCommsAddRouteRoute:
      ConsoleOrgIdClaimsDetailsIdCommsAddRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdCommsMessageMessageIdRouteRoute,
    ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdCommsReplyMessageIdRouteRoute,
  };

const ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdCommsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdCommsRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute;
}

const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute:
      ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdAddRoute,
  };

const ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdContactsRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdContactsAddRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsAddRoute;
  ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute;
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute;
  ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren;
}

const ConsoleOrgIdClaimsDetailsIdContactsRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdContactsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdContactsAddRoute:
      ConsoleOrgIdClaimsDetailsIdContactsAddRoute,
    ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute:
      ConsoleOrgIdClaimsDetailsIdContactsEditContactIdRoute,
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute:
      ConsoleOrgIdClaimsDetailsIdContactsSuppliersDetailsSupplierIdRoute,
    ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdContactsSuppliersReassignSupplierIdRouteRouteWithChildren,
  };

const ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdContactsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdContactsRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdExpensesAddRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesAddRoute;
  ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute;
}

const ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdExpensesAddRoute:
      ConsoleOrgIdClaimsDetailsIdExpensesAddRoute,
    ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute:
      ConsoleOrgIdClaimsDetailsIdExpensesEditExpenseItemIdRoute,
  };

const ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddCompensationPaymentsAddRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddExcessPaymentsAddRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddSuppliersAddRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsCompensationPaymentsDetailsCompensationPaymentIdRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsExcessPaymentsDetailsExcessPaymentIdRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdFinancialsRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdLibraryRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPayeeRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdPaymentRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdLibraryRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdManageRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdPaymentsRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsAddRoute,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdCompensationPaymentsRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdLibraryRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdReserveAdjustmentsRouteRouteWithChildren,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute;
  ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren;
}

const ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsAddRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesAddRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesAddRoute,
    ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsCompensationsDetailsCompensationIdRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsExcessesDetailsExcessIdRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsReservesDetailsReserveIdRouteRouteWithChildren,
  };

const ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdManageRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute;
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute: typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute;
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute: typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute;
  ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute: typeof ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute;
}

const ConsoleOrgIdClaimsDetailsIdManageRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdManageRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute:
      ConsoleOrgIdClaimsDetailsIdManageStrategiesAddRouteRoute,
    ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute:
      ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddRoute,
    ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute:
      ConsoleOrgIdClaimsDetailsIdManageSupplierJobsAddSupplierRoute,
    ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute:
      ConsoleOrgIdClaimsDetailsIdManageSupplierJobsEditJobIdRoute,
  };

const ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdManageRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsDetailsIdRouteRouteChildren {
  ConsoleOrgIdClaimsDetailsIdActivityRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute;
  ConsoleOrgIdClaimsDetailsIdCommsRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdContactsRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute;
  ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute;
  ConsoleOrgIdClaimsDetailsIdManageRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren;
  ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute;
  ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute;
  ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute;
}

const ConsoleOrgIdClaimsDetailsIdRouteRouteChildren: ConsoleOrgIdClaimsDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdClaimsDetailsIdActivityRouteRoute:
      ConsoleOrgIdClaimsDetailsIdActivityRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute:
      ConsoleOrgIdClaimsDetailsIdAiAssessmentRouteRoute,
    ConsoleOrgIdClaimsDetailsIdCommsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdCommsRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdContactsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdContactsRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdExpensesRouteRoute:
      ConsoleOrgIdClaimsDetailsIdExpensesRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdFinancialsRouteRoute:
      ConsoleOrgIdClaimsDetailsIdFinancialsRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute:
      ConsoleOrgIdClaimsDetailsIdHistoryRouteRoute,
    ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute:
      ConsoleOrgIdClaimsDetailsIdLibraryRouteRoute,
    ConsoleOrgIdClaimsDetailsIdManageRouteRoute:
      ConsoleOrgIdClaimsDetailsIdManageRouteRouteWithChildren,
    ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute:
      ConsoleOrgIdClaimsDetailsIdPolicyInfoRouteRoute,
    ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute:
      ConsoleOrgIdClaimsDetailsIdProductTypeDataRouteRoute,
    ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute:
      ConsoleOrgIdClaimsDetailsIdVehicleRouteRoute,
  };

const ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdClaimsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdClaimsRouteRouteChildren {
  ConsoleOrgIdClaimsIndexRoute: typeof ConsoleOrgIdClaimsIndexRoute;
  ConsoleOrgIdClaimsDetailsIdRouteRoute: typeof ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdClaimsRouteRouteChildren: ConsoleOrgIdClaimsRouteRouteChildren =
  {
    ConsoleOrgIdClaimsIndexRoute: ConsoleOrgIdClaimsIndexRoute,
    ConsoleOrgIdClaimsDetailsIdRouteRoute:
      ConsoleOrgIdClaimsDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdClaimsRouteRouteWithChildren =
  ConsoleOrgIdClaimsRouteRoute._addFileChildren(
    ConsoleOrgIdClaimsRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceCoiDetailsIdRouteRouteChildren {
  ConsoleOrgIdComplianceCoiDetailsIdIndexRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdIndexRoute;
  ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute;
  ConsoleOrgIdComplianceCoiDetailsIdManageRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdManageRoute;
}

const ConsoleOrgIdComplianceCoiDetailsIdRouteRouteChildren: ConsoleOrgIdComplianceCoiDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdComplianceCoiDetailsIdIndexRoute:
      ConsoleOrgIdComplianceCoiDetailsIdIndexRoute,
    ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute:
      ConsoleOrgIdComplianceCoiDetailsIdLibraryRoute,
    ConsoleOrgIdComplianceCoiDetailsIdManageRoute:
      ConsoleOrgIdComplianceCoiDetailsIdManageRoute,
  };

const ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceCoiDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceCoiDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceCoiRouteRouteChildren {
  ConsoleOrgIdComplianceCoiIndexRoute: typeof ConsoleOrgIdComplianceCoiIndexRoute;
  ConsoleOrgIdComplianceCoiAddRouteRoute: typeof ConsoleOrgIdComplianceCoiAddRouteRoute;
  ConsoleOrgIdComplianceCoiDetailsIdRouteRoute: typeof ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceCoiRouteRouteChildren: ConsoleOrgIdComplianceCoiRouteRouteChildren =
  {
    ConsoleOrgIdComplianceCoiIndexRoute: ConsoleOrgIdComplianceCoiIndexRoute,
    ConsoleOrgIdComplianceCoiAddRouteRoute:
      ConsoleOrgIdComplianceCoiAddRouteRoute,
    ConsoleOrgIdComplianceCoiDetailsIdRouteRoute:
      ConsoleOrgIdComplianceCoiDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceCoiRouteRouteWithChildren =
  ConsoleOrgIdComplianceCoiRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceCoiRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteChildren {
  ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute;
  ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute;
}

const ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteChildren: ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteChildren =
  {
    ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdManageIncidentsRoute,
    ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdManageNoteAddRouteRoute,
  };

const ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteChildren {
  ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute;
  ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute;
  ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute;
  ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute;
  ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteChildren: ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdIndexRoute,
    ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdCommsRouteRoute,
    ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdHistoryRouteRoute,
    ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdLibraryRouteRoute,
    ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdManageRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceComplaintsRouteRouteChildren {
  ConsoleOrgIdComplianceComplaintsIndexRoute: typeof ConsoleOrgIdComplianceComplaintsIndexRoute;
  ConsoleOrgIdComplianceComplaintsAddRouteRoute: typeof ConsoleOrgIdComplianceComplaintsAddRouteRoute;
  ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute: typeof ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceComplaintsRouteRouteChildren: ConsoleOrgIdComplianceComplaintsRouteRouteChildren =
  {
    ConsoleOrgIdComplianceComplaintsIndexRoute:
      ConsoleOrgIdComplianceComplaintsIndexRoute,
    ConsoleOrgIdComplianceComplaintsAddRouteRoute:
      ConsoleOrgIdComplianceComplaintsAddRouteRoute,
    ConsoleOrgIdComplianceComplaintsDetailsIdRouteRoute:
      ConsoleOrgIdComplianceComplaintsDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren =
  ConsoleOrgIdComplianceComplaintsRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceComplaintsRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteChildren {
  ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute;
  ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute;
}

const ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteChildren: ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteChildren =
  {
    ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdManageComplaintsRoute,
    ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdManageNoteAddRouteRoute,
  };

const ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteChildren {
  ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute;
  ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute;
  ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute;
  ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteChildren: ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdIndexRoute,
    ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdHistoryRouteRoute,
    ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdLibraryRouteRoute,
    ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdManageRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceIncidentsRouteRouteChildren {
  ConsoleOrgIdComplianceIncidentsIndexRoute: typeof ConsoleOrgIdComplianceIncidentsIndexRoute;
  ConsoleOrgIdComplianceIncidentsAddRoute: typeof ConsoleOrgIdComplianceIncidentsAddRoute;
  ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute: typeof ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceIncidentsRouteRouteChildren: ConsoleOrgIdComplianceIncidentsRouteRouteChildren =
  {
    ConsoleOrgIdComplianceIncidentsIndexRoute:
      ConsoleOrgIdComplianceIncidentsIndexRoute,
    ConsoleOrgIdComplianceIncidentsAddRoute:
      ConsoleOrgIdComplianceIncidentsAddRoute,
    ConsoleOrgIdComplianceIncidentsDetailsIdRouteRoute:
      ConsoleOrgIdComplianceIncidentsDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren =
  ConsoleOrgIdComplianceIncidentsRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceIncidentsRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteChildren {
  ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute;
  ConsoleOrgIdComplianceObligationsDetailsIdManageRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdManageRoute;
}

const ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteChildren: ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute:
      ConsoleOrgIdComplianceObligationsDetailsIdDebugRoute,
    ConsoleOrgIdComplianceObligationsDetailsIdManageRoute:
      ConsoleOrgIdComplianceObligationsDetailsIdManageRoute,
  };

const ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceObligationsRouteRouteChildren {
  ConsoleOrgIdComplianceObligationsIndexRoute: typeof ConsoleOrgIdComplianceObligationsIndexRoute;
  ConsoleOrgIdComplianceObligationsAddRouteRoute: typeof ConsoleOrgIdComplianceObligationsAddRouteRoute;
  ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute: typeof ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceObligationsRouteRouteChildren: ConsoleOrgIdComplianceObligationsRouteRouteChildren =
  {
    ConsoleOrgIdComplianceObligationsIndexRoute:
      ConsoleOrgIdComplianceObligationsIndexRoute,
    ConsoleOrgIdComplianceObligationsAddRouteRoute:
      ConsoleOrgIdComplianceObligationsAddRouteRoute,
    ConsoleOrgIdComplianceObligationsDetailsIdRouteRoute:
      ConsoleOrgIdComplianceObligationsDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceObligationsRouteRouteWithChildren =
  ConsoleOrgIdComplianceObligationsRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceObligationsRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteChildren {
  ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute;
  ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute;
}

const ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteChildren: ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteChildren =
  {
    ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute:
      ConsoleOrgIdComplianceRegistersRegisterIdIndexRoute,
    ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute:
      ConsoleOrgIdComplianceRegistersRegisterIdRecordsRecordIdRoute,
  };

const ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceRegistersRouteRouteChildren {
  ConsoleOrgIdComplianceRegistersIndexRoute: typeof ConsoleOrgIdComplianceRegistersIndexRoute;
  ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute: typeof ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceRegistersRouteRouteChildren: ConsoleOrgIdComplianceRegistersRouteRouteChildren =
  {
    ConsoleOrgIdComplianceRegistersIndexRoute:
      ConsoleOrgIdComplianceRegistersIndexRoute,
    ConsoleOrgIdComplianceRegistersRegisterIdRouteRoute:
      ConsoleOrgIdComplianceRegistersRegisterIdRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceRegistersRouteRouteWithChildren =
  ConsoleOrgIdComplianceRegistersRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRegistersRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceTrainingSearchRouteRouteChildren {
  ConsoleOrgIdComplianceTrainingSearchAddRoute: typeof ConsoleOrgIdComplianceTrainingSearchAddRoute;
}

const ConsoleOrgIdComplianceTrainingSearchRouteRouteChildren: ConsoleOrgIdComplianceTrainingSearchRouteRouteChildren =
  {
    ConsoleOrgIdComplianceTrainingSearchAddRoute:
      ConsoleOrgIdComplianceTrainingSearchAddRoute,
  };

const ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren =
  ConsoleOrgIdComplianceTrainingSearchRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceTrainingSearchRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteChildren {
  ConsoleOrgIdComplianceTrainingUserUserIdAddRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdAddRoute;
  ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute;
}

const ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteChildren: ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteChildren =
  {
    ConsoleOrgIdComplianceTrainingUserUserIdAddRoute:
      ConsoleOrgIdComplianceTrainingUserUserIdAddRoute,
    ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute:
      ConsoleOrgIdComplianceTrainingUserUserIdEditRecordIdRoute,
  };

const ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren =
  ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceTrainingRouteRouteChildren {
  ConsoleOrgIdComplianceTrainingIndexRoute: typeof ConsoleOrgIdComplianceTrainingIndexRoute;
  ConsoleOrgIdComplianceTrainingSearchRouteRoute: typeof ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren;
  ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute: typeof ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceTrainingRouteRouteChildren: ConsoleOrgIdComplianceTrainingRouteRouteChildren =
  {
    ConsoleOrgIdComplianceTrainingIndexRoute:
      ConsoleOrgIdComplianceTrainingIndexRoute,
    ConsoleOrgIdComplianceTrainingSearchRouteRoute:
      ConsoleOrgIdComplianceTrainingSearchRouteRouteWithChildren,
    ConsoleOrgIdComplianceTrainingUserUserIdRouteRoute:
      ConsoleOrgIdComplianceTrainingUserUserIdRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceTrainingRouteRouteWithChildren =
  ConsoleOrgIdComplianceTrainingRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceTrainingRouteRouteChildren,
  );

interface ConsoleOrgIdComplianceRouteRouteChildren {
  ConsoleOrgIdComplianceIndexRoute: typeof ConsoleOrgIdComplianceIndexRoute;
  ConsoleOrgIdComplianceCoiRouteRoute: typeof ConsoleOrgIdComplianceCoiRouteRouteWithChildren;
  ConsoleOrgIdComplianceComplaintsRouteRoute: typeof ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren;
  ConsoleOrgIdComplianceIncidentsRouteRoute: typeof ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren;
  ConsoleOrgIdComplianceIntakeRouteRoute: typeof ConsoleOrgIdComplianceIntakeRouteRoute;
  ConsoleOrgIdComplianceObligationsRouteRoute: typeof ConsoleOrgIdComplianceObligationsRouteRouteWithChildren;
  ConsoleOrgIdComplianceRegistersRouteRoute: typeof ConsoleOrgIdComplianceRegistersRouteRouteWithChildren;
  ConsoleOrgIdComplianceTrainingRouteRoute: typeof ConsoleOrgIdComplianceTrainingRouteRouteWithChildren;
}

const ConsoleOrgIdComplianceRouteRouteChildren: ConsoleOrgIdComplianceRouteRouteChildren =
  {
    ConsoleOrgIdComplianceIndexRoute: ConsoleOrgIdComplianceIndexRoute,
    ConsoleOrgIdComplianceCoiRouteRoute:
      ConsoleOrgIdComplianceCoiRouteRouteWithChildren,
    ConsoleOrgIdComplianceComplaintsRouteRoute:
      ConsoleOrgIdComplianceComplaintsRouteRouteWithChildren,
    ConsoleOrgIdComplianceIncidentsRouteRoute:
      ConsoleOrgIdComplianceIncidentsRouteRouteWithChildren,
    ConsoleOrgIdComplianceIntakeRouteRoute:
      ConsoleOrgIdComplianceIntakeRouteRoute,
    ConsoleOrgIdComplianceObligationsRouteRoute:
      ConsoleOrgIdComplianceObligationsRouteRouteWithChildren,
    ConsoleOrgIdComplianceRegistersRouteRoute:
      ConsoleOrgIdComplianceRegistersRouteRouteWithChildren,
    ConsoleOrgIdComplianceTrainingRouteRoute:
      ConsoleOrgIdComplianceTrainingRouteRouteWithChildren,
  };

const ConsoleOrgIdComplianceRouteRouteWithChildren =
  ConsoleOrgIdComplianceRouteRoute._addFileChildren(
    ConsoleOrgIdComplianceRouteRouteChildren,
  );

interface ConsoleOrgIdComponentShowcaseRouteRouteChildren {
  ConsoleOrgIdComponentShowcaseIndexRoute: typeof ConsoleOrgIdComponentShowcaseIndexRoute;
  ConsoleOrgIdComponentShowcaseAiChatTestRoute: typeof ConsoleOrgIdComponentShowcaseAiChatTestRoute;
  ConsoleOrgIdComponentShowcaseButtonIconTestRoute: typeof ConsoleOrgIdComponentShowcaseButtonIconTestRoute;
  ConsoleOrgIdComponentShowcaseButtonVariantsRoute: typeof ConsoleOrgIdComponentShowcaseButtonVariantsRoute;
  ConsoleOrgIdComponentShowcaseComponentShowcaseRoute: typeof ConsoleOrgIdComponentShowcaseComponentShowcaseRoute;
  ConsoleOrgIdComponentShowcaseDatePickerTestRoute: typeof ConsoleOrgIdComponentShowcaseDatePickerTestRoute;
  ConsoleOrgIdComponentShowcaseFitOnPageRoute: typeof ConsoleOrgIdComponentShowcaseFitOnPageRoute;
  ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute: typeof ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute;
  ConsoleOrgIdComponentShowcaseTableShowcaseRoute: typeof ConsoleOrgIdComponentShowcaseTableShowcaseRoute;
  ConsoleOrgIdComponentShowcaseTagVariantsRoute: typeof ConsoleOrgIdComponentShowcaseTagVariantsRoute;
  ConsoleOrgIdComponentShowcaseTiptapTestRoute: typeof ConsoleOrgIdComponentShowcaseTiptapTestRoute;
}

const ConsoleOrgIdComponentShowcaseRouteRouteChildren: ConsoleOrgIdComponentShowcaseRouteRouteChildren =
  {
    ConsoleOrgIdComponentShowcaseIndexRoute:
      ConsoleOrgIdComponentShowcaseIndexRoute,
    ConsoleOrgIdComponentShowcaseAiChatTestRoute:
      ConsoleOrgIdComponentShowcaseAiChatTestRoute,
    ConsoleOrgIdComponentShowcaseButtonIconTestRoute:
      ConsoleOrgIdComponentShowcaseButtonIconTestRoute,
    ConsoleOrgIdComponentShowcaseButtonVariantsRoute:
      ConsoleOrgIdComponentShowcaseButtonVariantsRoute,
    ConsoleOrgIdComponentShowcaseComponentShowcaseRoute:
      ConsoleOrgIdComponentShowcaseComponentShowcaseRoute,
    ConsoleOrgIdComponentShowcaseDatePickerTestRoute:
      ConsoleOrgIdComponentShowcaseDatePickerTestRoute,
    ConsoleOrgIdComponentShowcaseFitOnPageRoute:
      ConsoleOrgIdComponentShowcaseFitOnPageRoute,
    ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute:
      ConsoleOrgIdComponentShowcaseMarkdownShowcaseRoute,
    ConsoleOrgIdComponentShowcaseTableShowcaseRoute:
      ConsoleOrgIdComponentShowcaseTableShowcaseRoute,
    ConsoleOrgIdComponentShowcaseTagVariantsRoute:
      ConsoleOrgIdComponentShowcaseTagVariantsRoute,
    ConsoleOrgIdComponentShowcaseTiptapTestRoute:
      ConsoleOrgIdComponentShowcaseTiptapTestRoute,
  };

const ConsoleOrgIdComponentShowcaseRouteRouteWithChildren =
  ConsoleOrgIdComponentShowcaseRouteRoute._addFileChildren(
    ConsoleOrgIdComponentShowcaseRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteChildren {
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute;
}

const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteChildren: ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute:
      ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdIndexRoute,
  };

const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteChildren {
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute;
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteChildren: ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute:
      ConsoleOrgIdConfigurationApiIntegrationsFormDesignerIndexRoute,
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRoute:
      ConsoleOrgIdConfigurationApiIntegrationsFormDesignerFormDefinitionIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteWithChildren =
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationApiIntegrationsRouteRouteChildren {
  ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute;
  ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteWithChildren;
  ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute;
}

const ConsoleOrgIdConfigurationApiIntegrationsRouteRouteChildren: ConsoleOrgIdConfigurationApiIntegrationsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute:
      ConsoleOrgIdConfigurationApiIntegrationsApiTokensRouteRoute,
    ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRoute:
      ConsoleOrgIdConfigurationApiIntegrationsFormDesignerRouteRouteWithChildren,
    ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute:
      ConsoleOrgIdConfigurationApiIntegrationsMcpAccessRouteRoute,
  };

const ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationApiIntegrationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationApiIntegrationsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsEditCatastropheEventIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsEditClaimFlagIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralClaimStatusesEditClaimStatusIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksEditIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchTaskListIdTasksRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchEditIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsIndexRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsSearchRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute;
  ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsIndexRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsCatastropheEventsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsClaimFlagsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsDocumentsRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsGeneralRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsHandlingStandardsRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsTaskListsRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineConditionsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineExclusionsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineGuideRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLimitsExcessesRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineLossCausesRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineOverviewRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEnginePolicyTriggerMappingRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineProductInfoRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRedFlagsRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdDecisionEngineRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdEditPdsIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsTextPdsIdRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdPdsPdsIdRouteRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeEditThirdPartyContactTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdDataFieldsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdPolicyFieldsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdThirdPartyContactTypeRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesEditTransactionTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdCostCodesRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdSectionsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTaxRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdTransactionTypesRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesProductTypeIdRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesEditProductTypeIdRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesFinancialsIdRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesStatesIdRouteRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesEditContactTypeIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdContactTypesRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDetailsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdDocumentsRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdFieldsRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdProductVersionsDetailsProductVersionIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2AddRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2DetailsProductIdRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2EditProductIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute;
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute;
}

const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute:
      ConsoleOrgIdConfigurationClaimsProductsQuestionnaireAddRoute,
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute:
      ConsoleOrgIdConfigurationClaimsProductsQuestionnaireEditQuestionnaireIdRoute,
  };

const ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClaimsProductsRouteRouteChildren {
  ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute;
  ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationClaimsProductsRouteRouteChildren: ConsoleOrgIdConfigurationClaimsProductsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsClaimsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsInsurersRouteRoute,
    ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductTypesRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsProductsV2RouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsQuestionnaireRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationClaimsProductsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationClaimsProductsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationClientDatabaseRouteChildren {
  ConsoleOrgIdConfigurationClientDatabaseSplatRoute: typeof ConsoleOrgIdConfigurationClientDatabaseSplatRoute;
}

const ConsoleOrgIdConfigurationClientDatabaseRouteChildren: ConsoleOrgIdConfigurationClientDatabaseRouteChildren =
  {
    ConsoleOrgIdConfigurationClientDatabaseSplatRoute:
      ConsoleOrgIdConfigurationClientDatabaseSplatRoute,
  };

const ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren =
  ConsoleOrgIdConfigurationClientDatabaseRoute._addFileChildren(
    ConsoleOrgIdConfigurationClientDatabaseRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute;
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute;
}

const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute:
      ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsAddRoute,
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute:
      ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsEditIdRouteRoute,
  };

const ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRoute:
      ConsoleOrgIdConfigurationComplianceAttestationsUserAttestationsRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute;
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute;
}

const ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsFlagsAddRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsFlagsEditComplaintFlagIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute;
  ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute;
  ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute;
  ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute;
  ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute;
}

const ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsIndexRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsBrandsRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsCustomFieldsRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsFlagsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsGeneralRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsRulesRoute,
  };

const ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceGeneralRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceGeneralIndexRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralIndexRoute;
  ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute;
  ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute;
}

const ConsoleOrgIdConfigurationComplianceGeneralRouteRouteChildren: ConsoleOrgIdConfigurationComplianceGeneralRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceGeneralIndexRoute:
      ConsoleOrgIdConfigurationComplianceGeneralIndexRoute,
    ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute:
      ConsoleOrgIdConfigurationComplianceGeneralAsicProductsRoute,
    ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute:
      ConsoleOrgIdConfigurationComplianceGeneralDocumentsRoute,
  };

const ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceGeneralRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute;
}

const ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsFlagsAddRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsFlagsEditIncidentFlagIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute;
}

const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteChildren: ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralIndexRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralIncidentDetailsRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralLodgementRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralRectificationRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralTimelineRoute,
  };

const ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute;
  ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute;
}

const ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsIndexRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsCustomFieldsRoute,
    ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsFlagsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsGeneralRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsRulesRoute,
  };

const ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute;
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute;
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute;
}

const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedAddRoute,
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsExcludedEditIdRoute,
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsIdentifiedEditIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute;
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute;
}

const ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteChildren: ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute:
      ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesAddRoute,
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprDefinitionsCategoriesEditIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute;
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute;
}

const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteChildren: ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute:
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigAddRoute,
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute:
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigEditIdRoute,
  };

const ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceMsprRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute: typeof ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute;
  ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute: typeof ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationComplianceMsprRouteRouteChildren: ConsoleOrgIdConfigurationComplianceMsprRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRoute:
      ConsoleOrgIdConfigurationComplianceMsprCriticalOperationsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRoute:
      ConsoleOrgIdConfigurationComplianceMsprDefinitionsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute:
      ConsoleOrgIdConfigurationComplianceMsprDocumentsRoute,
    ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRoute:
      ConsoleOrgIdConfigurationComplianceMsprGovernanceConfigRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceMsprRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceMsprRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceTrainingRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceTrainingIndexRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingIndexRoute;
  ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute;
  ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute;
}

const ConsoleOrgIdConfigurationComplianceTrainingRouteRouteChildren: ConsoleOrgIdConfigurationComplianceTrainingRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceTrainingIndexRoute:
      ConsoleOrgIdConfigurationComplianceTrainingIndexRoute,
    ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute:
      ConsoleOrgIdConfigurationComplianceTrainingCustomFieldsRoute,
    ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute:
      ConsoleOrgIdConfigurationComplianceTrainingTrainingPeriodsRoute,
  };

const ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceTrainingRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceTrainingRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationComplianceRouteRouteChildren {
  ConsoleOrgIdConfigurationComplianceIndexRoute: typeof ConsoleOrgIdConfigurationComplianceIndexRoute;
  ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute: typeof ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute;
  ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute: typeof ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute;
  ConsoleOrgIdConfigurationComplianceGeneralRouteRoute: typeof ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute: typeof ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceMsprRouteRoute: typeof ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceObligationsRoute: typeof ConsoleOrgIdConfigurationComplianceObligationsRoute;
  ConsoleOrgIdConfigurationComplianceTrainingRouteRoute: typeof ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationComplianceRouteRouteChildren: ConsoleOrgIdConfigurationComplianceRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationComplianceIndexRoute:
      ConsoleOrgIdConfigurationComplianceIndexRoute,
    ConsoleOrgIdConfigurationComplianceAttestationsRouteRoute:
      ConsoleOrgIdConfigurationComplianceAttestationsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute:
      ConsoleOrgIdConfigurationComplianceAutoDetectRouteRoute,
    ConsoleOrgIdConfigurationComplianceComplaintsRouteRoute:
      ConsoleOrgIdConfigurationComplianceComplaintsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute:
      ConsoleOrgIdConfigurationComplianceComplianceAuditRouteRoute,
    ConsoleOrgIdConfigurationComplianceGeneralRouteRoute:
      ConsoleOrgIdConfigurationComplianceGeneralRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceIncidentsRouteRoute:
      ConsoleOrgIdConfigurationComplianceIncidentsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceMsprRouteRoute:
      ConsoleOrgIdConfigurationComplianceMsprRouteRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceObligationsRoute:
      ConsoleOrgIdConfigurationComplianceObligationsRoute,
    ConsoleOrgIdConfigurationComplianceTrainingRouteRoute:
      ConsoleOrgIdConfigurationComplianceTrainingRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren =
  ConsoleOrgIdConfigurationComplianceRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationComplianceRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationFinancialsBillingRouteRouteChildren {
  ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute;
  ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute;
  ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute;
  ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute;
  ConsoleOrgIdConfigurationFinancialsBillingUsageRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingUsageRoute;
  ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute;
}

const ConsoleOrgIdConfigurationFinancialsBillingRouteRouteChildren: ConsoleOrgIdConfigurationFinancialsBillingRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute:
      ConsoleOrgIdConfigurationFinancialsBillingBalanceRoute,
    ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute:
      ConsoleOrgIdConfigurationFinancialsBillingBillingInfoRoute,
    ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute:
      ConsoleOrgIdConfigurationFinancialsBillingInvoicesRoute,
    ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute:
      ConsoleOrgIdConfigurationFinancialsBillingTransactionsRoute,
    ConsoleOrgIdConfigurationFinancialsBillingUsageRoute:
      ConsoleOrgIdConfigurationFinancialsBillingUsageRoute,
    ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute:
      ConsoleOrgIdConfigurationFinancialsBillingPaymentSuccessRoute,
  };

const ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFinancialsBillingRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFinancialsBillingRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationFinancialsRouteRouteChildren {
  ConsoleOrgIdConfigurationFinancialsBillingRouteRoute: typeof ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren;
  ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute: typeof ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute;
  ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute: typeof ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute;
}

const ConsoleOrgIdConfigurationFinancialsRouteRouteChildren: ConsoleOrgIdConfigurationFinancialsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationFinancialsBillingRouteRoute:
      ConsoleOrgIdConfigurationFinancialsBillingRouteRouteWithChildren,
    ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute:
      ConsoleOrgIdConfigurationFinancialsExpensesBillingRouteRoute,
    ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute:
      ConsoleOrgIdConfigurationFinancialsPaymentsRouteRoute,
  };

const ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFinancialsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFinancialsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteChildren {
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute;
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute;
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute;
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute;
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute;
}

const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteChildren: ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdClientsRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdDriversRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdOverviewRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdPortalAccessRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdVehiclesRoute,
  };

const ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteChildren {
  ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute;
  ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteChildren: ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseAddRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationFleetRouteRouteChildren {
  ConsoleOrgIdConfigurationFleetIndexRoute: typeof ConsoleOrgIdConfigurationFleetIndexRoute;
  ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute: typeof ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren;
  ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute: typeof ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute;
  ConsoleOrgIdConfigurationFleetEscalationsRouteRoute: typeof ConsoleOrgIdConfigurationFleetEscalationsRouteRoute;
  ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute: typeof ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute;
}

const ConsoleOrgIdConfigurationFleetRouteRouteChildren: ConsoleOrgIdConfigurationFleetRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationFleetIndexRoute:
      ConsoleOrgIdConfigurationFleetIndexRoute,
    ConsoleOrgIdConfigurationFleetClientDatabaseRouteRoute:
      ConsoleOrgIdConfigurationFleetClientDatabaseRouteRouteWithChildren,
    ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute:
      ConsoleOrgIdConfigurationFleetDelegatedAuthorityRouteRoute,
    ConsoleOrgIdConfigurationFleetEscalationsRouteRoute:
      ConsoleOrgIdConfigurationFleetEscalationsRouteRoute,
    ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute:
      ConsoleOrgIdConfigurationFleetPortalClaimPageRouteRoute,
  };

const ConsoleOrgIdConfigurationFleetRouteRouteWithChildren =
  ConsoleOrgIdConfigurationFleetRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationFleetRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationMonitoringRouteRouteChildren {
  ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute: typeof ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute;
  ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute: typeof ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute;
  ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute: typeof ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute;
}

const ConsoleOrgIdConfigurationMonitoringRouteRouteChildren: ConsoleOrgIdConfigurationMonitoringRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute:
      ConsoleOrgIdConfigurationMonitoringAuditTrailRouteRoute,
    ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute:
      ConsoleOrgIdConfigurationMonitoringEmailActivityRouteRoute,
    ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute:
      ConsoleOrgIdConfigurationMonitoringStatisticsRouteRoute,
  };

const ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren =
  ConsoleOrgIdConfigurationMonitoringRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationMonitoringRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute;
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute;
}

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesAddRoute,
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesEditCommSignatureIdRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute;
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute;
}

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesAddRoute,
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesEditCommunicationTemplateIdRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren;
  ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommSignaturesRouteRouteWithChildren,
    ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationCommTemplatesRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute;
}

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute:
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdUsersRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute;
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute:
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesAddRoute,
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute;
  ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute;
}

const ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute:
      ConsoleOrgIdConfigurationOrgSettingsUsersIndexRoute,
    ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsUsersDetailsUserIdRouteRoute,
  };

const ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationOrgSettingsRouteRouteChildren {
  ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren;
  ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute: typeof ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute;
  ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren;
  ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute;
  ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute;
  ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute;
  ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute;
  ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationOrgSettingsRouteRouteChildren: ConsoleOrgIdConfigurationOrgSettingsRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsCommunicationRouteRouteWithChildren,
    ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute:
      ConsoleOrgIdConfigurationOrgSettingsFleetEscalationsRoute,
    ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsHandlingPartiesRouteRouteWithChildren,
    ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsSupportSessionsRouteRoute,
    ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsSystemRouteRoute,
    ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsTasksRouteRoute,
    ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsTrashRouteRoute,
    ConsoleOrgIdConfigurationOrgSettingsUsersRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsUsersRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren =
  ConsoleOrgIdConfigurationOrgSettingsRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationOrgSettingsRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationRiskRouteRouteChildren {
  ConsoleOrgIdConfigurationRiskIndexRoute: typeof ConsoleOrgIdConfigurationRiskIndexRoute;
  ConsoleOrgIdConfigurationRiskAppetiteRoute: typeof ConsoleOrgIdConfigurationRiskAppetiteRoute;
  ConsoleOrgIdConfigurationRiskCategoriesRoute: typeof ConsoleOrgIdConfigurationRiskCategoriesRoute;
  ConsoleOrgIdConfigurationRiskMatrixRoute: typeof ConsoleOrgIdConfigurationRiskMatrixRoute;
}

const ConsoleOrgIdConfigurationRiskRouteRouteChildren: ConsoleOrgIdConfigurationRiskRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationRiskIndexRoute:
      ConsoleOrgIdConfigurationRiskIndexRoute,
    ConsoleOrgIdConfigurationRiskAppetiteRoute:
      ConsoleOrgIdConfigurationRiskAppetiteRoute,
    ConsoleOrgIdConfigurationRiskCategoriesRoute:
      ConsoleOrgIdConfigurationRiskCategoriesRoute,
    ConsoleOrgIdConfigurationRiskMatrixRoute:
      ConsoleOrgIdConfigurationRiskMatrixRoute,
  };

const ConsoleOrgIdConfigurationRiskRouteRouteWithChildren =
  ConsoleOrgIdConfigurationRiskRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationRiskRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteChildren {
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute;
}

const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteChildren: ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsAddRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdContactsEditContactIdRoute,
  };

const ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteChildren {
  ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute;
  ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteChildren: ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersIndexRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersAddRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersDefinitionsRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersListIndexRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersSearchIndexRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersSearchDefinitionsRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersSearchListRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdIndexRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersDetailsIdSplatRoute,
    ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersListDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationVendorManagementRouteRouteChildren {
  ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute: typeof ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationVendorManagementRouteRouteChildren: ConsoleOrgIdConfigurationVendorManagementRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRoute:
      ConsoleOrgIdConfigurationVendorManagementSuppliersRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren =
  ConsoleOrgIdConfigurationVendorManagementRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationVendorManagementRouteRouteChildren,
  );

interface ConsoleOrgIdConfigurationRouteRouteChildren {
  ConsoleOrgIdConfigurationIndexRoute: typeof ConsoleOrgIdConfigurationIndexRoute;
  ConsoleOrgIdConfigurationApiIntegrationsRouteRoute: typeof ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClaimsProductsRouteRoute: typeof ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationClientDatabaseRoute: typeof ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren;
  ConsoleOrgIdConfigurationComplianceRouteRoute: typeof ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren;
  ConsoleOrgIdConfigurationFinancialsRouteRoute: typeof ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationFleetRouteRoute: typeof ConsoleOrgIdConfigurationFleetRouteRouteWithChildren;
  ConsoleOrgIdConfigurationMonitoringRouteRoute: typeof ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren;
  ConsoleOrgIdConfigurationOrgSettingsRouteRoute: typeof ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren;
  ConsoleOrgIdConfigurationRiskRouteRoute: typeof ConsoleOrgIdConfigurationRiskRouteRouteWithChildren;
  ConsoleOrgIdConfigurationVendorManagementRouteRoute: typeof ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren;
}

const ConsoleOrgIdConfigurationRouteRouteChildren: ConsoleOrgIdConfigurationRouteRouteChildren =
  {
    ConsoleOrgIdConfigurationIndexRoute: ConsoleOrgIdConfigurationIndexRoute,
    ConsoleOrgIdConfigurationApiIntegrationsRouteRoute:
      ConsoleOrgIdConfigurationApiIntegrationsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClaimsProductsRouteRoute:
      ConsoleOrgIdConfigurationClaimsProductsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationClientDatabaseRoute:
      ConsoleOrgIdConfigurationClientDatabaseRouteWithChildren,
    ConsoleOrgIdConfigurationComplianceRouteRoute:
      ConsoleOrgIdConfigurationComplianceRouteRouteWithChildren,
    ConsoleOrgIdConfigurationFinancialsRouteRoute:
      ConsoleOrgIdConfigurationFinancialsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationFleetRouteRoute:
      ConsoleOrgIdConfigurationFleetRouteRouteWithChildren,
    ConsoleOrgIdConfigurationMonitoringRouteRoute:
      ConsoleOrgIdConfigurationMonitoringRouteRouteWithChildren,
    ConsoleOrgIdConfigurationOrgSettingsRouteRoute:
      ConsoleOrgIdConfigurationOrgSettingsRouteRouteWithChildren,
    ConsoleOrgIdConfigurationRiskRouteRoute:
      ConsoleOrgIdConfigurationRiskRouteRouteWithChildren,
    ConsoleOrgIdConfigurationVendorManagementRouteRoute:
      ConsoleOrgIdConfigurationVendorManagementRouteRouteWithChildren,
  };

const ConsoleOrgIdConfigurationRouteRouteWithChildren =
  ConsoleOrgIdConfigurationRouteRoute._addFileChildren(
    ConsoleOrgIdConfigurationRouteRouteChildren,
  );

interface ConsoleOrgIdControlsRegisterDetailsIdRouteRouteChildren {
  ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute;
  ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute;
  ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute;
  ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute;
}

const ConsoleOrgIdControlsRegisterDetailsIdRouteRouteChildren: ConsoleOrgIdControlsRegisterDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute:
      ConsoleOrgIdControlsRegisterDetailsIdActivityActivityIdRouteRoute,
    ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute:
      ConsoleOrgIdControlsRegisterDetailsIdActivityAddRouteRoute,
    ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute:
      ConsoleOrgIdControlsRegisterDetailsIdTestTestIdRouteRoute,
    ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute:
      ConsoleOrgIdControlsRegisterDetailsIdTestAddRouteRoute,
  };

const ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdControlsRegisterDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdControlsRegisterDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdControlsRegisterRouteRouteChildren {
  ConsoleOrgIdControlsRegisterIndexRoute: typeof ConsoleOrgIdControlsRegisterIndexRoute;
  ConsoleOrgIdControlsRegisterAddRouteRoute: typeof ConsoleOrgIdControlsRegisterAddRouteRoute;
  ConsoleOrgIdControlsRegisterDetailsIdRouteRoute: typeof ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdControlsRegisterRouteRouteChildren: ConsoleOrgIdControlsRegisterRouteRouteChildren =
  {
    ConsoleOrgIdControlsRegisterIndexRoute:
      ConsoleOrgIdControlsRegisterIndexRoute,
    ConsoleOrgIdControlsRegisterAddRouteRoute:
      ConsoleOrgIdControlsRegisterAddRouteRoute,
    ConsoleOrgIdControlsRegisterDetailsIdRouteRoute:
      ConsoleOrgIdControlsRegisterDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdControlsRegisterRouteRouteWithChildren =
  ConsoleOrgIdControlsRegisterRouteRoute._addFileChildren(
    ConsoleOrgIdControlsRegisterRouteRouteChildren,
  );

interface ConsoleOrgIdControlsRouteRouteChildren {
  ConsoleOrgIdControlsIndexRoute: typeof ConsoleOrgIdControlsIndexRoute;
  ConsoleOrgIdControlsActivitiesRouteRoute: typeof ConsoleOrgIdControlsActivitiesRouteRoute;
  ConsoleOrgIdControlsRegisterRouteRoute: typeof ConsoleOrgIdControlsRegisterRouteRouteWithChildren;
  ConsoleOrgIdControlsTestsRouteRoute: typeof ConsoleOrgIdControlsTestsRouteRoute;
}

const ConsoleOrgIdControlsRouteRouteChildren: ConsoleOrgIdControlsRouteRouteChildren =
  {
    ConsoleOrgIdControlsIndexRoute: ConsoleOrgIdControlsIndexRoute,
    ConsoleOrgIdControlsActivitiesRouteRoute:
      ConsoleOrgIdControlsActivitiesRouteRoute,
    ConsoleOrgIdControlsRegisterRouteRoute:
      ConsoleOrgIdControlsRegisterRouteRouteWithChildren,
    ConsoleOrgIdControlsTestsRouteRoute: ConsoleOrgIdControlsTestsRouteRoute,
  };

const ConsoleOrgIdControlsRouteRouteWithChildren =
  ConsoleOrgIdControlsRouteRoute._addFileChildren(
    ConsoleOrgIdControlsRouteRouteChildren,
  );

interface ConsoleOrgIdDashboardRouteRouteChildren {
  ConsoleOrgIdDashboardIndexRoute: typeof ConsoleOrgIdDashboardIndexRoute;
  ConsoleOrgIdDashboardClaimsRoute: typeof ConsoleOrgIdDashboardClaimsRoute;
  ConsoleOrgIdDashboardComplaintsRoute: typeof ConsoleOrgIdDashboardComplaintsRoute;
  ConsoleOrgIdDashboardIncidentsRoute: typeof ConsoleOrgIdDashboardIncidentsRoute;
  ConsoleOrgIdDashboardManagementRoute: typeof ConsoleOrgIdDashboardManagementRoute;
  ConsoleOrgIdDashboardPeopleAndCultureRoute: typeof ConsoleOrgIdDashboardPeopleAndCultureRoute;
  ConsoleOrgIdDashboardRisksRoute: typeof ConsoleOrgIdDashboardRisksRoute;
}

const ConsoleOrgIdDashboardRouteRouteChildren: ConsoleOrgIdDashboardRouteRouteChildren =
  {
    ConsoleOrgIdDashboardIndexRoute: ConsoleOrgIdDashboardIndexRoute,
    ConsoleOrgIdDashboardClaimsRoute: ConsoleOrgIdDashboardClaimsRoute,
    ConsoleOrgIdDashboardComplaintsRoute: ConsoleOrgIdDashboardComplaintsRoute,
    ConsoleOrgIdDashboardIncidentsRoute: ConsoleOrgIdDashboardIncidentsRoute,
    ConsoleOrgIdDashboardManagementRoute: ConsoleOrgIdDashboardManagementRoute,
    ConsoleOrgIdDashboardPeopleAndCultureRoute:
      ConsoleOrgIdDashboardPeopleAndCultureRoute,
    ConsoleOrgIdDashboardRisksRoute: ConsoleOrgIdDashboardRisksRoute,
  };

const ConsoleOrgIdDashboardRouteRouteWithChildren =
  ConsoleOrgIdDashboardRouteRoute._addFileChildren(
    ConsoleOrgIdDashboardRouteRouteChildren,
  );

interface ConsoleOrgIdDocumentsRouteRouteChildren {
  ConsoleOrgIdDocumentsDetailsFileIdRouteRoute: typeof ConsoleOrgIdDocumentsDetailsFileIdRouteRoute;
}

const ConsoleOrgIdDocumentsRouteRouteChildren: ConsoleOrgIdDocumentsRouteRouteChildren =
  {
    ConsoleOrgIdDocumentsDetailsFileIdRouteRoute:
      ConsoleOrgIdDocumentsDetailsFileIdRouteRoute,
  };

const ConsoleOrgIdDocumentsRouteRouteWithChildren =
  ConsoleOrgIdDocumentsRouteRoute._addFileChildren(
    ConsoleOrgIdDocumentsRouteRouteChildren,
  );

interface ConsoleOrgIdFleetPortalClaimsRouteRouteChildren {
  ConsoleOrgIdFleetPortalClaimsIndexRoute: typeof ConsoleOrgIdFleetPortalClaimsIndexRoute;
  ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute: typeof ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute;
}

const ConsoleOrgIdFleetPortalClaimsRouteRouteChildren: ConsoleOrgIdFleetPortalClaimsRouteRouteChildren =
  {
    ConsoleOrgIdFleetPortalClaimsIndexRoute:
      ConsoleOrgIdFleetPortalClaimsIndexRoute,
    ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute:
      ConsoleOrgIdFleetPortalClaimsDetailsClaimIdRoute,
  };

const ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren =
  ConsoleOrgIdFleetPortalClaimsRouteRoute._addFileChildren(
    ConsoleOrgIdFleetPortalClaimsRouteRouteChildren,
  );

interface ConsoleOrgIdFleetPortalRouteRouteChildren {
  ConsoleOrgIdFleetPortalIndexRoute: typeof ConsoleOrgIdFleetPortalIndexRoute;
  ConsoleOrgIdFleetPortalAuthorisationsRoute: typeof ConsoleOrgIdFleetPortalAuthorisationsRoute;
  ConsoleOrgIdFleetPortalClaimsRouteRoute: typeof ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren;
  ConsoleOrgIdFleetPortalDashboardRoute: typeof ConsoleOrgIdFleetPortalDashboardRoute;
  ConsoleOrgIdFleetPortalFleetRoute: typeof ConsoleOrgIdFleetPortalFleetRoute;
  ConsoleOrgIdFleetPortalSlaRoute: typeof ConsoleOrgIdFleetPortalSlaRoute;
}

const ConsoleOrgIdFleetPortalRouteRouteChildren: ConsoleOrgIdFleetPortalRouteRouteChildren =
  {
    ConsoleOrgIdFleetPortalIndexRoute: ConsoleOrgIdFleetPortalIndexRoute,
    ConsoleOrgIdFleetPortalAuthorisationsRoute:
      ConsoleOrgIdFleetPortalAuthorisationsRoute,
    ConsoleOrgIdFleetPortalClaimsRouteRoute:
      ConsoleOrgIdFleetPortalClaimsRouteRouteWithChildren,
    ConsoleOrgIdFleetPortalDashboardRoute:
      ConsoleOrgIdFleetPortalDashboardRoute,
    ConsoleOrgIdFleetPortalFleetRoute: ConsoleOrgIdFleetPortalFleetRoute,
    ConsoleOrgIdFleetPortalSlaRoute: ConsoleOrgIdFleetPortalSlaRoute,
  };

const ConsoleOrgIdFleetPortalRouteRouteWithChildren =
  ConsoleOrgIdFleetPortalRouteRoute._addFileChildren(
    ConsoleOrgIdFleetPortalRouteRouteChildren,
  );

interface ConsoleOrgIdMsprMspExceptionsRouteRouteChildren {
  ConsoleOrgIdMsprMspExceptionsEditIdRoute: typeof ConsoleOrgIdMsprMspExceptionsEditIdRoute;
}

const ConsoleOrgIdMsprMspExceptionsRouteRouteChildren: ConsoleOrgIdMsprMspExceptionsRouteRouteChildren =
  {
    ConsoleOrgIdMsprMspExceptionsEditIdRoute:
      ConsoleOrgIdMsprMspExceptionsEditIdRoute,
  };

const ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren =
  ConsoleOrgIdMsprMspExceptionsRouteRoute._addFileChildren(
    ConsoleOrgIdMsprMspExceptionsRouteRouteChildren,
  );

interface ConsoleOrgIdMsprServiceProvidersSearchRouteRouteChildren {
  ConsoleOrgIdMsprServiceProvidersSearchAddRoute: typeof ConsoleOrgIdMsprServiceProvidersSearchAddRoute;
}

const ConsoleOrgIdMsprServiceProvidersSearchRouteRouteChildren: ConsoleOrgIdMsprServiceProvidersSearchRouteRouteChildren =
  {
    ConsoleOrgIdMsprServiceProvidersSearchAddRoute:
      ConsoleOrgIdMsprServiceProvidersSearchAddRoute,
  };

const ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersSearchRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersSearchRouteRouteChildren,
  );

interface ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteChildren {
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute;
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute;
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute;
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute;
}

const ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteChildren: ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteChildren =
  {
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageAddRoute,
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckCheckIdRouteRoute,
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageCheckAddRouteRoute,
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageEditArrangementIdRoute,
  };

const ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteChildren,
  );

interface ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteChildren {
  ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute;
  ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute;
  ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren;
}

const ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteChildren: ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdHistoryRouteRoute,
    ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdLibraryRouteRoute,
    ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdManageRouteRouteWithChildren,
  };

const ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdMsprServiceProvidersRouteRouteChildren {
  ConsoleOrgIdMsprServiceProvidersIndexRoute: typeof ConsoleOrgIdMsprServiceProvidersIndexRoute;
  ConsoleOrgIdMsprServiceProvidersSearchRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren;
  ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdMsprServiceProvidersRouteRouteChildren: ConsoleOrgIdMsprServiceProvidersRouteRouteChildren =
  {
    ConsoleOrgIdMsprServiceProvidersIndexRoute:
      ConsoleOrgIdMsprServiceProvidersIndexRoute,
    ConsoleOrgIdMsprServiceProvidersSearchRouteRoute:
      ConsoleOrgIdMsprServiceProvidersSearchRouteRouteWithChildren,
    ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRoute:
      ConsoleOrgIdMsprServiceProvidersDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren =
  ConsoleOrgIdMsprServiceProvidersRouteRoute._addFileChildren(
    ConsoleOrgIdMsprServiceProvidersRouteRouteChildren,
  );

interface ConsoleOrgIdMsprRouteRouteChildren {
  ConsoleOrgIdMsprMspExceptionsRouteRoute: typeof ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren;
  ConsoleOrgIdMsprServiceProvidersRouteRoute: typeof ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren;
}

const ConsoleOrgIdMsprRouteRouteChildren: ConsoleOrgIdMsprRouteRouteChildren = {
  ConsoleOrgIdMsprMspExceptionsRouteRoute:
    ConsoleOrgIdMsprMspExceptionsRouteRouteWithChildren,
  ConsoleOrgIdMsprServiceProvidersRouteRoute:
    ConsoleOrgIdMsprServiceProvidersRouteRouteWithChildren,
};

const ConsoleOrgIdMsprRouteRouteWithChildren =
  ConsoleOrgIdMsprRouteRoute._addFileChildren(
    ConsoleOrgIdMsprRouteRouteChildren,
  );

interface ConsoleOrgIdReportingRouteRouteChildren {
  ConsoleOrgIdReportingAddRoute: typeof ConsoleOrgIdReportingAddRoute;
}

const ConsoleOrgIdReportingRouteRouteChildren: ConsoleOrgIdReportingRouteRouteChildren =
  {
    ConsoleOrgIdReportingAddRoute: ConsoleOrgIdReportingAddRoute,
  };

const ConsoleOrgIdReportingRouteRouteWithChildren =
  ConsoleOrgIdReportingRouteRoute._addFileChildren(
    ConsoleOrgIdReportingRouteRouteChildren,
  );

interface ConsoleOrgIdRiskRasRouteRouteChildren {
  ConsoleOrgIdRiskRasIndexRoute: typeof ConsoleOrgIdRiskRasIndexRoute;
  ConsoleOrgIdRiskRasDetailsIdRouteRoute: typeof ConsoleOrgIdRiskRasDetailsIdRouteRoute;
}

const ConsoleOrgIdRiskRasRouteRouteChildren: ConsoleOrgIdRiskRasRouteRouteChildren =
  {
    ConsoleOrgIdRiskRasIndexRoute: ConsoleOrgIdRiskRasIndexRoute,
    ConsoleOrgIdRiskRasDetailsIdRouteRoute:
      ConsoleOrgIdRiskRasDetailsIdRouteRoute,
  };

const ConsoleOrgIdRiskRasRouteRouteWithChildren =
  ConsoleOrgIdRiskRasRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRasRouteRouteChildren,
  );

interface ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteChildren {
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute;
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute;
}

const ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteChildren: ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteChildren =
  {
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute:
      ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanActionPlanIdRouteRoute,
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute:
      ConsoleOrgIdRiskRegisterDetailsIdActionPlanActionPlanAddRouteRoute,
  };

const ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteChildren,
  );

interface ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteChildren {
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute;
}

const ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteChildren: ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteChildren =
  {
    ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute:
      ConsoleOrgIdRiskRegisterDetailsIdAssessmentIncidentsRoute,
  };

const ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteChildren,
  );

interface ConsoleOrgIdRiskRegisterDetailsIdRouteRouteChildren {
  ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren;
  ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren;
  ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute;
}

const ConsoleOrgIdRiskRegisterDetailsIdRouteRouteChildren: ConsoleOrgIdRiskRegisterDetailsIdRouteRouteChildren =
  {
    ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRoute:
      ConsoleOrgIdRiskRegisterDetailsIdActionPlanRouteRouteWithChildren,
    ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRoute:
      ConsoleOrgIdRiskRegisterDetailsIdAssessmentRouteRouteWithChildren,
    ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute:
      ConsoleOrgIdRiskRegisterDetailsIdHistoryRoute,
  };

const ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterDetailsIdRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterDetailsIdRouteRouteChildren,
  );

interface ConsoleOrgIdRiskRegisterRouteRouteChildren {
  ConsoleOrgIdRiskRegisterIndexRoute: typeof ConsoleOrgIdRiskRegisterIndexRoute;
  ConsoleOrgIdRiskRegisterDetailsIdRouteRoute: typeof ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren;
}

const ConsoleOrgIdRiskRegisterRouteRouteChildren: ConsoleOrgIdRiskRegisterRouteRouteChildren =
  {
    ConsoleOrgIdRiskRegisterIndexRoute: ConsoleOrgIdRiskRegisterIndexRoute,
    ConsoleOrgIdRiskRegisterDetailsIdRouteRoute:
      ConsoleOrgIdRiskRegisterDetailsIdRouteRouteWithChildren,
  };

const ConsoleOrgIdRiskRegisterRouteRouteWithChildren =
  ConsoleOrgIdRiskRegisterRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRegisterRouteRouteChildren,
  );

interface ConsoleOrgIdRiskRouteRouteChildren {
  ConsoleOrgIdRiskIndexRoute: typeof ConsoleOrgIdRiskIndexRoute;
  ConsoleOrgIdRiskRasRouteRoute: typeof ConsoleOrgIdRiskRasRouteRouteWithChildren;
  ConsoleOrgIdRiskRegisterRouteRoute: typeof ConsoleOrgIdRiskRegisterRouteRouteWithChildren;
}

const ConsoleOrgIdRiskRouteRouteChildren: ConsoleOrgIdRiskRouteRouteChildren = {
  ConsoleOrgIdRiskIndexRoute: ConsoleOrgIdRiskIndexRoute,
  ConsoleOrgIdRiskRasRouteRoute: ConsoleOrgIdRiskRasRouteRouteWithChildren,
  ConsoleOrgIdRiskRegisterRouteRoute:
    ConsoleOrgIdRiskRegisterRouteRouteWithChildren,
};

const ConsoleOrgIdRiskRouteRouteWithChildren =
  ConsoleOrgIdRiskRouteRoute._addFileChildren(
    ConsoleOrgIdRiskRouteRouteChildren,
  );

interface ConsoleOrgIdToolsAutoDetectInboxRouteRouteChildren {
  ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute: typeof ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute;
}

const ConsoleOrgIdToolsAutoDetectInboxRouteRouteChildren: ConsoleOrgIdToolsAutoDetectInboxRouteRouteChildren =
  {
    ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute:
      ConsoleOrgIdToolsAutoDetectInboxIdReviewEmailClassificationRoute,
  };

const ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren =
  ConsoleOrgIdToolsAutoDetectInboxRouteRoute._addFileChildren(
    ConsoleOrgIdToolsAutoDetectInboxRouteRouteChildren,
  );

interface ConsoleOrgIdToolsAutoDetectRouteRouteChildren {
  ConsoleOrgIdToolsAutoDetectDashboardRoute: typeof ConsoleOrgIdToolsAutoDetectDashboardRoute;
  ConsoleOrgIdToolsAutoDetectInboxRouteRoute: typeof ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren;
}

const ConsoleOrgIdToolsAutoDetectRouteRouteChildren: ConsoleOrgIdToolsAutoDetectRouteRouteChildren =
  {
    ConsoleOrgIdToolsAutoDetectDashboardRoute:
      ConsoleOrgIdToolsAutoDetectDashboardRoute,
    ConsoleOrgIdToolsAutoDetectInboxRouteRoute:
      ConsoleOrgIdToolsAutoDetectInboxRouteRouteWithChildren,
  };

const ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren =
  ConsoleOrgIdToolsAutoDetectRouteRoute._addFileChildren(
    ConsoleOrgIdToolsAutoDetectRouteRouteChildren,
  );

interface ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteChildren {
  ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute;
}

const ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteChildren: ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteChildren =
  {
    ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute:
      ConsoleOrgIdToolsComplianceAuditOverviewSearchAddRoute,
  };

const ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteChildren,
  );

interface ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteChildren {
  ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute;
  ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute;
  ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren;
}

const ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteChildren: ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteChildren =
  {
    ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute:
      ConsoleOrgIdToolsComplianceAuditOverviewIndexRoute,
    ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute:
      ConsoleOrgIdToolsComplianceAuditOverviewInsightsRoute,
    ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRoute:
      ConsoleOrgIdToolsComplianceAuditOverviewSearchRouteRouteWithChildren,
  };

const ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteChildren,
  );

interface ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteChildren {
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute: typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute;
}

const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteChildren: ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteChildren =
  {
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute:
      ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdStatisticsRoute,
  };

const ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteChildren,
  );

interface ConsoleOrgIdToolsComplianceAuditRouteRouteChildren {
  ConsoleOrgIdToolsComplianceAuditIndexRoute: typeof ConsoleOrgIdToolsComplianceAuditIndexRoute;
  ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute: typeof ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren;
  ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute: typeof ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren;
}

const ConsoleOrgIdToolsComplianceAuditRouteRouteChildren: ConsoleOrgIdToolsComplianceAuditRouteRouteChildren =
  {
    ConsoleOrgIdToolsComplianceAuditIndexRoute:
      ConsoleOrgIdToolsComplianceAuditIndexRoute,
    ConsoleOrgIdToolsComplianceAuditOverviewRouteRoute:
      ConsoleOrgIdToolsComplianceAuditOverviewRouteRouteWithChildren,
    ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRoute:
      ConsoleOrgIdToolsComplianceAuditDetailsComplianceAuditIdRouteWithChildren,
  };

const ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren =
  ConsoleOrgIdToolsComplianceAuditRouteRoute._addFileChildren(
    ConsoleOrgIdToolsComplianceAuditRouteRouteChildren,
  );

interface ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteChildren {
  ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute;
}

const ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteChildren: ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteChildren =
  {
    ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute:
      ConsoleOrgIdToolsDocumentAnalyzerHistoryIdResultsRoute,
  };

const ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren =
  ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute._addFileChildren(
    ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteChildren,
  );

interface ConsoleOrgIdToolsDocumentAnalyzerRouteRouteChildren {
  ConsoleOrgIdToolsDocumentAnalyzerIndexRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerIndexRoute;
  ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren;
  ConsoleOrgIdToolsDocumentAnalyzerUploadRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerUploadRoute;
}

const ConsoleOrgIdToolsDocumentAnalyzerRouteRouteChildren: ConsoleOrgIdToolsDocumentAnalyzerRouteRouteChildren =
  {
    ConsoleOrgIdToolsDocumentAnalyzerIndexRoute:
      ConsoleOrgIdToolsDocumentAnalyzerIndexRoute,
    ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRoute:
      ConsoleOrgIdToolsDocumentAnalyzerHistoryRouteRouteWithChildren,
    ConsoleOrgIdToolsDocumentAnalyzerUploadRoute:
      ConsoleOrgIdToolsDocumentAnalyzerUploadRoute,
  };

const ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren =
  ConsoleOrgIdToolsDocumentAnalyzerRouteRoute._addFileChildren(
    ConsoleOrgIdToolsDocumentAnalyzerRouteRouteChildren,
  );

interface ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteChildren {
  ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute: typeof ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute;
}

const ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteChildren: ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteChildren =
  {
    ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute:
      ConsoleOrgIdToolsPdsComparePdsDocumentsEditIdRoute,
  };

const ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren =
  ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute._addFileChildren(
    ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteChildren,
  );

interface ConsoleOrgIdToolsPdsCompareRouteRouteChildren {
  ConsoleOrgIdToolsPdsCompareIndexRoute: typeof ConsoleOrgIdToolsPdsCompareIndexRoute;
  ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute: typeof ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren;
}

const ConsoleOrgIdToolsPdsCompareRouteRouteChildren: ConsoleOrgIdToolsPdsCompareRouteRouteChildren =
  {
    ConsoleOrgIdToolsPdsCompareIndexRoute:
      ConsoleOrgIdToolsPdsCompareIndexRoute,
    ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRoute:
      ConsoleOrgIdToolsPdsComparePdsDocumentsRouteRouteWithChildren,
  };

const ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren =
  ConsoleOrgIdToolsPdsCompareRouteRoute._addFileChildren(
    ConsoleOrgIdToolsPdsCompareRouteRouteChildren,
  );

interface ConsoleOrgIdToolsWebsiteCheckerRouteRouteChildren {
  ConsoleOrgIdToolsWebsiteCheckerIndexRoute: typeof ConsoleOrgIdToolsWebsiteCheckerIndexRoute;
  ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute: typeof ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute;
}

const ConsoleOrgIdToolsWebsiteCheckerRouteRouteChildren: ConsoleOrgIdToolsWebsiteCheckerRouteRouteChildren =
  {
    ConsoleOrgIdToolsWebsiteCheckerIndexRoute:
      ConsoleOrgIdToolsWebsiteCheckerIndexRoute,
    ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute:
      ConsoleOrgIdToolsWebsiteCheckerReportIdRouteRoute,
  };

const ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren =
  ConsoleOrgIdToolsWebsiteCheckerRouteRoute._addFileChildren(
    ConsoleOrgIdToolsWebsiteCheckerRouteRouteChildren,
  );

interface ConsoleOrgIdToolsRouteRouteChildren {
  ConsoleOrgIdToolsIndexRoute: typeof ConsoleOrgIdToolsIndexRoute;
  ConsoleOrgIdToolsAutoDetectRouteRoute: typeof ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren;
  ConsoleOrgIdToolsComplianceAuditRouteRoute: typeof ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren;
  ConsoleOrgIdToolsDocumentAnalyzerRouteRoute: typeof ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren;
  ConsoleOrgIdToolsPdsCompareRouteRoute: typeof ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren;
  ConsoleOrgIdToolsWebsiteCheckerRouteRoute: typeof ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren;
}

const ConsoleOrgIdToolsRouteRouteChildren: ConsoleOrgIdToolsRouteRouteChildren =
  {
    ConsoleOrgIdToolsIndexRoute: ConsoleOrgIdToolsIndexRoute,
    ConsoleOrgIdToolsAutoDetectRouteRoute:
      ConsoleOrgIdToolsAutoDetectRouteRouteWithChildren,
    ConsoleOrgIdToolsComplianceAuditRouteRoute:
      ConsoleOrgIdToolsComplianceAuditRouteRouteWithChildren,
    ConsoleOrgIdToolsDocumentAnalyzerRouteRoute:
      ConsoleOrgIdToolsDocumentAnalyzerRouteRouteWithChildren,
    ConsoleOrgIdToolsPdsCompareRouteRoute:
      ConsoleOrgIdToolsPdsCompareRouteRouteWithChildren,
    ConsoleOrgIdToolsWebsiteCheckerRouteRoute:
      ConsoleOrgIdToolsWebsiteCheckerRouteRouteWithChildren,
  };

const ConsoleOrgIdToolsRouteRouteWithChildren =
  ConsoleOrgIdToolsRouteRoute._addFileChildren(
    ConsoleOrgIdToolsRouteRouteChildren,
  );

interface ConsoleOrgIdUserSettingsRouteRouteChildren {
  ConsoleOrgIdUserSettingsIndexRoute: typeof ConsoleOrgIdUserSettingsIndexRoute;
  ConsoleOrgIdUserSettingsNotificationsRoute: typeof ConsoleOrgIdUserSettingsNotificationsRoute;
  ConsoleOrgIdUserSettingsProfileRoute: typeof ConsoleOrgIdUserSettingsProfileRoute;
  ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute: typeof ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute;
}

const ConsoleOrgIdUserSettingsRouteRouteChildren: ConsoleOrgIdUserSettingsRouteRouteChildren =
  {
    ConsoleOrgIdUserSettingsIndexRoute: ConsoleOrgIdUserSettingsIndexRoute,
    ConsoleOrgIdUserSettingsNotificationsRoute:
      ConsoleOrgIdUserSettingsNotificationsRoute,
    ConsoleOrgIdUserSettingsProfileRoute: ConsoleOrgIdUserSettingsProfileRoute,
    ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute:
      ConsoleOrgIdUserSettingsAuthorisedAppsIndexRoute,
  };

const ConsoleOrgIdUserSettingsRouteRouteWithChildren =
  ConsoleOrgIdUserSettingsRouteRoute._addFileChildren(
    ConsoleOrgIdUserSettingsRouteRouteChildren,
  );

interface ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteChildren {
  ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute;
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute;
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute;
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute;
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute;
  ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute;
}

const ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteChildren: ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteChildren =
  {
    ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarAddRoute,
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarDetailsIdRoute,
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_activityIdRoute,
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarDetailsControl_testIdRoute,
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarDetailsMsp_governance_checkIdRoute,
    ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarDetailsRisk_actionIdRoute,
  };

const ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteChildren,
  );

interface ConsoleOrgIdWorkloadManagerTasksListRouteRouteChildren {
  ConsoleOrgIdWorkloadManagerTasksListAddRoute: typeof ConsoleOrgIdWorkloadManagerTasksListAddRoute;
  ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute: typeof ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute;
}

const ConsoleOrgIdWorkloadManagerTasksListRouteRouteChildren: ConsoleOrgIdWorkloadManagerTasksListRouteRouteChildren =
  {
    ConsoleOrgIdWorkloadManagerTasksListAddRoute:
      ConsoleOrgIdWorkloadManagerTasksListAddRoute,
    ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute:
      ConsoleOrgIdWorkloadManagerTasksListDetailsIdRoute,
  };

const ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerTasksListRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerTasksListRouteRouteChildren,
  );

interface ConsoleOrgIdWorkloadManagerTasksRouteRouteChildren {
  ConsoleOrgIdWorkloadManagerTasksIndexRoute: typeof ConsoleOrgIdWorkloadManagerTasksIndexRoute;
  ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute: typeof ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren;
  ConsoleOrgIdWorkloadManagerTasksListRouteRoute: typeof ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren;
}

const ConsoleOrgIdWorkloadManagerTasksRouteRouteChildren: ConsoleOrgIdWorkloadManagerTasksRouteRouteChildren =
  {
    ConsoleOrgIdWorkloadManagerTasksIndexRoute:
      ConsoleOrgIdWorkloadManagerTasksIndexRoute,
    ConsoleOrgIdWorkloadManagerTasksCalendarRouteRoute:
      ConsoleOrgIdWorkloadManagerTasksCalendarRouteRouteWithChildren,
    ConsoleOrgIdWorkloadManagerTasksListRouteRoute:
      ConsoleOrgIdWorkloadManagerTasksListRouteRouteWithChildren,
  };

const ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerTasksRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerTasksRouteRouteChildren,
  );

interface ConsoleOrgIdWorkloadManagerRouteRouteChildren {
  ConsoleOrgIdWorkloadManagerIndexRoute: typeof ConsoleOrgIdWorkloadManagerIndexRoute;
  ConsoleOrgIdWorkloadManagerComplaintsRoute: typeof ConsoleOrgIdWorkloadManagerComplaintsRoute;
  ConsoleOrgIdWorkloadManagerEmailsRouteRoute: typeof ConsoleOrgIdWorkloadManagerEmailsRouteRoute;
  ConsoleOrgIdWorkloadManagerTasksRouteRoute: typeof ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren;
}

const ConsoleOrgIdWorkloadManagerRouteRouteChildren: ConsoleOrgIdWorkloadManagerRouteRouteChildren =
  {
    ConsoleOrgIdWorkloadManagerIndexRoute:
      ConsoleOrgIdWorkloadManagerIndexRoute,
    ConsoleOrgIdWorkloadManagerComplaintsRoute:
      ConsoleOrgIdWorkloadManagerComplaintsRoute,
    ConsoleOrgIdWorkloadManagerEmailsRouteRoute:
      ConsoleOrgIdWorkloadManagerEmailsRouteRoute,
    ConsoleOrgIdWorkloadManagerTasksRouteRoute:
      ConsoleOrgIdWorkloadManagerTasksRouteRouteWithChildren,
  };

const ConsoleOrgIdWorkloadManagerRouteRouteWithChildren =
  ConsoleOrgIdWorkloadManagerRouteRoute._addFileChildren(
    ConsoleOrgIdWorkloadManagerRouteRouteChildren,
  );

interface ConsoleOrgIdRouteRouteChildren {
  ConsoleOrgIdIndexRoute: typeof ConsoleOrgIdIndexRoute;
  ConsoleOrgIdAttestationsRouteRoute: typeof ConsoleOrgIdAttestationsRouteRouteWithChildren;
  ConsoleOrgIdClaimsRouteRoute: typeof ConsoleOrgIdClaimsRouteRouteWithChildren;
  ConsoleOrgIdComplianceRouteRoute: typeof ConsoleOrgIdComplianceRouteRouteWithChildren;
  ConsoleOrgIdComponentShowcaseRouteRoute: typeof ConsoleOrgIdComponentShowcaseRouteRouteWithChildren;
  ConsoleOrgIdConfigurationRouteRoute: typeof ConsoleOrgIdConfigurationRouteRouteWithChildren;
  ConsoleOrgIdControlsRouteRoute: typeof ConsoleOrgIdControlsRouteRouteWithChildren;
  ConsoleOrgIdDashboardRouteRoute: typeof ConsoleOrgIdDashboardRouteRouteWithChildren;
  ConsoleOrgIdDocumentsRouteRoute: typeof ConsoleOrgIdDocumentsRouteRouteWithChildren;
  ConsoleOrgIdFaqRouteRoute: typeof ConsoleOrgIdFaqRouteRoute;
  ConsoleOrgIdFleetPortalRouteRoute: typeof ConsoleOrgIdFleetPortalRouteRouteWithChildren;
  ConsoleOrgIdGetFileRouteRoute: typeof ConsoleOrgIdGetFileRouteRoute;
  ConsoleOrgIdMsprRouteRoute: typeof ConsoleOrgIdMsprRouteRouteWithChildren;
  ConsoleOrgIdReportingRouteRoute: typeof ConsoleOrgIdReportingRouteRouteWithChildren;
  ConsoleOrgIdRiskRouteRoute: typeof ConsoleOrgIdRiskRouteRouteWithChildren;
  ConsoleOrgIdToolsRouteRoute: typeof ConsoleOrgIdToolsRouteRouteWithChildren;
  ConsoleOrgIdToolsOnlyHomePageRoute: typeof ConsoleOrgIdToolsOnlyHomePageRoute;
  ConsoleOrgIdUserSettingsRouteRoute: typeof ConsoleOrgIdUserSettingsRouteRouteWithChildren;
  ConsoleOrgIdWorkloadManagerRouteRoute: typeof ConsoleOrgIdWorkloadManagerRouteRouteWithChildren;
  ConsoleOrgIdDebugIndexRoute: typeof ConsoleOrgIdDebugIndexRoute;
}

const ConsoleOrgIdRouteRouteChildren: ConsoleOrgIdRouteRouteChildren = {
  ConsoleOrgIdIndexRoute: ConsoleOrgIdIndexRoute,
  ConsoleOrgIdAttestationsRouteRoute:
    ConsoleOrgIdAttestationsRouteRouteWithChildren,
  ConsoleOrgIdClaimsRouteRoute: ConsoleOrgIdClaimsRouteRouteWithChildren,
  ConsoleOrgIdComplianceRouteRoute:
    ConsoleOrgIdComplianceRouteRouteWithChildren,
  ConsoleOrgIdComponentShowcaseRouteRoute:
    ConsoleOrgIdComponentShowcaseRouteRouteWithChildren,
  ConsoleOrgIdConfigurationRouteRoute:
    ConsoleOrgIdConfigurationRouteRouteWithChildren,
  ConsoleOrgIdControlsRouteRoute: ConsoleOrgIdControlsRouteRouteWithChildren,
  ConsoleOrgIdDashboardRouteRoute: ConsoleOrgIdDashboardRouteRouteWithChildren,
  ConsoleOrgIdDocumentsRouteRoute: ConsoleOrgIdDocumentsRouteRouteWithChildren,
  ConsoleOrgIdFaqRouteRoute: ConsoleOrgIdFaqRouteRoute,
  ConsoleOrgIdFleetPortalRouteRoute:
    ConsoleOrgIdFleetPortalRouteRouteWithChildren,
  ConsoleOrgIdGetFileRouteRoute: ConsoleOrgIdGetFileRouteRoute,
  ConsoleOrgIdMsprRouteRoute: ConsoleOrgIdMsprRouteRouteWithChildren,
  ConsoleOrgIdReportingRouteRoute: ConsoleOrgIdReportingRouteRouteWithChildren,
  ConsoleOrgIdRiskRouteRoute: ConsoleOrgIdRiskRouteRouteWithChildren,
  ConsoleOrgIdToolsRouteRoute: ConsoleOrgIdToolsRouteRouteWithChildren,
  ConsoleOrgIdToolsOnlyHomePageRoute: ConsoleOrgIdToolsOnlyHomePageRoute,
  ConsoleOrgIdUserSettingsRouteRoute:
    ConsoleOrgIdUserSettingsRouteRouteWithChildren,
  ConsoleOrgIdWorkloadManagerRouteRoute:
    ConsoleOrgIdWorkloadManagerRouteRouteWithChildren,
  ConsoleOrgIdDebugIndexRoute: ConsoleOrgIdDebugIndexRoute,
};

const ConsoleOrgIdRouteRouteWithChildren =
  ConsoleOrgIdRouteRoute._addFileChildren(ConsoleOrgIdRouteRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminConsentRoute: AdminConsentRoute,
  AdminConsoleRouteRoute: AdminConsoleRouteRouteWithChildren,
  AttestationRouteRoute: AttestationRouteRouteWithChildren,
  InviteRouteRoute: InviteRouteRoute,
  MaintenanceRoute: MaintenanceRoute,
  NotFoundRoute: NotFoundRoute,
  NotSupportedRoute: NotSupportedRoute,
  OauthRouteRoute: OauthRouteRouteWithChildren,
  OrgSwitchedRoute: OrgSwitchedRoute,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  StatusRoute: StatusRoute,
  TermsAcceptanceRouteRoute: TermsAcceptanceRouteRoute,
  authenticationAdminLoginRoute: authenticationAdminLoginRoute,
  authenticationCallbackRoute: authenticationCallbackRoute,
  authenticationLoginRoute: authenticationLoginRoute,
  authenticationLogoutRoute: authenticationLogoutRoute,
  authenticationLogoutinRoute: authenticationLogoutinRoute,
  authenticationOrgMismatchRoute: authenticationOrgMismatchRoute,
  authenticationPaymentPendingRoute: authenticationPaymentPendingRoute,
  ConsoleOrgIdRouteRoute: ConsoleOrgIdRouteRouteWithChildren,
  PasswordResetRequestRoute: PasswordResetRequestRoute,
  PasswordResetResetRoute: PasswordResetResetRoute,
  WhatsNewReleaseIdRoute: WhatsNewReleaseIdRoute,
  authenticationChangeOrgOrgIdRoute: authenticationChangeOrgOrgIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
